import React, { useState, useEffect, useCallback, startTransition, useRef } from 'react';
import {
  Box, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, LinearProgress,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, FormControl, InputLabel, Select, MenuItem, Menu, Alert,
  Snackbar, CircularProgress, Avatar, Divider, TablePagination,
  Tooltip, Checkbox, FormControlLabel, Card, CardContent, Grid, Drawer, List,
  ListItemButton, ListItemIcon, ListItemText, AppBar, Toolbar,
  Badge, Accordion, AccordionSummary, AccordionDetails,
  Tab, Tabs, ListSubheader, Popover, TableSortLabel, InputAdornment,
  Autocomplete,
} from '@mui/material';
import {
  Business, People, School, Assessment, ChevronRight,
  Add, Upload, Visibility, Edit, Delete, DeleteForever, Search, CheckCircle, Check, Warning,
  TrendingUp, LocationOn, EventNote, Group,
  AccountTree, Menu as MenuIcon, Logout, ManageAccounts,
  LockReset, PersonAdd, LinkOff, Email, PictureAsPdf,
  Assignment, DragHandle, ExpandMore,
  Lock, LockOpen, Star, StarBorder, Download, Undo, AttachFile,
  Campaign, Send as SendIcon, Schedule as ScheduleIcon, Checkroom, DrawOutlined,
  RotateLeft, RotateRight, Dashboard as DashboardIcon,
  ArrowForward, TaskAlt, Payments, Description,
  FormatBold, FormatListBulleted, CalendarToday, CalendarMonth,
  GpsFixed, GpsNotFixed, MyLocation,
  Clear, ViewList, ViewModule, GroupWork,
  AccountBalance, EventAvailable,
} from '@mui/icons-material';
import axios from 'axios';
import {
  PieChart, Pie, Cell, BarChart, Bar, AreaChart, Area,
  XAxis, YAxis, CartesianGrid, Tooltip as ReTooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { API_ENDPOINTS, EXPERT_SEND_EMAIL_URL, EXPERT_PREVIEW_EMAIL_URL, EXPERT_ROTATE_SIGNATURE_URL, EXPERT_CLEAN_SIGNATURE_URL, WORK_ORDER_ISSUE_URL, WORK_ORDER_PDF_URL, WORK_ORDER_WITHDRAW_URL, MSME_SET_GROUPS_URL, BULK_EMAIL, BULK_EMAIL_LOG, BULK_SMS, BULK_SMS_BALANCE, TRAINING_REPORT_PDF_URL, MENTOR_REPORT_PDF_URL, PARTICIPANT_TRAINING_REPORT_PDF_URL, PARTICIPANT_TRAINING_REPORT_REVERT_URL, REPORT_REVERT_URL, GROUP_REPORT_REVERT_URL, TRAINING_REPORT_REVERT_URL, MENTOR_REPORT_REVERT_URL, TSHIRT_RECEIPT_PDF_URL, TSHIRT_RECEIPT_BULK_SIGN, WORK_ORDER_SUBMISSION_TIMESHEET_URL, WORK_ORDER_SUBMISSION_INVOICE_URL, WORK_ORDER_PAYMENT_NOTIFY_URL, SCHEDULED_MESSAGES, SCHEDULED_MESSAGES_PROCESS, SCHEDULED_MESSAGE_CANCEL, REPORTS_BGE_SUMMARY_URL, REPORTS_QUARTERLY_PDF_URL, REPORTS_ACTIVITY_PDF_URL, REPORTS_ACTIVITY_EXCEL_URL, WORK_ORDER_ATTACHMENT_DOWNLOAD_URL, SMART_ASSIGN_URL, SMART_ASSIGN_EXPORT_URL, WORK_ORDER_SUBMIT_PAYMENT_URL, WORK_ORDERS_CONFIRMED_PAYMENTS_URL, REPORTS_SUBMIT_PAYMENT_URL, GROUP_REPORTS_SUBMIT_PAYMENT_URL, TBIP_PDF_URL, TBIP_EXCEL_URL, FIAP_PDF_URL, FIAP_SUMMARY_URL } from '../config';
import { BRAND } from '../theme';
import AssignMsmesDialog from './AssignMsmesDialog';
import WorkOrderDialog from './WorkOrderDialog';
import SectionHeader from './SectionHeader';
import MSMEMap from './MSMEMap';
import CalendarPlanner from './CalendarPlanner';
import MSMEVisitSchedule from './MSMEVisitSchedule';
import EnterpriseImprovementPlanDialog from './EnterpriseImprovementPlanDialog';
import BookTBIPMeetingDialog from './BookTBIPMeetingDialog';
import SelectSessionMsmesDialog from './SelectSessionMsmesDialog';
import FinancialImprovementPlanDialog from './FinancialImprovementPlanDialog';
import BookFIAPMeetingDialog from './BookFIAPMeetingDialog';
import { FIAP_CATEGORIES } from '../fiap_constants';


import { Place } from '@mui/icons-material';
import { getErrorMessage } from '../utils/error';

const ROWS_PER_PAGE = 15;
const DRAWER_WIDTH = 220;

const NAV_ITEMS = [
  { key: 'overview',    label: 'Overview',        icon: <DashboardIcon /> },
  { key: 'calendar',    label: 'Calendar Planner', icon: <CalendarMonth /> },
  { key: 'msmes',       label: 'MSMEs',          icon: <Business /> },
  { key: 'maps',        label: 'MSME Maps',      icon: <Place /> },
  { key: 'experts',     label: 'BGE Experts',    icon: <People /> },
  { key: 'assignments', label: 'Assignments',    icon: <Assignment /> },
  { key: 'users',       label: 'User Accounts',  icon: <ManageAccounts /> },
  { key: 'bgegroups',   label: 'BGE Groups',     icon: <Group /> },
  { key: 'cohorts',     label: 'Cohorts',        icon: <AccountTree /> },
  { key: 'training',       label: 'Training',       icon: <School /> },
  { key: 'participation',  label: 'Participation',  icon: <TrendingUp /> },
  { key: 'reports',        label: 'Reports',        icon: <PictureAsPdf /> },
  { key: 'tbip',           label: 'Improvement Plans', icon: <TrendingUp /> },
  { key: 'fiap',           label: 'Financial Action Plans', icon: <AccountBalance /> },
  { key: 'workorders',     label: 'Work Orders',    icon: <Assignment /> },

  { key: 'bgeassignment',  label: 'BGE Assignment', icon: <LocationOn /> },
  { key: 'analytics',      label: 'Analytics',      icon: <Assessment /> },
  { key: 'communications', label: 'Communications', icon: <Campaign /> },
  { key: 'tshirts',        label: 'T-Shirt Receipts', icon: <Checkroom /> },
];

const STATUS_OPTIONS = [
  { value: 'active',             label: 'Active',             color: 'success', icon: '🟢', bgcolor: '#E8F5E9', textColor: '#2E7D32', border: '#A5D6A7' },
  { value: 'temporarily_closed', label: 'Temporarily Closed', color: 'warning', icon: '🟡', bgcolor: '#FFF3E0', textColor: '#E65100', border: '#FFE082' },
  { value: 'out_of_business',    label: 'Out of Business',    color: 'error',   icon: '🔴', bgcolor: '#FFEBEE', textColor: '#C62828', border: '#EF9A9A' },
  { value: 'unavailable',        label: 'Unavailable',        color: 'default', icon: '🟣', bgcolor: '#F3E5F5', textColor: '#6A1B9A', border: '#CE93D8' },
];

const getStatusInfo = (status) => {
  const s = (status || 'active').toLowerCase();
  if (s === 'approved') return STATUS_OPTIONS[0]; // Active
  return STATUS_OPTIONS.find(o => o.value === s) || {
    value: status,
    label: (status || 'Active').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    color: 'default',
    icon: '⚪',
    bgcolor: '#F5F5F5',
    textColor: '#616161',
    border: '#E0E0E0',
  };
};

const AttendeeRow = React.memo(function AttendeeRow({ att, idx, msmes, bgeParticipants, updateAttendee, removeAttendeeRow }) {
  const [name, setName] = React.useState(att.attendee_name);
  const [phone, setPhone] = React.useState(att.attendee_phone);
  // selectVal tracks the dropdown display; BGE selections use 'bge:{id}' prefix
  // so they don't pollute att.msme (which expects an MSME id or empty)
  const [selectVal, setSelectVal] = React.useState(att.msme || '');
  return (
    <TableRow hover>
      <TableCell sx={{ color: 'text.secondary', fontSize: 12 }}>{idx + 1}</TableCell>
      <TableCell>
        <TextField size="small" placeholder="Full name" variant="standard"
          value={name}
          onChange={e => setName(e.target.value)}
          onBlur={() => updateAttendee(att._key, 'attendee_name', name)}
          sx={{ minWidth: 140 }} />
      </TableCell>
      <TableCell>
        <TextField size="small" placeholder="Phone" variant="standard"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          onBlur={() => updateAttendee(att._key, 'attendee_phone', phone)}
          sx={{ minWidth: 110 }} />
      </TableCell>
      <TableCell>
        <Select size="small" variant="standard" displayEmpty
          value={selectVal}
          onChange={e => {
            const val = e.target.value;
            setSelectVal(val);
            if (typeof val === 'string' && val.startsWith('bge:')) {
              const b = (bgeParticipants || []).find(x => `bge:${x.id}` === val);
              updateAttendee(att._key, 'msme', '');
              if (b && !name) {
                setName(b.name);
                updateAttendee(att._key, 'attendee_name', b.name);
              }
            } else {
              const m = msmes.find(x => x.id === val);
              updateAttendee(att._key, 'msme', val);
              if (m && !name) {
                const ownerName = m.owner_name || '';
                setName(ownerName);
                updateAttendee(att._key, 'attendee_name', ownerName);
              }
            }
          }}
          sx={{ minWidth: 160 }}>
          <MenuItem value=""><em>— walk-in —</em></MenuItem>
          {(bgeParticipants || []).length > 0 && <ListSubheader>BGE Participants</ListSubheader>}
          {(bgeParticipants || []).map(b => (
            <MenuItem key={`bge:${b.id}`} value={`bge:${b.id}`}>{b.name}{b.bge_code ? ` (${b.bge_code})` : ''}</MenuItem>
          ))}
          {msmes.filter(m => m.is_active).length > 0 && <ListSubheader>MSMEs</ListSubheader>}
          {msmes.filter(m => m.is_active).map(m => (
            <MenuItem key={m.id} value={m.id}>{m.business_name}</MenuItem>
          ))}
        </Select>
      </TableCell>
      <TableCell>
        <Select size="small" variant="standard" displayEmpty
          value={att.gender}
          onChange={e => updateAttendee(att._key, 'gender', e.target.value)}
          sx={{ minWidth: 55 }}>
          <MenuItem value=""><em>—</em></MenuItem>
          <MenuItem value="M">M</MenuItem>
          <MenuItem value="F">F</MenuItem>
        </Select>
      </TableCell>
      <TableCell>
        <Select size="small" variant="standard" displayEmpty
          value={att.age_group}
          onChange={e => updateAttendee(att._key, 'age_group', e.target.value)}
          sx={{ minWidth: 80 }}>
          <MenuItem value=""><em>—</em></MenuItem>
          <MenuItem value="18-34">18–34</MenuItem>
          <MenuItem value="35-45">35–45</MenuItem>
          <MenuItem value="46-55">46–55</MenuItem>
          <MenuItem value="56+">56+</MenuItem>
        </Select>
      </TableCell>
      <TableCell>
        <Select size="small" variant="standard"
          value={att.refugee_status}
          onChange={e => updateAttendee(att._key, 'refugee_status', e.target.value)}
          sx={{ minWidth: 80 }}>
          <MenuItem value="H">Host Comm.</MenuItem>
          <MenuItem value="R">Refugee</MenuItem>
        </Select>
      </TableCell>
      <TableCell align="center">
        <Tooltip title="Photo consent">
          <Checkbox size="small" checked={!!att.consent_photo}
            onChange={e => updateAttendee(att._key, 'consent_photo', e.target.checked)} />
        </Tooltip>
      </TableCell>
      <TableCell>
        <IconButton size="small" color="error" onClick={() => removeAttendeeRow(att._key)}>
          <Delete fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
});

export default function Dashboard({ token, currentUser, onLogout }) {
  const isViewer          = currentUser?.role === 'viewer';
  const isStaff           = !!(currentUser?.is_staff || currentUser?.is_superuser || currentUser?.role === 'admin');
  const isProgrammeManager = !isStaff && currentUser?.role === 'cohort_admin';
  const isAdmin           = !isViewer && (isStaff || currentUser?.role === 'cohort_admin');
  const headers   = { Authorization: `Bearer ${token}` };

  const [section, setSection] = useState(() => {
    const requested = new URLSearchParams(window.location.search).get('section');
    return NAV_ITEMS.some((item) => item.key === requested) ? requested : 'overview';
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  // ── nav drag-and-drop ──────────────────────────────────────────────────────
  const [navOrder, setNavOrder] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('dashNavOrder') || 'null');
      if (Array.isArray(saved) && saved.every(k => NAV_ITEMS.some(n => n.key === k))) {
        // Automatically inject any newly introduced items (like 'calendar') into the saved order
        const missing = NAV_ITEMS.map(n => n.key).filter(k => !saved.includes(k));
        if (missing.length > 0) {
          const updated = [...saved];
          missing.forEach(k => {
            const defaultIdx = NAV_ITEMS.findIndex(n => n.key === k);
            if (defaultIdx !== -1 && defaultIdx <= updated.length) {
              updated.splice(defaultIdx, 0, k);
            } else {
              updated.push(k);
            }
          });
          try { localStorage.setItem('dashNavOrder', JSON.stringify(updated)); } catch {}
          return updated;
        }
        return saved;
      }
    } catch {}
    return NAV_ITEMS.map(n => n.key);
  });
  // Tabs hidden based on role
  const HIDDEN_TABS = isStaff
    ? []
    : isProgrammeManager
      ? ['users', 'cohorts', 'communications']
      : ['users', 'communications'];
  const orderedNav = navOrder.map(k => NAV_ITEMS.find(n => n.key === k)).filter(n => n && !HIDDEN_TABS.includes(n.key));
  const [dragKey, setDragKey] = useState(null);
  const [navLocked, setNavLocked] = useState(true);

  // ── data ───────────────────────────────────────────────────────────────────
  const [msmes, setMsmes] = useState([]);
  const [allMsmes, setAllMsmes] = useState([]);
  const [experts, setExperts] = useState([]);
  const [cohorts, setCohorts] = useState([]);
  const [bgeGroups, setBgeGroups] = useState([]);
  const [programmeGroups, setProgrammeGroups] = useState([]);
  const [trainingSessions, setTrainingSessions] = useState([]);
  const [trainingTopics, setTrainingTopics] = useState([]);
  const [analytics, setAnalytics] = useState({});
  const [loading, setLoading] = useState(false);

  // ── Enterprise Improvement Plans (TBIP) ──────────────────────────────────
  const [tbipPlans, setTbipPlans] = useState([]);
  const [tbipDialog, setTbipDialog] = useState(false);
  const [selectedTbip, setSelectedTbip] = useState(null);
  const [selectedTbipMsme, setSelectedTbipMsme] = useState(null);
  const [tbipFilterStatus, setTbipFilterStatus] = useState('all');
  const [tbipFilterPriority, setTbipFilterPriority] = useState('all');
  const [tbipFilterBge, setTbipFilterBge] = useState('all');
  const [tbipSearch, setTbipSearch] = useState('');
  const [tbipPage, setTbipPage] = useState(0);
  const [tbipBookMeetingOpen, setTbipBookMeetingOpen] = useState(false);
  const [tbipBookMeetingMsme, setTbipBookMeetingMsme] = useState(null);
  const [tbipBookMeetingPlan, setTbipBookMeetingPlan] = useState(null);

  // ── Financial Improvement Action Plans (FIAP / Access to Finance) ─────────
  const [fiapPlans, setFiapPlans] = useState([]);
  const [, setFiapSummary] = useState(null);
  const [fiapDialog, setFiapDialog] = useState(false);
  const [selectedFiap, setSelectedFiap] = useState(null);
  const [selectedFiapMsme, setSelectedFiapMsme] = useState(null);
  const [fiapFilterCategory, setFiapFilterCategory] = useState('all');
  const [fiapFilterPriority, setFiapFilterPriority] = useState('all');
  const [fiapFilterStatus, setFiapFilterStatus] = useState('all');
  const [fiapSearch, setFiapSearch] = useState('');
  const [fiapPage, setFiapPage] = useState(0);
  const [fiapBookMeetingOpen, setFiapBookMeetingOpen] = useState(false);
  const [fiapBookMeetingMsme, setFiapBookMeetingMsme] = useState(null);
  const [fiapBookMeetingPlan, setFiapBookMeetingPlan] = useState(null);



  // ── work orders ───────────────────────────────────────────────────────────
  const [workOrders, setWorkOrders] = useState([]);
  const deferredWorkOrders = React.useDeferredValue(workOrders);
  const [woLoading, setWoLoading] = useState(false);
  const [woError, setWoError] = useState('');
  const [woFilterBge, setWoFilterBge] = useState('');
  const [woFilterStatus, setWoFilterStatus] = useState('');
  const [woFilterType, setWoFilterType] = useState('');
  const [woDialog, setWoDialog] = useState(false);
  const [woEditing, setWoEditing] = useState(null);
  const [woIssuing, setWoIssuing] = useState(null);
  const [woWithdrawing, setWoWithdrawing] = useState(null);
  const [woWithdrawDialog, setWoWithdrawDialog] = useState(false);
  const [woWithdrawTarget, setWoWithdrawTarget] = useState(null);
  const [woWithdrawReason, setWoWithdrawReason] = useState('');
  const [woSubmissions, setWoSubmissions] = useState([]);
  const [woPayments, setWoPayments] = useState([]);
  const [woAttachments, setWoAttachments] = useState([]);
  const [woPaymentForms, setWoPaymentForms] = useState({});
  const [woPaymentSaving, setWoPaymentSaving] = useState(null);
  const [woFilterPaymentStatus, setWoFilterPaymentStatus] = useState('');
  const [woPaymentSubmitDialog, setWoPaymentSubmitDialog] = useState(false);
  const [woPaymentSubmitTarget, setWoPaymentSubmitTarget] = useState(null);
  const [woPaymentSubmitForm, setWoPaymentSubmitForm] = useState({
    payment_reference: '',
    payment_status: 'submitted_for_payment',
    payment_notes: '',
  });
  const [woPaymentSubmitting, setWoPaymentSubmitting] = useState(false);

  const [reportFilterPaymentStatus, setReportFilterPaymentStatus] = useState('');
  const [reportPaymentSubmitDialog, setReportPaymentSubmitDialog] = useState(false);
  const [reportPaymentSubmitTarget, setReportPaymentSubmitTarget] = useState(null);
  const [reportPaymentSubmitType, setReportPaymentSubmitType] = useState('msme'); // 'msme' or 'group'
  const [reportPaymentSubmitForm, setReportPaymentSubmitForm] = useState({
    payment_reference: '',
    payment_status: 'submitted',
    payment_notes: '',
  });
  const [reportPaymentSubmitting, setReportPaymentSubmitting] = useState(false);
  const [confirmedPaymentsFeed, setConfirmedPaymentsFeed] = useState([]);

  // ── Data-update bulk work order distributor ───────────────────────────────
  const [duDialog, setDuDialog]         = useState(false);
  const [duPreview, setDuPreview]       = useState(null);   // GET response
  const [duLoading, setDuLoading]       = useState(false);
  const [duCreating, setDuCreating]     = useState(false);
  const today = new Date();
  const [duStartDate, setDuStartDate]   = useState(`${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-01`);
  const [duEndDate, setDuEndDate]       = useState(() => {
    const d = new Date(today.getFullYear(), today.getMonth()+1, 0);
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  });
  const [duMaxDays, setDuMaxDays]       = useState(4);
  const [duRatePerDay, setDuRatePerDay] = useState(60000);
  const [duUpdateAssign, setDuUpdateAssign] = useState(true);
  const [duResult, setDuResult]         = useState(null);

  // ── Permanent-assignee bulk work order distributor (3x/month) ──────────────
  const [paDialog, setPaDialog]         = useState(false);
  const [paPreview, setPaPreview]       = useState(null);
  const [paLoading, setPaLoading]       = useState(false);
  const [paCreating, setPaCreating]     = useState(false);
  const [paStartDate, setPaStartDate]   = useState(`${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-01`);
  const [paEndDate, setPaEndDate]       = useState(() => {
    const d = new Date(today.getFullYear(), today.getMonth()+1, 0);
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  });
  const [paMaxDays, setPaMaxDays]       = useState(12);
  const [paRatePerDay, setPaRatePerDay] = useState(60000);
  const [paAllowEmpty, setPaAllowEmpty] = useState(false);
  const [paResult, setPaResult]         = useState(null);

  // ── Smart BGE Assignment ─────────────────────────────────────────────────
  const [saLoading, setSaLoading]   = useState(false);
  const [saApplying, setSaApplying] = useState(false);
  const [saData, setSaData]         = useState(null);   // preview response
  const [saApplyTo, setSaApplyTo]   = useState('all'); // 'all' | 'unassigned'
  const [saSearch, setSaSearch]     = useState('');
  const [saTab, setSaTab]           = useState(0);      // 0=Summary 1=Detail
  const [saExclude, setSaExclude]   = useState([]);     // [{id, name}] BGEs excluded from pool

  // ── filters ────────────────────────────────────────────────────────────────
  const [msmeSearch, setMsmeSearch] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterSector, setFilterSector] = useState('');
  const [filterCohort, setFilterCohort] = useState('');
  const [filterMsmeStatus, setFilterMsmeStatus] = useState('');
  const [msmeViewMode, setMsmeViewMode] = useState('table'); // 'table' | 'map'
  const [removingCoId, setRemovingCoId] = useState(null);

  // ── status menu & inactive confirm ──────────────────────────────────────────
  const [statusMenuAnchor, setStatusMenuAnchor] = useState(null);
  const [statusMenuTarget, setStatusMenuTarget] = useState(null); // { item, type: 'msme' | 'expert' }
  const [statusUpdating, setStatusUpdating] = useState(false);
  const [inactiveConfirmDialog, setInactiveConfirmDialog] = useState(false);
  const [inactiveConfirmData, setInactiveConfirmData] = useState(null); // { msme, bgeId, actionType }

  // ── pagination ─────────────────────────────────────────────────────────────
  const [msmePage, setMsmePage] = useState(0);       // 0-indexed server page
  const [msmeTotalCount, setMsmeTotalCount] = useState(0); // total from API
  const [expertPage, setExpertPage] = useState(0);
  const [sessionPage, setSessionPage] = useState(0);

  // ── notifications ──────────────────────────────────────────────────────────
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // ── dialogs ────────────────────────────────────────────────────────────────
  const [viewItem, setViewItem] = useState(null);
  const [viewType, setViewType] = useState('');
  const [editItem, setEditItem] = useState(null);
  const [editType, setEditType] = useState('');
  const [editForm, setEditForm] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);

  // ── cohort dialog ──────────────────────────────────────────────────────────
  const [cohortDialog, setCohortDialog] = useState(false);
  const [cohortForm, setCohortForm] = useState({ name: '', description: '' });
  const [cohortLoading, setCohortLoading] = useState(false);

  // ── bge group dialog ───────────────────────────────────────────────────────
  const [groupDialog, setGroupDialog] = useState(false);
  const [groupForm, setGroupForm] = useState({ name: '', description: '', objectives: '' });
  const [groupLoading, setGroupLoading] = useState(false);
  const [manageGroupItem, setManageGroupItem] = useState(null);

  // ── group MSME assignment dialog ───────────────────────────────────────────
  const [assignMsmeGroup, setAssignMsmeGroup] = useState(null);  // group object or null
  // assignedGroupMsmeIds, groupMsmeSession, groupMsmeSaving, toggleGroupMsme,
  // saveGroupMsmeAssignments all live inside AssignMsmesDialog to prevent
  // checkbox toggles from re-rendering the full Dashboard tree (was 312ms INP).

  // ── training dialogs ───────────────────────────────────────────────────────
  const [sessionDialog, setSessionDialog] = useState(false);
  const [sessionEditing, setSessionEditing] = useState(null);
  const [sessionMsmeListOpen, setSessionMsmeListOpen] = useState(false);
  // team = [{role:'lead'|'mentor', bge_id:'', work_order_id:'', _key: uniqueKey}]
  const EMPTY_SESSION_FORM = { title: '', date: '', end_date: '', location: '', description: '', topic: '', businesses: [], bge_participants: [], team: [] };
  const [sessionForm, setSessionForm] = useState(EMPTY_SESSION_FORM);
  const [sessionLoading, setSessionLoading] = useState(false);
  const [attendanceDialog, setAttendanceDialog] = useState(false);
  const [attendanceDay, setAttendanceDay] = useState('');
  const [selectedSession, setSelectedSession] = useState(null);
  const [sessionAttendees, setSessionAttendees] = useState([]);
  const [attendanceLoading, setAttendanceLoading] = useState(false);

  // Returns all calendar dates (YYYY-MM-DD strings) from start to end inclusive
  const sessionDays = React.useCallback((session) => {
    if (!session?.date) return [];
    const start = new Date(session.date);
    const end = session.end_date ? new Date(session.end_date) : start;
    const days = [];
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      days.push(d.toISOString().slice(0, 10));
    }
    return days;
  }, []);

  const activeDays = React.useMemo(() => sessionDays(selectedSession), [sessionDays, selectedSession]);
  const dayAttendees = React.useMemo(
    () => activeDays.length > 1 ? sessionAttendees.filter(a => a.attendance_date === attendanceDay) : sessionAttendees,
    [activeDays.length, sessionAttendees, attendanceDay],
  );

  // ── participation summary ──────────────────────────────────────────────────
  const [participationSummary, setParticipationSummary] = useState(null);
  const [participationLoading, setParticipationLoading] = useState(false);
  const [participationCohort, setParticipationCohort] = useState('');

  // ── reports ────────────────────────────────────────────────────────────────
  const [reports, setReports] = useState([]);
  const [groupReports, setGroupReports] = useState([]);
  const [reportFilterBge, setReportFilterBge] = useState('');
  const [reportFilterStatus, setReportFilterStatus] = useState('');
  const [reportSortBy, setReportSortBy] = useState('visit_date');
  const [reportSortDir, setReportSortDir] = useState('desc');
  const [reportSearch, setReportSearch] = useState('');
  const [reportFilterVisitType, setReportFilterVisitType] = useState('');
  const [reportViewMode, setReportViewMode] = useState('table'); // 'table' | 'cards' | 'grouped_bge'
  const [reportRowsPerPage, setReportRowsPerPage] = useState(15);
  const [reportExpandedBges, setReportExpandedBges] = useState({});
  const [viewReport, setViewReport] = useState(null);
  const [reportPage, setReportPage] = useState(0);

  // ── Quarterly Report generator ────────────────────────────────────────────
  const [qrStart, setQrStart]         = useState('');
  const [qrEnd, setQrEnd]             = useState('');
  const [qrLabel, setQrLabel]         = useState('');
  const [qrGenerating, setQrGenerating] = useState(false);
  const [arStart, setArStart]         = useState('');
  const [arEnd, setArEnd]             = useState('');
  const [arGenerating, setArGenerating] = useState(false);

  // ── BGE Assignment Summary ────────────────────────────────────────────────
  const [bsStart, setBsStart]         = useState('');
  const [bsEnd, setBsEnd]             = useState('');
  const [bsLoading, setBsLoading]     = useState(false);
  const [bsData, setBsData]           = useState(null);
  const [bsExpandedBge, setBsExpandedBge] = useState(null);
  const [bsExpandedMsme, setBsExpandedMsme] = useState({});
  const [emailingBgeId, setEmailingBgeId] = useState(null);
  const [emailPreview, setEmailPreview] = useState(null);   // { subject, body, to, bge }
  const [emailEditBody, setEmailEditBody] = useState('');   // editable copy of body
  const [emailEditSubject, setEmailEditSubject] = useState(''); // editable subject
  const [emailSending, setEmailSending] = useState(false);
  const [provisioningBgeId, setProvisioningBgeId] = useState(null);

  // ── training / mentor / participant reports (admin) ────────────────────────
  const [adminTrainingReports, setAdminTrainingReports] = useState([]);
  const [adminMentorReports, setAdminMentorReports] = useState([]);
  const [adminParticipantReports, setAdminParticipantReports] = useState([]);
  const [trReportsLoaded, setTrReportsLoaded] = useState(false);
  const [trReportTab, setTrReportTab] = useState(0);
  const [viewTrReport, setViewTrReport] = useState(null);
  const [viewMrReport, setViewMrReport] = useState(null);
  const [viewPtReport, setViewPtReport] = useState(null);

  // ── assignment dialog ──────────────────────────────────────────────────────
  const [assignDialog, setAssignDialog] = useState(false);
  const [coAssignAdd, setCoAssignAdd] = useState('');
  const [coAssignSaving, setCoAssignSaving] = useState(false);
  const [inactiveMsmes, setInactiveMsmes]   = useState(null);  // null=unchecked, [] or array when loaded
  const [reactivating, setReactivating]     = useState(false);

  const [assignTarget, setAssignTarget] = useState(null);  // MSME being assigned
  const [assignForm, setAssignForm] = useState({ bge_id: '', objectives: '', assignment_date: '' });
  const [assignSaving, setAssignSaving] = useState(false);

  // ── BGE-first assignments state ────────────────────────────────────────────
  const [bgeObjectives, setBgeObjectives] = useState({});
  const [savingObjectives, setSavingObjectives] = useState({});
  const [addMsmeDialog, setAddMsmeDialog] = useState(null); // bge object
  const [addMsmePick, setAddMsmePick] = useState('');
  const [addMsmeSearch, setAddMsmeSearch] = useState('');

  // ── t-shirt receipts ──────────────────────────────────────────────────────
  const [tshirtReceipts, setTshirtReceipts] = useState([]);
  const [tshirtLoading, setTshirtLoading] = useState(false);
  const [tshirtDialog, setTshirtDialog] = useState(false);
  const [tshirtForm, setTshirtForm] = useState({ title: 'PRUDEV II T-Shirt Collection', event: '', colour: 'Blue', notes: '' });
  const [tshirtFormEntries, setTshirtFormEntries] = useState([]); // [{bge_id, name, size, quantity}]
  const [tshirtSaving, setTshirtSaving] = useState(false);
  const [tshirtDetailId, setTshirtDetailId] = useState(null); // receipt id being viewed
  const [tshirtBulkSigning, setTshirtBulkSigning] = useState(false);
  const [tshirtBgeSearch, setTshirtBgeSearch] = useState('');
  const [tshirtPage, setTshirtPage] = useState(0);

  // ── user management ────────────────────────────────────────────────────────
  const [bgeUsers, setBgeUsers] = useState([]);
  const [userDialog, setUserDialog] = useState(false);
  const [userForm, setUserForm] = useState({ username: '', password: '', email: '', bge_id: '', role: 'bge', group_ids: [] });
  const [userLoading, setUserLoading] = useState(false);
  const [pwdDialog, setPwdDialog] = useState(false);
  const [pwdUser, setPwdUser] = useState(null);
  const [newPwd, setNewPwd] = useState('');
  const [pwdLoading, setPwdLoading] = useState(false);
  const [roleDialog, setRoleDialog] = useState(false);
  const [roleUser, setRoleUser] = useState(null);
  const [roleForm, setRoleForm] = useState({ role: 'viewer', group_ids: [] });
  const [bulkPwdDialog, setBulkPwdDialog] = useState(false);
  const [bulkPwdValue, setBulkPwdValue] = useState('prudev123');
  const [bulkPwdSendEmail, setBulkPwdSendEmail] = useState(false);
  const [bulkPwdLoading, setBulkPwdLoading] = useState(false);

  // ── fetch ──────────────────────────────────────────────────────────────────
  // Heavy initial load — runs once after login and after explicit refreshes
  // (e.g. mutations). Does NOT include search/filter state in deps, so a user
  // typing in the search box no longer fires 9 parallel HTTP calls per character.
  const fetchAll = useCallback(async () => {
    const h = { Authorization: `Bearer ${token}` };
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (msmeSearch) params.append('search', msmeSearch);
      if (filterType) params.append('business_type', filterType);
      if (filterSector) params.append('sector', filterSector);
      if (filterCohort) params.append('cohort', filterCohort);
      if (filterMsmeStatus) params.append('status', filterMsmeStatus);
      params.append('page', '1');
      params.append('page_size', '50');

      const reportParams = new URLSearchParams();
      if (reportFilterBge) reportParams.append('bge', reportFilterBge);
      if (reportFilterStatus) reportParams.append('status', reportFilterStatus);
      if (reportFilterVisitType) reportParams.append('visit_type', reportFilterVisitType);

      const safeGet = (url, fallback = { data: [] }) =>
        axios.get(url, { headers: h }).catch((err) => {
          console.warn(`[fetchAll] Non-blocking fetch issue for ${url}:`, err?.message || err);
          return fallback;
        });

      const [mRes, allMRes, eRes, cRes, gRes, sRes, tRes, aRes, uRes, rRes, grRes, pgRes, tbipRes, fiapRes, fiapSumRes] = await Promise.all([
        safeGet(`${API_ENDPOINTS.MSMES}?${params}`),
        safeGet(`${API_ENDPOINTS.MSMES}?all=1`),
        safeGet(`${API_ENDPOINTS.EXPERTS}?page_size=200`),
        safeGet(API_ENDPOINTS.COHORTS),
        safeGet(API_ENDPOINTS.BGE_GROUPS),
        safeGet(API_ENDPOINTS.TRAINING_SESSIONS),
        safeGet(API_ENDPOINTS.TRAINING_TOPICS),
        safeGet(`${API_ENDPOINTS.MSMES}analytics/`, { data: {} }),
        isStaff
          ? safeGet(API_ENDPOINTS.BGE_USERS)
          : Promise.resolve({ data: [] }),
        safeGet(`${API_ENDPOINTS.REPORTS}?${reportParams}`),
        safeGet(API_ENDPOINTS.GROUP_REPORTS),
        safeGet(API_ENDPOINTS.PROGRAMME_GROUPS),
        safeGet(API_ENDPOINTS.ENTERPRISE_IMPROVEMENT_PLANS),
        safeGet(API_ENDPOINTS.FINANCIAL_IMPROVEMENT_PLANS),
        safeGet(FIAP_SUMMARY_URL, { data: null }),
      ]);

      const toArr = (d) => (Array.isArray(d) ? d : d.results || []);
      const msmeList = toArr(mRes.data);
      const allMsmeList = toArr(allMRes.data);
      const expertsList = toArr(eRes.data);

      setMsmes(msmeList);
      setAllMsmes(allMsmeList.length > 0 ? allMsmeList : msmeList);
      setMsmeTotalCount(mRes.data?.count ?? (allMsmeList.length > 0 ? allMsmeList.length : msmeList.length));
      setExperts(expertsList);
      setCohorts(toArr(cRes.data));
      setBgeGroups(toArr(gRes.data));
      setProgrammeGroups(toArr(pgRes.data));
      setTrainingSessions(toArr(sRes.data));
      setTrainingTopics(toArr(tRes.data));
      setAnalytics(aRes.data || {});
      setBgeUsers(Array.isArray(uRes.data) ? uRes.data : []);
      setGroupReports(toArr(grRes.data));
      setReports(toArr(rRes.data));
      setTbipPlans(toArr(tbipRes.data));
      setFiapPlans(toArr(fiapRes.data));
      setFiapSummary(fiapSumRes.data || null);

      if (msmeList.length === 0 && expertsList.length === 0 && !navigator.onLine) {
        setError('Failed to load data. Check your connection.');
      } else {
        setError('');
      }
    } catch {
      setError('Failed to load data. Check your connection.');
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchTbipPlans = useCallback(async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.ENTERPRISE_IMPROVEMENT_PLANS, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTbipPlans(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {}
  }, [token]);

  const fetchFiapPlans = useCallback(async () => {
    try {
      const [res, sumRes] = await Promise.all([
        axios.get(API_ENDPOINTS.FINANCIAL_IMPROVEMENT_PLANS, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(FIAP_SUMMARY_URL, {
          headers: { Authorization: `Bearer ${token}` },
        }).catch(() => ({ data: null })),
      ]);
      setFiapPlans(Array.isArray(res.data) ? res.data : res.data.results || []);
      if (sumRes.data) setFiapSummary(sumRes.data);
    } catch {}
  }, [token]);


  useEffect(() => { fetchAll(); }, [fetchAll]);

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_title: `Admin - ${section}`, page_path: `/admin/${section}` });
    }
  }, [section]);

  // Auto-load participation summary whenever the user navigates to the tab.
  useEffect(() => {
    if (section === 'participation') fetchParticipationSummary(participationCohort);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  useEffect(() => {
    if (section !== 'reports' || trReportsLoaded) return;
    const h = { Authorization: `Bearer ${token}` };
    Promise.all([
      axios.get(API_ENDPOINTS.TRAINING_REPORTS, { headers: h }).catch(() => ({ data: [] })),
      axios.get(API_ENDPOINTS.MENTOR_REPORTS, { headers: h }).catch(() => ({ data: [] })),
      axios.get(API_ENDPOINTS.PARTICIPANT_TRAINING_REPORTS, { headers: h }).catch(() => ({ data: [] })),
    ]).then(([trRes, mrRes, ptRes]) => {
      const toArr = d => Array.isArray(d) ? d : d.results || [];
      setAdminTrainingReports(toArr(trRes.data));
      setAdminMentorReports(toArr(mrRes.data));
      setAdminParticipantReports(toArr(ptRes.data));
      setTrReportsLoaded(true);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section, trReportsLoaded, token]);

  const fetchWorkOrders = useCallback(async (retryCount = 0) => {
    if (!token) return;
    const h = { Authorization: `Bearer ${token}` };
    const params = {};
    if (woFilterBge) params.bge = woFilterBge;
    if (woFilterStatus) params.status = woFilterStatus;
    if (woFilterType) params.work_order_type = woFilterType;
    if (retryCount === 0) {
      setWoLoading(true);
      setWoError('');
    }
    try {
      const res = await axios.get(API_ENDPOINTS.WORK_ORDERS, {
        headers: h,
        params,
        timeout: 60000,
      });
      setWorkOrders(Array.isArray(res.data) ? res.data : res.data.results || []);
      setWoLoading(false);
      setWoError('');
    } catch (err) {
      const isNetworkOrColdStart = !err.response || err.message === 'Network Error' || err.code === 'ECONNABORTED' || err.response?.status >= 500;
      if (retryCount < 3 && isNetworkOrColdStart) {
        // Render free/starter tiers take up to 60-70s on cold boot. Progressive backoff: 3s, 7s, 12s
        const backoffMs = [3000, 7000, 12000][retryCount] || 5000;
        setWoLoading(true);
        setWoError(`Connecting to server (waking up backend, attempt ${retryCount + 1} of 3)...`);
        setTimeout(() => fetchWorkOrders(retryCount + 1), backoffMs);
        return;
      }
      setWorkOrders([]);
      const msg = getErrorMessage(err, 'Failed to load work orders.');
      setWoError(msg);
      setWoLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, woFilterBge, woFilterStatus, woFilterType]);

  const fetchWoSubmissions = useCallback(async () => {
    const h = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(API_ENDPOINTS.WORK_ORDER_SUBMISSIONS, { headers: h });
      setWoSubmissions(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {
      setWoSubmissions([]);
    }
  }, [token]);

  const fetchWoPayments = useCallback(async () => {
    const h = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(API_ENDPOINTS.WORK_ORDER_PAYMENTS, { headers: h });
      setWoPayments(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {
      setWoPayments([]);
    }
  }, [token]);

  const fetchWoAttachments = useCallback(async () => {
    const h = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(API_ENDPOINTS.WORK_ORDER_ATTACHMENTS, { headers: h });
      setWoAttachments(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {
      setWoAttachments([]);
    }
  }, [token]);

  useEffect(() => {
    if (section === 'workorders') {
      fetchWorkOrders();
    }
  }, [section, fetchWorkOrders]);

  useEffect(() => {
    if (section === 'workorders') {
      fetchWoSubmissions();
      fetchWoPayments();
      fetchWoAttachments();
    }
  }, [section, fetchWoSubmissions, fetchWoPayments, fetchWoAttachments]);

  const fetchConfirmedPayments = useCallback(async () => {
    if (!token) return;
    try {
      const res = await axios.get(WORK_ORDERS_CONFIRMED_PAYMENTS_URL, { headers: { Authorization: `Bearer ${token}` } });
      setConfirmedPaymentsFeed(res.data.confirmed_payments || []);
    } catch {
      setConfirmedPaymentsFeed([]);
    }
  }, [token]);

  useEffect(() => {
    fetchConfirmedPayments();
  }, [fetchConfirmedPayments]);

  const fetchTshirtReceipts = useCallback(async () => {
    const h = { Authorization: `Bearer ${token}` };
    setTshirtLoading(true);
    try {
      const res = await axios.get(API_ENDPOINTS.TSHIRT_RECEIPTS, { headers: h });
      setTshirtReceipts(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {
      setTshirtReceipts([]);
    } finally {
      setTshirtLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (section !== 'tshirts') return;
    fetchTshirtReceipts();
    // Ensure BGEs are loaded for the create-receipt dialog
    if (experts.length === 0) {
      const h = { Authorization: `Bearer ${token}` };
      axios.get(API_ENDPOINTS.EXPERTS, { headers: h })
        .then(res => setExperts(Array.isArray(res.data) ? res.data : res.data.results || []))
        .catch(() => {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section, fetchTshirtReceipts]);

  // Lightweight, debounced refetch JUST for the MSME list when search/filter/page
  // changes. AbortController cancels any in-flight request when the user keeps
  // typing, so we never paint stale results over fresh ones.
  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();
    const handle = setTimeout(async () => {
      const h = { Authorization: `Bearer ${token}` };
      const params = new URLSearchParams();
      if (msmeSearch) params.append('search', msmeSearch);
      if (filterType) params.append('business_type', filterType);
      if (filterSector) params.append('sector', filterSector);
      if (filterCohort) params.append('cohort', filterCohort);
      if (filterMsmeStatus) params.append('status', filterMsmeStatus);
      params.append('page', String(msmePage + 1));
      params.append('page_size', '50');
      try {
        const r = await axios.get(`${API_ENDPOINTS.MSMES}?${params}`, {
          headers: h, signal: controller.signal,
        });
        setMsmes(Array.isArray(r.data) ? r.data : (r.data.results || []));
        setMsmeTotalCount(r.data?.count ?? (Array.isArray(r.data) ? r.data.length : (r.data.results || []).length));
      } catch (e) {
        if (!axios.isCancel(e) && e.name !== 'CanceledError') {
          setError('Failed to refresh MSME list.');
        }
      }
    }, 300);
    return () => { clearTimeout(handle); controller.abort(); };
  }, [token, msmeSearch, filterType, filterSector, filterCohort, filterMsmeStatus, msmePage]);

  // Same pattern for the Reports list — debounced + cancellable
  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();
    const handle = setTimeout(async () => {
      const h = { Authorization: `Bearer ${token}` };
      const params = new URLSearchParams();
      if (reportFilterBge) params.append('bge', reportFilterBge);
      if (reportFilterStatus) params.append('status', reportFilterStatus);
      if (reportFilterVisitType) params.append('visit_type', reportFilterVisitType);
      try {
        const r = await axios.get(`${API_ENDPOINTS.REPORTS}?${params}`, {
          headers: h, signal: controller.signal,
        });
        setReports(Array.isArray(r.data) ? r.data : (r.data.results || []));
      } catch (e) {
        if (!axios.isCancel(e) && e.name !== 'CanceledError') {
          setError('Failed to refresh reports.');
        }
      }
    }, 300);
    return () => { clearTimeout(handle); controller.abort(); };
  }, [token, reportFilterBge, reportFilterStatus, reportFilterVisitType]);

  // ── helpers ────────────────────────────────────────────────────────────────
  const fmt = (n) => new Intl.NumberFormat('en-UG', { style: 'currency', currency: 'UGX', maximumFractionDigits: 0 }).format(n || 0);
  const statusColor = (s) => ({ approved: 'success', pending: 'warning', rejected: 'error' }[s] || 'default');

  const notify = (msg, type = 'success') => type === 'success' ? setSuccess(msg) : setError(msg);

  // ── email BGE — two-step: preview (editable) then confirm send ───────────
  const previewBgeEmail = async (bge) => {
    if (!bge.email) { notify(`${bge.name} has no email address on record`, 'error'); return; }
    const assignedCount = (bge.assigned_msmes_list || []).length || bge.assigned_msme_count || 0;
    if (!assignedCount) { notify(`${bge.name} has no assigned MSMEs — assign at least one before sending`, 'error'); return; }
    setEmailingBgeId(bge.id);
    try {
      const res = await axios.get(EXPERT_PREVIEW_EMAIL_URL(bge.id), { headers });
      const data = res.data;
      setEmailPreview({ ...data, bge });
      setEmailEditSubject(data.subject || '');
      setEmailEditBody(data.body || '');
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.detail || 'Could not load email preview. Ensure the BGE has assigned MSMEs.';
      notify(msg, 'error');
    } finally {
      setEmailingBgeId(null);
    }
  };

  const provisionBgeAccount = async (bge) => {
    if (!bge) return;
    setProvisioningBgeId(bge.id);
    try {
      const res = await axios.post(`${API_ENDPOINTS.EXPERTS}${bge.id}/provision-account/`, {}, { headers });
      notify(res.data.message || `Provisioned account for ${bge.name || 'BGE'}`);
      fetchAll();
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.detail || 'Failed to provision login account';
      notify(msg, 'error');
    } finally {
      setProvisioningBgeId(null);
    }
  };

  const confirmSendEmail = async () => {
    if (!emailPreview) return;
    setEmailSending(true);
    try {
      const res = await axios.post(
        EXPERT_SEND_EMAIL_URL(emailPreview.bge.id),
        { subject: emailEditSubject, body: emailEditBody },
        { headers }
      );
      notify(res.data.message || `Email sent to ${emailPreview.to}`);
      setEmailPreview(null);
    } catch (err) {
      notify(err.response?.data?.error || err.response?.data?.detail || 'Failed to send email', 'error');
    } finally {
      setEmailSending(false);
    }
  };

  // ── open expert view (fetches fresh data) ─────────────────────────────────
  // Track the currently-requested expert id so a slow response from a previously
  // closed dialog can't overwrite the data of whatever the user has open now.
  const expertFetchSeq = React.useRef(0);
  const [bgeTrReports, setBgeTrReports] = useState([]);
  const [bgeMrReports, setBgeMrReports] = useState([]);
  const openExpertView = async (bge) => {
    const seq = ++expertFetchSeq.current;
    setViewItem(bge);
    setViewType('expert');
    setBgeTrReports([]);
    setBgeMrReports([]);
    try {
      const [res, trRes, mrRes] = await Promise.all([
        axios.get(`${API_ENDPOINTS.EXPERTS}${bge.id}/`, { headers }),
        axios.get(`${API_ENDPOINTS.TRAINING_REPORTS}?bge=${bge.id}&page_size=100`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${API_ENDPOINTS.MENTOR_REPORTS}?bge=${bge.id}&page_size=100`, { headers }).catch(() => ({ data: [] })),
      ]);
      if (seq === expertFetchSeq.current) {
        setViewItem(res.data);
        const toArr = d => Array.isArray(d) ? d : (d.results || []);
        setBgeTrReports(toArr(trRes.data));
        setBgeMrReports(toArr(mrRes.data));
      }
    } catch {
      // keep the cached item already shown
    }
  };

  // ── rotate / clean BGE signature ─────────────────────────────────────────
  const [rotatingSig, setRotatingSig] = useState(false);
  const [cleaningSig, setCleaningSig] = useState(false);
  const rotateBgeSignature = async (bgeId, direction) => {
    setRotatingSig(true);
    try {
      await axios.post(EXPERT_ROTATE_SIGNATURE_URL(bgeId), { direction }, { headers });
      notify(`Signature rotated ${direction === 'ccw' ? '↺ CCW' : '↻ CW'} and saved.`);
      const fresh = await axios.get(`${API_ENDPOINTS.EXPERTS}${bgeId}/`, { headers });
      setViewItem(fresh.data);
    } catch (err) {
      notify(err.response?.data?.detail || 'Rotation failed.', 'error');
    } finally {
      setRotatingSig(false);
    }
  };
  const cleanBgeSignature = async (bgeId) => {
    setCleaningSig(true);
    try {
      await axios.post(EXPERT_CLEAN_SIGNATURE_URL(bgeId), {}, { headers });
      notify('Signature background removed successfully.');
      const fresh = await axios.get(`${API_ENDPOINTS.EXPERTS}${bgeId}/`, { headers });
      setViewItem(fresh.data);
    } catch (err) {
      notify(err.response?.data?.detail || 'Cleaning failed.', 'error');
    } finally {
      setCleaningSig(false);
    }
  };

  // ── edit/delete ────────────────────────────────────────────────────────────
  const openEdit = (item, type) => {
    setEditItem(item);
    setEditType(type);
    setEditForm({
      ...item,
      status: item.status || (item.is_active === false ? 'unavailable' : 'active'),
    });
  };
  const closeEdit = () => { setEditItem(null); setEditForm({}); };

  const saveEdit = async () => {
    setEditLoading(true);
    try {
      const url = editType === 'msme'
        ? `${API_ENDPOINTS.MSMES}${editItem.id}/`
        : `${API_ENDPOINTS.EXPERTS}${editItem.id}/`;

      // Strip computed / file fields that can't be PATCH'd as plain JSON.
      // Signature files are managed via the dedicated upload/rotate endpoints.
      const STRIP_FIELDS = [
        'signature', 'signature_data', 'signature_url',
        'assigned_msme_count', 'assigned_msmes_list', 'group_names',
        'created_at', 'updated_at',
        '_gpsLoading',   // UI-only flag, not a model field
      ];
      const payload = Object.fromEntries(
        Object.entries(editForm).filter(([k]) => !STRIP_FIELDS.includes(k))
      );

      await axios.patch(url, payload, { headers });
      notify('Saved successfully');
      closeEdit();
      fetchAll();
    } catch (err) {
      notify(getErrorMessage(err, 'Failed to save'), 'error');
    }
    finally { setEditLoading(false); }
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);
    try {
      const url = deleteType === 'msme'
        ? `${API_ENDPOINTS.MSMES}${deleteItem.id}/`
        : deleteType === 'expert'
        ? `${API_ENDPOINTS.EXPERTS}${deleteItem.id}/`
        : deleteType === 'cohort'
        ? `${API_ENDPOINTS.COHORTS}${deleteItem.id}/`
        : `${API_ENDPOINTS.BGE_GROUPS}${deleteItem.id}/`;
      await axios.delete(url, { headers });
      notify('Deleted');
      setDeleteItem(null);
      fetchAll();
    } catch (e) { notify(e.response?.data?.detail || 'Failed to delete', 'error'); }
    finally { setDeleteLoading(false); }
  };

  const openStatusMenu = (e, item, type) => {
    e.stopPropagation();
    setStatusMenuAnchor(e.currentTarget);
    setStatusMenuTarget({ item, type });
  };

  const closeStatusMenu = () => {
    setStatusMenuAnchor(null);
    setStatusMenuTarget(null);
  };

  const updateItemStatus = async (newStatus) => {
    if (!statusMenuTarget) return;
    const { item, type } = statusMenuTarget;
    setStatusUpdating(true);
    try {
      const url = type === 'expert'
        ? `${API_ENDPOINTS.EXPERTS}${item.id}/set-status/`
        : `${API_ENDPOINTS.MSMES}${item.id}/set-status/`;
      const res = await axios.patch(url, { status: newStatus }, { headers });
      notify(`${type === 'expert' ? 'Expert' : 'MSME'} status updated to ${getStatusInfo(newStatus).label}`);
      if (type === 'expert') {
        setExperts(prev => prev.map(e => e.id === item.id ? { ...e, ...res.data } : e));
      } else {
        setMsmes(prev => prev.map(m => m.id === item.id ? { ...m, ...res.data } : m));
        setAllMsmes(prev => prev.map(m => m.id === item.id ? { ...m, ...res.data } : m));
      }
      closeStatusMenu();
    } catch (err) {
      notify(err.response?.data?.error || 'Failed to update status', 'error');
    } finally {
      setStatusUpdating(false);
    }
  };

  const openAssignDialog = (msme) => {
    setAssignTarget(msme);
    setAssignForm({
      bge_id: msme.assigned_bge || '',
      objectives: msme.assignment_objectives || '',
      assignment_date: msme.assignment_date || new Date().toISOString().slice(0, 10),
    });
    setCoAssignAdd('');
    setAssignDialog(true);
  };

  const saveAssignment = async (forceConfirm = false) => {
    if (!assignForm.bge_id) { notify('Please select a BGE Expert', 'error'); return; }
    // If MSME is inactive and not explicitly confirmed, prompt confirmation
    if (assignTarget && assignTarget.status && assignTarget.status !== 'active' && !forceConfirm) {
      setInactiveConfirmData({
        msme: assignTarget,
        bgeId: assignForm.bge_id,
        actionType: 'primary',
      });
      setInactiveConfirmDialog(true);
      return;
    }

    setAssignSaving(true);
    try {
      await axios.patch(
        `${API_ENDPOINTS.MSMES}${assignTarget.id}/assign_bge/`,
        {
          bge_id: assignForm.bge_id,
          objectives: assignForm.objectives,
          assignment_date: assignForm.assignment_date || null,
          confirm_inactive: forceConfirm,
        },
        { headers }
      );
      notify('Assignment saved');
      setAssignDialog(false);
      setInactiveConfirmDialog(false);
      fetchAll();
    } catch (err) {
      if (err.response?.data?.requires_confirmation) {
        setInactiveConfirmData({
          msme: assignTarget,
          bgeId: assignForm.bge_id,
          actionType: 'primary',
        });
        setInactiveConfirmDialog(true);
      } else {
        notify(err.response?.data?.error || 'Failed to save assignment', 'error');
      }
    } finally {
      setAssignSaving(false);
    }
  };

  const addCoAssignee = async (bgeId, forceConfirm = false) => {
    if (!bgeId) return;
    // If MSME is inactive and not explicitly confirmed, prompt confirmation
    if (assignTarget && assignTarget.status && assignTarget.status !== 'active' && !forceConfirm) {
      setInactiveConfirmData({
        msme: assignTarget,
        bgeId: bgeId,
        actionType: 'co_assign',
      });
      setInactiveConfirmDialog(true);
      return;
    }

    setCoAssignSaving(true);
    try {
      const res = await axios.patch(
        `${API_ENDPOINTS.MSMES}${assignTarget.id}/add_co_assigned/`,
        { bge_id: bgeId, is_co_assign: true, confirm_inactive: forceConfirm },
        { headers }
      );
      setAssignTarget(res.data);
      setMsmes(prev => prev.map(m => m.id === assignTarget.id ? { ...m, ...res.data } : m));
      setAllMsmes(prev => prev.map(m => m.id === assignTarget.id ? { ...m, ...res.data } : m));
      setCoAssignAdd('');
      setInactiveConfirmDialog(false);
      notify('Co-assigned BGE added successfully');
    } catch (err) {
      if (err.response?.data?.requires_confirmation) {
        setInactiveConfirmData({
          msme: assignTarget,
          bgeId: bgeId,
          actionType: 'co_assign',
        });
        setInactiveConfirmDialog(true);
      } else {
        notify(err.response?.data?.error || 'Failed to add co-assignee', 'error');
      }
    } finally {
      setCoAssignSaving(false);
    }
  };

  const removeCoAssignee = async (bgeId) => {
    setRemovingCoId(bgeId);
    try {
      const res = await axios.patch(
        `${API_ENDPOINTS.MSMES}${assignTarget.id}/remove_co_assigned/`,
        { bge_id: bgeId },
        { headers }
      );
      setAssignTarget(res.data);
      setMsmes(prev => prev.map(m => m.id === assignTarget.id ? { ...m, ...res.data } : m));
      setAllMsmes(prev => prev.map(m => m.id === assignTarget.id ? { ...m, ...res.data } : m));
      notify('Co-assigned BGE removed successfully');
    } catch (err) {
      notify(err.response?.data?.error || 'Failed to remove co-assignee', 'error');
    } finally {
      setRemovingCoId(null);
    }
  };

  // ── assign cohort ──────────────────────────────────────────────────────────
  const assignCohort = async (msmeId, cohortId) => {
    try {
      await axios.patch(`${API_ENDPOINTS.MSMES}${msmeId}/assign_cohort/`, { cohort_id: cohortId || null }, { headers });
      notify('Cohort assigned');
      fetchAll();
    } catch { notify('Failed to assign cohort', 'error'); }
  };

  const toggleProgrammeGroup = async (msme, groupId) => {
    const current = (msme.programme_groups_detail || []).map(g => g.id);
    const next = current.includes(groupId)
      ? current.filter(id => id !== groupId)
      : [...current, groupId];
    try {
      const res = await axios.patch(MSME_SET_GROUPS_URL(msme.id), { group_ids: next }, { headers });
      setMsmes(prev => prev.map(m => m.id === msme.id ? res.data : m));
      setAllMsmes(prev => prev.map(m => m.id === msme.id ? res.data : m));
    } catch { notify('Failed to update programme group', 'error'); }
  };

  // ── MSME upload dialog ─────────────────────────────────────────────────────
  const [msmeUploadDialog, setMsmeUploadDialog] = useState(false);
  const [msmeUploadCohort, setMsmeUploadCohort] = useState('');
  const [msmeUploadNewCohort, setMsmeUploadNewCohort] = useState('');
  const [msmeUploadFile, setMsmeUploadFile] = useState(null);
  const [msmeUploading, setMsmeUploading] = useState(false);
  const [msmeUploadSkipDups, setMsmeUploadSkipDups] = useState(false);
  const [msmeUploadResult, setMsmeUploadResult] = useState(null);
  const msmeFileRef = React.useRef();

  const checkInactiveMsmes = async () => {
    try {
      const r = await axios.get(`${API_ENDPOINTS.MSMES}inactive/`, { headers: { Authorization: `Bearer ${token}` } });
      setInactiveMsmes(r.data.msmes || []);
    } catch { notify('Failed to fetch inactive MSMEs', 'error'); }
  };

  const reactivateAll = async () => {
    setReactivating(true);
    try {
      const r = await axios.post(`${API_ENDPOINTS.MSMES}reactivate-all/`, {}, { headers: { Authorization: `Bearer ${token}` } });
      notify(r.data.message || 'MSMEs reactivated', 'success');
      setInactiveMsmes(null);
      fetchAll();
    } catch { notify('Reactivation failed', 'error'); }
    finally { setReactivating(false); }
  };

  const openMsmeUpload = () => {
    setMsmeUploadDialog(true);
    setMsmeUploadCohort('');
    setMsmeUploadNewCohort('');
    setMsmeUploadFile(null);
    setMsmeUploadSkipDups(false);
    setMsmeUploadResult(null);
  };

  const downloadMsmeTemplate = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.UPLOAD_MSMES_TEMPLATE, {
        headers, responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'MSME_Upload_Template.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      notify('Could not download template', 'error');
    }
  };

  const doMsmeUpload = async () => {
    if (!msmeUploadFile) { notify('Please select a file', 'error'); return; }
    setMsmeUploading(true);
    setMsmeUploadResult(null);
    const fd = new FormData();
    fd.append('file', msmeUploadFile);
    const cohortName = msmeUploadCohort === '__new__' ? msmeUploadNewCohort.trim() : msmeUploadCohort;
    if (cohortName) fd.append('cohort_name', cohortName);
    fd.append('update_existing', msmeUploadSkipDups ? 'false' : 'true');
    try {
      const res = await axios.post(API_ENDPOINTS.UPLOAD_MSMES, fd, { headers });
      setMsmeUploadResult(res.data);
      notify(res.data?.message || 'MSMEs uploaded');
      fetchAll();
    } catch (err) {
      notify(err.response?.data?.error || 'Upload failed', 'error');
    } finally {
      setMsmeUploading(false);
      if (msmeFileRef.current) msmeFileRef.current.value = '';
    }
  };

  // ── BGE upload dialog ──────────────────────────────────────────────────────
  const [bgeUploadDialog, setBgeUploadDialog] = useState(false);
  const [bgeUploadFile, setBgeUploadFile] = useState(null);
  const [bgeUploading, setBgeUploading] = useState(false);
  const [bgeUploadSkipDups, setBgeUploadSkipDups] = useState(false);
  const [bgeDialog, setBgeDialog] = useState(false);
  const [bgeForm, setBgeForm] = useState({ name: '', email: '', phone: '', location: '', bge_code: '', status: 'approved' });
  const [bgeSaving, setBgeSaving] = useState(false);
  const bgeFileRef = React.useRef();

  const openBgeUpload = () => {
    setBgeUploadDialog(true);
    setBgeUploadFile(null);
    setBgeUploadSkipDups(false);
  };

  const doBgeUpload = async () => {
    if (!bgeUploadFile) { notify('Please select a file', 'error'); return; }
    setBgeUploading(true);
    const fd = new FormData();
    fd.append('file', bgeUploadFile);
    fd.append('update_existing', bgeUploadSkipDups ? 'false' : 'true');
    try {
      const res = await axios.post(`${API_ENDPOINTS.EXPERTS}upload/`, fd, { headers });
      notify(res.data?.message || 'BGE data uploaded');
      setBgeUploadDialog(false);
      fetchAll();
    } catch (err) {
      notify(err.response?.data?.error || 'Upload failed', 'error');
    } finally {
      setBgeUploading(false);
      if (bgeFileRef.current) bgeFileRef.current.value = '';
    }
  };

  const openBgeDialog = () => {
    setBgeDialog(true);
    setBgeForm({ name: '', email: '', phone: '', location: '', bge_code: '', status: 'approved' });
  };

  const openUserDialogForBge = (bge) => {
    const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '.').replace(/(^\.+|\.+$)/g, '').replace(/\.+/g, '.');
    const suggestedUsername = bge.email ? bge.email.split('@')[0].toLowerCase() : slug(bge.name || '');
    setUserForm({
      username: suggestedUsername,
      password: '',
      email: bge.email || '',
      bge_id: bge.id,
      role: 'bge',
      group_ids: [],
    });
    setUserDialog(true);
  };

  const createBge = async () => {
    if (!bgeForm.name.trim()) { notify('Please enter a name', 'error'); return; }
    setBgeSaving(true);
    try {
      const res = await axios.post(API_ENDPOINTS.EXPERTS, bgeForm, { headers });
      notify(res.data?.name ? `${res.data.name} created` : 'BGE expert created', 'success');
      setBgeDialog(false);
      setBgeForm({ name: '', email: '', phone: '', location: '', bge_code: '', status: 'approved' });
      if (res.data?.id) {
        openUserDialogForBge(res.data);
      }
      fetchAll();
    } catch (err) {
      const message = err.response?.data?.error || err.response?.data?.detail || 'Failed to create BGE expert';
      notify(message, 'error');
    } finally {
      setBgeSaving(false);
    }
  };

  // ── cohort CRUD ────────────────────────────────────────────────────────────
  const createCohort = async () => {
    setCohortLoading(true);
    try {
      await axios.post(API_ENDPOINTS.COHORTS, cohortForm, { headers });
      notify('Cohort created');
      setCohortDialog(false);
      setCohortForm({ name: '', description: '' });
      fetchAll();
    } catch { notify('Failed to create cohort', 'error'); }
    finally { setCohortLoading(false); }
  };

  // ── BGE group CRUD ─────────────────────────────────────────────────────────
  const createGroup = async () => {
    setGroupLoading(true);
    try {
      await axios.post(API_ENDPOINTS.BGE_GROUPS, groupForm, { headers });
      notify('Group created');
      setGroupDialog(false);
      setGroupForm({ name: '', description: '', objectives: '' });
      fetchAll();
    } catch { notify('Failed to create group', 'error'); }
    finally { setGroupLoading(false); }
  };

  const toggleGroupMember = async (groupId, bgeId, isMember) => {
    const action = isMember ? 'remove_member' : 'add_member';
    try {
      const res = await axios.post(`${API_ENDPOINTS.BGE_GROUPS}${groupId}/${action}/`, { bge_id: bgeId }, { headers });
      // The endpoint returns the freshly-serialised group — push it into the open
      // dialog so the checkbox flips instantly instead of waiting for fetchAll().
      if (res.data && manageGroupItem?.id === groupId) setManageGroupItem(res.data);
      fetchAll();
    } catch { notify('Failed to update group', 'error'); }
  };

  // ── Group report approval (admin) ──────────────────────────────────────────
  const approveGroupReport = async (id) => {
    try {
      await axios.patch(`${API_ENDPOINTS.GROUP_REPORTS}${id}/`, { status: 'approved' }, { headers });
      notify('Group report approved');
      fetchAll();
    } catch (e) {
      notify(e.response?.data?.error || 'Failed to approve report', 'error');
    }
  };

  const revertReport = async (kind, id) => {
    const label = kind === 'group' ? 'group report' : kind === 'training' ? 'training report' : kind === 'mentor' ? 'mentor report' : kind === 'participant' ? 'participant training report' : 'visit report';
    if (!window.confirm(`Revert this ${label} to draft? The BGE will be able to edit and resubmit it.`)) return;
    try {
      const url = kind === 'group' ? GROUP_REPORT_REVERT_URL(id)
        : kind === 'training' ? TRAINING_REPORT_REVERT_URL(id)
        : kind === 'mentor' ? MENTOR_REPORT_REVERT_URL(id)
        : kind === 'participant' ? PARTICIPANT_TRAINING_REPORT_REVERT_URL(id)
        : REPORT_REVERT_URL(id);
      await axios.post(url, {}, { headers });
      notify(`${label.charAt(0).toUpperCase() + label.slice(1)} reverted to draft`);
      fetchAll();
    } catch (e) {
      notify(e.response?.data?.detail || `Failed to revert ${label}`, 'error');
    }
  };

  const deleteReport = async (report) => {
    if (!window.confirm(`Delete this draft report for "${report.msme_name || 'this MSME'}"? This cannot be undone.`)) return;
    try {
      await axios.delete(`${API_ENDPOINTS.REPORTS}${report.id}/`, { headers });
      notify('Draft report deleted', 'success');
      setReports(prev => prev.filter(r => r.id !== report.id));
    } catch (e) {
      notify(e.response?.data?.detail || 'Failed to delete report', 'error');
    }
  };

  // ── PDF helpers (MSME + Group reports) ─────────────────────────────────────
  const openReportPdf = async (kind, reportId, mode = 'view') => {
    const base = kind === 'group' ? API_ENDPOINTS.GROUP_REPORTS : API_ENDPOINTS.REPORTS;
    try {
      const res = await axios.get(
        `${base}${reportId}/pdf/${mode === 'download' ? '?dl=1' : ''}`,
        { headers, responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      if (mode === 'download') {
        const a = document.createElement('a');
        a.href = url;
        a.download = `${kind === 'group' ? 'GroupReport' : 'MSMEReport'}_${reportId}.pdf`;
        document.body.appendChild(a); a.click(); a.remove();
      } else {
        window.open(url, '_blank');
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
    } catch {
      notify('Failed to render PDF', 'error');
    }
  };

  const downloadQuarterlyPdf = async () => {
    if (!qrStart || !qrEnd) { notify('Please select a start and end date', 'warning'); return; }
    setQrGenerating(true);
    try {
      const params = new URLSearchParams({ start: qrStart, end: qrEnd, dl: '1' });
      if (qrLabel) params.append('label', qrLabel);
      const res = await axios.get(REPORTS_QUARTERLY_PDF_URL(params.toString()), {
        headers, responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `PRUDEV2_BGE_Summary_${qrLabel || qrStart + '_' + qrEnd}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
    } catch {
      notify('Failed to generate quarterly report PDF', 'error');
    } finally {
      setQrGenerating(false);
    }
  };

  const generateActivityReport = async (format) => {
    if (!arStart || !arEnd) { notify('Select a start and end date', 'error'); return; }
    setArGenerating(true);
    try {
      const params = new URLSearchParams({ start: arStart, end: arEnd, dl: '1' });
      const url = format === 'excel'
        ? REPORTS_ACTIVITY_EXCEL_URL(params.toString())
        : REPORTS_ACTIVITY_PDF_URL(params.toString());
      const mimeType = format === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'application/pdf';
      const ext = format === 'excel' ? 'xlsx' : 'pdf';
      const resp = await axios.get(url, { headers, responseType: 'blob' });
      const blobUrl = URL.createObjectURL(new Blob([resp.data], { type: mimeType }));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `PRUDEV2_Activity_Report_${arStart}_${arEnd}.${ext}`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    } catch {
      notify('Failed to generate report', 'error');
    } finally {
      setArGenerating(false);
    }
  };

  const loadBgeSummary = async () => {
    setBsLoading(true);
    setBsData(null);
    try {
      const params = new URLSearchParams();
      if (bsStart) params.append('start', bsStart);
      if (bsEnd)   params.append('end',   bsEnd);
      const res = await axios.get(REPORTS_BGE_SUMMARY_URL(params.toString()), { headers });
      setBsData(res.data);
    } catch {
      notify('Failed to load BGE summary', 'error');
    } finally {
      setBsLoading(false);
    }
  };

  const openTrainingReportPdf = async (kind, reportId, mode = 'view') => {
    const urlFn = kind === 'mentor' ? MENTOR_REPORT_PDF_URL
                : kind === 'participant' ? PARTICIPANT_TRAINING_REPORT_PDF_URL
                : TRAINING_REPORT_PDF_URL;
    const label = kind === 'mentor' ? 'MentorReport'
                : kind === 'participant' ? 'ParticipantTrainingReport'
                : 'TrainingReport';
    try {
      const res = await axios.get(
        `${urlFn(reportId)}${mode === 'download' ? '?dl=1' : ''}`,
        { headers, responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      if (mode === 'download') {
        const a = document.createElement('a');
        a.href = url;
        a.download = `${label}_${reportId}.pdf`;
        document.body.appendChild(a); a.click(); a.remove();
      } else {
        window.open(url, '_blank');
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
    } catch {
      notify('Failed to render PDF', 'error');
    }
  };

  // Set / clear the group's team lead (must be a current member)
  const setGroupTeamLead = async (groupId, bgeId) => {
    try {
      const res = await axios.patch(`${API_ENDPOINTS.BGE_GROUPS}${groupId}/`, { team_lead: bgeId }, { headers });
      if (res.data && manageGroupItem?.id === groupId) setManageGroupItem(res.data);
      fetchAll();
      notify(bgeId ? 'Team lead set' : 'Team lead cleared');
    } catch { notify('Failed to set team lead', 'error'); }
  };

  // ── group MSME assignment ──────────────────────────────────────────────────
  const openAssignMsmeDialog = (group) => setAssignMsmeGroup(group);

  // ── facilitation assignments ───────────────────────────────────────────────
  // ── training sessions ──────────────────────────────────────────────────────
  const openSessionEdit = (s) => {
    setSessionEditing(s.id);
    setSessionForm({
      title: s.title,
      date: s.date,
      end_date: s.end_date || '',
      location: s.location || '',
      description: s.description || '',
      topic: s.topic || '',
      businesses: (s.businesses || []),
      bge_participants: (s.bge_participants_detail || []).map(b => b.id),
      team: (s.team || []).map(m => ({ ...m, _key: Math.random() })),
    });
    setSessionDialog(true);
  };

  const createSession = async () => {
    setSessionLoading(true);
    try {
      // 1. Prepare clean session payload
      const cleanTeam = (sessionForm.team || []).filter(m => m.bge_id).map(m => ({
        bge_id: m.bge_id,
        role: m.role || 'mentor',
        work_order_id: m.work_order_id || null,
      }));
      const sessionPayload = {
        title: (sessionForm.title || '').trim(),
        date: sessionForm.date,
        end_date: sessionForm.end_date || null,
        location: (sessionForm.location || '').trim(),
        description: (sessionForm.description || '').trim(),
        topic: sessionForm.topic || null,
        businesses: sessionForm.businesses || [],
        bge_participants: sessionForm.bge_participants || [],
        team: cleanTeam,
      };

      let sessionId = sessionEditing;
      if (sessionEditing) {
        await axios.put(`${API_ENDPOINTS.TRAINING_SESSIONS}${sessionEditing}/`, sessionPayload, { headers });
        notify('Session updated');
      } else {
        const res = await axios.post(API_ENDPOINTS.TRAINING_SESSIONS, sessionPayload, { headers });
        sessionId = res.data.id;
        notify('Session created');
      }

      // 2. Ensure team assignments are synchronized
      const existingRes = await axios.get(`${API_ENDPOINTS.FACILITATION_ASSIGNMENTS}?session=${sessionId}`, { headers });
      const existing = existingRes.data.results || existingRes.data;
      if (existing.length === 0 && cleanTeam.length > 0) {
        await Promise.all(
          cleanTeam.map(m =>
            axios.post(API_ENDPOINTS.FACILITATION_ASSIGNMENTS, {
              bge: m.bge_id,
              topic: sessionPayload.topic || null,
              session: sessionId,
              role: m.role,
              work_order: m.work_order_id || null,
              assigned_date: sessionPayload.date,
            }, { headers })
          )
        );
      }

      setSessionDialog(false);
      setSessionEditing(null);
      setSessionForm(EMPTY_SESSION_FORM);
      fetchAll();
    } catch (e) {
      notify(getErrorMessage(e, 'Failed to save session'), 'error');
    } finally {
      setSessionLoading(false);
    }
  };

  const EMPTY_ATTENDEE = (date = '') => ({
    _key: Math.random(),
    id: null,
    attendance_date: date,
    msme: '',
    attendee_name: '',
    attendee_phone: '',
    gender: '',
    age_group: '',
    refugee_status: 'H',
    consent_photo: true,
    consent_contact: true,
    present: true,
  });

  const deleteSession = async (session) => {
    if (!window.confirm(`Delete "${session.title}"? This will also remove all attendance records and reports for this session.`)) return;
    try {
      await axios.delete(`${API_ENDPOINTS.TRAINING_SESSIONS}${session.id}/`, { headers });
      notify('Session deleted');
      fetchAll();
    } catch (e) { notify(e.response?.data?.detail || 'Failed to delete session', 'error'); }
  };

  const openAttendance = async (session) => {
    setSelectedSession(session);
    setAttendanceLoading(true);
    setAttendanceDialog(true);
    const days = sessionDays(session);
    const firstDay = days[0] || session.date;
    setAttendanceDay(firstDay);
    try {
      const res = await axios.get(`${API_ENDPOINTS.ATTENDANCE}?session=${session.id}`, { headers });
      const records = Array.isArray(res.data) ? res.data : (res.data.results || []);
      if (records.length > 0) {
        setSessionAttendees(records.map(r => ({ ...r, _key: r.id || Math.random() })));
      } else {
        // Pre-fill each day with the session's MSMEs and BGE participants
        const allRows = days.flatMap(day => {
          const msmePrefill = (session.businesses_detail || []).map(m => ({
            ...EMPTY_ATTENDEE(day),
            msme: m.id,
            attendee_name: m.owner_name || '',
            attendee_phone: m.phone || '',
          }));
          const bgePrefill = (session.bge_participants_detail || []).map(b => ({
            ...EMPTY_ATTENDEE(day),
            msme: '',
            attendee_name: b.name || '',
          }));
          return [...msmePrefill, ...bgePrefill];
        });
        setSessionAttendees(allRows.length > 0 ? allRows : [EMPTY_ATTENDEE(firstDay)]);
      }
    } catch { notify('Failed to load attendance', 'error'); }
    finally { setAttendanceLoading(false); }
  };

  const updateAttendee = React.useCallback((key, field, value) => {
    setSessionAttendees(prev => prev.map(a => a._key === key ? { ...a, [field]: value } : a));
  }, []);

  const addAttendeeRow = () => {
    setSessionAttendees(prev => [...prev, EMPTY_ATTENDEE(attendanceDay)]);
  };

  const removeAttendeeRow = React.useCallback((key) => {
    setSessionAttendees(prev => prev.filter(a => a._key !== key));
  }, []);

  const saveAttendance = async () => {
    setAttendanceLoading(true);
    try {
      const present = sessionAttendees.filter(a => a.present);
      await Promise.all(present.map(a => {
        const payload = {
          session: selectedSession.id,
          attendance_date: a.attendance_date || null,
          msme: a.msme || null,
          attendee_name: a.attendee_name,
          attendee_phone: a.attendee_phone,
          gender: a.gender,
          age_group: a.age_group,
          refugee_status: a.refugee_status || 'H',
          consent_photo: a.consent_photo,
          consent_contact: a.consent_contact,
          present: true,
        };
        if (a.id) return axios.patch(`${API_ENDPOINTS.ATTENDANCE}${a.id}/`, payload, { headers });
        return axios.post(API_ENDPOINTS.ATTENDANCE, payload, { headers });
      }));
      notify('Attendance saved');
      setAttendanceDialog(false);
      fetchAll();
      // Live-refresh participation tab if it's currently visible
      if (section === 'participation') fetchParticipationSummary(participationCohort);
    } catch { notify('Failed to save attendance', 'error'); }
    finally { setAttendanceLoading(false); }
  };

  const fetchParticipationSummary = useCallback(async (cohortId = '') => {
    setParticipationLoading(true);
    try {
      const url = cohortId
        ? `${API_ENDPOINTS.ATTENDANCE_SUMMARY}?cohort=${cohortId}`
        : API_ENDPOINTS.ATTENDANCE_SUMMARY;
      const res = await axios.get(url, { headers });
      setParticipationSummary(res.data);
    } catch { notify('Failed to load participation summary', 'error'); }
    finally { setParticipationLoading(false); }
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── user management helpers ────────────────────────────────────────────────
  const createBGEUser = async () => {
    if (!userForm.username || !userForm.password) return;
    setUserLoading(true);
    try {
      const res = await axios.post(API_ENDPOINTS.BGE_USERS, {
        username: userForm.username,
        password: userForm.password,
        email: userForm.email,
        bge_id: userForm.role === 'bge' ? userForm.bge_id : '',
      }, { headers });
      // Set role if not a plain BGE account
      if (userForm.role !== 'bge') {
        await axios.patch(`${API_ENDPOINTS.BGE_USERS}${res.data.id}/set-role/`,
          { role: userForm.role, group_ids: userForm.group_ids }, { headers });
      }
      notify('Account created — welcome email sent if an email address was provided');
      setUserDialog(false);
      setUserForm({ username: '', password: '', email: '', bge_id: '', role: 'bge', group_ids: [] });
      fetchAll();
    } catch (e) { notify(e.response?.data?.error || 'Failed to create user', 'error'); }
    finally { setUserLoading(false); }
  };

  const bulkCreateMissingAccounts = async () => {
    setUserLoading(true);
    try {
      const res = await axios.post(`${API_ENDPOINTS.BGE_USERS}bulk-create-missing/`, {}, { headers });
      const { created, skipped, names } = res.data;
      if (created > 0) {
        notify(`Created ${created} account${created !== 1 ? 's' : ''}: ${names.join(', ')}. Welcome emails with login details sent.`);
      } else {
        notify('All BGE experts already have accounts.');
      }
      if (skipped > 0) notify(`${skipped} BGE(s) skipped — no name/email to generate username.`, 'warning');
      fetchAll();
    } catch (e) { notify(e.response?.data?.error || 'Failed to bulk create accounts', 'error'); }
    finally { setUserLoading(false); }
  };

  // Auto-fill username/email when BGE is selected in the Create Account dialog
  const handleUserBgeSelect = (bgeId) => {
    const bge = experts.find(e => e.id === Number(bgeId) || e.id === bgeId);
    if (!bge) { setUserForm(f => ({ ...f, bge_id: bgeId })); return; }
    const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '.').replace(/^\.+|\.+$/g, '').replace(/\.+/g, '.');
    const suggestedUsername = bge.email ? bge.email.split('@')[0].toLowerCase() : slug(bge.name || '');
    setUserForm(f => ({
      ...f,
      bge_id: bgeId,
      role: 'bge',
      username: f.username || suggestedUsername,
      email: f.email || bge.email || '',
    }));
  };

  const resetPassword = async () => {
    if (!newPwd || newPwd.length < 6) return;
    setPwdLoading(true);
    try {
      await axios.post(`${API_ENDPOINTS.BGE_USERS}${pwdUser.id}/set-password/`, { password: newPwd }, { headers });
      notify(`Password reset for ${pwdUser.username}`);
      setPwdDialog(false);
      setNewPwd('');
    } catch (e) { notify(e.response?.data?.error || 'Failed to reset password', 'error'); }
    finally { setPwdLoading(false); }
  };

  const handleBulkResetPasswords = async () => {
    if (!bulkPwdValue || bulkPwdValue.length < 8) {
      notify('Password must be at least 8 characters.', 'error');
      return;
    }
    setBulkPwdLoading(true);
    try {
      const res = await axios.post(`${API_ENDPOINTS.BGE_USERS}bulk-reset-passwords/`, {
        password: bulkPwdValue,
        send_email: bulkPwdSendEmail,
        target: 'bge',
      }, { headers });
      notify(res.data.message || 'BGE passwords reset successfully.', 'success');
      setBulkPwdDialog(false);
      fetchAll();
    } catch (e) {
      notify(e.response?.data?.error || 'Failed to bulk reset passwords', 'error');
    } finally {
      setBulkPwdLoading(false);
    }
  };

  const openRoleDialog = (u) => {
    setRoleUser(u);
    setRoleForm({
      role: ['cohort_admin', 'viewer', 'bge'].includes(u.role) ? u.role : 'viewer',
      group_ids: u.managed_groups?.map(g => g.id) || [],
      bge_id: u.bge_profile?.id || '',
    });
    setRoleDialog(true);
  };

  const saveRole = async () => {
    if (!roleUser) return;
    setUserLoading(true);
    try {
      await axios.patch(`${API_ENDPOINTS.BGE_USERS}${roleUser.id}/set-role/`, roleForm, { headers });
      notify(`Role updated for ${roleUser.username}`);
      setRoleDialog(false);
      fetchAll();
    } catch (e) { notify(e.response?.data?.error || 'Failed to update role', 'error'); }
    finally { setUserLoading(false); }
  };

  const toggleUserActive = async (user) => {
    try {
      await axios.patch(`${API_ENDPOINTS.BGE_USERS}${user.id}/toggle-active/`, {}, { headers });
      notify(`${user.username} ${user.is_active ? 'deactivated' : 'activated'}`);
      fetchAll();
    } catch { notify('Failed to update user', 'error'); }
  };

  const deleteUser = async (user) => {
    if (!window.confirm(`Permanently delete ${user.username}? This cannot be undone. Their BGE profile (if any) will be unlinked but kept.`)) return;
    try {
      await axios.delete(`${API_ENDPOINTS.BGE_USERS}${user.id}/`, { headers });
      notify(`${user.username} permanently deleted`);
      fetchAll();
    } catch (e) { notify(e.response?.data?.error || 'Failed to delete user', 'error'); }
  };

  const approveUser = async (user) => {
    try {
      await axios.post(`${API_ENDPOINTS.BGE_USERS}${user.id}/approve/`, {}, { headers });
      notify(`${user.username} approved for viewer access.`);
      fetchAll();
    } catch (e) { notify(e.response?.data?.error || 'Failed to approve user', 'error'); }
  };

  const rejectUser = async (user) => {
    if (!window.confirm(`Reject and deactivate ${user.username}? They will not be able to sign in.`)) return;
    try {
      await axios.post(`${API_ENDPOINTS.BGE_USERS}${user.id}/reject/`, {}, { headers });
      notify(`${user.username} rejected and deactivated.`);
      fetchAll();
    } catch (e) { notify(e.response?.data?.error || 'Failed to reject user', 'error'); }
  };

  const unlinkBGE = async (userId) => {
    try {
      await axios.patch(`${API_ENDPOINTS.BGE_USERS}${userId}/link-bge/`, { bge_id: null }, { headers });
      notify('BGE profile unlinked');
      fetchAll();
    } catch { notify('Failed to unlink', 'error'); }
  };

  const linkBGE = async (userId, bgeId) => {
    if (!bgeId) return;
    try {
      await axios.patch(`${API_ENDPOINTS.BGE_USERS}${userId}/link-bge/`, { bge_id: bgeId }, { headers });
      notify('BGE profile linked successfully');
      setLinkBgeUser(null);
      fetchAll();
    } catch (err) { notify(err.response?.data?.error || 'Failed to link BGE', 'error'); }
  };

  // ── link BGE dialog ────────────────────────────────────────────────────────
  const [linkBgeUser, setLinkBgeUser] = useState(null);
  const [linkBgeId, setLinkBgeId] = useState('');

  // ── sidebar ────────────────────────────────────────────────────────────────
  const drawerContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh', minHeight: 0, bgcolor: BRAND.sidebarBg }}>
      {/* GOPA Pro & GIZ dual brand accent stripe */}
      <Box sx={{
        height: 3, flexShrink: 0,
        background: `linear-gradient(90deg, ${BRAND.gopaGold} 0%, ${BRAND.gopaGold} 52%, ${BRAND.gizRed} 52%, ${BRAND.gizRed} 100%)`,
      }} />
      <Box sx={{ p: 2.5, borderBottom: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.25 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box sx={{
              bgcolor: BRAND.gopaGold,
              color: BRAND.primaryMain,
              px: 0.8, py: 0.3, borderRadius: 1,
              fontWeight: 900, fontSize: 8.5, letterSpacing: 0.5,
              lineHeight: 1.1, textAlign: 'center',
            }}>
              GOPA<br/><span style={{ fontSize: 7, fontWeight: 800 }}>Pro</span>
            </Box>
            <Box sx={{
              bgcolor: BRAND.gizRed,
              color: '#fff',
              px: 0.8, py: 0.3, borderRadius: 1,
              fontWeight: 800, fontSize: 8.5, letterSpacing: 0.5,
              lineHeight: 1.1, textAlign: 'center',
            }}>
              GIZ
            </Box>
          </Box>
          <Tooltip title={navLocked ? 'Unlock to reorder tabs' : 'Lock tab order'}>
            <IconButton size="small" onClick={() => setNavLocked(!navLocked)}
              sx={{ color: 'rgba(255,255,255,0.5)', '&:hover': { color: '#fff' } }}>
              {navLocked ? <Lock fontSize="small" /> : <LockOpen fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Box>
        <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.2 }}>
          PRUDEV II
        </Typography>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
          Portfolio Manager
        </Typography>
      </Box>
      <List sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        py: 1,
        WebkitOverflowScrolling: 'touch',
        '&::-webkit-scrollbar': { width: 8 },
        '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(255,255,255,0.24)', borderRadius: 8 },
      }}>
        {orderedNav.map(({ key, label, icon }) => (
          <ListItemButton
            key={key}
            selected={section === key}
            onClick={() => { startTransition(() => setSection(key)); setMobileOpen(false); }}
            draggable={!navLocked}
            onDragStart={!navLocked ? () => setDragKey(key) : undefined}
            onDragOver={!navLocked ? e => e.preventDefault() : undefined}
            onDrop={!navLocked ? () => {
              if (!dragKey || dragKey === key) return;
              const from = navOrder.indexOf(dragKey);
              const to = navOrder.indexOf(key);
              const next = [...navOrder];
              next.splice(from, 1);
              next.splice(to, 0, dragKey);
              setNavOrder(next);
              localStorage.setItem('dashNavOrder', JSON.stringify(next));
              setDragKey(null);
            } : undefined}
            onDragEnd={!navLocked ? () => setDragKey(null) : undefined}
            sx={{
              mx: 1, mb: 0.5, borderRadius: 2,
              color: 'rgba(255,255,255,0.75)',
              transition: 'all 0.15s ease',
              '&.Mui-selected': {
                bgcolor: BRAND.sidebarSelected,
                color: '#FFFFFF',
                borderLeft: `3px solid ${BRAND.gopaGold}`,
                '& .MuiListItemIcon-root': { color: BRAND.gopaGold },
                fontWeight: 600,
              },
              '&:hover': { bgcolor: 'rgba(255,255,255,0.08)', color: '#fff' },
              opacity: dragKey === key ? 0.4 : 1,
              cursor: navLocked ? 'pointer' : 'grab',
            }}
          >
            <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>{icon}</ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{ fontSize: 14 }} />
            {!navLocked && <DragHandle sx={{ fontSize: 16, opacity: 0.35, ml: 0.5 }} />}
          </ListItemButton>
        ))}
      </List>
      <Box sx={{
        p: 1.5,
        borderTop: '1px solid rgba(255,255,255,0.12)',
        bgcolor: 'rgba(0,0,0,0.12)',
        flexShrink: 0,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25 }}>
          <Avatar sx={{ width: 36, height: 36, bgcolor: 'rgba(255,255,255,0.18)', fontSize: 14, fontWeight: 700 }}>
            {currentUser?.username?.[0]?.toUpperCase()}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.15 }} noWrap>
              {currentUser?.username}
            </Typography>
            {isAdmin && (
              <Typography variant="caption" sx={{
                color: BRAND.gopaGold,
                bgcolor: 'rgba(243,187,54,0.16)',
                border: '1px solid rgba(243,187,54,0.3)',
                px: 0.8, py: 0.1, borderRadius: 1,
                fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
              }}>
                ADMIN
              </Typography>
            )}
          </Box>
        </Box>
        <Button
          fullWidth size="small" variant="outlined" startIcon={<Logout />}
          onClick={onLogout}
          sx={{
            color: '#fff',
            borderColor: 'rgba(255,255,255,0.28)',
            justifyContent: 'center',
            textTransform: 'none',
            bgcolor: 'rgba(255,255,255,0.04)',
            '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
          }}
        >
          Sign out
        </Button>
      </Box>
    </Box>
  );

  // ── section renderers ──────────────────────────────────────────────────────
  const paginate = (arr, page) => arr.slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE);

  const ActionCell = ({ item, type }) => (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Tooltip title="View">
        <IconButton size="small" onClick={() => {
          if (type === 'expert') { openExpertView(item); }
          else { setViewItem(item); setViewType(type); }
        }}>
          <Visibility fontSize="small" />
        </IconButton>
      </Tooltip>
      {isStaff && <Tooltip title="Edit"><IconButton size="small" onClick={() => openEdit(item, type)}><Edit fontSize="small" /></IconButton></Tooltip>}
      {isStaff && <Tooltip title="Delete"><IconButton size="small" color="error" onClick={() => { setDeleteItem(item); setDeleteType(type); }}><Delete fontSize="small" /></IconButton></Tooltip>}
    </Box>
  );

  const renderMSMEs = () => (
    <Box>
      <SectionHeader title="MSMEs" subtitle={`${msmes.length} records`}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button
            variant={msmeViewMode === 'table' ? 'contained' : 'outlined'}
            size="small"
            onClick={() => setMsmeViewMode('table')}
            sx={{ textTransform: 'none', fontSize: 12 }}
          >
            Table View
          </Button>
          <Button
            variant={msmeViewMode === 'map' ? 'contained' : 'outlined'}
            color="success"
            size="small"
            startIcon={<Place sx={{ fontSize: 15 }} />}
            onClick={() => setMsmeViewMode('map')}
            sx={{ textTransform: 'none', fontSize: 12 }}
          >
            Spatial Map View
          </Button>
        </Box>
        <Button variant="outlined" color="warning" size="small" onClick={checkInactiveMsmes}>
          Check Inactive
        </Button>
        <Button variant="outlined" startIcon={<Upload />} size="small" onClick={openMsmeUpload}>
          Import MSME List
        </Button>
      </SectionHeader>

      {msmeViewMode === 'map' ? (
        <MSMEMap
          msmes={allMsmes.length > 0 ? allMsmes : msmes}
          experts={experts}
          cohorts={cohorts}
          programmeGroups={programmeGroups}
          onOpenMsme={(m) => {
            setViewItem(m);
            setViewType('msme');
          }}
          onOpenExpert={(e) => {
            openExpertView(e);
          }}
        />
      ) : (
        <>
          {/* filters */}
          <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
            <TextField
              size="small" placeholder="Search name, owner, sector…" value={msmeSearch}
              onChange={e => { setMsmePage(0); startTransition(() => setMsmeSearch(e.target.value)); }}
              onKeyDown={e => e.key === 'Enter' && fetchAll()}
              InputProps={{ startAdornment: <Search fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} /> }}
              sx={{ flex: '1 1 160px', minWidth: 0 }}
            />
            <FormControl size="small" sx={{ flex: '1 1 100px', minWidth: 0 }}>
              <InputLabel>Type</InputLabel>
              <Select value={filterType} onChange={e => { setFilterType(e.target.value); setMsmePage(0); }} label="Type">
                <MenuItem value="">All</MenuItem>
                {['MICRO','SMALL','MEDIUM'].map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ flex: '1 1 120px', minWidth: 0 }}>
              <InputLabel>Sector</InputLabel>
              <Select value={filterSector} onChange={e => { setFilterSector(e.target.value); setMsmePage(0); }} label="Sector">
                <MenuItem value="">All</MenuItem>
                {['MANUFACTURING','SERVICES','TRADE','AGRICULTURE','TECHNOLOGY','CONSTRUCTION','HEALTHCARE','EDUCATION','OTHER'].map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ flex: '1 1 120px', minWidth: 0 }}>
              <InputLabel>Cohort</InputLabel>
              <Select value={filterCohort} onChange={e => { setFilterCohort(e.target.value); setMsmePage(0); }} label="Cohort">
                <MenuItem value="">All</MenuItem>
                {cohorts.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ flex: '1 1 130px', minWidth: 0 }}>
              <InputLabel>Status</InputLabel>
              <Select value={filterMsmeStatus} onChange={e => { setFilterMsmeStatus(e.target.value); setMsmePage(0); }} label="Status">
                <MenuItem value="">All Statuses</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="temporarily_closed">Temporarily Closed</MenuItem>
                <MenuItem value="out_of_business">Out of Business</MenuItem>
                <MenuItem value="unavailable">Unavailable</MenuItem>
              </Select>
            </FormControl>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button variant="contained" size="small" onClick={fetchAll}>Search</Button>
              {(msmeSearch || filterType || filterSector || filterCohort || filterMsmeStatus) &&
                <Button size="small" onClick={() => { setMsmeSearch(''); setFilterType(''); setFilterSector(''); setFilterCohort(''); setFilterMsmeStatus(''); setMsmePage(0); }}>Clear</Button>}
            </Box>
          </Paper>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell>Code</TableCell>
                  <TableCell>Business</TableCell>
                  <TableCell>Owner</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Cohort</TableCell>
                  <TableCell>Groups</TableCell>
                  <TableCell>Assigned BGE</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell align="center">Supports</TableCell>
                  <TableCell>Last Support</TableCell>
                  <TableCell>Growth Update</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {msmes.length === 0 ? (
                  <TableRow><TableCell colSpan={13} align="center" sx={{ py: 4, color: 'text.secondary' }}>No MSMEs found</TableCell></TableRow>
                ) : msmes.map(m => (
                  <TableRow key={m.id} hover>
                    <TableCell><Chip label={m.msme_code} size="small" variant="outlined" /></TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{m.business_name}</TableCell>
                    <TableCell>{m.owner_name}</TableCell>
                    <TableCell><Chip label={m.business_type} size="small" color="primary" /></TableCell>
                    <TableCell>
                      {(() => {
                        const sInfo = getStatusInfo(m.status);
                        return (
                          <Tooltip title={isAdmin ? "Click to change MSME status" : `Status: ${sInfo.label}`}>
                            <Chip
                              label={sInfo.label}
                              size="small"
                              onClick={isAdmin ? (ev) => openStatusMenu(ev, m, 'msme') : undefined}
                              sx={{
                                cursor: isAdmin ? 'pointer' : 'default',
                                fontWeight: 600,
                                fontSize: 11,
                                bgcolor: sInfo.bgcolor,
                                color: sInfo.textColor,
                                border: `1px solid ${sInfo.border}`,
                                '&:hover': isAdmin ? { opacity: 0.85, transform: 'scale(1.02)' } : {},
                                transition: 'all 0.15s ease',
                              }}
                            />
                          </Tooltip>
                        );
                      })()}
                    </TableCell>
                    <TableCell>
                      <Select
                        size="small" value={m.cohort || ''} displayEmpty variant="standard" disableUnderline
                        onChange={e => assignCohort(m.id, e.target.value)}
                        sx={{ fontSize: 12, minWidth: 90 }}
                      >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {cohorts.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                      </Select>
                    </TableCell>
                    <TableCell sx={{ minWidth: 160 }}>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                        {(m.programme_groups_detail || []).map(g => (
                          <Chip
                            key={g.id}
                            label={g.name}
                            size="small"
                            onDelete={isAdmin ? () => toggleProgrammeGroup(m, g.id) : undefined}
                            sx={{
                              fontSize: 10, height: 20,
                              bgcolor: g.color || BRAND.primaryMain,
                              color: '#fff',
                              '& .MuiChip-deleteIcon': { color: 'rgba(255,255,255,0.7)', fontSize: 14 },
                            }}
                          />
                        ))}
                        {isAdmin && programmeGroups.filter(g =>
                          !(m.programme_groups_detail || []).some(mg => mg.id === g.id)
                        ).length > 0 && (
                          <Select
                            value=""
                            displayEmpty
                            variant="standard"
                            disableUnderline
                            size="small"
                            onChange={e => { if (e.target.value) toggleProgrammeGroup(m, e.target.value); }}
                            sx={{ fontSize: 11, minWidth: 28, '& .MuiSelect-select': { py: 0, px: 0.5 } }}
                            renderValue={() => <Typography sx={{ fontSize: 18, lineHeight: 1, color: 'text.secondary' }}>+</Typography>}
                          >
                            <MenuItem value="" disabled><em>Add to group…</em></MenuItem>
                            {programmeGroups
                              .filter(g => !(m.programme_groups_detail || []).some(mg => mg.id === g.id))
                              .map(g => <MenuItem key={g.id} value={g.id} sx={{ fontSize: 13 }}>{g.name}</MenuItem>)
                            }
                          </Select>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {m.assigned_bge_name || (m.co_assigned_bge_names || []).length > 0 ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                          {m.assigned_bge_name && (
                            <Chip
                              label={m.assigned_bge_name}
                              size="small"
                              color="success"
                              variant="outlined"
                              onClick={() => openAssignDialog(m)}
                              sx={{ cursor: 'pointer', fontSize: 11 }}
                            />
                          )}
                          {(m.co_assigned_bge_names || []).map(b => (
                            <Chip
                              key={b.id}
                              label={b.name}
                              size="small"
                              variant="outlined"
                              sx={{ fontSize: 11, borderColor: '#7B1FA2', color: '#7B1FA2' }}
                            />
                          ))}
                        </Box>
                      ) : (
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<People fontSize="small" />}
                          onClick={() => openAssignDialog(m)}
                          sx={{ fontSize: 11, py: 0.3, px: 1 }}
                        >
                          Assign
                        </Button>
                      )}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: 12 }}>
                        <LocationOn sx={{ fontSize: 14, color: 'text.secondary' }} />{m.city}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      {m.total_reports > 0 ? (
                        <Chip label={m.total_reports} size="small" color="primary" variant="outlined" />
                      ) : (
                        <Typography variant="caption" color="text.disabled">—</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {m.last_support_date ? (
                        <Typography variant="caption" color={
                          // highlight recent (within 30 days) vs stale (>90 days)
                          (new Date() - new Date(m.last_support_date)) / 86400000 < 30
                            ? 'success.main'
                            : (new Date() - new Date(m.last_support_date)) / 86400000 > 90
                              ? 'warning.main'
                              : 'text.primary'
                        }>{m.last_support_date}</Typography>
                      ) : (
                        <Typography variant="caption" color="text.disabled">No visits yet</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {(() => {
                        const snaps = adminSnapshots.filter(s => s.msme === m.id);
                        if (!snaps.length) return <Typography variant="caption" color="text.disabled">—</Typography>;
                        const latest = snaps.sort((a, b) => new Date(b.snapshot_date) - new Date(a.snapshot_date))[0];
                        const days = Math.floor((new Date() - new Date(latest.snapshot_date)) / 86400000);
                        const color = days <= 30 ? 'success.main' : days <= 90 ? 'warning.main' : 'error.main';
                        return (
                          <Tooltip title={`${snaps.length} update${snaps.length !== 1 ? 's' : ''}`}>
                            <Typography variant="caption" color={color}>{latest.snapshot_date}</Typography>
                          </Tooltip>
                        );
                      })()}
                    </TableCell>
                    <TableCell><ActionCell item={m} type="msme" /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div" count={msmeTotalCount} page={msmePage}
              rowsPerPage={50} rowsPerPageOptions={[50]}
              onPageChange={(_, p) => setMsmePage(p)}
            />
          </TableContainer>
        </>
      )}
    </Box>
  );

  const renderMaps = () => (
    <Box>
      <SectionHeader title="Northern Uganda Spatial Location Maps" subtitle="Interactive spatial GPS mapping for MSMEs & BGE Experts" />
      <MSMEMap
        msmes={allMsmes.length > 0 ? allMsmes : msmes}
        experts={experts}
        cohorts={cohorts}
        programmeGroups={programmeGroups}
        onOpenMsme={(m) => {
          setViewItem(m);
          setViewType('msme');
        }}
        onOpenExpert={(e) => {
          openExpertView(e);
        }}
      />
    </Box>
  );

  // ── Overview / Home Dashboard ─────────────────────────────────────────────
  const renderOverview = () => {
    const A = analytics || {};

    const totalMsmes     = A.total_msmes  || (allMsmes.length > 0 ? allMsmes.length : (msmeTotalCount || msmes.length));
    const totalBges      = A.total_bges   || experts.length;
    const totalSessions  = trainingSessions.length;
    const totalReports   = (A.total_reports || 0) + (A.total_group_reports || 0);
    const totalGroups    = A.total_groups  || bgeGroups.length;
    // const totalRevenue = fmt(A.total_annual_revenue);  // reserved for future use
    // const diag_total  = A.diag_total || 0;            // reserved for future use

    // Employees from latest data-update snapshots
    const snapEmp        = A.snapshot_employees || {};
    const totalEmployees = A.total_employees || 0;
    const ftTotal        = (snapEmp.ft_male || 0) + (snapEmp.ft_female || 0);
    const ptTotal        = (snapEmp.pt_male || 0) + (snapEmp.pt_female || 0);
    const refugeeTotal   = (snapEmp.ft_refugee || 0) + (snapEmp.pt_refugee || 0);
    const empSub         = totalEmployees
      ? `FT ${ftTotal} · PT ${ptTotal}${refugeeTotal ? ` · Refugee ${refugeeTotal}` : ''}`
      : 'from latest data updates';

    const kpiCards = [
      { val: totalMsmes,    label: 'MSMEs Enrolled',   sub: 'programme participants', color: BRAND.primaryMain,   key: 'msmes' },
      { val: totalBges,     label: 'BGE Experts',      sub: 'coaches in field',       color: BRAND.gizRed,        key: 'experts' },
      { val: totalSessions, label: 'Training Sessions',sub: 'conducted to date',      color: BRAND.gopaGoldDark,  key: 'training' },
      { val: totalReports,  label: 'Reports Filed',    sub: 'MSME + group visits',    color: BRAND.programmeGreen,key: 'reports' },
      { val: totalGroups,   label: 'BGE Groups',       sub: 'active teams',           color: BRAND.proSlate,      key: 'bgegroups' },
      { val: totalEmployees,label: 'Total Employees',  sub: empSub,                   color: '#44403C',           key: 'analytics' },
    ];

    const quickLinks = [
      { key: 'msmes',         label: 'MSMEs',             icon: <Business />,      desc: 'Browse and manage enrolled businesses' },
      { key: 'experts',       label: 'BGE Experts',       icon: <People />,        desc: 'View coach profiles and assignments' },
      { key: 'training',      label: 'Training',          icon: <School />,        desc: 'Sessions, attendance and reports' },
      { key: 'reports',       label: 'Reports',           icon: <PictureAsPdf />,  desc: 'Field visit and mentor reports' },
      { key: 'analytics',     label: 'Analytics',         icon: <Assessment />,    desc: 'Programme-wide insights and trends' },
      { key: 'participation', label: 'Participation',     icon: <TrendingUp />,    desc: 'Per-session MSME participation' },
      { key: 'workorders',    label: 'Work Orders',       icon: <Assignment />,    desc: 'Issue and track BGE work orders' },
      { key: 'bgeassignment', label: 'BGE Assignment',    icon: <LocationOn />,    desc: 'Smart focal-person assignment by proximity & engagement' },
      { key: 'communications',label: 'Communications',    icon: <Campaign />,      desc: 'Email MSMEs and send bulk messages' },
    ];

    // Upcoming / recent sessions
    const today = new Date().toISOString().slice(0, 10);
    const upcoming = trainingSessions
      .filter(s => s.date >= today)
      .sort((a, b) => a.date.localeCompare(b.date))
      .slice(0, 4);
    const recent = trainingSessions
      .filter(s => s.date < today)
      .sort((a, b) => b.date.localeCompare(a.date))
      .slice(0, 4);

    return (
      <Box>
        {/* ── Welcome bar ── */}
        <Box sx={{
          mb: 3, p: 2.5, borderRadius: 2,
          background: `linear-gradient(135deg, ${BRAND.sidebarBg} 0%, #353330 60%, #191817 100%)`,
          color: '#fff',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 16px rgba(38,37,35,0.15)',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0, left: 0, right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${BRAND.gopaGold} 0%, ${BRAND.gopaGold} 52%, ${BRAND.gizRed} 52%, ${BRAND.gizRed} 100%)`,
          },
        }}>
          <Typography variant="h5" fontWeight={800} gutterBottom>
            PRUDEV II Programme Dashboard
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Welcome back{currentUser?.name ? `, ${currentUser.name}` : ''}. Here's the programme at a glance.
          </Typography>
        </Box>

        {/* ── KPI cards ── */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {kpiCards.map(({ val, label, sub, color, key }) => (
            <Grid item xs={6} sm={4} lg={2} key={key}>
              <Card
                variant="outlined"
                sx={{ height: '100%', borderLeft: `4px solid ${color}`, cursor: 'pointer', '&:hover': { boxShadow: 3 } }}
                onClick={() => startTransition(() => setSection(key))}
              >
                <CardContent sx={{ pb: '12px !important', pt: '14px !important' }}>
                  <Typography variant="h5" fontWeight={800} color={color}>{val}</Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.2, mt: 0.5 }}>{label}</Typography>
                  <Typography variant="caption" color="text.secondary">{sub}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* ── Highlight cards ── */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined" sx={{ height: '100%', borderTop: `3px solid ${BRAND.primaryMain}` }}>
              <CardContent>
                <Typography variant="overline" color="text.secondary">Active BGEs (Last 30 Days)</Typography>
                <Typography variant="h4" fontWeight={800} color={BRAND.primaryMain}>
                  {A.active_bges_30d ?? '—'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  BGEs who filed a report or data update · out of {totalBges} total
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined" sx={{ height: '100%', borderTop: '3px solid #2E7D32' }}>
              <CardContent>
                <Typography variant="overline" color="text.secondary">Data Update Coverage</Typography>
                <Typography variant="h4" fontWeight={800} color="#2E7D32">
                  {A.msmes_with_updates ?? '—'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  MSMEs with at least one data update
                  {totalMsmes > 0 && A.msmes_with_updates != null
                    ? ` (${Math.round(A.msmes_with_updates / totalMsmes * 100)}% of enrolled)`
                    : ''}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card variant="outlined" sx={{ height: '100%', borderTop: `3px solid ${BRAND.gopaGoldDark}` }}>
              <CardContent>
                <Typography variant="overline" color="text.secondary">Training Engagement</Typography>
                <Typography variant="h4" fontWeight={800} color={BRAND.gopaGoldDark}>{totalSessions}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Sessions held · {trainingSessions.reduce((t, s) => t + (s.attendance_count || 0), 0)} total attendances
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* ── Spatial Map Overview ── */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="overline" color="text.secondary" fontWeight={700}>
              Northern Uganda Spatial Deployment Map
            </Typography>
            <Button
              size="small"
              variant="text"
              endIcon={<ArrowForward fontSize="small" />}
              onClick={() => startTransition(() => setSection('maps'))}
              sx={{ textTransform: 'none', fontSize: 12, fontWeight: 600 }}
            >
              Full Spatial View →
            </Button>
          </Box>
          <MSMEMap
            msmes={allMsmes.length > 0 ? allMsmes : msmes}
            experts={experts}
            cohorts={cohorts}
            programmeGroups={programmeGroups}
            onOpenMsme={(m) => {
              setViewItem(m);
              setViewType('msme');
            }}
            onOpenExpert={(e) => {
              openExpertView(e);
            }}
          />
        </Box>

        {/* ── Quick links grid ── */}
        <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>Quick Access</Typography>
        <Grid container spacing={1.5} sx={{ mb: 3 }}>
          {quickLinks.map(({ key, label, icon, desc }) => (
            <Grid item xs={12} sm={6} md={3} key={key}>
              <Card
                variant="outlined"
                sx={{ cursor: 'pointer', '&:hover': { boxShadow: 3, borderColor: BRAND.primaryMain } }}
                onClick={() => startTransition(() => setSection(key))}
              >
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: '12px !important' }}>
                  <Box sx={{ color: BRAND.primaryMain, display: 'flex', flexShrink: 0 }}>{icon}</Box>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="subtitle2" fontWeight={700}>{label}</Typography>
                    <Typography variant="caption" color="text.secondary" noWrap>{desc}</Typography>
                  </Box>
                  <ArrowForward fontSize="small" sx={{ ml: 'auto', color: 'text.disabled', flexShrink: 0 }} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* ── Upcoming & recent sessions ── */}
        {(upcoming.length > 0 || recent.length > 0) && (
          <Grid container spacing={2}>
            {upcoming.length > 0 && (
              <Grid item xs={12} md={6}>
                <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                  <TaskAlt fontSize="inherit" sx={{ mr: 0.5, verticalAlign: 'middle', color: '#2E7D32' }} />
                  Upcoming Sessions
                </Typography>
                <Paper variant="outlined">
                  {upcoming.map((s, i) => (
                    <Box key={s.id} sx={{ px: 2, py: 1.5, borderBottom: i < upcoming.length - 1 ? '1px solid #eee' : 'none',
                      display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EventNote fontSize="small" sx={{ color: BRAND.gopaGoldDark }} />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" fontWeight={600} noWrap>{s.title}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {s.date} · {(s.team || []).find(m => m.role === 'lead')?.bge_name || 'Lead TBC'}
                        </Typography>
                      </Box>
                      <Chip label={`${s.attendance_count ?? 0} attending`} size="small" />
                    </Box>
                  ))}
                </Paper>
              </Grid>
            )}
            {recent.length > 0 && (
              <Grid item xs={12} md={6}>
                <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                  <School fontSize="inherit" sx={{ mr: 0.5, verticalAlign: 'middle', color: BRAND.gizRed }} />
                  Recent Sessions
                </Typography>
                <Paper variant="outlined">
                  {recent.map((s, i) => (
                    <Box key={s.id} sx={{ px: 2, py: 1.5, borderBottom: i < recent.length - 1 ? '1px solid #eee' : 'none',
                      display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EventNote fontSize="small" sx={{ color: BRAND.gizRed }} />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" fontWeight={600} noWrap>{s.title}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {s.date} · {(s.team || []).find(m => m.role === 'lead')?.bge_name || 'No lead'}
                        </Typography>
                      </Box>
                      <Chip label={`${s.attendance_count ?? 0} attended`} size="small" variant="outlined" />
                    </Box>
                  ))}
                </Paper>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    );
  };

  const renderExperts = () => (
    <Box>
      <SectionHeader title="BGE Experts" subtitle={`${experts.length} experts`}>
        {isStaff && (
          <>
            <Button variant="contained" startIcon={<Add />} size="small" onClick={openBgeDialog}>
              Add BGE
            </Button>
            <Button variant="outlined" startIcon={<Upload />} size="small" onClick={openBgeUpload} sx={{ ml: 1 }}>
              Import BGE Excel
            </Button>
          </>
        )}
      </SectionHeader>

      <Alert severity="info" sx={{ mb: 2 }} icon={false}>
        Upload your <strong>PRUDEV II BGE list</strong> Excel file. Required columns: <code>Full name</code>, <code>Phone number</code>, <code>Email address</code>, <code>Location</code>, <code>BGE code</code>. Existing experts are updated by name unless you choose to skip duplicates.
      </Alert>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>BGE Code</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Assigned MSMEs</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginate(experts, expertPage).length === 0 ? (
              <TableRow><TableCell colSpan={7} align="center" sx={{ py: 4, color: 'text.secondary' }}>No experts yet — use Import BGE Excel to upload your list</TableCell></TableRow>
            ) : paginate(experts, expertPage).map(e => (
              <TableRow key={e.id} hover>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar sx={{ width: 28, height: 28, fontSize: 12, bgcolor: BRAND.primaryMain }}>{(e.name || '?')[0]}</Avatar>
                    <Box>
                      <Typography variant="body2" fontWeight={500}>{e.name}</Typography>
                      {e.email && <Typography variant="caption" color="text.secondary">{e.email}</Typography>}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  {e.bge_code
                    ? <Chip label={e.bge_code} size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: 11 }} />
                    : <Typography variant="caption" color="text.disabled">—</Typography>}
                </TableCell>
                <TableCell><Typography variant="body2">{e.phone || '—'}</Typography></TableCell>
                <TableCell>{e.location}</TableCell>
                <TableCell>
                  <Badge badgeContent={e.assigned_msme_count} color="primary" showZero>
                    <Business fontSize="small" color="action" />
                  </Badge>
                </TableCell>
                <TableCell>
                  {(() => {
                    const sInfo = getStatusInfo(e.status);
                    return (
                      <Tooltip title={isStaff ? "Click to change BGE status" : `Status: ${sInfo.label}`}>
                        <Chip
                          label={sInfo.label}
                          size="small"
                          onClick={isStaff ? (ev) => openStatusMenu(ev, e, 'expert') : undefined}
                          sx={{
                            cursor: isStaff ? 'pointer' : 'default',
                            fontWeight: 600,
                            fontSize: 11,
                            bgcolor: sInfo.bgcolor,
                            color: sInfo.textColor,
                            border: `1px solid ${sInfo.border}`,
                            '&:hover': isStaff ? { opacity: 0.85, transform: 'scale(1.02)' } : {},
                            transition: 'all 0.15s ease',
                          }}
                        />
                      </Tooltip>
                    );
                  })()}
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title={e.email ? `Preview & send MSME list to ${e.email}` : 'No email on record'}>
                      <span>
                        <IconButton
                          size="small"
                          disabled={!e.email || emailingBgeId === e.id}
                          onClick={() => previewBgeEmail(e)}
                          color="primary"
                        >
                          {emailingBgeId === e.id
                            ? <CircularProgress size={16} />
                            : <Email fontSize="small" />}
                        </IconButton>
                      </span>
                    </Tooltip>
                    {isStaff && (
                      <Tooltip title={e.user_id ? 'Resend welcome email/SMS' : 'Provision login account and send welcome email/SMS'}>
                        <span>
                          <IconButton
                            size="small"
                            color="secondary"
                            disabled={provisioningBgeId === e.id}
                            onClick={() => provisionBgeAccount(e)}
                          >
                            {provisioningBgeId === e.id
                              ? <CircularProgress size={16} />
                              : <LockOpen fontSize="small" />}
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                    <ActionCell item={e} type="expert" />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div" count={experts.length} page={expertPage}
          rowsPerPage={ROWS_PER_PAGE} rowsPerPageOptions={[ROWS_PER_PAGE]}
          onPageChange={(_, p) => setExpertPage(p)}
        />
      </TableContainer>
    </Box>
  );

  const renderBGEGroups = () => (
    <Box>
      <SectionHeader title="BGE Groups" subtitle="Organise experts into teams">
        <Button variant="contained" startIcon={<Add />} size="small" onClick={() => setGroupDialog(true)}>
          New Group
        </Button>
      </SectionHeader>

      <Grid container spacing={2}>
        {bgeGroups.length === 0 ? (
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ py: 6, textAlign: 'center', color: 'text.secondary' }}>
              No BGE groups yet. Create one to start organising experts.
            </Paper>
          </Grid>
        ) : bgeGroups.map(group => (
          <Grid item xs={12} md={6} lg={4} key={group.id}>
            <Card variant="outlined">
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight={600}>{group.name}</Typography>
                    {group.description && <Typography variant="caption" color="text.secondary">{group.description}</Typography>}
                  </Box>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Manage members">
                      <IconButton size="small" onClick={() => setManageGroupItem(group)}><People fontSize="small" /></IconButton>
                    </Tooltip>
                    {isAdmin && (
                      <Tooltip title="Assign MSMEs">
                        <IconButton size="small" onClick={() => openAssignMsmeDialog(group)}>
                          <Assignment fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    {isStaff && (
                      <Tooltip title="Delete group">
                        <IconButton size="small" color="error" onClick={() => { setDeleteItem(group); setDeleteType('group'); }}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                  <Chip size="small" icon={<People sx={{ fontSize: 14 }} />}
                        label={`${group.member_count} member${group.member_count !== 1 ? 's' : ''}`} />
                  <Chip size="small" icon={<Business sx={{ fontSize: 14 }} />}
                        label={`${group.msme_count != null ? group.msme_count : (allMsmes.length > 0 ? allMsmes : msmes).filter(m => m.assigned_group === group.id).length} MSMEs`}
                        color="primary" variant="outlined" />
                  {group.team_lead_name && (
                    <Chip size="small" icon={<Star sx={{ fontSize: 14 }} />}
                          label={`Lead: ${group.team_lead_name}`}
                          color="warning" variant="outlined" />
                  )}
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {group.members_detail?.slice(0, 5).map(m => (
                    <Chip key={m.id} avatar={<Avatar sx={{ fontSize: 10 }}>{(m.name || '?')[0]}</Avatar>} label={m.name} size="small" />
                  ))}
                  {group.member_count > 5 && <Chip label={`+${group.member_count - 5} more`} size="small" variant="outlined" />}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  const renderCohorts = () => (
    <Box>
      <SectionHeader title="Cohorts" subtitle="Group MSMEs by programme cohort">
        <Button variant="contained" startIcon={<Add />} size="small" onClick={() => setCohortDialog(true)}>
          New Cohort
        </Button>
      </SectionHeader>

      <Grid container spacing={2}>
        {cohorts.length === 0 ? (
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ py: 6, textAlign: 'center', color: 'text.secondary' }}>No cohorts yet.</Paper>
          </Grid>
        ) : cohorts.map(c => (
          <Grid item xs={12} sm={6} md={4} key={c.id}>
            <Card
              variant="outlined"
              sx={{ cursor: 'pointer', '&:hover': { boxShadow: 2 } }}
              onClick={() => { setFilterCohort(c.id); startTransition(() => setSection('msmes')); }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="h6" fontWeight={700}>{c.name}</Typography>
                    {c.description && <Typography variant="caption" color="text.secondary">{c.description}</Typography>}
                  </Box>
                  {isAdmin && (
                    <IconButton size="small" color="error"
                      onClick={ev => { ev.stopPropagation(); setDeleteItem(c); setDeleteType('cohort'); }}
                    ><Delete fontSize="small" /></IconButton>
                  )}
                </Box>
                <Divider sx={{ my: 1.5 }} />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="h4" fontWeight={700} color="primary">{c.msme_count}</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                    <Typography variant="body2">MSMEs</Typography>
                    <ChevronRight fontSize="small" />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  const renderTraining = () => (
    <Box>
      {/* ── Training Sessions ── */}
      <SectionHeader title="Training Sessions" subtitle={`${trainingSessions.length} sessions`}>
        <Button variant="contained" startIcon={<Add />} size="small" onClick={() => { setSessionEditing(null); setSessionForm(EMPTY_SESSION_FORM); setSessionDialog(true); }}>
          New Session
        </Button>
      </SectionHeader>

      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 520, overflowY: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>Title</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>Date</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>Lead BGE</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>Mentors</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>MSMEs</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>BGE Participants</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>Attendance</TableCell>
              <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginate(trainingSessions, sessionPage).length === 0 ? (
              <TableRow><TableCell colSpan={7} align="center" sx={{ py: 4, color: 'text.secondary' }}>No sessions yet</TableCell></TableRow>
            ) : paginate(trainingSessions, sessionPage).map(s => (
              <TableRow key={s.id} hover>
                <TableCell sx={{ fontWeight: 500 }}>{s.title}</TableCell>
                <TableCell>{s.date}</TableCell>
                <TableCell>{(s.team || []).find(m => m.role === 'lead')?.bge_name || '—'}</TableCell>
                <TableCell>
                  {(s.team || []).filter(m => m.role === 'mentor').length > 0
                    ? <Chip label={`${(s.team || []).filter(m => m.role === 'mentor').length} mentor${(s.team || []).filter(m => m.role === 'mentor').length !== 1 ? 's' : ''}`} size="small" color="secondary" />
                    : <Typography variant="caption" color="text.secondary">—</Typography>}
                </TableCell>
                <TableCell>
                  {(s.businesses_detail || []).length > 0
                    ? <Chip label={`${s.businesses_detail.length} MSME${s.businesses_detail.length !== 1 ? 's' : ''}`} size="small" color="info" />
                    : <Typography variant="caption" color="text.secondary">—</Typography>}
                </TableCell>
                <TableCell>
                  {(s.bge_participants_detail || []).length > 0
                    ? <Chip label={`${s.bge_participants_detail.length} BGE${s.bge_participants_detail.length !== 1 ? 's' : ''}`} size="small" color="secondary" />
                    : <Typography variant="caption" color="text.secondary">—</Typography>}
                </TableCell>
                <TableCell><Chip icon={<EventNote />} label={`${s.attendance_count ?? 0} present`} size="small" /></TableCell>
                <TableCell>
                  <Tooltip title="Edit session">
                    <IconButton size="small" onClick={() => openSessionEdit(s)}><Edit fontSize="small" /></IconButton>
                  </Tooltip>
                  <Tooltip title={`Notify ${(s.businesses_detail || []).length} MSME${(s.businesses_detail || []).length !== 1 ? 's' : ''} by email`}>
                    <span>
                      <IconButton size="small" color="secondary" disabled={!(s.businesses_detail || []).length}
                        onClick={() => openSessionNotify(s)}>
                        <Email fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Mark attendance">
                    <IconButton size="small" color="primary" onClick={() => openAttendance(s)}><CheckCircle fontSize="small" /></IconButton>
                  </Tooltip>
                  <Tooltip title="Delete session">
                    <IconButton size="small" color="error" onClick={() => deleteSession(s)}><Delete fontSize="small" /></IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div" count={trainingSessions.length} page={sessionPage}
          rowsPerPage={ROWS_PER_PAGE} rowsPerPageOptions={[ROWS_PER_PAGE]}
          onPageChange={(_, p) => setSessionPage(p)}
        />
      </TableContainer>
    </Box>
  );

  // Brand-aligned palette for charts
  const CHART_PALETTE = [
    '#262523', '#C8102E', '#D97706', '#009B62', '#6A6E6B',
    '#8D5B4C', '#B45309', '#44403C', '#991B1B', '#047857',
  ];

  // Drill-down filter state for the analytics page
  const [analyticsFilter, setAnalyticsFilter] = useState({
    cohort: '', district: '', sector: '', bge: '',
  });
  const [richAnalytics, setRichAnalytics] = useState(null);
  const [analyticTab, setAnalyticTab] = useState(0);

  // ── growth snapshots (admin view) ─────────────────────────────────────────
  const [adminSnapshots, setAdminSnapshots] = useState([]);
  const [adminSnapshotsLoading, setAdminSnapshotsLoading] = useState(false);
  const [msmeDetailTab, setMsmeDetailTab] = useState(0);
  const [snapshotFilterBge, setSnapshotFilterBge] = useState('');
  const [snapshotFilterSource, setSnapshotFilterSource] = useState('');
  const [snapshotPage, setSnapshotPage] = useState(0);
  const [viewSnapshot, setViewSnapshot] = useState(null);

  // ── diagnostic baseline analytics state ───────────────────────────────────
  const [diagSummary, setDiagSummary] = useState(null);
  const [diagCohorts, setDiagCohorts] = useState(null);
  const [diagLoading, setDiagLoading] = useState(false);
  const [diagCohortFilter, setDiagCohortFilter] = useState('all');
  const [diagExportLoading, setDiagExportLoading] = useState(false);

  const fetchDiagnosticData = useCallback((cohortFilter = 'all') => {
    if (!token) return;
    setDiagLoading(true);
    const summaryUrl = cohortFilter && cohortFilter !== 'all'
      ? `${API_ENDPOINTS.DIAGNOSTIC_SUMMARY}?cohort=${encodeURIComponent(cohortFilter)}`
      : API_ENDPOINTS.DIAGNOSTIC_SUMMARY;

    Promise.all([
      axios.get(summaryUrl, { headers: { Authorization: `Bearer ${token}` } }),
      axios.get(API_ENDPOINTS.DIAGNOSTIC_COHORTS, { headers: { Authorization: `Bearer ${token}` } }),
    ])
      .then(([sumRes, cohortRes]) => {
        setDiagSummary(sumRes.data);
        setDiagCohorts(cohortRes.data);
      })
      .catch(err => {
        console.error('Failed to load diagnostic analytics:', err);
      })
      .finally(() => setDiagLoading(false));
  }, [token]);

  useEffect(() => {
    if (!token || (section !== 'analytics' && section !== 'reports')) return;
    fetchDiagnosticData(diagCohortFilter);
  }, [token, section, diagCohortFilter, fetchDiagnosticData]);

  // Fetch all growth snapshots for the admin view (MSMEs table + analytics + reports).
  // Runs once on mount and whenever section switches to msmes/analytics/reports.
  useEffect(() => {
    if (!token) return;
    if (section !== 'msmes' && section !== 'analytics' && section !== 'reports') return;
    setAdminSnapshotsLoading(true);
    axios.get(API_ENDPOINTS.GROWTH_SNAPSHOTS, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        const data = Array.isArray(r.data) ? r.data : (r.data.results || []);
        setAdminSnapshots(data);
      })
      .catch(err => {
        if (!axios.isCancel(err)) console.error('Failed to load growth snapshots:', err);
      })
      .finally(() => setAdminSnapshotsLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, section]);

  // Refetch analytics whenever the filter changes — debounced + cancellable.
  // Without this the page fired a request on every Select change and a slow
  // response could overwrite a fresher one.
  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();
    const handle = setTimeout(async () => {
      const params = new URLSearchParams();
      Object.entries(analyticsFilter).forEach(([k, v]) => { if (v) params.append(k, v); });
      try {
        const r = await axios.get(
          `${API_ENDPOINTS.MSMES}analytics/?${params}`,
          { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal },
        );
        setRichAnalytics(r.data || null);
      } catch (e) {
        if (!axios.isCancel(e) && e.name !== 'CanceledError') {
          // Drop back to the unfiltered baseline so charts don't blank out
          setRichAnalytics(null);
        }
      }
    }, 250);
    return () => { clearTimeout(handle); controller.abort(); };
  }, [token, analyticsFilter]);

  // Prefer the filtered payload, else the baseline `analytics` state, else
  // an empty object so chart components don't crash on undefined.
  const A = (richAnalytics && Object.keys(richAnalytics).length > 0)
    ? richAnalytics
    : (analytics || {});

  // Helper: convert a [{key:value, count}] list into recharts shape
  const pieData = (rows, labelKey) =>
    (rows || []).map(r => ({ name: r[labelKey] || 'Unspecified', value: r.count }));

  const DiagnosticImporter = ({ token: tok, onImported, isAdmin: admin }) => {
    const [file, setFile] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [result, setResult] = React.useState(null);
    const [error, setError] = React.useState(null);
    const doImport = () => {
      if (!file) return;
      setLoading(true); setResult(null); setError(null);
      const fd = new FormData(); fd.append('file', file);
      axios.post(`${API_ENDPOINTS.MSMES}import-diagnostics/`, fd,
        { headers: { Authorization: `Bearer ${tok}`, 'Content-Type': 'multipart/form-data' } })
        .then(r => { setResult(r.data.detail); setLoading(false); onImported(); })
        .catch(e => {
          setError(getErrorMessage(e, `HTTP ${e.response?.status || '500'}: Import failed`));
          setLoading(false);
        });
    };
    if (!admin) return (
      <Alert severity="info">No diagnostic baseline data yet. Contact an admin to import the diagnostics Excel.</Alert>
    );
    return (
      <Box sx={{ p: 3, border: '1px dashed #ccc', borderRadius: 2, maxWidth: 480 }}>
        <Typography variant="subtitle1" fontWeight={700} gutterBottom>Import Diagnostic Baseline</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Upload the <em>PRUDEV_II_MSMEs_Categorized_Output.xlsx</em> file to populate the diagnostic dashboard.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
          <Button variant="outlined" component="label" size="small">
            {file ? file.name : 'Choose Excel file'}
            <input type="file" hidden accept=".xlsx,.xls" onChange={e => setFile(e.target.files[0])} />
          </Button>
          <Button variant="contained" size="small" disabled={!file || loading} onClick={doImport}>
            {loading ? 'Importing…' : 'Import'}
          </Button>
        </Box>
        {result && <Alert severity="success" sx={{ mt: 2 }}><pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 12 }}>{result}</pre></Alert>}
        {error  && <Alert severity="error"   sx={{ mt: 2 }}><pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 11, maxHeight: 200, overflow: 'auto' }}>{error}</pre></Alert>}
      </Box>
    );
  };

  const renderAnalytics = () => {
    const monthlyData = (A.time_series || []).map(t => ({
      month: t.month ? new Date(t.month).toLocaleString('en', { month: 'short', year: '2-digit' }) : '?',
      MSMEs: t.count,
    }));
    // ── shared sub-components ────────────────────────────────────────────────
    const KPI = ({ val, label, sub, color = BRAND.primaryMain, pct }) => (
      <Card sx={{ height: '100%', borderLeft: `4px solid ${color}` }} variant="outlined">
        <CardContent sx={{ pb: '12px !important', pt: '14px !important' }}>
          <Typography variant="h5" fontWeight={800} color={color}>{val}</Typography>
          <Typography variant="body2" fontWeight={600} sx={{ mt: 0.25 }}>{label}</Typography>
          {sub  && <Typography variant="caption" color="text.secondary">{sub}</Typography>}
          {pct != null && (
            <Box sx={{ mt: 0.75 }}>
              <LinearProgress variant="determinate" value={Math.min(pct, 100)}
                sx={{ height: 5, borderRadius: 3, bgcolor: '#E8EDF2', '& .MuiLinearProgress-bar': { bgcolor: color } }} />
              <Typography variant="caption" color="text.secondary">{pct.toFixed(0)}%</Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    );
    const ChartCard = ({ title, subtitle, children, height = 260, action }) => (
      <Card variant="outlined" sx={{ height: '100%' }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
            <Box>
              <Typography variant="subtitle2" fontWeight={700}>{title}</Typography>
              {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
            </Box>
            {action}
          </Box>
          <Box sx={{ width: '100%', height }}>{children}</Box>
        </CardContent>
      </Card>
    );
    const SectionLabel = ({ children }) => (
      <Typography variant="overline" color="text.secondary" fontWeight={700}
        sx={{ display: 'block', mb: 1, mt: 0.5, letterSpacing: 1.2 }}>{children}</Typography>
    );
    const ComplianceStat = ({ label, count, total, color }) => (
      <Box sx={{ mb: 1.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
          <Typography variant="body2">{label}</Typography>
          <Typography variant="body2" fontWeight={700} color={color}>
            {count} <Typography component="span" variant="caption" color="text.secondary">/ {total}</Typography>
          </Typography>
        </Box>
        <LinearProgress variant="determinate" value={total ? (count / total) * 100 : 0}
          sx={{ height: 8, borderRadius: 4, bgcolor: '#E8EDF2', '& .MuiLinearProgress-bar': { bgcolor: color, borderRadius: 4 } }} />
      </Box>
    );

    const totalMsmes = A.total_msmes || 0;
    const diagTotal  = A.diag_total  || 0;
    const dropFilters = () => setAnalyticsFilter({ cohort: '', district: '', sector: '', bge: '' });
    const hasFilters = !!(analyticsFilter.cohort || analyticsFilter.district || analyticsFilter.sector || analyticsFilter.bge);

    // Band sort order for turnover/assets charts
    const bandOrder = ['Up to 10 million UGX', '10 – 100 million UGX', '100 – 360 million UGX', 'More than 360 million UGX'];
    const shortBand = s => (s || '').replace(' million UGX','M').replace('More than ','> ').replace('Up to ','< ').trim();
    const turnoverData = [...(A.diag_turnover_bands || [])].sort((a,b)=>bandOrder.indexOf(a.diag_annual_turnover)-bandOrder.indexOf(b.diag_annual_turnover)).map(b=>({name:shortBand(b.diag_annual_turnover),count:b.count}));
    const assetData    = [...(A.diag_asset_bands    || [])].sort((a,b)=>bandOrder.indexOf(a.diag_total_assets   )-bandOrder.indexOf(b.diag_total_assets   )).map(b=>({name:shortBand(b.diag_total_assets),    count:b.count}));

    return (
      <Box>
        <SectionHeader title="Analytics" subtitle="Programme intelligence dashboard" />

        {/* ── Filter bar ─────────────────────────────────────────────────── */}
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
              <Typography variant="caption" fontWeight={700} sx={{ color: 'text.secondary', display: { xs: 'none', sm: 'block' } }}>FILTER</Typography>
              <FormControl size="small" sx={{ flex: '1 1 120px', minWidth: 0 }}>
                <InputLabel>Cohort</InputLabel>
                <Select label="Cohort" value={analyticsFilter.cohort}
                  onChange={e => setAnalyticsFilter(f => ({ ...f, cohort: e.target.value }))}>
                  <MenuItem value="">All</MenuItem>
                  {cohorts.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ flex: '1 1 120px', minWidth: 0 }}>
                <InputLabel>District</InputLabel>
                <Select label="District" value={analyticsFilter.district}
                  onChange={e => setAnalyticsFilter(f => ({ ...f, district: e.target.value }))}>
                  <MenuItem value="">All</MenuItem>
                  {(A.top_districts || []).map(d => <MenuItem key={d.state} value={d.state}>{d.state}</MenuItem>)}
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ flex: '1 1 120px', minWidth: 0 }}>
                <InputLabel>Sector</InputLabel>
                <Select label="Sector" value={analyticsFilter.sector}
                  onChange={e => setAnalyticsFilter(f => ({ ...f, sector: e.target.value }))}>
                  <MenuItem value="">All</MenuItem>
                  {(A.sector_stats || []).map(s => <MenuItem key={s.sector} value={s.sector}>{s.sector}</MenuItem>)}
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ flex: '1 1 140px', minWidth: 0 }}>
                <InputLabel>BGE</InputLabel>
                <Select label="BGE" value={analyticsFilter.bge}
                  onChange={e => setAnalyticsFilter(f => ({ ...f, bge: e.target.value }))}>
                  <MenuItem value="">All</MenuItem>
                  {experts.map(e => <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>)}
                </Select>
              </FormControl>
              {hasFilters && <Button size="small" onClick={dropFilters}>Clear</Button>}
              {hasFilters && <Chip size="small" label="Filtered view" color="warning" variant="outlined" />}
            </Box>
          </CardContent>
        </Card>

        {/* ── Tab navigation ──────────────────────────────────────────────── */}
        <Paper variant="outlined" sx={{ mb: 2 }}>
          <Tabs value={analyticTab} onChange={(_, v) => setAnalyticTab(v)}
            textColor="primary" indicatorColor="primary" variant="scrollable" scrollButtons="auto">
            <Tab label="Programme Health"  />
            <Tab label="Growth & Impact"   />
            <Tab label="Operations"        />
            <Tab label="Business Profiles" />
            <Tab label="Data Updates"      />
            <Tab label="Diagnostic Baselines & Cohorts" />
          </Tabs>
        </Paper>

        {/* ════════════════════════════════════════════════════════════════
            TAB 0 — Overview
            ════════════════════════════════════════════════════════════════ */}
        {analyticTab === 0 && (
          <Box>
            {/* ── Programme context banner ── */}
            <Box sx={{ mb: 2.5, p: 2, bgcolor: '#F0F4FA', borderRadius: 2, borderLeft: `4px solid ${BRAND.primaryMain}` }}>
              <Typography variant="subtitle2" fontWeight={700} color={BRAND.primaryMain} gutterBottom>
                About PRUDEV II
              </Typography>
              <Typography variant="body2" color="text.secondary">
                PRUDEV II is a GIZ-funded business growth programme that enrols micro and small enterprises (MSMEs),
                assigns Business Growth Experts (BGEs) to coach them, and tracks progress through a series of
                field visits and growth updates. This dashboard shows the programme at a glance — use the other
                tabs to explore growth impact, operations performance, and the business baseline.
              </Typography>
            </Box>

            {/* ── Headline numbers ── */}
            <SectionLabel>Programme at a Glance</SectionLabel>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {[
                { val: totalMsmes,                                          label: 'MSMEs Enrolled',    sub: 'in filtered view',   color: BRAND.primaryMain },
                { val: A.total_bges || experts.length,                      label: 'BGE Experts',       sub: 'coaches in field',   color: BRAND.gizRed },
                { val: A.total_groups || 0,                                 label: 'BGE Groups',        sub: 'active teams',       color: BRAND.gopaGoldDark },
                { val: (A.total_reports||0)+(A.total_group_reports||0),     label: 'Reports Filed',     sub: 'MSME + group visits', color: '#2E7D32' },
                { val: A.total_employees || 0,                              label: 'Total Employees',   sub: 'from latest data updates', color: '#5D4037' },
                { val: fmt(A.total_annual_revenue),                         label: 'Total Revenue',     sub: 'self-reported',      color: '#7B1FA2' },
              ].map((k, i) => <Grid item xs={6} sm={4} lg={2} key={i}><KPI {...k} /></Grid>)}
            </Grid>

            {/* ── Attention required ── */}
            {(() => {
              if (adminSnapshotsLoading) return null;
              if (!adminSnapshots.length) return null;
              const now2 = new Date();
              const latB = {};
              adminSnapshots.forEach(s => {
                const cur = latB[s.msme];
                if (!cur || s.snapshot_date > cur.snapshot_date) latB[s.msme] = s;
              });
              const allLatest = Object.values(latB);
              const stale90 = allLatest.filter(s => (now2 - new Date(s.snapshot_date)) / 86400000 > 90);
              const firstB = {};
              adminSnapshots.forEach(s => {
                const cur = firstB[s.msme];
                if (!cur || s.snapshot_date < cur.snapshot_date) firstB[s.msme] = s;
              });
              const declining = allLatest.filter(s => {
                const f = firstB[s.msme];
                return f && f.id !== s.id &&
                  Number(f.annual_turnover) > 0 && Number(s.annual_turnover) > 0 &&
                  Number(s.annual_turnover) < Number(f.annual_turnover);
              });
              const zeroComp = allLatest.filter(s =>
                !s.has_tin && !s.has_ursb && !s.has_business_bank && !s.has_mobile_money && !s.has_sacco
              );
              const msmePool = allMsmes.length > 0 ? allMsmes : msmes;
              const noUpdate = msmePool.filter(m => !latB[m.id]);
              const attentionItems = [
                { count: stale90.length,   label: 'No update in 90+ days',   sub: 'BGE visit overdue',         color: '#E65100', severity: 'warning' },
                { count: noUpdate.length,  label: 'Never updated',           sub: 'no growth data at all',     color: '#C8102E', severity: 'error' },
                { count: declining.length, label: 'Declining revenue',       sub: 'latest < first update',     color: '#B71C1C', severity: 'error' },
                { count: zeroComp.length,  label: 'Zero compliance items',   sub: 'no TIN, URSB, Bank or SACCO', color: '#827717', severity: 'warning' },
              ].filter(a => a.count > 0);
              if (!attentionItems.length) return (
                <Alert severity="success" sx={{ mb: 3 }}>
                  All MSMEs with growth data are up-to-date and at least one compliance item is ticked.
                </Alert>
              );
              return (
                <>
                  <SectionLabel>Action Required</SectionLabel>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    {attentionItems.map((a, i) => (
                      <Grid item xs={12} sm={6} md={3} key={i}>
                        <Card variant="outlined" sx={{ borderLeft: `4px solid ${a.color}`, height: '100%' }}>
                          <CardContent sx={{ py: '14px !important' }}>
                            <Typography variant="h4" fontWeight={800} color={a.color}>{a.count}</Typography>
                            <Typography variant="body2" fontWeight={700}>{a.label}</Typography>
                            <Typography variant="caption" color="text.secondary">{a.sub}</Typography>
                            <Box sx={{ mt: 1 }}>
                              <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                → See Growth &amp; Impact tab for details
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </>
              );
            })()}

            {/* ── Enrolment trend & cohort ── */}
            <SectionLabel>Enrolment Over Time</SectionLabel>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={8}>
                <ChartCard title="MSMEs Onboarded Over Time" subtitle="Monthly additions — all cohorts" height={260}>
                  <ResponsiveContainer>
                    <AreaChart data={monthlyData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis dataKey="month" tick={{fontSize:11}}/>
                      <YAxis tick={{fontSize:11}}/>
                      <ReTooltip/>
                      <Area type="monotone" dataKey="MSMEs" stroke="#262523" fill="#262523" fillOpacity={0.18} strokeWidth={2}/>
                    </AreaChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <ChartCard title="By Cohort" subtitle="Enrolment per cohort" height={260}>
                  <ResponsiveContainer>
                    <BarChart data={(A.cohort_stats||[]).map(c=>({name:c.cohort__name||'Unassigned',count:c.count}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis dataKey="name" tick={{fontSize:10}}/>
                      <YAxis tick={{fontSize:11}}/>
                      <ReTooltip/>
                      <Bar dataKey="count" fill="#C8102E" radius={[4,4,0,0]}/>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
            </Grid>

            {/* ── Quick sector + gender split ── */}
            <SectionLabel>Who Is in the Programme?</SectionLabel>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={4}>
                <ChartCard title="Business Type" subtitle="Scale of enrolled MSMEs" height={240}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie data={pieData(A.business_type_stats, 'business_type')} dataKey="value" nameKey="name"
                           outerRadius={80} label={({ name, percent }) => `${(percent*100).toFixed(0)}%`}>
                        {(A.business_type_stats||[]).map((_,i)=><Cell key={i} fill={CHART_PALETTE[i%CHART_PALETTE.length]}/>)}
                      </Pie>
                      <ReTooltip /><Legend wrapperStyle={{fontSize:11}}/>
                    </PieChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <ChartCard title="Sector" subtitle="Industry distribution" height={240}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie data={pieData(A.sector_stats, 'sector')} dataKey="value" nameKey="name"
                           innerRadius={45} outerRadius={80} paddingAngle={2}>
                        {(A.sector_stats||[]).map((_,i)=><Cell key={i} fill={CHART_PALETTE[(i+2)%CHART_PALETTE.length]}/>)}
                      </Pie>
                      <ReTooltip /><Legend wrapperStyle={{fontSize:11}}/>
                    </PieChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <ChartCard title="Owner Gender" subtitle="Founder demographics" height={240}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie data={pieData(A.gender_stats, 'gender')} dataKey="value" nameKey="name"
                           innerRadius={45} outerRadius={80}>
                        {(A.gender_stats||[]).map((_,i)=><Cell key={i} fill={['#262523','#C8102E','#999'][i%3]}/>)}
                      </Pie>
                      <ReTooltip /><Legend wrapperStyle={{fontSize:11}}/>
                    </PieChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
            </Grid>
          </Box>
        )}

        {/* ════════════════════════════════════════════════════════════════
            TAB 3 — Business Profiles (was Diagnostic)
            ════════════════════════════════════════════════════════════════ */}
        {analyticTab === 3 && (
          <Box>
            {diagTotal === 0 ? (
              <DiagnosticImporter token={token} onImported={() => {
                axios.get(`${API_ENDPOINTS.MSMES}analytics/`, { headers: { Authorization: `Token ${token}` } })
                  .then(r => setAnalytics(r.data))
                  .catch(err => console.warn('Analytics refresh failed after import:', err));
              }} isAdmin={isAdmin} />
            ) : (
              <>
                <SectionLabel>Baseline Summary — {diagTotal} MSMEs with diagnostic data</SectionLabel>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  {[
                    { val: A.diag_green?.green||0,                                                                   label:'Green Businesses',   sub:`${diagTotal?(((A.diag_green?.green||0)/diagTotal*100).toFixed(0)):'0'}% of total`,  color:'#2E7D32', pct:diagTotal?((A.diag_green?.green||0)/diagTotal*100):0 },
                    { val: A.diag_compliance?.has_tin||0,                                                            label:'Have TIN',            sub:'Tax ID registered',   color:'#D97706', pct:diagTotal?((A.diag_compliance?.has_tin||0)/diagTotal*100):0 },
                    { val: A.diag_compliance?.has_business_bank||0,                                                  label:'Business Bank Acct',  sub:'Financial access',    color:'#00695C', pct:diagTotal?((A.diag_compliance?.has_business_bank||0)/diagTotal*100):0 },
                    { val: A.diag_compliance?.has_unbs||0,                                                           label:'UNBS Registered',     sub:'Product standard',    color:'#4527A0', pct:diagTotal?((A.diag_compliance?.has_unbs||0)/diagTotal*100):0 },
                    { val:(A.diag_employees?.ft_male||0)+(A.diag_employees?.ft_female||0),                          label:'Full-time Staff',      sub:'Total at baseline',   color:'#5D4037' },
                    { val:(A.diag_employees?.pt_male||0)+(A.diag_employees?.pt_female||0),                          label:'Part-time Staff',      sub:'Total at baseline',   color:'#827717' },
                  ].map((k,i)=><Grid item xs={6} md={4} lg={2} key={i}><KPI {...k}/></Grid>)}
                </Grid>

                <SectionLabel>Compliance & Financial Access</SectionLabel>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ height: '100%' }}>
                      <CardContent>
                        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>Compliance Rates</Typography>
                        <ComplianceStat label="Has TIN (Tax ID)"            count={A.diag_compliance?.has_tin||0}           total={diagTotal} color="#D97706"/>
                        <ComplianceStat label="Registered with UNBS"        count={A.diag_compliance?.has_unbs||0}          total={diagTotal} color="#4527A0"/>
                        <ComplianceStat label="Has Business Bank Account"   count={A.diag_compliance?.has_business_bank||0} total={diagTotal} color="#00695C"/>
                        <ComplianceStat label="Has Mobile Money Account"    count={A.diag_compliance?.has_mobile_money||0}  total={diagTotal} color="#E65100"/>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ChartCard title="Green vs Non-Green" subtitle="Green business classification" height={220}>
                      <ResponsiveContainer>
                        <PieChart>
                          <Pie data={[{name:'Green',value:A.diag_green?.green||0},{name:'Non-Green',value:A.diag_green?.non_green||0}]}
                               dataKey="value" nameKey="name" innerRadius={55} outerRadius={85}>
                            <Cell fill="#2E7D32"/><Cell fill="#CFD8DC"/>
                          </Pie>
                          <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                        </PieChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                </Grid>

                <SectionLabel>Revenue & Assets (Self-Reported Bands)</SectionLabel>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <ChartCard title="Annual Turnover Bands" subtitle="Total sales last 12 months (UGX)" height={220}>
                      <ResponsiveContainer>
                        <BarChart data={turnoverData}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="name" tick={{fontSize:10}}/>
                          <YAxis tick={{fontSize:11}}/>
                          <ReTooltip/>
                          <Bar dataKey="count" fill="#D97706" radius={[4,4,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ChartCard title="Total Assets Bands" subtitle="Investment in assets (UGX)" height={220}>
                      <ResponsiveContainer>
                        <BarChart data={assetData}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="name" tick={{fontSize:10}}/>
                          <YAxis tick={{fontSize:11}}/>
                          <ReTooltip/>
                          <Bar dataKey="count" fill="#00695C" radius={[4,4,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                </Grid>

                <SectionLabel>Workforce & Business Maturity</SectionLabel>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} md={4}>
                    <ChartCard title="Workforce by Type & Gender" subtitle="Full-time vs part-time" height={220}>
                      <ResponsiveContainer>
                        <BarChart data={[
                          {name:'Full-time', Male:A.diag_employees?.ft_male||0, Female:A.diag_employees?.ft_female||0},
                          {name:'Part-time', Male:A.diag_employees?.pt_male||0, Female:A.diag_employees?.pt_female||0},
                        ]}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="name" tick={{fontSize:11}}/><YAxis tick={{fontSize:11}}/>
                          <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                          <Bar dataKey="Male"   stackId="a" fill="#262523"/>
                          <Bar dataKey="Female" stackId="a" fill="#C8102E" radius={[4,4,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ChartCard title="Years in Business" subtitle="Business maturity distribution" height={220}>
                      <ResponsiveContainer>
                        <BarChart data={(A.diag_years_operating||[]).map(y=>({name:(y.diag_years_operating||'').trim(),count:y.count}))}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="name" tick={{fontSize:10}}/><YAxis tick={{fontSize:11}}/>
                          <ReTooltip/>
                          <Bar dataKey="count" fill="#E65100" radius={[4,4,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ChartCard title="Owner Gender (Diagnostic)" subtitle="Self-reported at application" height={220}>
                      <ResponsiveContainer>
                        <PieChart>
                          <Pie data={(A.diag_owner_sex||[]).map(s=>({name:s.diag_owner_sex,value:s.count}))}
                               dataKey="value" nameKey="name" innerRadius={50} outerRadius={80}>
                            {(A.diag_owner_sex||[]).map((_,i)=><Cell key={i} fill={['#262523','#C8102E','#999'][i%3]}/>)}
                          </Pie>
                          <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                        </PieChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        )}

        {/* ════════════════════════════════════════════════════════════════
            TAB 2 — Operations (Performance + Geography)
            ════════════════════════════════════════════════════════════════ */}
        {analyticTab === 2 && (
          <Box>
            <SectionLabel>BGE Activity</SectionLabel>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <ChartCard title="BGE Workload" subtitle="MSMEs assigned (direct + via group)" height={320}>
                  <ResponsiveContainer>
                    <BarChart layout="vertical"
                      data={(A.bge_workload||[]).slice(0,12).map(b=>({name:(b.bge_name||'').slice(0,20),Direct:b.direct,ViaGroup:b.via_group}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis type="number" tick={{fontSize:11}}/>
                      <YAxis dataKey="name" type="category" width={130} tick={{fontSize:10}}/>
                      <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                      <Bar dataKey="Direct"   stackId="a" fill="#262523"/>
                      <Bar dataKey="ViaGroup" stackId="a" fill="#C8102E" radius={[0,4,4,0]}/>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <ChartCard title="BGE Pipeline" subtitle="Approval funnel" height={320}>
                  <ResponsiveContainer>
                    <BarChart data={(A.bge_status_stats||[]).map(s=>({name:s.status,count:s.count}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis dataKey="name" tick={{fontSize:11}}/><YAxis tick={{fontSize:11}}/>
                      <ReTooltip/>
                      <Bar dataKey="count" radius={[4,4,0,0]}>
                        {(A.bge_status_stats||[]).map((s,i)=>(
                          <Cell key={i} fill={s.status==='approved'?'#2E7D32':s.status==='pending'?'#F9A825':'#C8102E'}/>
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
            </Grid>

            <SectionLabel>Group Performance</SectionLabel>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12}>
                <ChartCard title="Groups — MSMEs & Reports" subtitle="Performance per BGE group" height={280}>
                  <ResponsiveContainer>
                    <BarChart data={(A.group_stats||[]).slice(0,12).map(g=>({name:(g.group_name||'').slice(0,18),MSMEs:g.msme_count,Reports:g.reports_count}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis dataKey="name" tick={{fontSize:10}}/><YAxis tick={{fontSize:11}}/>
                      <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                      <Bar dataKey="MSMEs"   fill="#262523" radius={[4,4,0,0]}/>
                      <Bar dataKey="Reports" fill="#2E7D32" radius={[4,4,0,0]}/>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
            </Grid>

            <SectionLabel>Report Pipeline</SectionLabel>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <ChartCard title="MSME Reports — by status" subtitle={`${A.total_reports||0} reports total`} height={220}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie data={pieData(A.report_status_stats,'status')} dataKey="value" nameKey="name" outerRadius={70}>
                        {(A.report_status_stats||[]).map((s,i)=>(
                          <Cell key={i} fill={s.status==='submitted'?'#262523':s.status==='reviewed'?'#2E7D32':'#C8102E'}/>
                        ))}
                      </Pie>
                      <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                    </PieChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <ChartCard title="Group Reports — by status" subtitle={`${A.total_group_reports||0} group reports total`} height={220}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie data={pieData(A.group_report_status_stats,'status')} dataKey="value" nameKey="name" outerRadius={70}>
                        {(A.group_report_status_stats||[]).map((s,i)=>(
                          <Cell key={i} fill={s.status==='submitted'?'#262523':s.status==='approved'?'#2E7D32':'#C8102E'}/>
                        ))}
                      </Pie>
                      <ReTooltip/><Legend wrapperStyle={{fontSize:11}}/>
                    </PieChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
            </Grid>
            {/* ── Geography (merged into Operations) ── */}
            <SectionLabel>Geographic Distribution</SectionLabel>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <ChartCard title="Districts (Diagnostic)" subtitle="From application forms — most complete coverage" height={340}>
                  <ResponsiveContainer>
                    <BarChart layout="vertical"
                      data={(A.diag_districts||[]).map(d=>({name:d.diag_district,count:d.count}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis type="number" tick={{fontSize:11}}/>
                      <YAxis dataKey="name" type="category" width={110} tick={{fontSize:11}}/>
                      <ReTooltip/>
                      <Bar dataKey="count" fill="#4527A0" radius={[0,4,4,0]}/>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <ChartCard title="Districts (MSME Profile)" subtitle="From system registration" height={340}>
                  <ResponsiveContainer>
                    <BarChart layout="vertical"
                      data={(A.top_districts||[]).map(d=>({name:d.state,count:d.count}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis type="number" tick={{fontSize:11}}/>
                      <YAxis dataKey="name" type="category" width={110} tick={{fontSize:11}}/>
                      <ReTooltip/>
                      <Bar dataKey="count" fill="#262523" radius={[0,4,4,0]}/>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <ChartCard title="Top Cities" subtitle="MSME concentration by city" height={280}>
                  <ResponsiveContainer>
                    <BarChart layout="vertical"
                      data={(A.top_cities||[]).map(d=>({name:d.city,count:d.count}))}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                      <XAxis type="number" tick={{fontSize:11}}/>
                      <YAxis dataKey="name" type="category" width={100} tick={{fontSize:11}}/>
                      <ReTooltip/>
                      <Bar dataKey="count" fill="#D97706" radius={[0,4,4,0]}/>
                    </BarChart>
                  </ResponsiveContainer>
                </ChartCard>
              </Grid>
            </Grid>
          </Box>
        )}

        {/* ════════════════════════════════════════════════════════════════
            TAB 1 — Growth & Impact (was Growth Data, Tab 4)
            ════════════════════════════════════════════════════════════════ */}
        {analyticTab === 1 && (() => {
          if (adminSnapshotsLoading) return <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress /></Box>;
          if (!adminSnapshots.length) return (
            <Box sx={{ py: 8, textAlign: 'center' }}>
              <TrendingUp sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6" color="text.secondary">No growth update data yet.</Typography>
              <Typography variant="body2" color="text.secondary">BGEs need to fill in "Record Growth Update" for their MSMEs before analytics appear here.</Typography>
            </Box>
          );
          /* ── print CSS injected once ──────────────────────────────── */
          if (!document.getElementById('prudev2-print-css')) {
            const s = document.createElement('style');
            s.id = 'prudev2-print-css';
            s.textContent = `@media print{body>*{display:none!important}.prudev2-printable{display:block!important;position:fixed;top:0;left:0;width:100%;background:#fff;z-index:99999;padding:24px}}`;
            document.head.appendChild(s);
          }

          // ── Core data derivations ─────────────────────────────────────────
          const firstByMsme = {};
          const latestByMsme = {};
          adminSnapshots.forEach(s => {
            const cur = firstByMsme[s.msme];
            if (!cur || s.snapshot_date < cur.snapshot_date || (s.snapshot_date === cur.snapshot_date && s.id < cur.id))
              firstByMsme[s.msme] = s;
            const lat = latestByMsme[s.msme];
            if (!lat || s.snapshot_date > lat.snapshot_date || (s.snapshot_date === lat.snapshot_date && s.id > lat.id))
              latestByMsme[s.msme] = s;
          });
          const msmeIds = Object.keys(latestByMsme).map(Number);
          const latestList = msmeIds.map(id => ({ ...latestByMsme[id], _first: firstByMsme[id] }))
            .sort((a, b) => b.snapshot_date.localeCompare(a.snapshot_date));
          const paired = latestList.filter(s => s._first && s._first.id !== s.id);

          // ── Helpers ───────────────────────────────────────────────────────
          const fmtUGX = v => v == null || v === '' ? '—' : `UGX ${Number(v).toLocaleString()}`;
          const compFields = [
            { label: 'URSB',         key: 'has_ursb',          color: '#4527A0' },
            { label: 'TIN',          key: 'has_tin',           color: '#D97706' },
            { label: 'Bank Account', key: 'has_business_bank', color: '#00695C' },
            { label: 'Mobile Money', key: 'has_mobile_money',  color: '#E65100' },
            { label: 'MOMO Pay',     key: 'has_momo_pay',      color: '#F57C00' },
            { label: 'SACCO',        key: 'has_sacco',         color: '#2E7D32' },
          ];
          const compBefore = (key) => paired.filter(s => s._first[key]).length;
          const compAfter  = (key) => paired.filter(s => s[key]).length;

          // ── Summary stats ─────────────────────────────────────────────────
          const withRev = latestList.filter(s => s.annual_turnover);
          const withRevFirst = paired.filter(s => Number(s._first.annual_turnover) > 0 && Number(s.annual_turnover) > 0);
          const avgRevBefore = withRevFirst.length
            ? withRevFirst.reduce((a,s) => a+Number(s._first.annual_turnover), 0) / withRevFirst.length : 0;
          const avgRevAfter  = withRevFirst.length
            ? withRevFirst.reduce((a,s) => a+Number(s.annual_turnover), 0) / withRevFirst.length : 0;
          const avgRevLatest = withRev.length
            ? withRev.reduce((a,x) => a+Number(x.annual_turnover), 0) / withRev.length : 0;
          const totalRevGrowth = withRevFirst.reduce((acc, s) =>
            acc + (Number(s.annual_turnover) - Number(s._first.annual_turnover)), 0);
          const pctRevGrowth = withRevFirst.length
            ? ((withRevFirst.reduce((a,s) =>
                a + (Number(s.annual_turnover)/Number(s._first.annual_turnover)-1), 0)
              / withRevFirst.length) * 100).toFixed(0)
            : null;

          const totalStaffBefore = paired.reduce((a,s) =>
            a + (s._first.employees_ft_male||0)+(s._first.employees_ft_female||0)
              + (s._first.employees_pt_male||0)+(s._first.employees_pt_female||0), 0);
          const totalStaffAfter  = paired.reduce((a,s) =>
            a + (s.employees_ft_male||0)+(s.employees_ft_female||0)
              + (s.employees_pt_male||0)+(s.employees_pt_female||0), 0);

          // ── Compliance counts from latest snapshots ───────────────────────
          const bankCount        = latestList.filter(s => s.has_business_bank).length;
          const momoCount        = latestList.filter(s => s.has_momo_pay).length;
          const tinCount         = latestList.filter(s => s.has_tin).length;
          const ursbCount        = latestList.filter(s => s.has_ursb).length;
          const saccoCount       = latestList.filter(s => s.has_sacco).length;
          const mobileMoneyCount = latestList.filter(s => s.has_mobile_money).length;

          // ── Diagnostic Baseline vs Growth Update comparison ───────────────
          const diagTotal = A.diag_total || 0;
          const diagComp  = A.diag_compliance || {};
          const diagEmp   = A.diag_employees  || {};

          const diagVsGrowthCompliance = [
            { metric: 'TIN',           Diagnostic: diagTotal ? Math.round((diagComp.has_tin||0)/diagTotal*100)            : 0, GrowthUpdate: latestList.length ? Math.round(tinCount/latestList.length*100)         : 0, diagRaw: diagComp.has_tin||0,            growthRaw: tinCount },
            { metric: 'Business Bank', Diagnostic: diagTotal ? Math.round((diagComp.has_business_bank||0)/diagTotal*100)  : 0, GrowthUpdate: latestList.length ? Math.round(bankCount/latestList.length*100)        : 0, diagRaw: diagComp.has_business_bank||0,  growthRaw: bankCount },
            { metric: 'Mobile Money',  Diagnostic: diagTotal ? Math.round((diagComp.has_mobile_money||0)/diagTotal*100)   : 0, GrowthUpdate: latestList.length ? Math.round(mobileMoneyCount/latestList.length*100) : 0, diagRaw: diagComp.has_mobile_money||0,   growthRaw: mobileMoneyCount },
            { metric: 'URSB/UNBS',    Diagnostic: diagTotal ? Math.round((diagComp.has_unbs||0)/diagTotal*100)            : 0, GrowthUpdate: latestList.length ? Math.round(ursbCount/latestList.length*100)        : 0, diagRaw: diagComp.has_unbs||0,           growthRaw: ursbCount },
          ];

          const diagVsGrowthEmployees = [
            { category: 'FT Male',   Diagnostic: diagEmp.ft_male||0,   GrowthUpdate: latestList.reduce((a,s) => a+(s.employees_ft_male||0),    0) },
            { category: 'FT Female', Diagnostic: diagEmp.ft_female||0, GrowthUpdate: latestList.reduce((a,s) => a+(s.employees_ft_female||0),  0) },
            { category: 'PT Male',   Diagnostic: diagEmp.pt_male||0,   GrowthUpdate: latestList.reduce((a,s) => a+(s.employees_pt_male||0),    0) },
            { category: 'PT Female', Diagnostic: diagEmp.pt_female||0, GrowthUpdate: latestList.reduce((a,s) => a+(s.employees_pt_female||0),  0) },
          ].filter(r => r.Diagnostic > 0 || r.GrowthUpdate > 0);

          // ── Employee breakdown by category (before vs after, paired only) ─
          const empCats = [
            { key: 'employees_ft_male',    label: 'FT Male'    },
            { key: 'employees_ft_female',  label: 'FT Female'  },
            { key: 'employees_pt_male',    label: 'PT Male'    },
            { key: 'employees_pt_female',  label: 'PT Female'  },
            { key: 'employees_ft_refugee', label: 'FT Refugee' },
            { key: 'employees_pt_refugee', label: 'PT Refugee' },
          ];
          const empChart = empCats.map(({ key, label }) => ({
            category: label,
            Before: paired.reduce((a, s) => a + (s._first[key]||0), 0),
            After:  paired.reduce((a, s) => a + (s[key]||0), 0),
          })).filter(r => r.Before > 0 || r.After > 0);

          const totalEmpBefore = empCats.reduce((a, { key }) =>
            a + paired.reduce((b, s) => b + (s._first[key]||0), 0), 0);
          const totalEmpAfter  = empCats.reduce((a, { key }) =>
            a + paired.reduce((b, s) => b + (s[key]||0), 0), 0);

          const now = new Date();
          const fresh = latestList.filter(s => (now - new Date(s.snapshot_date)) / 86400000 <= 30).length;

          // ── Programme summary chart data ──────────────────────────────────
          // Financial chart: avg revenue before vs after (in thousands)
          const financialChart = withRevFirst.length ? [
            { metric: 'Avg Annual Revenue (K)', Before: Math.round(avgRevBefore/1000), After: Math.round(avgRevAfter/1000) },
          ] : [];
          if (paired.length) {
            financialChart.push({ metric: 'Total Staff', Before: totalStaffBefore, After: totalStaffAfter });
          }

          // Compliance chart: before vs after % for each flag
          const complianceChart = compFields.map(({ label, key }) => ({
            metric: label,
            Before: compBefore(key),
            After: compAfter(key),
          }));

          // ── Quarterly trend ───────────────────────────────────────────────
          const currentYear = new Date().getFullYear();
          const qData = {};
          adminSnapshots.forEach(s => {
            const y = new Date(s.snapshot_date).getFullYear();
            const q = `Q${Math.floor(new Date(s.snapshot_date).getMonth()/3)+1}`;
            if (y !== currentYear && y !== currentYear - 1) return;
            const key = `${y} ${q}`;
            if (!qData[key]) qData[key] = { period: key, revenue: 0, count: 0 };
            if (s.annual_turnover) { qData[key].revenue += Number(s.annual_turnover); qData[key].count++; }
          });
          const quarterlyChart = Object.values(qData)
            .sort((a,b) => a.period.localeCompare(b.period))
            .map(q => ({ period: q.period, 'Avg Revenue (K)': q.count ? Math.round(q.revenue/q.count/1000) : 0 }));

          // ── CSV Export ────────────────────────────────────────────────────
          const exportCSV = () => {
            const rows = [
              ['MSME', 'Code', 'BGE', 'First Update', 'Latest Update', '# Updates',
               'Annual Revenue (Before)', 'Annual Revenue (After)', 'Rev Change %',
               'Last Month Revenue', 'FT Staff (Before)', 'FT Staff (After)',
               'PT Staff (Before)', 'PT Staff (After)',
               'TIN (Before)', 'TIN (After)', 'URSB (Before)', 'URSB (After)',
               'Bank (Before)', 'Bank (After)', 'SACCO (Before)', 'SACCO (After)',
               'MoMo (Before)', 'MoMo (After)', 'Bank Name'].join(','),
              ...latestList.map(s => {
                const f = s._first || {};
                const bFT = (f.employees_ft_male||0)+(f.employees_ft_female||0);
                const bPT = (f.employees_pt_male||0)+(f.employees_pt_female||0);
                const aFT = (s.employees_ft_male||0)+(s.employees_ft_female||0);
                const aPT = (s.employees_pt_male||0)+(s.employees_pt_female||0);
                const revPct = (f.annual_turnover && s.annual_turnover)
                  ? ((Number(s.annual_turnover)/Number(f.annual_turnover)-1)*100).toFixed(1)+'%' : '';
                const m = (allMsmes.length > 0 ? allMsmes : msmes).find(m => m.id === s.msme);
                return [
                  `"${s.msme_name||''}"`, m?.msme_code||'', `"${m?.assigned_bge_name||''}"`,
                  f.snapshot_date||'', s.snapshot_date,
                  adminSnapshots.filter(x => x.msme === s.msme).length,
                  f.annual_turnover||'', s.annual_turnover||'', revPct, s.last_month_revenue||'',
                  bFT, aFT, bPT, aPT,
                  f.has_tin?'Yes':'No', s.has_tin?'Yes':'No',
                  f.has_ursb?'Yes':'No', s.has_ursb?'Yes':'No',
                  f.has_business_bank?'Yes':'No', s.has_business_bank?'Yes':'No',
                  f.has_sacco?'Yes':'No', s.has_sacco?'Yes':'No',
                  f.has_mobile_money?'Yes':'No', s.has_mobile_money?'Yes':'No',
                  `"${s.bank_name||''}"`,
                ].join(',');
              }),
            ].join('\n');
            const blob = new Blob([rows], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = `prudev2-growth-report-${new Date().toISOString().slice(0,10)}.csv`;
            a.click(); URL.revokeObjectURL(url);
          };

          const msmePoolTab1 = allMsmes.length > 0 ? allMsmes : msmes;
          const totalEnrolledTab1 = A.total_msmes || (msmePoolTab1.length > 0 ? msmePoolTab1.length : (msmeTotalCount || msmes.length));

          return (
            <Box>
              {/* ── Header ── */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box>
                  <Typography variant="h6" fontWeight={700}>Growth Analytics</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Before/after comparison · {msmeIds.length} MSMEs · {adminSnapshots.length} total updates · {paired.length} paired
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button variant="outlined" size="small" startIcon={<Download />} onClick={exportCSV}>
                    Export CSV
                  </Button>
                  <Button variant="contained" size="small" startIcon={<Assessment />}
                    onClick={() => window.print()}
                    sx={{ bgcolor: BRAND.primaryMain }}>
                    Export Chart (PDF)
                  </Button>
                </Box>
              </Box>

              {/* ════════════════════════════════════════════════════════════
                  PRINTABLE SUMMARY REPORT (hidden on screen, shown on print)
                  ════════════════════════════════════════════════════════════ */}
              <Box className="prudev2-printable" sx={{ display: 'none' }}>
                <Box sx={{ mb: 3, pb: 2, borderBottom: '2px solid #262523' }}>
                  <Typography variant="h5" fontWeight={800} color="#262523">PRUDEV II — Growth Impact Report</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Generated {new Date().toLocaleDateString('en-UG', { day: 'numeric', month: 'long', year: 'numeric' })} ·
                    {msmeIds.length} MSMEs · {paired.length} with before/after comparison
                  </Typography>
                </Box>

                {/* KPI summary row */}
                <Box sx={{ display: 'flex', gap: 3, mb: 3, flexWrap: 'wrap' }}>
                  {[
                    { label: 'Avg Revenue (After)',  val: `UGX ${(avgRevLatest/1000).toFixed(0)}K` },
                    { label: 'Revenue Growth',       val: pctRevGrowth != null ? `+${pctRevGrowth}%` : '—' },
                    { label: 'Total Revenue Uplift', val: `UGX ${(totalRevGrowth/1000).toFixed(0)}K` },
                    { label: 'Staff Change',         val: totalStaffAfter > totalStaffBefore ? `+${totalStaffAfter - totalStaffBefore}` : String(totalStaffAfter - totalStaffBefore) },
                  ].map(({ label, val }) => (
                    <Box key={label} sx={{ textAlign: 'center', minWidth: 110 }}>
                      <Typography fontSize={22} fontWeight={800} color="#262523">{val}</Typography>
                      <Typography fontSize={11} color="#555">{label}</Typography>
                    </Box>
                  ))}
                </Box>

                {/* Printable financial chart */}
                {financialChart.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography fontWeight={700} fontSize={13} sx={{ mb: 1 }}>Financial Impact — Before vs After</Typography>
                    <ResponsiveContainer width="100%" height={200}>
                      <BarChart data={financialChart} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#E8EDF2"/>
                        <XAxis dataKey="metric" tick={{ fontSize: 11 }}/>
                        <YAxis tick={{ fontSize: 10 }}/>
                        <ReTooltip/>
                        <Legend wrapperStyle={{ fontSize: 11 }}/>
                        <Bar dataKey="Before" fill="#90A4AE" radius={[3,3,0,0]}/>
                        <Bar dataKey="After"  fill="#262523" radius={[3,3,0,0]}/>
                      </BarChart>
                    </ResponsiveContainer>
                  </Box>
                )}

                {/* Printable compliance chart */}
                {paired.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography fontWeight={700} fontSize={13} sx={{ mb: 1 }}>Compliance Improvements — Before vs After (# MSMEs)</Typography>
                    <ResponsiveContainer width="100%" height={220}>
                      <BarChart data={complianceChart} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#E8EDF2"/>
                        <XAxis dataKey="metric" tick={{ fontSize: 11 }}/>
                        <YAxis allowDecimals={false} tick={{ fontSize: 10 }}/>
                        <ReTooltip/>
                        <Legend wrapperStyle={{ fontSize: 11 }}/>
                        <Bar dataKey="Before" fill="#90A4AE" radius={[3,3,0,0]}/>
                        <Bar dataKey="After"  fill="#C8102E" radius={[3,3,0,0]}/>
                      </BarChart>
                    </ResponsiveContainer>
                  </Box>
                )}

                {/* Quarterly trend */}
                {quarterlyChart.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography fontWeight={700} fontSize={13} sx={{ mb: 1 }}>
                      Quarterly Average Revenue — {currentYear-1}/{currentYear} (UGX thousands)
                    </Typography>
                    <ResponsiveContainer width="100%" height={200}>
                      <BarChart data={quarterlyChart} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#E8EDF2"/>
                        <XAxis dataKey="period" tick={{ fontSize: 11 }}/>
                        <YAxis tickFormatter={v => `${v}K`} tick={{ fontSize: 10 }}/>
                        <ReTooltip formatter={v => [`UGX ${(v*1000).toLocaleString()}`, 'Avg Revenue']}/>
                        <Bar dataKey="Avg Revenue (K)" fill="#262523" radius={[3,3,0,0]}/>
                      </BarChart>
                    </ResponsiveContainer>
                  </Box>
                )}
              </Box>

              {/* ════════════════════════════════════════════════════════════
                  PROGRAMME SUMMARY KPIs (screen view)
                  ════════════════════════════════════════════════════════════ */}
              <SectionLabel>Programme Summary</SectionLabel>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {[
                  { val: msmeIds.length,                                    label: 'MSMEs with Data',    sub: `of ${totalEnrolledTab1} total`,   color: BRAND.primaryMain },
                  { val: paired.length,                                     label: 'Paired (Before/After)', sub: '≥2 snapshots',            color: BRAND.gopaGoldDark },
                  { val: `UGX ${(avgRevLatest/1000).toFixed(0)}K`,         label: 'Avg Annual Revenue', sub: 'latest snapshot',            color: '#2E7D32' },
                  { val: pctRevGrowth != null ? `+${pctRevGrowth}%` : '—', label: 'Avg Revenue Growth', sub: 'first → latest',            color: Number(pctRevGrowth) > 0 ? '#2E7D32' : '#C8102E' },
                  { val: `UGX ${(totalRevGrowth/1000).toFixed(0)}K`,       label: 'Total Revenue Uplift', sub: 'across paired MSMEs',     color: '#7B1FA2' },
                  { val: fresh, label: 'Updated ≤30 days', sub: 'recently active', color: '#2E7D32' },
                ].map((k, i) => <Grid item xs={6} sm={4} lg={2} key={i}><KPI {...k} /></Grid>)}
              </Grid>

              {/* ════════════════════════════════════════════════════════════
                  PROGRAMME SUMMARY CHARTS (screen view)
                  ════════════════════════════════════════════════════════════ */}
              {/* ════════════════════════════════════════════════════════════
                  BUSINESS METRICS SUMMARY
                  ════════════════════════════════════════════════════════════ */}
              <SectionLabel>Business Metrics Summary (Latest Updates)</SectionLabel>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {[
                  { val: `UGX ${(avgRevLatest/1000).toFixed(0)}K`, label: 'Avg Annual Revenue',  sub: 'across all updated MSMEs',    color: '#2E7D32' },
                  { val: `${bankCount} / ${latestList.length}`,    label: 'Business Bank Acct',  sub: 'have formal bank account',    color: '#00695C',
                    pct: latestList.length ? bankCount/latestList.length*100 : 0 },
                  { val: `${momoCount} / ${latestList.length}`,    label: 'MOMO Pay Code',       sub: 'registered mobile payment',   color: '#F57C00',
                    pct: latestList.length ? momoCount/latestList.length*100 : 0 },
                  { val: `${tinCount} / ${latestList.length}`,     label: 'TIN Registered',      sub: 'tax identification number',   color: '#D97706',
                    pct: latestList.length ? tinCount/latestList.length*100 : 0 },
                  { val: `${ursbCount} / ${latestList.length}`,    label: 'URSB Registered',     sub: 'business registration',       color: '#4527A0',
                    pct: latestList.length ? ursbCount/latestList.length*100 : 0 },
                  { val: `${saccoCount} / ${latestList.length}`,   label: 'SACCO Members',       sub: 'savings cooperative',         color: '#2E7D32',
                    pct: latestList.length ? saccoCount/latestList.length*100 : 0 },
                ].map((k, i) => <Grid item xs={6} sm={4} lg={2} key={i}><KPI {...k} /></Grid>)}
              </Grid>

              {/* Employee totals before vs after */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={4}>
                  <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>Total Employees</Typography>
                      {[
                        { label: 'Before (first update)', val: totalEmpBefore, color: '#90A4AE' },
                        { label: 'After (latest update)',  val: totalEmpAfter,  color: '#262523' },
                        { label: 'Net change',
                          val: `${totalEmpAfter - totalEmpBefore >= 0 ? '+' : ''}${totalEmpAfter - totalEmpBefore}`,
                          color: totalEmpAfter >= totalEmpBefore ? '#2E7D32' : '#C8102E' },
                      ].map(({ label, val, color }) => (
                        <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
                          <Typography variant="body2" color="text.secondary">{label}</Typography>
                          <Typography variant="body2" fontWeight={700} color={color}>{val}</Typography>
                        </Box>
                      ))}
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="caption" color="text.secondary">
                        Based on {paired.length} MSMEs with ≥2 updates
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                {empChart.length > 0 && (
                  <Grid item xs={12} sm={8}>
                    <ChartCard title="Employees Before vs After — By Category"
                      subtitle={`${paired.length} paired MSMEs · first update vs latest update`} height={200}>
                      <ResponsiveContainer>
                        <BarChart data={empChart} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="category" tick={{ fontSize: 11 }}/>
                          <YAxis allowDecimals={false} tick={{ fontSize: 11 }}/>
                          <ReTooltip/>
                          <Legend wrapperStyle={{ fontSize: 11 }}/>
                          <Bar dataKey="Before" fill="#90A4AE" radius={[3,3,0,0]}/>
                          <Bar dataKey="After"  fill="#262523" radius={[3,3,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                )}
              </Grid>

              {/* ════════════════════════════════════════════════════════════
                  DIAGNOSTIC BASELINE vs GROWTH UPDATE COMPARISON
                  ════════════════════════════════════════════════════════════ */}
              {(diagTotal > 0 || latestList.length > 0) && (
                <>
                  <SectionLabel>Diagnostic Baseline vs Growth Update</SectionLabel>
                  <Box sx={{ mb: 2, p: 1.5, bgcolor: '#F3F6FA', borderRadius: 2, border: '1px solid #DDE4EE' }}>
                    <Typography variant="caption" color="text.secondary">
                      <strong>Diagnostic Baseline</strong> — data collected during the initial diagnostic assessment
                      ({diagTotal} MSMEs). &nbsp;
                      <strong>Growth Update</strong> — latest update submitted by BGEs
                      ({latestList.length} MSMEs). &nbsp;
                      Compliance shown as % of each respective population.
                    </Typography>
                  </Box>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    {diagVsGrowthCompliance.some(r => r.Diagnostic > 0 || r.GrowthUpdate > 0) && (
                      <Grid item xs={12} md={6}>
                        <ChartCard
                          title="Compliance — Diagnostic vs Growth Update"
                          subtitle="% of each population with the compliance flag"
                          height={260}>
                          <ResponsiveContainer>
                            <BarChart data={diagVsGrowthCompliance} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                              <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                              <XAxis dataKey="metric" tick={{ fontSize: 10 }}/>
                              <YAxis unit="%" domain={[0,100]} tick={{ fontSize: 10 }}/>
                              <ReTooltip formatter={(val, name, props) => [
                                `${val}% (${name === 'Diagnostic' ? props.payload.diagRaw : props.payload.growthRaw} MSMEs)`,
                                name,
                              ]}/>
                              <Legend wrapperStyle={{ fontSize: 11 }}/>
                              <Bar dataKey="Diagnostic"   fill="#C8102E" radius={[3,3,0,0]}/>
                              <Bar dataKey="GrowthUpdate" name="Growth Update" fill="#262523" radius={[3,3,0,0]}/>
                            </BarChart>
                          </ResponsiveContainer>
                        </ChartCard>
                      </Grid>
                    )}
                    {diagVsGrowthEmployees.length > 0 && (
                      <Grid item xs={12} md={6}>
                        <ChartCard
                          title="Employees — Diagnostic vs Growth Update"
                          subtitle="Total headcount per category across all MSMEs"
                          height={260}>
                          <ResponsiveContainer>
                            <BarChart data={diagVsGrowthEmployees} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                              <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                              <XAxis dataKey="category" tick={{ fontSize: 10 }}/>
                              <YAxis allowDecimals={false} tick={{ fontSize: 10 }}/>
                              <ReTooltip/>
                              <Legend wrapperStyle={{ fontSize: 11 }}/>
                              <Bar dataKey="Diagnostic"   fill="#C8102E" radius={[3,3,0,0]}/>
                              <Bar dataKey="GrowthUpdate" name="Growth Update" fill="#262523" radius={[3,3,0,0]}/>
                            </BarChart>
                          </ResponsiveContainer>
                        </ChartCard>
                      </Grid>
                    )}
                  </Grid>
                </>
              )}

              <SectionLabel>Programme Before / After Charts</SectionLabel>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {financialChart.length > 0 && (
                  <Grid item xs={12} md={5}>
                    <ChartCard title="Financial Impact" subtitle="Avg revenue (UGX K) & total staff — first vs latest" height={240}>
                      <ResponsiveContainer>
                        <BarChart data={financialChart}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="metric" tick={{ fontSize: 10 }}/>
                          <YAxis tick={{ fontSize: 10 }}/>
                          <ReTooltip/>
                          <Legend wrapperStyle={{ fontSize: 11 }}/>
                          <Bar dataKey="Before" fill="#90A4AE" radius={[3,3,0,0]}/>
                          <Bar dataKey="After"  fill="#262523" radius={[3,3,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                )}
                {paired.length > 0 && (
                  <Grid item xs={12} md={financialChart.length > 0 ? 7 : 12}>
                    <ChartCard title="Compliance Improvements" subtitle={`# MSMEs (of ${paired.length} paired) — first vs latest update`} height={240}>
                      <ResponsiveContainer>
                        <BarChart data={complianceChart}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="metric" tick={{ fontSize: 10 }}/>
                          <YAxis allowDecimals={false} tick={{ fontSize: 10 }}/>
                          <ReTooltip/>
                          <Legend wrapperStyle={{ fontSize: 11 }}/>
                          <Bar dataKey="Before" fill="#90A4AE" radius={[3,3,0,0]}/>
                          <Bar dataKey="After"  fill="#C8102E" radius={[3,3,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                )}
                {quarterlyChart.length > 0 && (
                  <Grid item xs={12}>
                    <ChartCard title="Quarterly Average Revenue" subtitle={`${currentYear-1} / ${currentYear} — UGX thousands`} height={220}>
                      <ResponsiveContainer>
                        <BarChart data={quarterlyChart}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                          <XAxis dataKey="period" tick={{ fontSize: 11 }}/>
                          <YAxis tickFormatter={v => `${v}K`} tick={{ fontSize: 10 }} width={48}/>
                          <ReTooltip formatter={v => [`UGX ${(v*1000).toLocaleString()}`, 'Avg Revenue']}/>
                          <Bar dataKey="Avg Revenue (K)" fill="#262523" radius={[3,3,0,0]}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                )}
              </Grid>

              {/* ════════════════════════════════════════════════════════════
                  REVENUE DISTRIBUTION + PERFORMERS (scales to 200+ MSMEs)
                  ════════════════════════════════════════════════════════════ */}
              {paired.length > 0 && (() => {
                // Revenue bracket distribution — how many MSMEs fall into each revenue band
                const revBrackets = [
                  { label: '< 1M',      min: 0,          max: 1000000    },
                  { label: '1M – 5M',   min: 1000000,    max: 5000000    },
                  { label: '5M – 20M',  min: 5000000,    max: 20000000   },
                  { label: '20M – 100M',min: 20000000,   max: 100000000  },
                  { label: '100M+',     min: 100000000,  max: Infinity   },
                ];
                const revDist = revBrackets.map(b => ({
                  band: b.label,
                  Before: paired.filter(s => { const r = Number(s._first.annual_turnover)||0; return r > 0 && r >= b.min && r < b.max; }).length,
                  After:  paired.filter(s => { const r = Number(s.annual_turnover)||0;        return r > 0 && r >= b.min && r < b.max; }).length,
                })).filter(b => b.Before > 0 || b.After > 0);

                // Top & declining performers (list-based — works at any scale)
                const perfRows = withRevFirst
                  .map(s => ({
                    id: s.id,
                    name: (s.msme_name || `MSME ${s.msme}`).slice(0, 32),
                    before: Number(s._first.annual_turnover),
                    after:  Number(s.annual_turnover),
                    pct: ((Number(s.annual_turnover) / Number(s._first.annual_turnover) - 1) * 100),
                  }))
                  .sort((a, b) => b.pct - a.pct);
                const topPerformers      = perfRows.filter(r => r.pct > 0).slice(0, 10);
                const decliningPerformers = perfRows.filter(r => r.pct < 0).sort((a,b) => a.pct - b.pct).slice(0, 10);

                return (
                  <>
                    {/* Revenue distribution chart */}
                    {revDist.length > 0 && (
                      <>
                        <SectionLabel>Revenue Distribution — Before vs After</SectionLabel>
                        <Box sx={{ mb: 2, p: 1.5, bgcolor: '#F3F6FA', borderRadius: 2, border: '1px solid #DDE4EE' }}>
                          <Typography variant="caption" color="text.secondary">
                            How many of the <strong>{paired.length} paired MSMEs</strong> fall into each annual revenue bracket at first update vs latest update.
                            Moving right = revenue growth; larger "After" bar = more businesses reaching that tier.
                          </Typography>
                        </Box>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                          <Grid item xs={12}>
                            <ChartCard title="Annual Revenue Bands" subtitle="# MSMEs per bracket — first update vs latest update" height={260}>
                              <ResponsiveContainer>
                                <BarChart data={revDist} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                                  <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                                  <XAxis dataKey="band" tick={{ fontSize: 11 }}/>
                                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} label={{ value: '# MSMEs', angle: -90, position: 'insideLeft', style: { fontSize: 10 } }}/>
                                  <ReTooltip formatter={(v, n) => [`${v} MSMEs`, n]}/>
                                  <Legend wrapperStyle={{ fontSize: 11 }}/>
                                  <Bar dataKey="Before" name="First update"  fill="#90A4AE" radius={[3,3,0,0]}/>
                                  <Bar dataKey="After"  name="Latest update" fill="#262523" radius={[3,3,0,0]}/>
                                </BarChart>
                              </ResponsiveContainer>
                            </ChartCard>
                          </Grid>
                        </Grid>
                      </>
                    )}

                    {/* Top & Declining performers */}
                    {(topPerformers.length > 0 || decliningPerformers.length > 0) && (
                      <>
                        <SectionLabel>Revenue Performance — Top & Declining Businesses</SectionLabel>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                          {topPerformers.length > 0 && (
                            <Grid item xs={12} md={decliningPerformers.length > 0 ? 6 : 12}>
                              <Card variant="outlined">
                                <CardContent>
                                  <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                                    🏆 Top {topPerformers.length} — Highest Revenue Growth
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                                    Annual revenue % change, first → latest update
                                  </Typography>
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow sx={{ bgcolor: '#F5F5F5' }}>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }}>Business</TableCell>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }} align="right">Before</TableCell>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }} align="right">After</TableCell>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }} align="right">Growth</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {topPerformers.map(r => (
                                        <TableRow key={r.id} hover>
                                          <TableCell sx={{ fontSize: 11 }}>{r.name}</TableCell>
                                          <TableCell sx={{ fontSize: 11, color: 'text.secondary' }} align="right">
                                            {(r.before/1000).toFixed(0)}K
                                          </TableCell>
                                          <TableCell sx={{ fontSize: 11, fontWeight: 600 }} align="right">
                                            {(r.after/1000).toFixed(0)}K
                                          </TableCell>
                                          <TableCell align="right">
                                            <Chip size="small" label={`+${r.pct.toFixed(0)}%`}
                                              sx={{ fontSize: 10, height: 18, bgcolor: '#E8F5E9', color: '#2E7D32', fontWeight: 700 }}/>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </CardContent>
                              </Card>
                            </Grid>
                          )}
                          {decliningPerformers.length > 0 && (
                            <Grid item xs={12} md={topPerformers.length > 0 ? 6 : 12}>
                              <Card variant="outlined" sx={{ borderColor: '#FFCDD2' }}>
                                <CardContent>
                                  <Typography variant="subtitle2" fontWeight={700} color="#C62828" gutterBottom>
                                    ⚠ Needs Attention — Declining Revenue ({decliningPerformers.length})
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                                    These businesses earn less now than when they first joined. Follow up with their BGEs.
                                  </Typography>
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow sx={{ bgcolor: '#FFF8F8' }}>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }}>Business</TableCell>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }} align="right">Before</TableCell>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }} align="right">After</TableCell>
                                        <TableCell sx={{ fontSize: 11, fontWeight: 700 }} align="right">Change</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {decliningPerformers.map(r => (
                                        <TableRow key={r.id} hover>
                                          <TableCell sx={{ fontSize: 11 }}>{r.name}</TableCell>
                                          <TableCell sx={{ fontSize: 11, color: 'text.secondary' }} align="right">
                                            {(r.before/1000).toFixed(0)}K
                                          </TableCell>
                                          <TableCell sx={{ fontSize: 11, fontWeight: 600, color: '#C62828' }} align="right">
                                            {(r.after/1000).toFixed(0)}K
                                          </TableCell>
                                          <TableCell align="right">
                                            <Chip size="small" label={`${r.pct.toFixed(0)}%`}
                                              sx={{ fontSize: 10, height: 18, bgcolor: '#FFEBEE', color: '#C62828', fontWeight: 700 }}/>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </CardContent>
                              </Card>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    )}

                    {/* ── Compliance transition (unchanged) ── */}
                    {(() => {
                      // For each metric, categorise each paired MSME into one of 4 buckets
                      const transData = compFields.map(({ label, key }) => {
                        const gained    = paired.filter(s => !s._first[key] && s[key]).length;
                        const maintained= paired.filter(s =>  s._first[key] && s[key]).length;
                        const stillNo   = paired.filter(s => !s._first[key] && !s[key]).length;
                        const lost      = paired.filter(s =>  s._first[key] && !s[key]).length;
                        return { metric: label, '↑ Gained': gained, '✓ Maintained': maintained, '— Still No': stillNo, '↓ Lost': lost };
                      });

                      // Which MSMEs changed on at least one metric?
                      const changedMsmes = paired.filter(s =>
                        compFields.some(f => !!s._first[f.key] !== !!s[f.key])
                      );

                      return (
                        <>
                          {/* ── Six metric summary cards ── */}
                          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
                            Compliance — Before vs After ({paired.length} businesses with paired updates)
                          </Typography>
                          <Grid container spacing={1.5} sx={{ mb: 3 }}>
                            {transData.map(({ metric, ...counts }) => {
                              const gained = counts['↑ Gained'];
                              const lost   = counts['↓ Lost'];
                              const afterYes = counts['↑ Gained'] + counts['✓ Maintained'];
                              const beforeYes = counts['✓ Maintained'] + counts['↓ Lost'];
                              const net = gained - lost;
                              const pctAfter = paired.length ? Math.round(afterYes / paired.length * 100) : 0;
                              const pctBefore = paired.length ? Math.round(beforeYes / paired.length * 100) : 0;
                              return (
                                <Grid item xs={6} sm={4} md={2} key={metric}>
                                  <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, height: '100%' }}>
                                    <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" noWrap>
                                      {metric}
                                    </Typography>

                                    {/* Before → After counts */}
                                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mt: 0.5 }}>
                                      <Typography variant="body2" color="text.disabled" sx={{ fontSize: 13 }}>
                                        {beforeYes}
                                      </Typography>
                                      <Typography variant="caption" color="text.disabled">→</Typography>
                                      <Typography variant="h6" fontWeight={800} color={net > 0 ? '#2E7D32' : net < 0 ? '#C62828' : 'text.primary'} sx={{ lineHeight: 1 }}>
                                        {afterYes}
                                      </Typography>
                                      <Typography variant="caption" color="text.secondary">/ {paired.length}</Typography>
                                    </Box>

                                    {/* Progress bar: before (grey) → after (coloured fill) */}
                                    <Box sx={{ mt: 1, mb: 0.5 }}>
                                      <Box sx={{ position: 'relative', height: 6, bgcolor: '#E0E0E0', borderRadius: 3 }}>
                                        <Box sx={{ position: 'absolute', left: 0, top: 0, height: '100%', width: `${pctBefore}%`, bgcolor: '#BDBDBD', borderRadius: 3 }}/>
                                        <Box sx={{ position: 'absolute', left: 0, top: 0, height: '100%', width: `${pctAfter}%`, bgcolor: net >= 0 ? '#2E7D32' : '#C62828', borderRadius: 3, opacity: 0.85 }}/>
                                      </Box>
                                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                                        {pctBefore}% → {pctAfter}%
                                      </Typography>
                                    </Box>

                                    {/* Net change badge */}
                                    {(gained > 0 || lost > 0) && (
                                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                                        {gained > 0 && (
                                          <Chip label={`+${gained} gained`} size="small"
                                            sx={{ fontSize: 10, height: 18, bgcolor: '#E8F5E9', color: '#2E7D32', fontWeight: 700 }}/>
                                        )}
                                        {lost > 0 && (
                                          <Chip label={`−${lost} lost`} size="small"
                                            sx={{ fontSize: 10, height: 18, bgcolor: '#FFEBEE', color: '#C62828', fontWeight: 700 }}/>
                                        )}
                                      </Box>
                                    )}
                                    {gained === 0 && lost === 0 && (
                                      <Typography variant="caption" color="text.disabled" sx={{ fontSize: 10 }}>No change</Typography>
                                    )}
                                  </Paper>
                                </Grid>
                              );
                            })}
                          </Grid>

                          {/* ── Changes-only table ── */}
                          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
                            What Changed — businesses with at least one compliance shift
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                            Only showing {changedMsmes.length} of {paired.length} businesses where something moved.
                            {changedMsmes.length === 0 && ' No compliance changes recorded yet.'}
                          </Typography>
                          {changedMsmes.length > 0 && (
                            <TableContainer component={Paper} variant="outlined" sx={{ mb: 3, overflowX: 'auto' }}>
                              <Table size="small">
                                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Business</TableCell>
                                    {compFields.map(f => (
                                      <TableCell key={f.key} align="center" sx={{ fontWeight: 700, fontSize: 11 }}>{f.label}</TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {changedMsmes.map(s => (
                                    <TableRow key={s.id} hover>
                                      <TableCell sx={{ fontSize: 11, fontWeight: 600, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {(s.msme_name || `MSME ${s.msme}`).slice(0, 30)}
                                      </TableCell>
                                      {compFields.map(f => {
                                        const before = !!s._first[f.key];
                                        const after  = !!s[f.key];
                                        if (after && !before) return (
                                          <TableCell key={f.key} align="center" sx={{ fontSize: 12, color: '#2E7D32', fontWeight: 700 }}>↑ Gained</TableCell>
                                        );
                                        if (!after && before) return (
                                          <TableCell key={f.key} align="center" sx={{ fontSize: 12, color: '#C62828', fontWeight: 700 }}>↓ Lost</TableCell>
                                        );
                                        // Unchanged — show muted current state
                                        return (
                                          <TableCell key={f.key} align="center" sx={{ fontSize: 11, color: after ? '#262523' : '#BDBDBD' }}>
                                            {after ? '✓' : '—'}
                                          </TableCell>
                                        );
                                      })}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                        </>
                      );
                    })()}
                  </>
                );
              })()}

              {/* ════════════════════════════════════════════════════════════
                  RAW DATA TABLE (scrollable)
                  ════════════════════════════════════════════════════════════ */}
              <SectionLabel>Full Data Table</SectionLabel>
              <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
                <Table size="small" sx={{ minWidth: 900 }}>
                  <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell>MSME</TableCell>
                      <TableCell>BGE</TableCell>
                      <TableCell># Updates</TableCell>
                      <TableCell>Annual Revenue (Before → After)</TableCell>
                      <TableCell>Last Month Rev.</TableCell>
                      <TableCell>FT Staff</TableCell>
                      <TableCell>PT Staff</TableCell>
                      <TableCell>TIN</TableCell>
                      <TableCell>URSB</TableCell>
                      <TableCell>Bank</TableCell>
                      <TableCell>SACCO</TableCell>
                      <TableCell>MoMo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {latestList.map(s => {
                      const f = s._first || {};
                      const m = (allMsmes.length > 0 ? allMsmes : msmes).find(x => x.id === s.msme);
                      const hasPair = f.id && f.id !== s.id;
                      const bFT = (f.employees_ft_male||0)+(f.employees_ft_female||0);
                      const bPT = (f.employees_pt_male||0)+(f.employees_pt_female||0);
                      const aFT = (s.employees_ft_male||0)+(s.employees_ft_female||0);
                      const aPT = (s.employees_pt_male||0)+(s.employees_pt_female||0);
                      const updateCount = adminSnapshots.filter(x => x.msme === s.msme).length;
                      const revPct = hasPair && f.annual_turnover && s.annual_turnover
                        ? ((Number(s.annual_turnover)/Number(f.annual_turnover)-1)*100).toFixed(0) : null;

                      const DotCell = ({ before, after }) => (
                        <TableCell>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                            {hasPair && <Typography fontSize={10} color="text.disabled">{before ? '✓' : '✗'}</Typography>}
                            <Typography fontSize={11} fontWeight={hasPair && after !== before ? 700 : 400}
                              color={hasPair && after !== before ? (after ? 'success.main' : 'error.main') : 'text.primary'}>
                              {after ? '✓' : '✗'}
                            </Typography>
                          </Box>
                        </TableCell>
                      );

                      return (
                        <TableRow key={s.id} hover>
                          <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>{s.msme_name || `MSME ${s.msme}`}</TableCell>
                          <TableCell sx={{ fontSize: 11 }}>{m?.assigned_bge_name || '—'}</TableCell>
                          <TableCell align="center">
                            <Chip label={updateCount} size="small" variant="outlined" sx={{ fontSize: 10 }} />
                          </TableCell>
                          <TableCell sx={{ fontSize: 11 }}>
                            {hasPair ? (
                              <Box>
                                <Typography fontSize={10} color="text.disabled">{fmtUGX(f.annual_turnover)}</Typography>
                                <Typography fontSize={11} fontWeight={600}>→ {fmtUGX(s.annual_turnover)}</Typography>
                                {revPct != null && (
                                  <Chip size="small" label={`${revPct > 0 ? '+' : ''}${revPct}%`}
                                    sx={{ fontSize: 9, height: 15, bgcolor: revPct > 0 ? '#E8F5E9' : '#FFEBEE',
                                      color: revPct > 0 ? '#2E7D32' : '#C8102E', fontWeight: 700 }} />
                                )}
                              </Box>
                            ) : <Typography fontSize={11}>{fmtUGX(s.annual_turnover)}</Typography>}
                          </TableCell>
                          <TableCell sx={{ fontSize: 11 }}>{s.last_month_revenue ? fmtUGX(s.last_month_revenue) : '—'}</TableCell>
                          <TableCell sx={{ fontSize: 11 }}>
                            {hasPair ? <><Typography fontSize={10} color="text.disabled">{bFT}</Typography><Typography fontSize={11} fontWeight={600}>→ {aFT}</Typography></> : aFT || '—'}
                          </TableCell>
                          <TableCell sx={{ fontSize: 11 }}>
                            {hasPair ? <><Typography fontSize={10} color="text.disabled">{bPT}</Typography><Typography fontSize={11} fontWeight={600}>→ {aPT}</Typography></> : aPT || '—'}
                          </TableCell>
                          <DotCell before={f.has_tin} after={s.has_tin} />
                          <DotCell before={f.has_ursb} after={s.has_ursb} />
                          <TableCell>
                            {hasPair && <Typography fontSize={10} color="text.disabled">{f.has_business_bank ? '✓' : '✗'}</Typography>}
                            {s.has_business_bank == null
                              ? <Typography fontSize={11} color="text.disabled">—</Typography>
                              : <Chip size="small" label={s.bank_name || (s.has_business_bank ? '✓' : '✗')}
                                  color={s.has_business_bank ? 'success' : 'default'}
                                  variant={s.has_business_bank ? 'filled' : 'outlined'} sx={{ fontSize: 10, height: 18 }} />}
                          </TableCell>
                          <DotCell before={f.has_sacco} after={s.has_sacco} />
                          <DotCell before={f.has_mobile_money} after={s.has_mobile_money} />
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          );
        })()}

        {/* ════════════════════════════════════════════════════════════════
            TAB 4 — Data Updates (coverage, freshness, BGE scorecard)
            ════════════════════════════════════════════════════════════════ */}
        {analyticTab === 4 && (() => {
          if (adminSnapshotsLoading) return <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress /></Box>;

          const now3 = new Date();
          const daysSince = s => (now3 - new Date(s.snapshot_date)) / 86400000;

          // Latest snapshot per MSME
          const latB3 = {};
          adminSnapshots.forEach(s => {
            const cur = latB3[s.msme];
            if (!cur || s.snapshot_date > cur.snapshot_date) latB3[s.msme] = s;
          });
          const updatedSnaps = Object.values(latB3);

          // Update count per MSME
          const updCounts = {};
          adminSnapshots.forEach(s => { updCounts[s.msme] = (updCounts[s.msme] || 0) + 1; });

          // Freshness buckets
          const msmePoolTab4 = allMsmes.length > 0 ? allMsmes : msmes;
          const totalEnrolledTab4 = A.total_msmes || (msmePoolTab4.length > 0 ? msmePoolTab4.length : (msmeTotalCount || msmes.length));
          const fresh30    = updatedSnaps.filter(s => daysSince(s) <= 30);
          const stale3090  = updatedSnaps.filter(s => daysSince(s) > 30 && daysSince(s) <= 90);
          const stale90180 = updatedSnaps.filter(s => daysSince(s) > 90 && daysSince(s) <= 180);
          const stale180p  = updatedSnaps.filter(s => daysSince(s) > 180);
          const neverUpdatedMsmes = msmePoolTab4.filter(m => !latB3[m.id]);

          const freshnessData = [
            { label: '≤ 30 days',   count: fresh30.length,            fill: '#2E7D32' },
            { label: '31–90 days',  count: stale3090.length,          fill: '#F9A825' },
            { label: '91–180 days', count: stale90180.length,         fill: '#E65100' },
            { label: '180+ days',   count: stale180p.length,          fill: '#C62828' },
            { label: 'Never',       count: neverUpdatedMsmes.length,  fill: '#9E9E9E' },
          ].filter(d => d.count > 0);

          // Update frequency distribution
          const freqMap = {};
          Object.values(updCounts).forEach(n => {
            const k = n >= 5 ? '5+' : String(n);
            freqMap[k] = (freqMap[k] || 0) + 1;
          });
          const freqData = ['1','2','3','4','5+']
            .map(k => ({ updates: `${k} update${k === '1' ? '' : 's'}`, count: freqMap[k] || 0 }))
            .filter(d => d.count > 0);

          // BGE update scorecard — built from snapshots (collected_by_name), not MSME assignments.
          // For snapshots submitted before BGE accounts were linked (collected_by=null), fall back
          // to the assigned BGE of that MSME so pre-linking submissions are not lost in "Unassigned".
          const msmeBgeFallback = {};
          msmePoolTab4.forEach(m => {
            if (m.assigned_bge_name) msmeBgeFallback[m.id] = m.assigned_bge_name;
          });
          // Also build fallback from bge_workload assignment data for group-assigned MSMEs.
          // bge_workload carries bge_name but not individual msme ids, so msme-level fallback
          // is limited to direct assignments (assigned_bge_name). Group-assigned unlinked
          // snapshots will still show as "Unassigned" until collected_by is backfilled.
          const bgeSnapBuckets = {};
          adminSnapshots.forEach(s => {
            const bgeName = s.collected_by_name || msmeBgeFallback[s.msme] || 'Unassigned';
            if (!bgeSnapBuckets[bgeName]) bgeSnapBuckets[bgeName] = { msmeSet: new Set(), snapCount: 0, lastDate: null, hasUnlinked: false };
            bgeSnapBuckets[bgeName].msmeSet.add(s.msme);
            bgeSnapBuckets[bgeName].snapCount++;
            if (!s.collected_by_name && bgeName !== 'Unassigned') bgeSnapBuckets[bgeName].hasUnlinked = true;
            if (!bgeSnapBuckets[bgeName].lastDate || s.snapshot_date > bgeSnapBuckets[bgeName].lastDate)
              bgeSnapBuckets[bgeName].lastDate = s.snapshot_date;
          });
          // Join with analytics workload to get total-assigned count (handles direct + group assignments)
          const workloadLookup = {};
          (A.bge_workload || []).forEach(b => { workloadLookup[b.bge_name] = (b.direct||0) + (b.via_group||0); });
          const bgeScoreRows = Object.entries(bgeSnapBuckets).map(([bgeName, d]) => {
            const overdue90 = [...d.msmeSet].filter(id => { const lat = latB3[id]; return lat && daysSince(lat) > 90; }).length;
            return {
              name: bgeName,
              assigned: workloadLookup[bgeName] || 0,
              covered: d.msmeSet.size,
              snapCount: d.snapCount,
              lastDate: d.lastDate,
              overdue90,
              hasUnlinked: d.hasUnlinked || false,
            };
          }).sort((a, b) => b.overdue90 - a.overdue90);

          // Stale list: never updated + updated but 60+ days ago
          const staleAll = [
            ...neverUpdatedMsmes.map(m => ({
              name: m.business_name, bgeName: m.assigned_bge_name || '—',
              lastUpdate: null, days: Infinity,
            })),
            ...updatedSnaps
              .filter(s => daysSince(s) > 60)
              .map(s => {
                const m = msmePoolTab4.find(x => x.id === s.msme);
                return {
                  name: s.msme_name || `MSME ${s.msme}`,
                  bgeName: m?.assigned_bge_name || '—',
                  lastUpdate: s.snapshot_date,
                  days: Math.floor(daysSince(s)),
                };
              }),
          ].sort((a, b) => b.days - a.days);

          const coveragePct = totalEnrolledTab4 ? Math.round(updatedSnaps.length / totalEnrolledTab4 * 100) : 0;
          const avgUpd = updatedSnaps.length ? (adminSnapshots.length / updatedSnaps.length).toFixed(1) : '—';

          return (
            <Box>
              {/* ── Coverage KPIs ── */}
              <SectionLabel>Data Coverage</SectionLabel>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {[
                  { val: `${updatedSnaps.length} / ${totalEnrolledTab4}`, label: 'MSMEs Updated',      sub: 'have at least one growth update',    color: BRAND.primaryMain, pct: coveragePct },
                  { val: fresh30.length,                             label: 'Fresh (≤ 30 days)',  sub: 'updated in the last month',          color: '#2E7D32' },
                  { val: neverUpdatedMsmes.length,                  label: 'Never Updated',       sub: 'no growth data at all',              color: '#C8102E' },
                  { val: stale90180.length + stale180p.length,      label: 'Overdue (90+ days)',  sub: 'last update was 3+ months ago',      color: '#E65100' },
                  { val: avgUpd,                                     label: 'Avg Updates / MSME',  sub: 'among MSMEs with any data',          color: BRAND.gopaGoldDark },
                  { val: adminSnapshots.length,                      label: 'Total Snapshots',     sub: 'all updates ever submitted',         color: '#7B1FA2' },
                ].map((k, i) => <Grid item xs={6} sm={4} lg={2} key={i}><KPI {...k} /></Grid>)}
              </Grid>

              {/* ── Freshness + frequency + coverage rate ── */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={5}>
                  <ChartCard title="Update Freshness" subtitle="Days since last growth update — how stale is the data?" height={240}>
                    <ResponsiveContainer>
                      <BarChart data={freshnessData} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                        <XAxis dataKey="label" tick={{ fontSize: 11 }}/>
                        <YAxis tick={{ fontSize: 11 }} allowDecimals={false}/>
                        <ReTooltip formatter={v => [`${v} MSMEs`, '']}/>
                        <Bar dataKey="count" radius={[4,4,0,0]}>
                          {freshnessData.map((d, i) => <Cell key={i} fill={d.fill}/>)}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </ChartCard>
                </Grid>
                <Grid item xs={12} md={4}>
                  <ChartCard title="Update Frequency" subtitle="How many snapshots has each MSME submitted?" height={240}>
                    <ResponsiveContainer>
                      <BarChart data={freqData} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#eee"/>
                        <XAxis dataKey="updates" tick={{ fontSize: 11 }}/>
                        <YAxis tick={{ fontSize: 11 }} allowDecimals={false}/>
                        <ReTooltip formatter={v => [`${v} MSMEs`, '']}/>
                        <Bar dataKey="count" fill="#262523" radius={[4,4,0,0]}/>
                      </BarChart>
                    </ResponsiveContainer>
                  </ChartCard>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <CardContent>
                      <Typography variant="subtitle2" fontWeight={700} gutterBottom>Data Coverage Rate</Typography>
                      <Typography variant="h3" fontWeight={800} sx={{ lineHeight: 1.1 }}
                        color={coveragePct >= 80 ? '#2E7D32' : coveragePct >= 50 ? '#F9A825' : '#C8102E'}>
                        {coveragePct}%
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        of enrolled MSMEs have at least one growth update
                      </Typography>
                      <LinearProgress variant="determinate" value={Math.min(coveragePct, 100)}
                        sx={{ height: 8, borderRadius: 4, bgcolor: '#E8EDF2',
                          '& .MuiLinearProgress-bar': { bgcolor: coveragePct >= 80 ? '#2E7D32' : coveragePct >= 50 ? '#F9A825' : '#C8102E' } }}/>
                      <Typography variant="caption" color="text.secondary">
                        {updatedSnaps.length} of {totalEnrolledTab4} MSMEs
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* ── BGE Update Scorecard ── */}
              {bgeScoreRows.length > 0 && (
                <>
                  <SectionLabel>BGE Update Scorecard</SectionLabel>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                    Built from who actually <em>submitted</em> each update (collected_by field). Where collected_by is missing
                    (submissions before account linking), the BGE is inferred from MSME assignment — those rows show a <strong style={{color:'#E65100'}}>~</strong> badge.
                    "MSMEs Updated" = distinct MSMEs this BGE has submitted data for. "Overdue" = MSMEs whose most recent update is 90+ days old. Sorted by most overdue first.
                  </Typography>
                  <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead sx={{ bgcolor: '#F5F5F5' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>BGE Name</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11 }}>Total Assigned</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11 }}>MSMEs Updated</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11 }}>Total Snapshots</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Last Submitted</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11, color: '#C8102E' }}>Overdue (90+ d)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {bgeScoreRows.map((b, i) => (
                          <TableRow key={i} hover sx={b.overdue90 > 0 ? { bgcolor: '#FFF8F8' } : {}}>
                            <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                {b.name}
                                {b.hasUnlinked && (
                                  <Tooltip title="Some snapshots here were submitted before this BGE's account was linked — attributed by MSME assignment">
                                    <Chip label="~" size="small" sx={{ fontSize: 9, height: 16, bgcolor: '#FFF3E0', color: '#E65100', fontWeight: 700, cursor: 'help' }}/>
                                  </Tooltip>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 12, color: b.assigned ? 'inherit' : 'text.disabled' }}>
                              {b.assigned || '—'}
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 12, fontWeight: 600 }}>{b.covered}</TableCell>
                            <TableCell align="center" sx={{ fontSize: 12, color: 'text.secondary' }}>{b.snapCount}</TableCell>
                            <TableCell sx={{ fontSize: 11, color: 'text.secondary' }}>
                              {b.lastDate
                                ? new Date(b.lastDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: '2-digit' })
                                : '—'}
                            </TableCell>
                            <TableCell align="center">
                              {b.overdue90 > 0
                                ? <Chip label={b.overdue90} size="small"
                                    sx={{ fontSize: 10, height: 20, bgcolor: '#FFEBEE', color: '#C62828', fontWeight: 700 }}/>
                                : <Typography fontSize={12} color="text.disabled">—</Typography>}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}

              {/* ── Data Completeness ── */}
              {updatedSnaps.length > 0 && (() => {
                const total4 = updatedSnaps.length;
                const pct4 = n => total4 ? Math.round(n / total4 * 100) : 0;
                const completenessFields = [
                  { label: 'Annual Revenue',    filled: updatedSnaps.filter(s => s.annual_turnover != null && s.annual_turnover !== '').length },
                  { label: 'Last Month Rev.',   filled: updatedSnaps.filter(s => s.last_month_revenue != null && s.last_month_revenue !== '').length },
                  { label: 'Total Assets',      filled: updatedSnaps.filter(s => s.total_assets != null && s.total_assets !== '').length },
                  { label: 'FT Staff',          filled: updatedSnaps.filter(s => s.employees_ft_male != null || s.employees_ft_female != null).length },
                  { label: 'PT Staff',          filled: updatedSnaps.filter(s => s.employees_pt_male != null || s.employees_pt_female != null).length },
                  { label: 'Refugee Staff',     filled: updatedSnaps.filter(s => (s.employees_ft_refugee||0) > 0 || (s.employees_pt_refugee||0) > 0).length },
                  { label: 'TIN',               filled: updatedSnaps.filter(s => s.has_tin != null).length },
                  { label: 'URSB',              filled: updatedSnaps.filter(s => s.has_ursb != null).length },
                  { label: 'Business Bank',     filled: updatedSnaps.filter(s => s.has_business_bank != null).length },
                  { label: 'Mobile Money',      filled: updatedSnaps.filter(s => s.has_mobile_money != null).length },
                  { label: 'MOMO Pay Code',     filled: updatedSnaps.filter(s => s.has_momo_pay != null).length },
                  { label: 'SACCO',             filled: updatedSnaps.filter(s => s.has_sacco != null).length },
                  { label: 'Digital Tools',     filled: updatedSnaps.filter(s => (s.digital_tools||[]).length > 0).length },
                  { label: 'Training Impact',   filled: updatedSnaps.filter(s => s.training_made_changes != null).length },
                  { label: 'Notes / Context',   filled: updatedSnaps.filter(s => s.notes && s.notes.trim().length > 0).length },
                ].map(f => ({ ...f, pct: pct4(f.filled) }));

                const sourceData = (() => {
                  const sc = {};
                  updatedSnaps.forEach(s => { const k = s.source || 'unknown'; sc[k] = (sc[k]||0) + 1; });
                  const labels = { bge_visit: 'BGE Visit', self_report: 'Self-Report', imported: 'Imported', other: 'Other', unknown: 'Unknown' };
                  return Object.entries(sc).map(([k,v]) => ({ source: labels[k]||k, count: v })).sort((a,b)=>b.count-a.count);
                })();

                return (
                  <>
                    <SectionLabel>Data Completeness — What Fields Are Being Filled In?</SectionLabel>
                    <Box sx={{ mb: 1.5, p: 1.5, bgcolor: '#F3F6FA', borderRadius: 2, border: '1px solid #DDE4EE' }}>
                      <Typography variant="caption" color="text.secondary">
                        Based on the latest snapshot for each of the <strong>{total4} MSMEs with data</strong>.
                        Fields showing a low fill rate indicate areas where BGEs may need reminders to collect that information.
                      </Typography>
                    </Box>
                    {/* Completeness Key legend strip */}
                    <Box sx={{ display: 'flex', gap: 2.5, flexWrap: 'wrap', mb: 1.5, px: 0.5 }}>
                      {[['#2E7D32','80–100%','Good coverage'],['#F9A825','50–79%','Needs attention'],['#C8102E','< 50%','Often skipped']].map(([c,pct,lbl]) => (
                        <Box key={c} sx={{ display:'flex', alignItems:'center', gap: 0.75 }}>
                          <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: c, flexShrink: 0 }}/>
                          <Typography variant="caption" fontWeight={700} color={c}>{pct}</Typography>
                          <Typography variant="caption" color="text.secondary">— {lbl}</Typography>
                        </Box>
                      ))}
                    </Box>
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                      <Grid item xs={12} md={8}>
                        <ChartCard title="Field Fill Rate" subtitle="% of latest snapshots where each field is filled in" height={360}>
                          <ResponsiveContainer>
                            <BarChart
                              data={completenessFields}
                              layout="vertical"
                              margin={{ top: 4, right: 48, left: 4, bottom: 4 }}>
                              <CartesianGrid strokeDasharray="3 3" stroke="#eee" horizontal={false}/>
                              <XAxis type="number" domain={[0,100]} tickFormatter={v => `${v}%`} tick={{ fontSize: 10 }}/>
                              <YAxis dataKey="label" type="category" width={115} tick={{ fontSize: 10 }}/>
                              <ReTooltip formatter={(v, _, props) => [`${v}% (${props.payload.filled}/${total4} MSMEs)`, '']}/>
                              <Bar dataKey="pct" radius={[0,4,4,0]} label={{ position:'right', fontSize:9, formatter: v => `${v}%` }}>
                                {completenessFields.map((f, i) => (
                                  <Cell key={i} fill={f.pct >= 80 ? '#2E7D32' : f.pct >= 50 ? '#F9A825' : '#C8102E'}/>
                                ))}
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                        </ChartCard>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ChartCard title="Update Source" subtitle="How was the data collected?" height={360}>
                          <ResponsiveContainer>
                            <BarChart data={sourceData} layout="vertical" margin={{ top: 4, right: 32, left: 4, bottom: 4 }}>
                              <CartesianGrid strokeDasharray="3 3" stroke="#eee" horizontal={false}/>
                              <XAxis type="number" tick={{ fontSize: 10 }} allowDecimals={false}/>
                              <YAxis dataKey="source" type="category" width={90} tick={{ fontSize: 11 }}/>
                              <ReTooltip formatter={v => [`${v} snapshots`, '']}/>
                              <Bar dataKey="count" fill="#262523" radius={[0,4,4,0]}
                                label={{ position:'right', fontSize:10, fill:'#555' }}/>
                            </BarChart>
                          </ResponsiveContainer>
                        </ChartCard>
                      </Grid>
                    </Grid>
                  </>
                );
              })()}

              {/* ── Digital Tools & Training Impact ── */}
              {updatedSnaps.length > 0 && (() => {
                const toolCounts = {};
                updatedSnaps.forEach(s => (s.digital_tools||[]).forEach(t => { toolCounts[t] = (toolCounts[t]||0)+1; }));
                const toolData = Object.entries(toolCounts)
                  .sort((a,b) => b[1]-a[1]).slice(0,12)
                  .map(([tool, count]) => ({ tool: tool.length > 28 ? tool.slice(0,26)+'…' : tool, count }));

                const trainingYes  = updatedSnaps.filter(s => s.training_made_changes === true).length;
                const trainingNo   = updatedSnaps.filter(s => s.training_made_changes === false).length;
                const trainingNull = updatedSnaps.length - trainingYes - trainingNo;
                const trainingChanges = {};
                updatedSnaps.forEach(s => (s.training_changes||[]).forEach(c => { trainingChanges[c] = (trainingChanges[c]||0)+1; }));
                const trainingChangeData = Object.entries(trainingChanges)
                  .sort((a,b)=>b[1]-a[1]).slice(0,10)
                  .map(([chg,count]) => ({ change: chg.length > 28 ? chg.slice(0,26)+'…' : chg, count }));

                const trainingTotal = trainingYes + trainingNo + trainingNull;
                return (
                  <>
                    <SectionLabel>Digital Tools Adoption &amp; Training Impact</SectionLabel>

                    {/* Row 1: Digital Tools chart + Training impact side-by-side */}
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      {/* Left: Digital Tools bar chart */}
                      <Grid item xs={12} md={toolData.length > 0 ? 6 : 12}>
                        {toolData.length > 0 ? (
                          <ChartCard title="Digital Tools in Use" subtitle="Top tools adopted across businesses (latest data updates)" height={320}>
                            <ResponsiveContainer>
                              <BarChart data={toolData} layout="vertical" margin={{ top: 4, right: 40, left: 4, bottom: 4 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#eee" horizontal={false}/>
                                <XAxis type="number" allowDecimals={false} tick={{ fontSize: 10 }}/>
                                <YAxis dataKey="tool" type="category" width={135} tick={{ fontSize: 10 }}/>
                                <ReTooltip formatter={v => [`${v} businesses`, '']}/>
                                <Bar dataKey="count" fill="#D97706" radius={[0,4,4,0]}
                                  label={{ position:'right', fontSize:10, fill:'#D97706' }}/>
                              </BarChart>
                            </ResponsiveContainer>
                          </ChartCard>
                        ) : (
                          <Card variant="outlined" sx={{ height: 320, display:'flex', alignItems:'center', justifyContent:'center' }}>
                            <Typography variant="body2" color="text.secondary">No digital tool data recorded yet.</Typography>
                          </Card>
                        )}
                      </Grid>

                      {/* Right: Training impact summary */}
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined" sx={{ height: 320, display:'flex', flexDirection:'column' }}>
                          <CardContent sx={{ flex: 1 }}>
                            <Typography variant="subtitle2" fontWeight={700} gutterBottom>Training Made a Difference?</Typography>
                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                              BGE-reported training impact across latest snapshots
                            </Typography>
                            {[
                              { label: 'Yes — changes observed', count: trainingYes,  color: '#2E7D32', bg: '#E8F5E9' },
                              { label: 'No change reported',     count: trainingNo,   color: '#C8102E', bg: '#FFEBEE' },
                              { label: 'Not answered',           count: trainingNull, color: '#757575', bg: '#F5F5F5' },
                            ].map(({ label, count, color, bg }) => (
                              <Box key={label} sx={{ mb: 2 }}>
                                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb: 0.5 }}>
                                  <Typography variant="body2" fontSize={12} fontWeight={500}>{label}</Typography>
                                  <Box sx={{ display:'flex', alignItems:'center', gap: 0.75 }}>
                                    <Typography variant="body2" fontWeight={700} color={color}>{count}</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      ({trainingTotal ? Math.round(count/trainingTotal*100) : 0}%)
                                    </Typography>
                                  </Box>
                                </Box>
                                <LinearProgress variant="determinate"
                                  value={trainingTotal ? count/trainingTotal*100 : 0}
                                  sx={{ height: 10, borderRadius: 5, bgcolor: bg,
                                    '& .MuiLinearProgress-bar': { bgcolor: color, borderRadius: 5 } }}/>
                              </Box>
                            ))}
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>

                    {/* Row 2: Training Change Areas — full width */}
                    {trainingChangeData.length > 0 && (
                      <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12}>
                          <ChartCard title="Training Change Areas" subtitle="Which business aspects improved as a result of PRUDEV II training?" height={280}>
                            <ResponsiveContainer>
                              <BarChart data={trainingChangeData} layout="vertical" margin={{ top: 4, right: 60, left: 4, bottom: 4 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#eee" horizontal={false}/>
                                <XAxis type="number" allowDecimals={false} tick={{ fontSize: 10 }}/>
                                <YAxis dataKey="change" type="category" width={160} tick={{ fontSize: 10 }}/>
                                <ReTooltip formatter={v => [`${v} businesses`, '']}/>
                                <Bar dataKey="count" fill="#2E7D32" radius={[0,4,4,0]}
                                  label={{ position:'right', fontSize:10, fill:'#2E7D32' }}/>
                              </BarChart>
                            </ResponsiveContainer>
                          </ChartCard>
                        </Grid>
                      </Grid>
                    )}
                  </>
                );
              })()}

              {/* ── Latest Snapshot Data Table ── */}
              {updatedSnaps.length > 0 && (
                <>
                  <SectionLabel>Latest Snapshot — Full Data View ({updatedSnaps.length} MSMEs)</SectionLabel>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                    The most recent growth update submitted for each MSME. All key fields visible — scroll right to see more.
                    Values in <span style={{ color: '#9E9E9E' }}>grey</span> were not filled in.
                  </Typography>
                  <TableContainer component={Paper} variant="outlined" sx={{ mb: 3, maxHeight: 520, overflowY: 'auto', overflowX: 'auto' }}>
                    <Table size="small" stickyHeader sx={{ minWidth: 1200 }}>
                      <TableHead>
                        <TableRow>
                          {[
                            'Business','BGE','Date','Source',
                            'Ann. Revenue','Last Mo. Rev.','Total Assets',
                            'FT Staff','PT Staff','Refugee',
                            'TIN','URSB','Bank','MoMo','MoMo Pay','SACCO',
                            'Digital Tools','Training','Notes',
                          ].map(h => (
                            <TableCell key={h} sx={{ fontWeight: 700, fontSize: 10, bgcolor: '#F5F5F5', whiteSpace: 'nowrap' }}>{h}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[...updatedSnaps].sort((a,b) => b.snapshot_date.localeCompare(a.snapshot_date)).map(s => {
                          const fmtUGX2 = v => (v == null || v === '') ? null : `${(Number(v)/1000).toFixed(0)}K`;
                          const ft = (s.employees_ft_male||0)+(s.employees_ft_female||0);
                          const pt = (s.employees_pt_male||0)+(s.employees_pt_female||0);
                          const ref = (s.employees_ft_refugee||0)+(s.employees_pt_refugee||0);
                          const Tick = ({ val, label }) => val == null
                            ? <Typography fontSize={10} color="text.disabled">—</Typography>
                            : <Chip size="small" label={val ? (label||'✓') : '✗'}
                                sx={{ fontSize: 9, height: 16, fontWeight: 700,
                                  bgcolor: val ? '#E8F5E9' : '#FFEBEE',
                                  color: val ? '#2E7D32' : '#C62828' }}/>;
                          return (
                            <TableRow key={s.id} hover>
                              <TableCell sx={{ fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {s.msme_name || `MSME ${s.msme}`}
                              </TableCell>
                              <TableCell sx={{ fontSize: 10, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                                {s.collected_by_name || '—'}
                              </TableCell>
                              <TableCell sx={{ fontSize: 10, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                                {new Date(s.snapshot_date).toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'2-digit' })}
                              </TableCell>
                              <TableCell>
                                <Chip size="small" label={s.source === 'bge_visit' ? 'BGE' : s.source === 'self_report' ? 'Self' : s.source || '?'}
                                  sx={{ fontSize: 9, height: 16, bgcolor: s.source === 'bge_visit' ? '#FEF3C7' : '#F3E5F5', color: s.source === 'bge_visit' ? '#92400E' : '#333' }}/>
                              </TableCell>
                              {[fmtUGX2(s.annual_turnover), fmtUGX2(s.last_month_revenue), fmtUGX2(s.total_assets)].map((v,i) => (
                                <TableCell key={i} sx={{ fontSize: 10, whiteSpace: 'nowrap' }}>
                                  {v ? <Typography fontSize={10} fontWeight={600}>{v}</Typography>
                                     : <Typography fontSize={10} color="text.disabled">—</Typography>}
                                </TableCell>
                              ))}
                              <TableCell sx={{ fontSize: 10 }}>
                                {ft > 0 ? <><Typography fontSize={10} fontWeight={600} display="inline">{ft}</Typography><Typography fontSize={9} color="text.secondary" display="inline"> ({s.employees_ft_male||0}M/{s.employees_ft_female||0}F)</Typography></> : <Typography fontSize={10} color="text.disabled">—</Typography>}
                              </TableCell>
                              <TableCell sx={{ fontSize: 10 }}>
                                {pt > 0 ? <><Typography fontSize={10} fontWeight={600} display="inline">{pt}</Typography><Typography fontSize={9} color="text.secondary" display="inline"> ({s.employees_pt_male||0}M/{s.employees_pt_female||0}F)</Typography></> : <Typography fontSize={10} color="text.disabled">—</Typography>}
                              </TableCell>
                              <TableCell sx={{ fontSize: 10 }}>
                                {ref > 0 ? <Typography fontSize={10} fontWeight={600}>{ref}</Typography> : <Typography fontSize={10} color="text.disabled">—</Typography>}
                              </TableCell>
                              <TableCell><Tick val={s.has_tin}           label={s.tin_number || '✓'}/></TableCell>
                              <TableCell><Tick val={s.has_ursb}          label={s.ursb_reg_number || '✓'}/></TableCell>
                              <TableCell><Tick val={s.has_business_bank} label={s.bank_name || '✓'}/></TableCell>
                              <TableCell><Tick val={s.has_mobile_money}/></TableCell>
                              <TableCell><Tick val={s.has_momo_pay}      label={s.momo_pay_code || '✓'}/></TableCell>
                              <TableCell><Tick val={s.has_sacco}/></TableCell>
                              <TableCell sx={{ fontSize: 10 }}>
                                {(s.digital_tools||[]).length > 0
                                  ? <Chip size="small" label={`${(s.digital_tools||[]).length} tool${(s.digital_tools||[]).length > 1 ? 's' : ''}`}
                                      sx={{ fontSize: 9, height: 16, bgcolor: '#F5F5F4', color: '#44403C' }}/>
                                  : <Typography fontSize={10} color="text.disabled">—</Typography>}
                              </TableCell>
                              <TableCell>
                                {s.training_made_changes == null
                                  ? <Typography fontSize={10} color="text.disabled">—</Typography>
                                  : <Chip size="small" label={s.training_made_changes ? 'Yes' : 'No'}
                                      sx={{ fontSize: 9, height: 16,
                                        bgcolor: s.training_made_changes ? '#E8F5E9' : '#FFEBEE',
                                        color:   s.training_made_changes ? '#2E7D32' : '#C62828', fontWeight: 700 }}/>}
                              </TableCell>
                              <TableCell sx={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {s.notes && s.notes.trim()
                                  ? <Tooltip title={s.notes} placement="left">
                                      <Typography fontSize={10} color="text.secondary" sx={{ cursor: 'default', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 130 }}>
                                        {s.notes.trim().slice(0, 50)}{s.notes.trim().length > 50 ? '…' : ''}
                                      </Typography>
                                    </Tooltip>
                                  : <Typography fontSize={10} color="text.disabled">—</Typography>}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}

              {/* ── Stale MSME list ── */}
              {staleAll.length > 0 && (
                <>
                  <SectionLabel>MSMEs Needing a Visit ({staleAll.length})</SectionLabel>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                    MSMEs that have never been updated, or whose last growth update was more than 60 days ago.
                    Share this list with BGEs to prioritise field visits.
                  </Typography>
                  <TableContainer component={Paper} variant="outlined" sx={{ mb: 3, maxHeight: 440, overflowY: 'auto' }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700, fontSize: 11, bgcolor: '#F5F5F5' }}>Business Name</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: 11, bgcolor: '#F5F5F5' }}>Assigned BGE</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: 11, bgcolor: '#F5F5F5' }}>Last Update</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, bgcolor: '#F5F5F5' }}>Days Since Update</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {staleAll.slice(0, 100).map((r, i) => (
                          <TableRow key={i} hover
                            sx={r.days === Infinity ? { bgcolor: '#FFF3E0' } : r.days > 180 ? { bgcolor: '#FFF8F8' } : {}}>
                            <TableCell sx={{ fontSize: 11, fontWeight: 600 }}>{r.name}</TableCell>
                            <TableCell sx={{ fontSize: 11, color: 'text.secondary' }}>{r.bgeName}</TableCell>
                            <TableCell sx={{ fontSize: 11 }}>
                              {r.lastUpdate
                                ? new Date(r.lastUpdate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: '2-digit' })
                                : <Chip size="small" label="Never updated"
                                    sx={{ fontSize: 10, bgcolor: '#FFF3E0', color: '#E65100', fontWeight: 700 }}/>}
                            </TableCell>
                            <TableCell align="right">
                              {r.days === Infinity
                                ? <Chip size="small" label="No data"
                                    sx={{ fontSize: 10, height: 18, bgcolor: '#FFF3E0', color: '#E65100', fontWeight: 700 }}/>
                                : <Chip size="small" label={`${r.days} days`}
                                    sx={{ fontSize: 10, height: 18, fontWeight: 700,
                                      bgcolor: r.days > 180 ? '#FFEBEE' : r.days > 90 ? '#FFF3E0' : '#FFFDE7',
                                      color:   r.days > 180 ? '#C62828' : r.days > 90 ? '#E65100' : '#F57F17' }}/>}
                            </TableCell>
                          </TableRow>
                        ))}
                        {staleAll.length > 100 && (
                          <TableRow>
                            <TableCell colSpan={4} align="center" sx={{ color: 'text.secondary', fontSize: 11, py: 1.5 }}>
                              Showing first 100 of {staleAll.length} — export the full list via the CSV button on the Growth &amp; Impact tab
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}

              {adminSnapshots.length === 0 && (
                <Box sx={{ py: 8, textAlign: 'center' }}>
                  <Assessment sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
                  <Typography variant="h6" color="text.secondary">No growth updates yet.</Typography>
                  <Typography variant="body2" color="text.secondary">
                    BGEs need to submit at least one growth update before data appears here.
                  </Typography>
                </Box>
              )}
            </Box>
          );
        })()}

        {/* ════════════════════════════════════════════════════════════════
            TAB 5 — Diagnostic Baselines & Cohorts Analytics
            ════════════════════════════════════════════════════════════════ */}
        {analyticTab === 5 && (() => {
          if (diagLoading) return <Box sx={{ py: 6, textAlign: 'center' }}><CircularProgress /></Box>;
          if (!diagSummary) return (
            <Box sx={{ py: 6, textAlign: 'center' }}>
              <Assessment sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6" color="text.secondary">Diagnostic data not loaded.</Typography>
            </Box>
          );

          const handleExportDiagExcel = async () => {
            try {
              setDiagExportLoading(true);
              const resp = await axios.get(
                `${API_ENDPOINTS.DIAGNOSTIC_EXPORT_EXCEL}${diagCohortFilter !== 'all' ? `?cohort=${encodeURIComponent(diagCohortFilter)}` : ''}`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                  responseType: 'blob',
                }
              );
              const blobUrl = window.URL.createObjectURL(new Blob([resp.data]));
              const a = document.createElement('a');
              a.href = blobUrl;
              a.setAttribute('download', `PRUDEV_II_Diagnostic_Progress_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
              document.body.appendChild(a);
              a.click();
              a.remove();
            } catch (err) {
              console.error('Failed to export diagnostic report:', err);
            } finally {
              setDiagExportLoading(false);
            }
          };

          const wf = diagSummary.workforce || {};
          const form = diagSummary.formalization || {};
          const fin = diagSummary.financial_health || {};
          const ops = diagSummary.operations_quality || {};
          const dig = diagSummary.digitalization || {};
          const grn = diagSummary.green || {};
          const gov = diagSummary.governance || {};
          const c1 = diagCohorts?.cohort_1 || {};
          const c2 = diagCohorts?.cohort_2 || {};

          return (
            <Box>
              {/* ── Context & Action Header ── */}
              <Box sx={{ mb: 3, p: 2.5, bgcolor: '#F0F4FA', borderRadius: 2, borderLeft: `4px solid ${BRAND.primaryMain}`, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { md: 'center' }, gap: 2 }}>
                <Box>
                  <Typography variant="h6" fontWeight={700} color={BRAND.primaryMain}>
                    PRUDEV II MSME Diagnostic Baseline &amp; Multi-Thematic Analytics
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Enriched diagnostic analysis across <strong>{diagSummary.total_assessed} assessed enterprises</strong> (170 in Cohort 1, 77 in Cohort 2).
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={diagExportLoading ? <CircularProgress size={18} color="inherit" /> : <Download />}
                  onClick={handleExportDiagExcel}
                  disabled={diagExportLoading}
                  sx={{ bgcolor: BRAND.primaryMain, '&:hover': { bgcolor: '#0D1B2A' }, whiteSpace: 'nowrap' }}
                >
                  {diagExportLoading ? 'Generating…' : 'Export Diagnostic Report (.xlsx)'}
                </Button>
              </Box>

              {/* ── Cohort Filter Tabs / Chips ── */}
              <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                <Typography variant="subtitle2" fontWeight={700} color="text.secondary">
                  Cohort View:
                </Typography>
                {[
                  { key: 'all', label: `All Assessed (${diagSummary.total_assessed})` },
                  { key: 'Cohort 1', label: `Cohort 1 (${diagSummary.cohort_counts?.['Cohort 1 (Selected MSMEs)'] || 170})` },
                  { key: 'Cohort 2', label: `Cohort 2 (${diagSummary.cohort_counts?.['Cohort 2 (Selected MSMEs)'] || 77})` },
                  { key: 'compare', label: 'Side-by-Side Comparison' },
                ].map(({ key, label }) => (
                  <Chip
                    key={key}
                    label={label}
                    clickable
                    color={diagCohortFilter === key ? 'primary' : 'default'}
                    variant={diagCohortFilter === key ? 'filled' : 'outlined'}
                    onClick={() => setDiagCohortFilter(key)}
                    sx={{ fontWeight: 600, fontSize: 12 }}
                  />
                ))}
              </Box>

              {/* ── Side-by-Side Cohort Comparison View ── */}
              {diagCohortFilter === 'compare' ? (
                <Box sx={{ mb: 4 }}>
                  <SectionLabel>Cohort 1 vs Cohort 2 Baseline Comparison</SectionLabel>
                  <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead sx={{ bgcolor: '#F5F5F5' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>Indicator / Metric Dimension</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 12, bgcolor: '#E8F5E9', color: '#1B5E20' }}>
                            Cohort 1 (Selected MSMEs)
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 12, bgcolor: '#E3F2FD', color: '#0D47A1' }}>
                            Cohort 2 (Selected MSMEs)
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, fontSize: 12 }}>Variance / Insight</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[
                          // Demographics & Workforce
                          { label: 'Enterprises Assessed', c1: `${c1.total_assessed || 0}`, c2: `${c2.total_assessed || 0}`, note: 'Diagnostic baseline coverage' },
                          { label: 'Total Baseline Jobs', c1: `${(c1.workforce?.total_baseline_jobs || 0).toLocaleString()}`, c2: `${(c2.workforce?.total_baseline_jobs || 0).toLocaleString()}`, note: `Avg ${(c1.total_assessed ? (c1.workforce?.total_baseline_jobs / c1.total_assessed).toFixed(1) : 0)} vs ${(c2.total_assessed ? (c2.workforce?.total_baseline_jobs / c2.total_assessed).toFixed(1) : 0)} jobs/enterprise` },
                          { label: 'Female Workforce Share (%)', c1: `${c1.workforce?.female_share_pct || 0}%`, c2: `${c2.workforce?.female_share_pct || 0}%`, note: (c2.workforce?.female_share_pct > c1.workforce?.female_share_pct ? '+ Higher female share in Cohort 2' : '') },
                          { label: 'Youth Employment Share (%)', c1: `${c1.workforce?.youth_share_pct || 0}%`, c2: `${c2.workforce?.youth_share_pct || 0}%`, note: `${c1.workforce?.ft_youth || 0} vs ${c2.workforce?.ft_youth || 0} youth employed` },
                          // Formalization & Compliance
                          { label: 'URA Tax ID (TIN) Registered', c1: `${c1.formalization?.has_tin_pct || 0}%`, c2: `${c2.formalization?.has_tin_pct || 0}%`, note: 'Formal tax registration' },
                          { label: 'Dedicated Business Bank Account', c1: `${c1.formalization?.has_bank_pct || 0}%`, c2: `${c2.formalization?.has_bank_pct || 0}%`, note: 'Banking inclusion baseline' },
                          { label: 'Registered Brand Logo', c1: `${c1.formalization?.has_brand_logo_pct || 0}%`, c2: `${c2.formalization?.has_brand_logo_pct || 0}%`, note: 'Brand identity maturity' },
                          { label: 'Affiliated to Industry Association', c1: `${c1.formalization?.has_association_pct || 0}%`, c2: `${c2.formalization?.has_association_pct || 0}%`, note: 'UMA, USSIA, PSFU, etc.' },
                          // Financials & Accounting
                          { label: 'Operating Profitably (%)', c1: `${c1.total_assessed ? Math.round((c1.financial_health?.profit_breakdown?.Profitable || 0) / c1.total_assessed * 100) : 0}%`, c2: `${c2.total_assessed ? Math.round((c2.financial_health?.profit_breakdown?.Profitable || 0) / c2.total_assessed * 100) : 0}%`, note: 'Self-reported past 12 months' },
                          { label: 'Electronic Accounting Software', c1: `${c1.total_assessed ? Math.round((c1.financial_health?.bookkeeping?.['Electronic Software'] || 0) / c1.total_assessed * 100) : 0}%`, c2: `${c2.total_assessed ? Math.round((c2.financial_health?.bookkeeping?.['Electronic Software'] || 0) / c2.total_assessed * 100) : 0}%`, note: 'QuickBooks, Tally, Excel' },
                          { label: 'Annual Audited Financial Accounts', c1: `${c1.financial_health?.audited_pct || 0}%`, c2: `${c2.financial_health?.audited_pct || 0}%`, note: 'Certified auditor sign-off' },
                          { label: 'Crisis Cash Reserves Maintained', c1: `${c1.financial_health?.cash_reserves_pct || 0}%`, c2: `${c2.financial_health?.cash_reserves_pct || 0}%`, note: 'Buffer for crisis resilience' },
                          // Operations & Quality
                          { label: 'UNBS Certified Products', c1: `${c1.operations_quality?.unbs_pct || 0}%`, c2: `${c2.operations_quality?.unbs_pct || 0}%`, note: 'Standards certification' },
                          { label: 'Quality Control Measures in Place', c1: `${c1.operations_quality?.qc_measures_pct || 0}%`, c2: `${c2.operations_quality?.qc_measures_pct || 0}%`, note: 'In-house quality systems' },
                          { label: 'Food Health / Safety Certificates', c1: `${c1.operations_quality?.food_health_pct || 0}%`, c2: `${c2.operations_quality?.food_health_pct || 0}%`, note: 'Food processing compliance' },
                          { label: 'Process/Product Innovation (Last 2 Yrs)', c1: `${c1.operations_quality?.innovation_2yr_pct || 0}%`, c2: `${c2.operations_quality?.innovation_2yr_pct || 0}%`, note: 'Active innovation adoption' },
                          { label: 'Meets Current Market Demand', c1: `${c1.operations_quality?.meets_demand_pct || 0}%`, c2: `${c2.operations_quality?.meets_demand_pct || 0}%`, note: 'Production capacity adequacy' },
                          // Digital & Green
                          { label: 'Average Digitalization Score (1–5)', c1: `${c1.digitalization?.avg_score || 0}`, c2: `${c2.digitalization?.avg_score || 0}`, note: 'Self-rated digital adoption' },
                          { label: 'Dedicated IT / Digitalization Personnel', c1: `${c1.digitalization?.has_it_staff_pct || 0}%`, c2: `${c2.digitalization?.has_it_staff_pct || 0}%`, note: 'Internal digital leadership' },
                          { label: 'Social Media Marketing', c1: `${c1.digitalization?.social_media_pct || 0}%`, c2: `${c2.digitalization?.social_media_pct || 0}%`, note: 'Online promotional channels' },
                          { label: 'Cloud / Internet Storage Adoption', c1: `${c1.digitalization?.cloud_storage_pct || 0}%`, c2: `${c2.digitalization?.cloud_storage_pct || 0}%`, note: 'Google Drive, OneDrive, etc.' },
                          { label: 'Green Business Classification', c1: `${c1.green?.green_pct || 0}%`, c2: `${c2.green?.green_pct || 0}%`, note: 'GIZ green enterprise match' },
                          { label: 'Environmental Management Plan', c1: `${c1.green?.env_plan_pct || 0}%`, c2: `${c2.green?.env_plan_pct || 0}%`, note: 'Written plan & mitigation' },
                        ].map((row, idx) => (
                          <TableRow key={idx} hover sx={idx % 2 === 1 ? { bgcolor: '#FAFAFA' } : {}}>
                            <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>{row.label}</TableCell>
                            <TableCell align="center" sx={{ fontSize: 12, fontWeight: 700 }}>{row.c1}</TableCell>
                            <TableCell align="center" sx={{ fontSize: 12, fontWeight: 700 }}>{row.c2}</TableCell>
                            <TableCell align="center" sx={{ fontSize: 11, color: 'text.secondary' }}>{row.note || '—'}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                <>
                  {/* ── Summary KPI Grid ── */}
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6} md={2.4}>
                      <Card variant="outlined" sx={{ height: '100%', borderLeft: '4px solid #162A3A' }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                            Assessed MSMEs
                          </Typography>
                          <Typography variant="h4" fontWeight={800} color="#162A3A" sx={{ my: 0.5 }}>
                            {diagSummary.total_assessed}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {wf.total_baseline_jobs?.toLocaleString()} baseline jobs
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Card variant="outlined" sx={{ height: '100%', borderLeft: '4px solid #27AE60' }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                            Baseline Jobs
                          </Typography>
                          <Typography variant="h4" fontWeight={800} color="#27AE60" sx={{ my: 0.5 }}>
                            {(wf.total_baseline_jobs || 0).toLocaleString()}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {wf.female_share_pct}% Female | {wf.youth_share_pct}% Youth
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Card variant="outlined" sx={{ height: '100%', borderLeft: '4px solid #D97706' }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                            URA TIN Registered
                          </Typography>
                          <Typography variant="h4" fontWeight={800} color="#D97706" sx={{ my: 0.5 }}>
                            {form.has_tin_pct}%
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {form.has_tin_count} formal tax registered
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Card variant="outlined" sx={{ height: '100%', borderLeft: '4px solid #1E88E5' }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                            UNBS Quality Certified
                          </Typography>
                          <Typography variant="h4" fontWeight={800} color="#1E88E5" sx={{ my: 0.5 }}>
                            {ops.unbs_pct}%
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {ops.qc_measures_pct}% have in-house QC
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Card variant="outlined" sx={{ height: '100%', borderLeft: '4px solid #2E7D32' }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                            Green Business
                          </Typography>
                          <Typography variant="h4" fontWeight={800} color="#2E7D32" sx={{ my: 0.5 }}>
                            {grn.green_pct}%
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {grn.green_count} green enterprises
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

                  {/* ── Section 1: Financial Performance, Accounting & Credit ── */}
                  <SectionLabel>1. Financial Performance, Accounting &amp; Cash Reserves</SectionLabel>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={4}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Profitability &amp; 12-Month Revenue Trajectory
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Baseline revenue movement and profit status
                          </Typography>
                          <Box sx={{ mb: 2, p: 1.5, bgcolor: '#F0FDF4', borderRadius: 1.5, border: '1px solid #DCFCE7' }}>
                            <Typography variant="caption" color="text.secondary">Reported Operating Profit</Typography>
                            <Typography variant="h6" fontWeight={700} color="#15803D">
                              {fin.profit_breakdown?.Profitable || 0} / {diagSummary.total_assessed} ({Math.round((fin.profit_breakdown?.Profitable || 0) / (diagSummary.total_assessed || 1) * 100)}% Profitable)
                            </Typography>
                          </Box>
                          <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 1 }}>
                            12-Month Revenue Trend:
                          </Typography>
                          {Object.entries(fin.revenue_trend || {}).map(([tr, count], i) => (
                            <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.4, borderBottom: '1px dashed #E2E8F0' }}>
                              <Typography variant="body2" fontSize={11}>{tr}</Typography>
                              <Typography variant="body2" fontSize={11} fontWeight={700}>{count} MSMEs</Typography>
                            </Box>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Bookkeeping &amp; Accounting Practices
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Financial record-keeping systems and audit coverage
                          </Typography>
                          {[
                            { label: 'Electronic Software (QuickBooks/Excel)', val: fin.bookkeeping?.['Electronic Software'] || 0, color: '#0284C7' },
                            { label: 'Manual / Paper Ledger Books', val: fin.bookkeeping?.['Manual / Paper Books'] || 0, color: '#F59E0B' },
                            { label: 'No Formal Financial Records', val: fin.bookkeeping?.['No Formal Records'] || 0, color: '#EF4444' },
                          ].map((item, i) => (
                            <Box key={i} sx={{ mb: 1.5 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                <Typography variant="body2" fontSize={11} fontWeight={500}>{item.label}</Typography>
                                <Typography variant="body2" fontSize={11} fontWeight={700} color={item.color}>
                                  {item.val} ({Math.round(item.val / (diagSummary.total_assessed || 1) * 100)}%)
                                </Typography>
                              </Box>
                              <LinearProgress variant="determinate" value={Math.round(item.val / (diagSummary.total_assessed || 1) * 100)} sx={{ height: 6, borderRadius: 3, bgcolor: '#F1F5F9', '& .MuiLinearProgress-bar': { bgcolor: item.color } }} />
                            </Box>
                          ))}
                          <Divider sx={{ my: 1.5 }} />
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="caption" fontWeight={600} color="text.secondary">Audited by Accredited Accountant</Typography>
                            <Chip size="small" label={`${fin.audited_pct}%`} sx={{ fontWeight: 700, bgcolor: fin.audited_pct > 25 ? '#DCFCE7' : '#FEF3C7', color: fin.audited_pct > 25 ? '#166534' : '#92400E' }} />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Crisis Cash Reserves &amp; Credit
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Business resilience and loan access profile
                          </Typography>
                          <Box sx={{ mb: 2, p: 1.5, bgcolor: '#F8FAFC', borderRadius: 1.5, border: '1px solid #E2E8F0' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="caption" color="text.secondary">Has Crisis Cash Reserves</Typography>
                              <Typography variant="caption" fontWeight={700} color="#0F766E">{fin.cash_reserves_pct}%</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                              <Typography variant="caption" color="text.secondary">Has Outstanding Business Loan</Typography>
                              <Typography variant="caption" fontWeight={700} color="#7C3AED">{fin.loan_outstanding_pct}%</Typography>
                            </Box>
                          </Box>
                          <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 1 }}>
                            Reserves Duration in Crisis:
                          </Typography>
                          {Object.entries(fin.reserves_duration || {}).map(([dur, count], i) => (
                            <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.3 }}>
                              <Typography variant="body2" fontSize={11}>{dur}</Typography>
                              <Typography variant="body2" fontSize={11} fontWeight={700}>{count} MSMEs</Typography>
                            </Box>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

                  {/* ── Section 2: Operations, Standards & UNBS Quality ── */}
                  <SectionLabel>2. Operations, Quality Standards &amp; Market Readiness</SectionLabel>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Quality Assurance &amp; Standards Compliance
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Certification, food safety and quality control systems
                          </Typography>
                          {[
                            { label: 'In-house Quality Control Measures', pct: ops.qc_measures_pct || 0, color: '#2563EB' },
                            { label: 'UNBS Product Quality Certification', pct: ops.unbs_pct || 0, color: '#16A34A' },
                            { label: 'Familiar with HSSEQ Legal Standards', pct: ops.hsseq_pct || 0, color: '#D97706' },
                            { label: 'Food Health & Safety Certificate', pct: ops.food_health_pct || 0, color: '#9333EA' },
                          ].map((item, i) => (
                            <Box key={i} sx={{ mb: 1.5 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                <Typography variant="body2" fontSize={12} fontWeight={500}>{item.label}</Typography>
                                <Typography variant="body2" fontSize={12} fontWeight={700} color={item.color}>
                                  {item.pct}%
                                </Typography>
                              </Box>
                              <LinearProgress variant="determinate" value={item.pct} sx={{ height: 6, borderRadius: 3, bgcolor: '#F1F5F9', '& .MuiLinearProgress-bar': { bgcolor: item.color } }} />
                            </Box>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Market Capacity &amp; Innovation Pace
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Production capacity vs demand and 2-year innovation track record
                          </Typography>
                          <Grid container spacing={1.5} sx={{ mb: 2 }}>
                            <Grid item xs={6}>
                              <Box sx={{ p: 2, bgcolor: '#F8FAFC', borderRadius: 1.5, border: '1px solid #E2E8F0', textAlign: 'center' }}>
                                <Typography variant="caption" color="text.secondary">Meets Market Demand</Typography>
                                <Typography variant="h5" fontWeight={800} color="#0D9488">{ops.meets_demand_pct}%</Typography>
                                <Typography variant="caption" color="text.secondary">of assessed enterprises</Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box sx={{ p: 2, bgcolor: '#F8FAFC', borderRadius: 1.5, border: '1px solid #E2E8F0', textAlign: 'center' }}>
                                <Typography variant="caption" color="text.secondary">2-Year Innovation Rate</Typography>
                                <Typography variant="h5" fontWeight={800} color="#4F46E5">{ops.innovation_2yr_pct}%</Typography>
                                <Typography variant="caption" color="text.secondary">new process/product</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
                            <Typography variant="body2" fontSize={11}>Registered Brand Logo</Typography>
                            <Typography variant="body2" fontSize={11} fontWeight={700}>{form.has_brand_logo_pct}%</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
                            <Typography variant="body2" fontSize={11}>Affiliated to Trade Association</Typography>
                            <Typography variant="body2" fontSize={11} fontWeight={700}>{form.has_association_pct}%</Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

                  {/* ── Section 3: Digitalization & Technology Maturity ── */}
                  <SectionLabel>3. Digitalization &amp; Technology Adoption</SectionLabel>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Digital Maturity Level (1 to 5 Scale)
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Average Digitalization Score: <strong>{dig.avg_score} / 5.0</strong>
                          </Typography>
                          <Grid container spacing={1}>
                            {[
                              { lvl: '1 - None', count: dig.score_distribution?.[1] || 0, color: '#EF4444' },
                              { lvl: '2 - Basic', count: dig.score_distribution?.[2] || 0, color: '#F59E0B' },
                              { lvl: '3 - Moderate', count: dig.score_distribution?.[3] || 0, color: '#3B82F6' },
                              { lvl: '4 - Advanced', count: dig.score_distribution?.[4] || 0, color: '#10B981' },
                              { lvl: '5 - Full Digital', count: dig.score_distribution?.[5] || 0, color: '#6366F1' },
                            ].map((lvlItem, idx) => (
                              <Grid item xs={2.4} key={idx}>
                                <Box sx={{ p: 1, bgcolor: '#F8FAFC', borderRadius: 1.5, border: '1px solid #E2E8F0', textAlign: 'center' }}>
                                  <Typography variant="caption" fontSize={9} color="text.secondary" display="block">{lvlItem.lvl}</Typography>
                                  <Typography variant="body1" fontWeight={800} color={lvlItem.color}>{lvlItem.count}</Typography>
                                  <Typography variant="caption" fontSize={9} color="text.secondary">({Math.round(lvlItem.count / (diagSummary.total_assessed || 1) * 100)}%)</Typography>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Digital Tools &amp; Marketing Channels
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Adoption of digital payments, online marketing, and cloud systems
                          </Typography>
                          <Grid container spacing={1}>
                            {[
                              { label: 'Accepts Digital Payments', pct: dig.digital_payments_pct || 0 },
                              { label: 'Data-Driven Decisions', pct: dig.data_decision_pct || 0 },
                              { label: 'Cloud / Online Storage', pct: dig.cloud_storage_pct || 0 },
                              { label: 'Social Media Marketing', pct: dig.social_media_pct || 0 },
                              { label: 'Dedicated IT Staff', pct: dig.has_it_staff_pct || 0 },
                            ].map((dItem, idx) => (
                              <Grid item xs={6} key={idx}>
                                <Box sx={{ p: 1, bgcolor: '#F8FAFC', borderRadius: 1.5, border: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="caption" fontSize={11}>{dItem.label}</Typography>
                                  <Chip size="small" label={`${dItem.pct}%`} sx={{ fontSize: 10, height: 18, fontWeight: 700, bgcolor: dItem.pct > 30 ? '#DCFCE7' : '#F1F5F9', color: dItem.pct > 30 ? '#166534' : 'inherit' }} />
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

                  {/* ── Section 4: Workforce, Ownership & Governance ── */}
                  <SectionLabel>4. Workforce Demographics &amp; Ownership Governance</SectionLabel>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Workforce Breakdown at Baseline
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Direct employment generated across assessed micro and small enterprises
                          </Typography>
                          <Grid container spacing={1.5}>
                            {[
                              { label: 'Full-time Male', val: wf.ft_male || 0, color: '#1E88E5' },
                              { label: 'Full-time Female', val: wf.ft_female || 0, color: '#E91E63' },
                              { label: 'Full-time Youth', val: wf.ft_youth || 0, color: '#8E24AA' },
                              { label: 'Part-time / Casual', val: wf.pt_total || 0, color: '#F57C00' },
                            ].map((item, i) => (
                              <Grid item xs={6} key={i}>
                                <Box sx={{ p: 1.5, bgcolor: '#F8FAFC', borderRadius: 1.5, border: '1px solid #E2E8F0' }}>
                                  <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                                  <Typography variant="h6" fontWeight={700} color={item.color}>
                                    {(item.val).toLocaleString()}
                                  </Typography>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                          <Box sx={{ mt: 2, pt: 1.5, borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="caption" color="text.secondary">Female Ownership:</Typography>
                            <Typography variant="caption" fontWeight={700}>{gov.owner_gender?.female || 0} Female Owners ({Math.round((gov.owner_gender?.female || 0) / ((gov.owner_gender?.female || 0) + (gov.owner_gender?.male || 0) || 1) * 100)}%)</Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Legal Structures &amp; Form of Enterprise
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Distribution of registered legal entities
                          </Typography>
                          {Object.entries(gov.legal_forms || {}).map(([lForm, cnt], i) => (
                            <Box key={i} sx={{ mb: 1.5 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                <Typography variant="body2" fontSize={12} fontWeight={500}>{lForm}</Typography>
                                <Typography variant="body2" fontSize={12} fontWeight={700} color="#1E293B">
                                  {cnt} ({Math.round(cnt / (diagSummary.total_assessed || 1) * 100)}%)
                                </Typography>
                              </Box>
                              <LinearProgress
                                variant="determinate"
                                value={Math.round(cnt / (diagSummary.total_assessed || 1) * 100)}
                                sx={{ height: 6, borderRadius: 3, bgcolor: '#F1F5F9', '& .MuiLinearProgress-bar': { bgcolor: '#475569' } }}
                              />
                            </Box>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

                  {/* ── Section 5: Capacity Development Needs & Green Sustainability ── */}
                  <SectionLabel>5. Prioritized Capacity Needs &amp; Environmental Sustainability</SectionLabel>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Prioritized Capacity Building Demands
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Top technical assistance and coaching requested by MSMEs
                          </Typography>
                          {Object.entries(diagSummary.capacity_needs || {}).map(([need, cnt], i) => (
                            <Box key={i} sx={{ mb: 1.5 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                <Typography variant="body2" fontSize={11} fontWeight={500}>{need}</Typography>
                                <Typography variant="body2" fontSize={11} fontWeight={700} color={BRAND.primaryMain}>
                                  {cnt} MSMEs ({Math.round(cnt / (diagSummary.total_assessed || 1) * 100)}%)
                                </Typography>
                              </Box>
                              <LinearProgress
                                variant="determinate"
                                value={Math.round(cnt / (diagSummary.total_assessed || 1) * 100)}
                                sx={{ height: 6, borderRadius: 3, bgcolor: '#F1F5F9', '& .MuiLinearProgress-bar': { bgcolor: BRAND.primaryMain } }}
                              />
                            </Box>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                            Green Business Classifications &amp; Practices
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            Environmental management plans ({grn.env_plan_pct}%), resource monitoring ({grn.resource_monitor_pct}%), waste reduction ({grn.waste_systems_pct}%)
                          </Typography>
                          {Object.entries(grn.categories || {}).map(([catName, cnt], i) => (
                            <Box key={i} sx={{ mb: 1.5 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                <Typography variant="body2" fontSize={11} fontWeight={500} sx={{ maxWidth: '80%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                  {catName}
                                </Typography>
                                <Typography variant="body2" fontSize={12} fontWeight={700} color="#27AE60">
                                  {cnt}
                                </Typography>
                              </Box>
                              <LinearProgress
                                variant="determinate"
                                value={Math.min(Math.round(cnt / (diagSummary.total_assessed || 1) * 100), 100)}
                                sx={{ height: 6, borderRadius: 3, bgcolor: '#F1F5F9', '& .MuiLinearProgress-bar': { bgcolor: '#27AE60' } }}
                              />
                            </Box>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          );
        })()}
      </Box>
    );
  };

  const renderUsers = () => {
    const pendingUsers = bgeUsers.filter(u => u.role === 'pending');
    return (
    <Box>
      <SectionHeader title="User Accounts" subtitle={`${bgeUsers.length} account${bgeUsers.length !== 1 ? 's' : ''} — BGEs, Programme Managers, Viewers`}>
        <Button variant="outlined" color="warning" size="small" sx={{ mr: 1 }} onClick={() => setBulkPwdDialog(true)} disabled={userLoading}>
          Reset All BGE Passwords
        </Button>
        {experts.some(e => !bgeUsers.some(u => u.bge_profile?.id === e.id)) && (
          <Button variant="outlined" size="small" sx={{ mr: 1 }} onClick={bulkCreateMissingAccounts} disabled={userLoading}>
            {userLoading ? 'Creating…' : 'Create Missing Accounts'}
          </Button>
        )}
        <Button variant="contained" size="small" startIcon={<PersonAdd />} onClick={() => setUserDialog(true)}>
          Create Account
        </Button>
      </SectionHeader>

      {pendingUsers.length > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography fontWeight={700} sx={{ mb: 1 }}>
            {pendingUsers.length} account{pendingUsers.length !== 1 ? 's' : ''} awaiting approval
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            These signed in with Google but aren't linked to a BGE/Programme Manager profile and have no data access until approved.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {pendingUsers.map(u => (
              <Box key={u.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <Typography fontSize={13} fontWeight={600}>{u.username}</Typography>
                <Typography fontSize={13} color="text.secondary">{u.email}</Typography>
                <Button size="small" variant="contained" color="success" onClick={() => approveUser(u)}>
                  Approve as Viewer
                </Button>
                <Button size="small" variant="outlined" color="error" onClick={() => rejectUser(u)}>
                  Reject
                </Button>
              </Box>
            ))}
          </Box>
        </Alert>
      )}

      <Alert severity="info" sx={{ mb: 2 }}>
        Create and manage login accounts for all users. <strong>BGE</strong> accounts are linked to an expert profile and see only their assigned MSMEs. <strong>Programme Managers</strong> see all MSMEs in their assigned groups. <strong>Viewers</strong> have read-only access to everything. Use the <ManageAccounts sx={{ fontSize: 14, verticalAlign: 'middle' }} /> icon on any row to change a user's role.
      </Alert>

      {bgeUsers.length === 0 ? (
        <Paper sx={{ p: 6, textAlign: 'center' }}>
          <ManageAccounts sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
          <Typography color="text.secondary">No BGE user accounts yet.</Typography>
          <Typography variant="body2" color="text.secondary">Click "Create Account" to give a BGE Expert login access.</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Username</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Linked BGE Expert</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bgeUsers.map(u => (
                <TableRow key={u.id} hover>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Avatar sx={{ width: 28, height: 28, fontSize: 12, bgcolor: BRAND.programmeGreen }}>{(u.username || '?')[0].toUpperCase()}</Avatar>
                      <Typography fontSize={13} fontWeight={600}>{u.username}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell><Typography fontSize={13}>{u.email || '—'}</Typography></TableCell>
                  <TableCell>
                    {u.bge_profile ? (
                      <Chip label={u.bge_profile.name} size="small" color="success" variant="outlined" />
                    ) : (
                      <Chip label="Not linked" size="small" color="warning" variant="outlined" />
                    )}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                      {u.role === 'cohort_admin' ? (
                        <>
                          <Chip label="Programme Manager" size="small" color="primary" variant="outlined"
                            onClick={() => openRoleDialog(u)} sx={{ cursor: 'pointer' }} />
                          {u.managed_groups?.map(g => (
                            <Chip key={g.id} label={g.name} size="small" sx={{ fontSize: 10 }} />
                          ))}
                        </>
                      ) : u.role === 'bge' ? (
                        <Chip label="BGE" size="small" color="success" variant="outlined"
                          onClick={() => openRoleDialog(u)} sx={{ cursor: 'pointer' }} />
                      ) : u.role === 'pending' ? (
                        <Chip label="Pending Approval" size="small" color="warning" />
                      ) : (
                        <Chip label="Viewer" size="small" color="default" variant="outlined"
                          onClick={() => openRoleDialog(u)} sx={{ cursor: 'pointer' }} />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip label={u.is_active ? 'Active' : 'Disabled'} size="small" color={u.is_active ? 'success' : 'default'} />
                  </TableCell>
                  <TableCell align="right">
                    <Tooltip title="Change role">
                      <IconButton size="small" color="secondary" onClick={() => openRoleDialog(u)}>
                        <ManageAccounts fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Reset password">
                      <IconButton size="small" onClick={() => { setPwdUser(u); setPwdDialog(true); }}>
                        <LockReset fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    {u.bge_profile ? (
                      <Tooltip title="Unlink BGE profile">
                        <IconButton size="small" onClick={() => unlinkBGE(u.id)}>
                          <LinkOff fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Link to BGE profile">
                        <IconButton size="small" color="primary" onClick={() => { setLinkBgeUser(u); setLinkBgeId(''); }}>
                          <People fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title={u.is_active ? 'Disable login' : 'Enable login'}>
                      <IconButton size="small" color={u.is_active ? 'warning' : 'success'} onClick={() => toggleUserActive(u)}>
                        {u.is_active ? <Delete fontSize="small" /> : <CheckCircle fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Permanently delete account">
                      <IconButton size="small" color="error" onClick={() => deleteUser(u)}>
                        <DeleteForever fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
    );
  };

  const REPORT_STATUS_COLORS = { draft: 'default', submitted: 'primary', reviewed: 'success' };
  const VISIT_LABELS = {
    bcp_facilitation: 'BCP Facilitation & Accountability',
    one_on_one:       'One-on-One Visit',
    coaching:         'Business Coaching',
    data_update:      'Data Collection',
    training:         'Training Visit',
    annual_review:    'Annual Review',
    quarterly_review: 'Quarterly Review',
    mentoring:        'Mentoring Session',
    initial:          'Initial Assessment',
    followup:         'Follow-up Visit',
    final:            'Final Assessment',
  };

  const VISIT_TYPE_COLORS = {
    bcp_facilitation: '#00695C',
    annual_review:    '#2B5278',
    one_on_one:       '#2E7D32',
    data_update:      '#E67E22',
    coaching:         '#8E44AD',
    training:         '#16A085',
    followup:         '#C0392B',
    quarterly_review: '#2980B9',
    mentoring:        '#F39C12',
    initial:          '#7F8C8D',
  };

  const renderReports = () => (
    <Box>

      {/* ── Quarterly Report Generator ──────────────────────────────────── */}
      <Box sx={{ mb: 3 }}>
        <SectionHeader
          title="Generate Quarterly Report"
          subtitle="Download a full BGE support summary PDF for any date range"
        />
        <Paper variant="outlined" sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <TextField
              label="Start Date" type="date" size="small"
              value={qrStart} onChange={e => setQrStart(e.target.value)}
              InputLabelProps={{ shrink: true }} sx={{ minWidth: 150 }}
            />
            <TextField
              label="End Date" type="date" size="small"
              value={qrEnd} onChange={e => setQrEnd(e.target.value)}
              InputLabelProps={{ shrink: true }} sx={{ minWidth: 150 }}
            />
            <TextField
              label="Period Label (optional)" size="small" placeholder="e.g. Q2 2026"
              value={qrLabel} onChange={e => setQrLabel(e.target.value)}
              sx={{ minWidth: 170 }}
            />
            <Button
              variant="contained" startIcon={qrGenerating ? <CircularProgress size={16} color="inherit" /> : <Download />}
              onClick={downloadQuarterlyPdf} disabled={qrGenerating || !qrStart || !qrEnd}
              sx={{ bgcolor: '#162A3A', '&:hover': { bgcolor: '#2B5278' }, whiteSpace: 'nowrap' }}
            >
              {qrGenerating ? 'Generating…' : 'Download PDF'}
            </Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            Generates a consolidated PDF with KPI summary, per-BGE table, and full visit narratives for the selected date range.
          </Typography>
        </Paper>
      </Box>

      {/* ── Programme Activity Report ───────────────────────────────────── */}
      <Box sx={{ mb: 3 }}>
        <SectionHeader
          title="Programme Activity Report"
          subtitle="Download a cross-cutting report covering data collection visits, training sessions, and mentorship support"
        />
        <Paper variant="outlined" sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <TextField
              label="Start Date" type="date" size="small"
              value={arStart} onChange={e => setArStart(e.target.value)}
              InputLabelProps={{ shrink: true }} sx={{ minWidth: 150 }}
            />
            <TextField
              label="End Date" type="date" size="small"
              value={arEnd} onChange={e => setArEnd(e.target.value)}
              InputLabelProps={{ shrink: true }} sx={{ minWidth: 150 }}
            />
            <Button
              variant="contained"
              startIcon={arGenerating ? <CircularProgress size={16} color="inherit" /> : <PictureAsPdf />}
              onClick={() => generateActivityReport('pdf')}
              disabled={arGenerating || !arStart || !arEnd}
              sx={{ bgcolor: '#C0392B', '&:hover': { bgcolor: '#A93226' }, whiteSpace: 'nowrap' }}
            >
              {arGenerating ? 'Generating…' : 'Download PDF'}
            </Button>
            <Button
              variant="outlined"
              startIcon={arGenerating ? <CircularProgress size={16} color="inherit" /> : <Download />}
              onClick={() => generateActivityReport('excel')}
              disabled={arGenerating || !arStart || !arEnd}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {arGenerating ? 'Generating…' : 'Download Excel'}
            </Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            Generates a multi-section report with KPI summary, data update visits, training session attendance (by gender and age), and mentorship support — available as PDF or Excel.
          </Typography>
        </Paper>
      </Box>

      {/* ── BGE Assignment Summary ──────────────────────────────────────── */}
      <Box sx={{ mb: 3 }}>
        <SectionHeader
          title="BGE Assignment Summaries"
          subtitle="Consolidated view of all visits per BGE — grouped by MSME"
        >
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
            <TextField
              label="From" type="date" size="small"
              value={bsStart} onChange={e => setBsStart(e.target.value)}
              InputLabelProps={{ shrink: true }} sx={{ minWidth: 140 }}
            />
            <TextField
              label="To" type="date" size="small"
              value={bsEnd} onChange={e => setBsEnd(e.target.value)}
              InputLabelProps={{ shrink: true }} sx={{ minWidth: 140 }}
            />
            <Button
              variant="outlined" size="small"
              startIcon={bsLoading ? <CircularProgress size={14} /> : <Assessment />}
              onClick={loadBgeSummary} disabled={bsLoading}
            >
              {bsLoading ? 'Loading…' : 'Load Summary'}
            </Button>
          </Box>
        </SectionHeader>

        {bsData && (
          <Box>
            {/* Totals strip */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
              {[
                { val: bsData.total_bges,    label: 'BGEs',          color: '#2B5278' },
                { val: bsData.total_reports, label: 'Reports Filed', color: '#2E7D32' },
                { val: bsData.total_msmes,   label: 'MSMEs Reached', color: '#E67E22' },
              ].map(({ val, label, color }) => (
                <Paper key={label} variant="outlined" sx={{ px: 2.5, py: 1.5, borderLeft: `4px solid ${color}`, minWidth: 100 }}>
                  <Typography variant="h5" fontWeight={700} color={color}>{val}</Typography>
                  <Typography variant="caption" color="text.secondary">{label}</Typography>
                </Paper>
              ))}
              {bsData.period_start && (
                <Paper variant="outlined" sx={{ px: 2.5, py: 1.5, borderLeft: '4px solid #8E44AD', minWidth: 160 }}>
                  <Typography variant="body2" fontWeight={600} color="#8E44AD">
                    {bsData.period_start} → {bsData.period_end}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">Date Range</Typography>
                </Paper>
              )}
            </Box>

            {/* Per-BGE accordions */}
            {bsData.bges.map(bge => (
              <Accordion
                key={bge.bge_id}
                expanded={bsExpandedBge === bge.bge_id}
                onChange={(_, open) => setBsExpandedBge(open ? bge.bge_id : null)}
                variant="outlined"
                sx={{ mb: 1, '&:before': { display: 'none' } }}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', flexWrap: 'wrap' }}>
                    <Typography fontWeight={600} sx={{ minWidth: 180 }}>{bge.bge_name}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      <Chip label={`${bge.total_reports} reports`} size="small" color="primary" variant="outlined" />
                      <Chip label={`${bge.total_msmes} MSMEs`} size="small" color="success" variant="outlined" />
                      {bge.date_range?.start && (
                        <Chip label={`${bge.date_range.start} – ${bge.date_range.end}`} size="small" variant="outlined" />
                      )}
                    </Box>
                    <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                      {bge.visit_type_breakdown.map(vt => (
                        <Chip
                          key={vt.visit_type}
                          label={`${vt.label} (${vt.count})`}
                          size="small"
                          sx={{ bgcolor: VISIT_TYPE_COLORS[vt.visit_type] || '#888', color: '#fff', fontSize: 10 }}
                        />
                      ))}
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  {bge.msmes.map(msme => (
                    <Accordion
                      key={msme.msme_id}
                      expanded={!!bsExpandedMsme[`${bge.bge_id}-${msme.msme_id}`]}
                      onChange={(_, open) => setBsExpandedMsme(prev => ({
                        ...prev,
                        [`${bge.bge_id}-${msme.msme_id}`]: open,
                      }))}
                      disableGutters
                      elevation={0}
                      sx={{ borderBottom: '1px solid', borderColor: 'divider', '&:before': { display: 'none' } }}
                    >
                      <AccordionSummary expandIcon={<ExpandMore />} sx={{ bgcolor: '#fafafa', pl: 3 }}>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', width: '100%', flexWrap: 'wrap' }}>
                          <Typography variant="body2" fontWeight={600}>{msme.msme_name}</Typography>
                          {msme.msme_code && (
                            <Typography variant="caption" color="text.secondary">{msme.msme_code}</Typography>
                          )}
                          <Chip label={`${msme.visits.length} visit${msme.visits.length !== 1 ? 's' : ''}`} size="small" variant="outlined" />
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails sx={{ pl: 4, pr: 2, pt: 1, pb: 1 }}>
                        {msme.visits.map((v, vi) => (
                          <Box key={v.id} sx={{ mb: 2, pb: 2, borderBottom: vi < msme.visits.length - 1 ? '1px dashed' : 'none', borderColor: 'divider' }}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1, flexWrap: 'wrap' }}>
                              <Chip
                                label={v.visit_type_label}
                                size="small"
                                sx={{ bgcolor: VISIT_TYPE_COLORS[v.visit_type] || '#888', color: '#fff', fontSize: 10 }}
                              />
                              <Typography variant="caption" color="text.secondary">{v.visit_date}</Typography>
                              <Chip label={v.status} size="small" color={{ submitted: 'success', reviewed: 'primary', draft: 'default' }[v.status] || 'default'} />
                              {v.growth_rating && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  {[1,2,3,4,5].map(n => (
                                    <Star key={n} sx={{ fontSize: 14, color: n <= v.growth_rating ? '#F39C12' : '#ddd' }} />
                                  ))}
                                </Box>
                              )}
                              {v.revenue_ugx && (
                                <Chip label={`UGX ${Number(v.revenue_ugx).toLocaleString()}`} size="small" variant="outlined" color="success" />
                              )}
                            </Box>
                            {[
                              ['Support Provided',    v.support_provided],
                              ['Key Achievement',     v.key_achievement],
                              ['Challenges',          v.challenges_identified],
                              ['Action Plan',         v.action_plan],
                              ['Recommendations',     v.recommendations],
                            ].filter(([, val]) => val).map(([lbl, val]) => (
                              <Box key={lbl} sx={{ mb: 0.75 }}>
                                <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">{lbl}</Typography>
                                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{val}</Typography>
                              </Box>
                            ))}
                          </Box>
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        )}

        {!bsData && !bsLoading && (
          <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
            <Assessment sx={{ fontSize: 40, mb: 1, opacity: 0.3 }} />
            <Typography variant="body2">
              Select a date range and click "Load Summary" to see consolidated BGE activity.
            </Typography>
          </Paper>
        )}
      </Box>

      <Divider sx={{ my: 3 }} />

      <SectionHeader title="Visit Reports" subtitle={`${reports.length} total reports`}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Button
            size="small"
            variant={reportViewMode === 'table' ? 'contained' : 'outlined'}
            startIcon={<ViewList fontSize="small" />}
            onClick={() => setReportViewMode('table')}
            sx={{ textTransform: 'none', fontSize: 12, borderRadius: 1.5 }}
          >
            Table View
          </Button>
          <Button
            size="small"
            variant={reportViewMode === 'cards' ? 'contained' : 'outlined'}
            startIcon={<ViewModule fontSize="small" />}
            onClick={() => setReportViewMode('cards')}
            sx={{ textTransform: 'none', fontSize: 12, borderRadius: 1.5 }}
          >
            Cards View
          </Button>
          <Button
            size="small"
            variant={reportViewMode === 'grouped_bge' ? 'contained' : 'outlined'}
            startIcon={<GroupWork fontSize="small" />}
            onClick={() => setReportViewMode('grouped_bge')}
            sx={{ textTransform: 'none', fontSize: 12, borderRadius: 1.5 }}
          >
            Grouped by BGE
          </Button>
        </Box>
      </SectionHeader>

      {/* ── Filters & Sort Toolbar ──────────────────────────────────────── */}
      <Paper variant="outlined" sx={{ p: 2, mb: 2, bgcolor: '#FAFBFD' }}>
        <Grid container spacing={1.5} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth size="small" placeholder="Search MSME, BGE, notes, code..."
              value={reportSearch}
              onChange={e => { setReportSearch(e.target.value); setReportPage(0); }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" sx={{ color: 'text.secondary' }} />
                  </InputAdornment>
                ),
                endAdornment: reportSearch ? (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => { setReportSearch(''); setReportPage(0); }}>
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Sort Order</InputLabel>
              <Select
                value={`${reportSortBy}:${reportSortDir}`}
                label="Sort Order"
                onChange={e => {
                  const [col, dir] = e.target.value.split(':');
                  setReportSortBy(col);
                  setReportSortDir(dir);
                  setReportPage(0);
                }}
              >
                <MenuItem value="visit_date:desc">Newest Visit First (Date ↓)</MenuItem>
                <MenuItem value="visit_date:asc">Oldest Visit First (Date ↑)</MenuItem>
                <MenuItem value="created_at:desc">Recently Added (Created ↓)</MenuItem>
                <MenuItem value="msme:asc">MSME Name (A → Z)</MenuItem>
                <MenuItem value="msme:desc">MSME Name (Z → A)</MenuItem>
                <MenuItem value="bge:asc">BGE Expert (A → Z)</MenuItem>
                <MenuItem value="visit_type:asc">Visit Type</MenuItem>
                <MenuItem value="status:asc">Status &amp; Payment</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Filter by BGE</InputLabel>
              <Select value={reportFilterBge} label="Filter by BGE"
                onChange={e => { setReportFilterBge(e.target.value); setReportPage(0); }}>
                <MenuItem value="">All BGEs</MenuItem>
                {experts.map(e => <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Visit Type</InputLabel>
              <Select value={reportFilterVisitType} label="Visit Type"
                onChange={e => { setReportFilterVisitType(e.target.value); setReportPage(0); }}>
                <MenuItem value="">All Visit Types</MenuItem>
                {Object.entries(VISIT_LABELS).map(([k, v]) => (
                  <MenuItem key={k} value={k}>{v}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4} md={1.25}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select value={reportFilterStatus} label="Status"
                onChange={e => { setReportFilterStatus(e.target.value); setReportPage(0); }}>
                <MenuItem value="">All</MenuItem>
                <MenuItem value="draft">Draft</MenuItem>
                <MenuItem value="submitted">Submitted</MenuItem>
                <MenuItem value="reviewed">Reviewed</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4} md={1.25}>
            <FormControl fullWidth size="small">
              <InputLabel>Payment</InputLabel>
              <Select value={reportFilterPaymentStatus} label="Payment"
                onChange={e => { setReportFilterPaymentStatus(e.target.value); setReportPage(0); }}>
                <MenuItem value="">All</MenuItem>
                <MenuItem value="unsubmitted">Unsubmitted</MenuItem>
                <MenuItem value="submitted">Submitted</MenuItem>
                <MenuItem value="confirmed">Confirmed ✓</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {(Boolean(reportSearch) || Boolean(reportFilterBge) || Boolean(reportFilterStatus) ||
          Boolean(reportFilterPaymentStatus) || Boolean(reportFilterVisitType) ||
          reportSortBy !== 'visit_date' || reportSortDir !== 'desc') && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5, pt: 1, borderTop: '1px dashed #E2E8F0', flexWrap: 'wrap' }}>
            <Typography variant="caption" color="text.secondary">Active filters applied:</Typography>
            {reportSearch && <Chip size="small" label={`Search: "${reportSearch}"`} onDelete={() => setReportSearch('')} />}
            {reportFilterBge && <Chip size="small" label={`BGE: ${experts.find(e => e.id === reportFilterBge)?.name || reportFilterBge}`} onDelete={() => setReportFilterBge('')} />}
            {reportFilterVisitType && <Chip size="small" label={`Type: ${VISIT_LABELS[reportFilterVisitType] || reportFilterVisitType}`} onDelete={() => setReportFilterVisitType('')} />}
            {reportFilterStatus && <Chip size="small" label={`Status: ${reportFilterStatus}`} onDelete={() => setReportFilterStatus('')} />}
            {reportFilterPaymentStatus && <Chip size="small" label={`Payment: ${reportFilterPaymentStatus}`} onDelete={() => setReportFilterPaymentStatus('')} />}
            {(reportSortBy !== 'visit_date' || reportSortDir !== 'desc') && (
              <Chip size="small" variant="outlined" label={`Sorted by: ${reportSortBy} (${reportSortDir})`} onDelete={() => { setReportSortBy('visit_date'); setReportSortDir('desc'); }} />
            )}
            <Button
              size="small" color="inherit"
              onClick={() => {
                setReportSearch('');
                setReportFilterBge('');
                setReportFilterStatus('');
                setReportFilterPaymentStatus('');
                setReportFilterVisitType('');
                setReportSortBy('visit_date');
                setReportSortDir('desc');
                setReportPage(0);
              }}
              sx={{ textTransform: 'none', fontSize: 11, ml: 'auto' }}
            >
              Reset All Filters
            </Button>
          </Box>
        )}
      </Paper>

      {(() => {
        const handleReportSort = (col) => {
          if (reportSortBy === col) {
            setReportSortDir(prev => (prev === 'asc' ? 'desc' : 'asc'));
          } else {
            setReportSortBy(col);
            setReportSortDir(col === 'visit_date' || col === 'created_at' ? 'desc' : 'asc');
          }
          setReportPage(0);
        };

        const renderReportStatusChips = (r) => (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'flex-start' }}>
            <Chip label={r.status} size="small" color={REPORT_STATUS_COLORS[r.status] || 'default'} />
            {r.payment_status === 'submitted' && (
              <Tooltip title={`Submitted for payment: ${r.payment_reference || 'N/A'}`}>
                <Chip label={r.payment_reference ? `Submitted: ${r.payment_reference}` : 'Submitted'} size="small" sx={{ bgcolor: '#FFF3E0', color: '#E65100', fontSize: 10, height: 20 }} />
              </Tooltip>
            )}
            {(r.payment_status === 'confirmed' || r.payment_confirmed_by_bge) && (
              <Tooltip title={`Payment confirmed by BGE on ${r.payment_confirmed_at ? r.payment_confirmed_at.slice(0, 16).replace('T', ' ') : ''}`}>
                <Chip label="Confirmed ✓" size="small" sx={{ bgcolor: '#E8F5E9', color: '#2E7D32', fontSize: 10, height: 20 }} />
              </Tooltip>
            )}
          </Box>
        );

        const renderReportActions = (r, msme, bge) => (
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
            <Tooltip title="View report">
              <IconButton size="small" color="primary" onClick={() => setViewReport({ ...r, _msme: msme, _bgeName: r.bge_name || bge.name })}>
                <Visibility fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Open PDF">
              <IconButton size="small" onClick={() => openReportPdf('msme', r.id, 'view')}>
                <PictureAsPdf fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download PDF">
              <IconButton size="small" onClick={() => openReportPdf('msme', r.id, 'download')}>
                <Download fontSize="small" />
              </IconButton>
            </Tooltip>
            {isStaff && (
              <Tooltip title="Submit for Payment / Update Reference">
                <IconButton size="small" color={r.payment_confirmed_by_bge ? 'success' : r.payment_status === 'submitted' ? 'warning' : 'default'} onClick={() => openReportPaymentSubmit(r, 'msme')}>
                  <Payments fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {r.status !== 'draft' && (
              <Tooltip title="Revert to draft">
                <IconButton size="small" color="warning" onClick={() => revertReport('msme', r.id)}>
                  <Undo fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {r.status === 'draft' && (
              <Tooltip title="Delete draft">
                <IconButton size="small" color="error" onClick={() => deleteReport(r)}>
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );

        // Filter reports
        const filteredReports = reports.filter(r => {
          if (reportFilterPaymentStatus) {
            if (reportFilterPaymentStatus === 'confirmed' && !(r.payment_status === 'confirmed' || r.payment_confirmed_by_bge)) return false;
            if (reportFilterPaymentStatus === 'submitted' && r.payment_status !== 'submitted') return false;
            if (reportFilterPaymentStatus === 'unsubmitted' && !(!r.payment_status || r.payment_status === 'unsubmitted')) return false;
          }
          if (reportFilterVisitType && r.visit_type !== reportFilterVisitType) {
            return false;
          }
          if (reportSearch.trim()) {
            const q = reportSearch.toLowerCase().trim();
            const msmeObj = (allMsmes.length > 0 ? allMsmes : msmes).find(m => m.id === r.msme) || {};
            const bgeObj  = experts.find(e => e.id === r.bge) || {};
            const msmeName = (r.msme_name || msmeObj.business_name || '').toLowerCase();
            const msmeCode = (r.msme_code || msmeObj.msme_code || '').toLowerCase();
            const bgeName  = (r.bge_name || bgeObj.name || '').toLowerCase();
            const vType    = (VISIT_LABELS[r.visit_type] || r.visit_type || '').toLowerCase();
            const takeaway = (r.concrete_takeaway || '').toLowerCase();
            const ach      = (r.key_achievement || '').toLowerCase();
            const purpose  = (r.stated_purpose || r.visit_objectives || '').toLowerCase();
            const notes    = (r.additional_notes || '').toLowerCase();
            const ref      = (r.payment_reference || '').toLowerCase();

            if (!msmeName.includes(q) &&
                !msmeCode.includes(q) &&
                !bgeName.includes(q) &&
                !vType.includes(q) &&
                !takeaway.includes(q) &&
                !ach.includes(q) &&
                !purpose.includes(q) &&
                !notes.includes(q) &&
                !ref.includes(q)) {
              return false;
            }
          }
          return true;
        });

        // Sort reports (defaults to visit_date desc, with id desc tiebreaker)
        const sortedReports = [...filteredReports].sort((a, b) => {
          let cmp = 0;
          if (reportSortBy === 'visit_date') {
            const da = a.visit_date ? new Date(a.visit_date).getTime() : 0;
            const db = b.visit_date ? new Date(b.visit_date).getTime() : 0;
            cmp = da - db;
          } else if (reportSortBy === 'created_at') {
            const da = a.created_at ? new Date(a.created_at).getTime() : (a.id || 0);
            const db = b.created_at ? new Date(b.created_at).getTime() : (b.id || 0);
            cmp = da - db;
          } else if (reportSortBy === 'msme') {
            const na = (a.msme_name || '').toLowerCase();
            const nb = (b.msme_name || '').toLowerCase();
            cmp = na.localeCompare(nb);
          } else if (reportSortBy === 'bge') {
            const na = (a.bge_name || '').toLowerCase();
            const nb = (b.bge_name || '').toLowerCase();
            cmp = na.localeCompare(nb);
          } else if (reportSortBy === 'status') {
            const sa = (a.status || '').toLowerCase();
            const sb = (b.status || '').toLowerCase();
            cmp = sa.localeCompare(sb);
          } else if (reportSortBy === 'visit_type') {
            const ta = (VISIT_LABELS[a.visit_type] || a.visit_type || '').toLowerCase();
            const tb = (VISIT_LABELS[b.visit_type] || b.visit_type || '').toLowerCase();
            cmp = ta.localeCompare(tb);
          }
          if (cmp === 0) {
            return (b.id || 0) - (a.id || 0);
          }
          return reportSortDir === 'desc' ? -cmp : cmp;
        });

        const pagedReports = paginate(sortedReports, reportPage);

        return (
          <Box>
            {/* View Mode 1: Table View */}
            {reportViewMode === 'table' && (
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell>
                        <TableSortLabel
                          active={reportSortBy === 'msme'}
                          direction={reportSortBy === 'msme' ? reportSortDir : 'asc'}
                          onClick={() => handleReportSort('msme')}
                        >
                          MSME
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={reportSortBy === 'bge'}
                          direction={reportSortBy === 'bge' ? reportSortDir : 'asc'}
                          onClick={() => handleReportSort('bge')}
                        >
                          BGE Expert
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={reportSortBy === 'visit_type'}
                          direction={reportSortBy === 'visit_type' ? reportSortDir : 'asc'}
                          onClick={() => handleReportSort('visit_type')}
                        >
                          Visit Type
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={reportSortBy === 'visit_date'}
                          direction={reportSortBy === 'visit_date' ? reportSortDir : 'desc'}
                          onClick={() => handleReportSort('visit_date')}
                        >
                          Visit Date
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={reportSortBy === 'status'}
                          direction={reportSortBy === 'status' ? reportSortDir : 'asc'}
                          onClick={() => handleReportSort('status')}
                        >
                          Status &amp; Payment
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pagedReports.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                          No reports found matching criteria
                        </TableCell>
                      </TableRow>
                    ) : pagedReports.map(r => {
                      const msme = (allMsmes.length > 0 ? allMsmes : msmes).find(m => m.id === r.msme) || { business_name: r.msme_name, msme_code: r.msme_code };
                      const bge  = experts.find(e => e.id === r.bge)  || { name: r.bge_name };
                      return (
                        <TableRow key={r.id} hover>
                          <TableCell>
                            <Typography variant="body2" fontWeight={600}>{r.msme_name || msme.business_name}</Typography>
                            {(r.msme_code || msme.msme_code) &&
                              <Typography variant="caption" color="text.secondary">{r.msme_code || msme.msme_code}</Typography>}
                          </TableCell>
                          <TableCell>{r.bge_name || bge.name}</TableCell>
                          <TableCell>
                            <Chip
                              label={VISIT_LABELS[r.visit_type] || r.visit_type}
                              size="small"
                              variant="outlined"
                              sx={{
                                borderColor: VISIT_TYPE_COLORS[r.visit_type] || '#7F8C8D',
                                color: VISIT_TYPE_COLORS[r.visit_type] || '#7F8C8D',
                                fontWeight: 500,
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ fontWeight: reportSortBy === 'visit_date' ? 600 : 400 }}>
                            {r.visit_date}
                          </TableCell>
                          <TableCell>
                            {renderReportStatusChips(r)}
                          </TableCell>
                          <TableCell>
                            {renderReportActions(r, msme, bge)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={sortedReports.length}
                  page={reportPage}
                  rowsPerPage={reportRowsPerPage}
                  rowsPerPageOptions={[10, 15, 25, 50, 100]}
                  onPageChange={(_, p) => setReportPage(p)}
                  onRowsPerPageChange={e => {
                    setReportRowsPerPage(parseInt(e.target.value, 10));
                    setReportPage(0);
                  }}
                />
              </TableContainer>
            )}

            {/* View Mode 2: Cards View */}
            {reportViewMode === 'cards' && (
              <Box>
                {pagedReports.length === 0 ? (
                  <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                    No reports found matching criteria
                  </Paper>
                ) : (
                  <Grid container spacing={2}>
                    {pagedReports.map(r => {
                      const msme = (allMsmes.length > 0 ? allMsmes : msmes).find(m => m.id === r.msme) || { business_name: r.msme_name, msme_code: r.msme_code };
                      const bge  = experts.find(e => e.id === r.bge)  || { name: r.bge_name };
                      return (
                        <Grid item xs={12} sm={6} md={4} key={r.id}>
                          <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 2, '&:hover': { boxShadow: 2 } }}>
                            <CardContent sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                <Box sx={{ minWidth: 0, mr: 1 }}>
                                  <Typography variant="subtitle2" fontWeight={700} noWrap title={r.msme_name || msme.business_name}>
                                    {r.msme_name || msme.business_name}
                                  </Typography>
                                  {(r.msme_code || msme.msme_code) && (
                                    <Typography variant="caption" color="text.secondary" display="block">
                                      {r.msme_code || msme.msme_code}
                                    </Typography>
                                  )}
                                </Box>
                                <Chip
                                  label={r.visit_date}
                                  size="small"
                                  sx={{ bgcolor: '#F1F5F9', color: '#334155', fontWeight: 600, fontSize: 11, flexShrink: 0 }}
                                />
                              </Box>

                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5, gap: 1, flexWrap: 'wrap' }}>
                                <Chip
                                  label={VISIT_LABELS[r.visit_type] || r.visit_type}
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    borderColor: VISIT_TYPE_COLORS[r.visit_type] || '#7F8C8D',
                                    color: VISIT_TYPE_COLORS[r.visit_type] || '#7F8C8D',
                                    fontWeight: 600,
                                    fontSize: 11,
                                  }}
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  <People sx={{ fontSize: 14 }} /> {r.bge_name || bge.name}
                                </Typography>
                              </Box>

                              {r.concrete_takeaway ? (
                                <Box sx={{ p: 1.25, bgcolor: '#F8FAFC', borderRadius: 1.5, borderLeft: '3px solid #00695C', mb: 1.5 }}>
                                  <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ fontSize: 10, textTransform: 'uppercase' }}>
                                    Acid Test Takeaway
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontSize: 12, color: '#1E293B', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                    {r.concrete_takeaway}
                                  </Typography>
                                </Box>
                              ) : r.key_achievement ? (
                                <Box sx={{ p: 1.25, bgcolor: '#F8FAFC', borderRadius: 1.5, borderLeft: '3px solid #2B5278', mb: 1.5 }}>
                                  <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ fontSize: 10, textTransform: 'uppercase' }}>
                                    Key Achievement
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontSize: 12, color: '#1E293B', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                    {r.key_achievement}
                                  </Typography>
                                </Box>
                              ) : r.stated_purpose ? (
                                <Box sx={{ p: 1.25, bgcolor: '#F8FAFC', borderRadius: 1.5, borderLeft: '3px solid #94A3B8', mb: 1.5 }}>
                                  <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ fontSize: 10, textTransform: 'uppercase' }}>
                                    Purpose
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontSize: 12, color: '#1E293B', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                    {r.stated_purpose}
                                  </Typography>
                                </Box>
                              ) : null}

                              <Box sx={{ mt: 'auto', pt: 1, borderTop: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {renderReportStatusChips(r)}
                                {renderReportActions(r, msme, bge)}
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
                <TablePagination
                  component="div"
                  count={sortedReports.length}
                  page={reportPage}
                  rowsPerPage={reportRowsPerPage}
                  rowsPerPageOptions={[10, 15, 25, 50, 100]}
                  onPageChange={(_, p) => setReportPage(p)}
                  onRowsPerPageChange={e => {
                    setReportRowsPerPage(parseInt(e.target.value, 10));
                    setReportPage(0);
                  }}
                  sx={{ mt: 2 }}
                />
              </Box>
            )}

            {/* View Mode 3: Grouped by BGE */}
            {reportViewMode === 'grouped_bge' && (() => {
              const bgeGroups = {};
              sortedReports.forEach(r => {
                const bgeId = r.bge || 'unassigned';
                const bgeObj = experts.find(e => e.id === r.bge);
                const bgeName = r.bge_name || (bgeObj ? bgeObj.name : 'Unassigned');
                if (!bgeGroups[bgeId]) {
                  bgeGroups[bgeId] = { bgeId, bgeName, reports: [] };
                }
                bgeGroups[bgeId].reports.push(r);
              });

              const bgeList = Object.values(bgeGroups).sort((a, b) => b.reports.length - a.reports.length);

              if (bgeList.length === 0) {
                return (
                  <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                    No reports found matching criteria
                  </Paper>
                );
              }

              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {bgeList.map(group => {
                    const submittedCount = group.reports.filter(r => r.status === 'submitted' || r.status === 'reviewed').length;
                    const confirmedCount = group.reports.filter(r => r.payment_status === 'confirmed' || r.payment_confirmed_by_bge).length;
                    const isExpanded = reportExpandedBges[group.bgeId] ?? (bgeList.length <= 3);
                    return (
                      <Accordion
                        key={group.bgeId}
                        variant="outlined"
                        expanded={isExpanded}
                        onChange={() => setReportExpandedBges(prev => ({ ...prev, [group.bgeId]: !isExpanded }))}
                        sx={{ borderRadius: '8px !important', '&:before': { display: 'none' } }}
                      >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', width: '100%', pr: 2 }}>
                            <Avatar sx={{ width: 32, height: 32, bgcolor: '#162A3A', fontSize: 13, fontWeight: 700 }}>
                              {group.bgeName.slice(0, 2).toUpperCase()}
                            </Avatar>
                            <Typography variant="subtitle2" fontWeight={700} sx={{ minWidth: 160 }}>
                              {group.bgeName}
                            </Typography>
                            <Chip label={`${group.reports.length} reports`} size="small" sx={{ fontWeight: 600, bgcolor: '#EEF2FF', color: '#3730A3' }} />
                            <Chip label={`${submittedCount} submitted`} size="small" variant="outlined" color="primary" sx={{ fontSize: 11 }} />
                            {confirmedCount > 0 && (
                              <Chip label={`${confirmedCount} paid ✓`} size="small" variant="outlined" color="success" sx={{ fontSize: 11 }} />
                            )}
                            <Box sx={{ flexGrow: 1 }} />
                            <Typography variant="caption" color="text.secondary">
                              Latest: {group.reports[0]?.visit_date || '—'}
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                          <Table size="small">
                            <TableHead sx={{ bgcolor: '#FAFAFA' }}>
                              <TableRow>
                                <TableCell>MSME</TableCell>
                                <TableCell>Visit Type</TableCell>
                                <TableCell>Visit Date</TableCell>
                                <TableCell>Status &amp; Payment</TableCell>
                                <TableCell>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {group.reports.map(r => {
                                const msme = (allMsmes.length > 0 ? allMsmes : msmes).find(m => m.id === r.msme) || { business_name: r.msme_name, msme_code: r.msme_code };
                                const bge = experts.find(e => e.id === r.bge) || { name: r.bge_name };
                                return (
                                  <TableRow key={r.id} hover>
                                    <TableCell>
                                      <Typography variant="body2" fontWeight={600}>{r.msme_name || msme.business_name}</Typography>
                                      {(r.msme_code || msme.msme_code) && (
                                        <Typography variant="caption" color="text.secondary">{r.msme_code || msme.msme_code}</Typography>
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={VISIT_LABELS[r.visit_type] || r.visit_type}
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                          borderColor: VISIT_TYPE_COLORS[r.visit_type] || '#7F8C8D',
                                          color: VISIT_TYPE_COLORS[r.visit_type] || '#7F8C8D',
                                          fontWeight: 500,
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>{r.visit_date}</TableCell>
                                    <TableCell>{renderReportStatusChips(r)}</TableCell>
                                    <TableCell>{renderReportActions(r, msme, bge)}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </Box>
              );
            })()}
          </Box>
        );
      })()}

      {/* ── Group Reports panel (admin approval) ─────────────────────── */}
      <Box sx={{ mt: 4 }}>
        <SectionHeader title="Group Reports" subtitle={`${groupReports.length} group report${groupReports.length === 1 ? '' : 's'} filed`} />
        {groupReports.length === 0 ? (
          <Paper variant="outlined" sx={{ p: 5, textAlign: 'center', color: 'text.secondary' }}>
            No group reports yet. Team leads file these from the BGE dashboard.
          </Paper>
        ) : (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell>Group</TableCell>
                  <TableCell>Team Lead</TableCell>
                  <TableCell>Session</TableCell>
                  <TableCell>Visit Date</TableCell>
                  <TableCell>MSMEs</TableCell>
                  <TableCell>Status &amp; Payment</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[...groupReports].sort((a, b) => new Date(b.visit_date || 0) - new Date(a.visit_date || 0) || ((b.id || 0) - (a.id || 0))).map(g => (
                  <TableRow key={g.id} hover>
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>{g.group_name}</Typography>
                    </TableCell>
                    <TableCell>{g.team_lead_name || '—'}</TableCell>
                    <TableCell>{g.session_number ? `Session ${g.session_number}` : '—'}</TableCell>
                    <TableCell>{g.visit_date}</TableCell>
                    <TableCell>{g.msme_count || 0}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'flex-start' }}>
                        <Chip
                          label={g.status} size="small"
                          color={g.status === 'approved' ? 'success' : (g.status === 'submitted' ? 'primary' : 'default')}
                        />
                        {g.payment_status === 'submitted' && (
                          <Tooltip title={`Submitted for payment: ${g.payment_reference || 'N/A'}`}>
                            <Chip label={g.payment_reference ? `Submitted: ${g.payment_reference}` : 'Submitted'} size="small" sx={{ bgcolor: '#FFF3E0', color: '#E65100', fontSize: 10, height: 20 }} />
                          </Tooltip>
                        )}
                        {(g.payment_status === 'confirmed' || g.payment_confirmed_by_bge) && (
                          <Tooltip title={`Payment confirmed by BGE on ${g.payment_confirmed_at ? g.payment_confirmed_at.slice(0, 16).replace('T', ' ') : ''}`}>
                            <Chip label="Confirmed ✓" size="small" sx={{ bgcolor: '#E8F5E9', color: '#2E7D32', fontSize: 10, height: 20 }} />
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Tooltip title="Open PDF">
                          <IconButton size="small" onClick={() => openReportPdf('group', g.id, 'view')}>
                            <PictureAsPdf fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download PDF">
                          <IconButton size="small" onClick={() => openReportPdf('group', g.id, 'download')}>
                            <Download fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {isStaff && (
                          <Tooltip title="Submit for Payment / Update Reference">
                            <IconButton size="small" color={g.payment_confirmed_by_bge ? 'success' : g.payment_status === 'submitted' ? 'warning' : 'default'} onClick={() => openReportPaymentSubmit(g, 'group')}>
                              <Payments fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {g.status === 'submitted' && (
                          <Tooltip title="Approve report">
                            <IconButton size="small" color="success" onClick={() => approveGroupReport(g.id)}>
                              <CheckCircle fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {g.status !== 'draft' && (
                          <Tooltip title="Revert to draft">
                            <IconButton size="small" color="warning" onClick={() => revertReport('group', g.id)}>
                              <Undo fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      {/* ── Training & Mentor Reports ───────────────────────────────────── */}
      <Box sx={{ mt: 4 }}>
        <SectionHeader
          title="Training Reports"
          subtitle={`${adminTrainingReports.length} lead · ${adminMentorReports.length} mentor · ${adminParticipantReports.length} participant`}
        />
        <Tabs value={trReportTab} onChange={(_, v) => setTrReportTab(v)}
          sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Tab label={`Lead Reports (${adminTrainingReports.length})`} />
          <Tab label={`Mentor Reports (${adminMentorReports.length})`} />
          <Tab label={`Participant Reports (${adminParticipantReports.length})`} />
        </Tabs>

        {trReportTab === 0 && (
          adminTrainingReports.length === 0 ? (
            <Paper variant="outlined" sx={{ p: 5, textAlign: 'center', color: 'text.secondary' }}>
              No training reports submitted yet.
            </Paper>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell>Session</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Lead BGE</TableCell>
                    <TableCell>Participants</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminTrainingReports.map(r => (
                    <TableRow key={r.id} hover>
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>{r.session_title}</Typography>
                        {r.session_location && (
                          <Typography variant="caption" color="text.secondary">{r.session_location}</Typography>
                        )}
                      </TableCell>
                      <TableCell>{r.session_date || '—'}</TableCell>
                      <TableCell>{r.bge_name || '—'}</TableCell>
                      <TableCell>
                        {r.total_participants > 0 ? (
                          <Chip label={`${r.total_participants} participants`} size="small" variant="outlined" />
                        ) : '—'}
                      </TableCell>
                      <TableCell>
                        <Chip label={r.status} size="small"
                          color={r.status === 'submitted' ? 'primary' : 'default'} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          <Tooltip title="View report">
                            <IconButton size="small" color="primary" onClick={() => setViewTrReport(r)}>
                              <Visibility fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Open PDF">
                            <IconButton size="small" onClick={() => openTrainingReportPdf('lead', r.id, 'view')}>
                              <PictureAsPdf fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download PDF">
                            <IconButton size="small" onClick={() => openTrainingReportPdf('lead', r.id, 'download')}>
                              <Download fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {isAdmin && r.status !== 'draft' && (
                            <Tooltip title="Revert to draft">
                              <IconButton size="small" color="warning" onClick={() => revertReport('training', r.id)}>
                                <Undo fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}

        {trReportTab === 1 && (
          adminMentorReports.length === 0 ? (
            <Paper variant="outlined" sx={{ p: 5, textAlign: 'center', color: 'text.secondary' }}>
              No mentor reports submitted yet.
            </Paper>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell>Session</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Mentor BGE</TableCell>
                    <TableCell>Lead BGE</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminMentorReports.map(r => (
                    <TableRow key={r.id} hover>
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>{r.session_title}</Typography>
                        {r.session_location && (
                          <Typography variant="caption" color="text.secondary">{r.session_location}</Typography>
                        )}
                      </TableCell>
                      <TableCell>{r.session_date || '—'}</TableCell>
                      <TableCell>{r.bge_name || '—'}</TableCell>
                      <TableCell>{r.lead_bge_name || '—'}</TableCell>
                      <TableCell>
                        <Chip label={r.status} size="small"
                          color={r.status === 'submitted' ? 'primary' : 'default'} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          <Tooltip title="View report">
                            <IconButton size="small" color="primary" onClick={() => setViewMrReport(r)}>
                              <Visibility fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Open PDF">
                            <IconButton size="small" onClick={() => openTrainingReportPdf('mentor', r.id, 'view')}>
                              <PictureAsPdf fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download PDF">
                            <IconButton size="small" onClick={() => openTrainingReportPdf('mentor', r.id, 'download')}>
                              <Download fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {isAdmin && r.status !== 'draft' && (
                            <Tooltip title="Revert to draft">
                              <IconButton size="small" color="warning" onClick={() => revertReport('mentor', r.id)}>
                                <Undo fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}

        {trReportTab === 2 && (
          adminParticipantReports.length === 0 ? (
            <Paper variant="outlined" sx={{ p: 5, textAlign: 'center', color: 'text.secondary' }}>
              No participant training reports submitted yet.
            </Paper>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell>Training Title</TableCell>
                    <TableCell>Dates</TableCell>
                    <TableCell>Venue</TableCell>
                    <TableCell>BGE</TableCell>
                    <TableCell>Attendees</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminParticipantReports.map(r => (
                    <TableRow key={r.id} hover>
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>{r.training_title || '—'}</Typography>
                        {r.facilitator_name && (
                          <Typography variant="caption" color="text.secondary">Facilitator: {r.facilitator_name}</Typography>
                        )}
                      </TableCell>
                      <TableCell>{r.training_dates || '—'}</TableCell>
                      <TableCell>
                        <Typography variant="body2">{r.venue || '—'}</Typography>
                        {r.district && <Typography variant="caption" color="text.secondary">{r.district}</Typography>}
                      </TableCell>
                      <TableCell>{r.bge_name || '—'}</TableCell>
                      <TableCell>
                        {(r.attendees || []).length > 0
                          ? <Chip label={`${r.attendees.length} attendees`} size="small" variant="outlined" />
                          : '—'}
                      </TableCell>
                      <TableCell>
                        <Chip label={r.status} size="small"
                          color={r.status === 'submitted' ? 'primary' : 'default'} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          <Tooltip title="View report">
                            <IconButton size="small" color="primary" onClick={() => setViewPtReport(r)}>
                              <Visibility fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Open PDF">
                            <IconButton size="small" onClick={() => openTrainingReportPdf('participant', r.id, 'view')}>
                              <PictureAsPdf fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download PDF">
                            <IconButton size="small" onClick={() => openTrainingReportPdf('participant', r.id, 'download')}>
                              <Download fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {isAdmin && r.status !== 'draft' && (
                            <Tooltip title="Revert to draft">
                              <IconButton size="small" color="warning" onClick={() => revertReport('participant', r.id)}>
                                <Undo fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
      </Box>

      {/* ── Growth Updates (Snapshots) ──────────────────────────────────── */}
      <Box sx={{ mt: 4 }}>
        <SectionHeader
          title="Growth Updates"
          subtitle={`${adminSnapshots.length} submission${adminSnapshots.length === 1 ? '' : 's'} · ${[...new Set(adminSnapshots.map(s => s.msme))].length} MSMEs covered`}
        >
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ flex: '1 1 140px', minWidth: 0 }}>
              <InputLabel>Filter by BGE</InputLabel>
              <Select value={snapshotFilterBge} label="Filter by BGE"
                onChange={e => { setSnapshotFilterBge(e.target.value); setSnapshotPage(0); }}>
                <MenuItem value="">All BGEs</MenuItem>
                {experts.map(e => <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ flex: '1 1 130px', minWidth: 0 }}>
              <InputLabel>Source</InputLabel>
              <Select value={snapshotFilterSource} label="Source"
                onChange={e => { setSnapshotFilterSource(e.target.value); setSnapshotPage(0); }}>
                <MenuItem value="">All Sources</MenuItem>
                <MenuItem value="diagnostic">Baseline Diagnostic</MenuItem>
                <MenuItem value="bge_visit">BGE Visit</MenuItem>
                <MenuItem value="quarterly">Quarterly Review</MenuItem>
                <MenuItem value="annual">Data Update</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </SectionHeader>

        {adminSnapshotsLoading ? (
          <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress /></Box>
        ) : (() => {
          if (adminSnapshots.length === 0) return (
            <Paper variant="outlined" sx={{ p: 5, textAlign: 'center', color: 'text.secondary' }}>
              No growth updates recorded yet.
            </Paper>
          );

          // ── Core derivations (all snapshots, not filtered) ─────────────
          const SOURCE_LABELS = {
            diagnostic: 'Baseline', bge_visit: 'BGE Visit', quarterly: 'Quarterly',
            annual: 'Data Update', other: 'Other',
          };
          const fmtUGX = v => (v == null || v === '') ? '—' : `UGX ${Number(v).toLocaleString()}`;

          const latestByMsme = {};
          const firstByMsme  = {};
          adminSnapshots.forEach(s => {
            const lat = latestByMsme[s.msme];
            if (!lat || s.snapshot_date > lat.snapshot_date || (s.snapshot_date === lat.snapshot_date && s.id > lat.id))
              latestByMsme[s.msme] = s;
            const cur = firstByMsme[s.msme];
            if (!cur || s.snapshot_date < cur.snapshot_date || (s.snapshot_date === cur.snapshot_date && s.id < cur.id))
              firstByMsme[s.msme] = s;
          });
          const latestList = Object.values(latestByMsme);
          const paired = latestList
            .filter(s => firstByMsme[s.msme] && firstByMsme[s.msme].id !== s.id)
            .map(s => ({ ...s, _first: firstByMsme[s.msme] }))
            .sort((a, b) => b.snapshot_date.localeCompare(a.snapshot_date));

          const bgeCnt = new Set(adminSnapshots.filter(x => x.collected_by).map(x => x.collected_by)).size;

          // ── Compliance (latest snapshot per MSME) ─────────────────────
          const compFields = [
            { label: 'TIN',           key: 'has_tin',           color: '#D97706' },
            { label: 'URSB',          key: 'has_ursb',          color: '#4527A0' },
            { label: 'Business Bank', key: 'has_business_bank', color: '#00695C' },
            { label: 'SACCO',         key: 'has_sacco',         color: '#2E7D32' },
            { label: 'Mobile Money',  key: 'has_mobile_money',  color: '#E65100' },
            { label: 'MOMO Pay',      key: 'has_momo_pay',      color: '#F57C00' },
          ];

          // ── Financials ────────────────────────────────────────────────
          const withRev     = latestList.filter(s => s.annual_turnover);
          const totalRev    = withRev.reduce((a, s) => a + Number(s.annual_turnover), 0);
          const avgRev      = withRev.length ? totalRev / withRev.length : 0;
          const withMoRev   = latestList.filter(s => s.last_month_revenue);
          const avgMoRev    = withMoRev.length
            ? withMoRev.reduce((a, s) => a + Number(s.last_month_revenue), 0) / withMoRev.length : 0;
          const totalEmpAll = latestList.reduce((a, s) =>
            a + (s.employees_ft_male||0)+(s.employees_ft_female||0)
              + (s.employees_pt_male||0)+(s.employees_pt_female||0), 0);
          const femaleEmp   = latestList.reduce((a, s) =>
            a + (s.employees_ft_female||0)+(s.employees_pt_female||0), 0);
          const refugeeEmp  = latestList.reduce((a, s) =>
            a + (s.employees_ft_refugee||0)+(s.employees_pt_refugee||0), 0);
          const trainingImpact = latestList.filter(s => s.training_made_changes === true).length;

          // ── Filtered table ────────────────────────────────────────────
          const filtered = adminSnapshots.filter(s =>
            (!snapshotFilterBge    || s.collected_by === Number(snapshotFilterBge)) &&
            (!snapshotFilterSource || s.source === snapshotFilterSource)
          );
          const pageSlice = filtered.slice(snapshotPage * ROWS_PER_PAGE, (snapshotPage + 1) * ROWS_PER_PAGE);

          const COMP_LABELS = { has_tin: 'TIN', has_ursb: 'URSB', has_business_bank: 'Bank', has_sacco: 'SACCO', has_mobile_money: 'MoMo', has_momo_pay: 'MOMO Pay' };
          const COMP_KEYS   = Object.keys(COMP_LABELS);

          return (
            <>
              {/* ── Coverage stat chips ─────────────────────────────────── */}
              <Box sx={{ display: 'flex', gap: 1.5, mb: 2.5, flexWrap: 'wrap' }}>
                {[
                  { label: 'Total Submissions',  value: adminSnapshots.length },
                  { label: 'MSMEs Covered',      value: latestList.length },
                  { label: 'BGEs Reporting',     value: bgeCnt },
                  { label: 'With Baseline Data', value: paired.length, sub: 'baseline + update' },
                  { label: 'Training Impact',    value: trainingImpact, sub: 'training made a change' },
                ].map(({ label, value, sub }) => (
                  <Box key={label} sx={{ flex: '1 1 130px', textAlign: 'center',
                    bgcolor: '#F4F6F9', borderRadius: 2, px: 2, py: 1.5 }}>
                    <Typography variant="h5" fontWeight={700} color="primary.main">{value}</Typography>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ lineHeight: 1.3 }}>{label}</Typography>
                    {sub && <Typography variant="caption" color="text.disabled" sx={{ fontSize: 10 }}>{sub}</Typography>}
                  </Box>
                ))}
              </Box>

              {/* ── Compliance summary ──────────────────────────────────── */}
              <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
                  Compliance &amp; Access
                  <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (based on latest snapshot · {latestList.length} MSMEs)
                  </Typography>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                  {compFields.map(({ label, key, color }) => {
                    const cnt = latestList.filter(s => s[key]).length;
                    const pct = latestList.length > 0 ? Math.round(cnt / latestList.length * 100) : 0;
                    return (
                      <Box key={key} sx={{ flex: '1 1 130px', bgcolor: '#FAFAFA',
                        borderRadius: 1.5, p: 1.5, borderLeft: `3px solid ${color}` }}>
                        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
                          <Typography variant="h6" fontWeight={700} sx={{ color }}>{cnt}</Typography>
                          <Typography variant="caption" color="text.disabled">/ {latestList.length}</Typography>
                        </Box>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>{label}</Typography>
                        <LinearProgress variant="determinate" value={pct}
                          sx={{ height: 6, borderRadius: 3, bgcolor: '#E0E0E0',
                            '& .MuiLinearProgress-bar': { bgcolor: color } }} />
                        <Typography variant="caption" color="text.disabled" sx={{ fontSize: 10 }}>{pct}%</Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Paper>

              {/* ── Financial & workforce summary ───────────────────────── */}
              <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
                  Financial &amp; Workforce
                  <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (latest snapshot per MSME)
                  </Typography>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                  {[
                    { label: 'Total Annual Turnover',   value: fmtUGX(Math.round(totalRev)),  sub: `${withRev.length} MSMEs reported` },
                    { label: 'Avg Annual Turnover',     value: fmtUGX(Math.round(avgRev)),    sub: 'per MSME' },
                    { label: 'Avg Last Month Revenue',  value: fmtUGX(Math.round(avgMoRev)),  sub: `${withMoRev.length} MSMEs reported` },
                    { label: 'Total Employees (FT+PT)', value: totalEmpAll,                   sub: 'across all MSMEs' },
                    { label: 'Female Employees',        value: femaleEmp,                     sub: `${totalEmpAll > 0 ? Math.round(femaleEmp/totalEmpAll*100) : 0}% of total` },
                    { label: 'Refugee Employees',       value: refugeeEmp,                    sub: 'FT + PT refugees' },
                  ].map(({ label, value, sub }) => (
                    <Box key={label} sx={{ flex: '1 1 155px', bgcolor: '#F4F6F9', borderRadius: 1.5, px: 2, py: 1.5 }}>
                      <Typography variant="caption" color="text.secondary"
                        sx={{ textTransform: 'uppercase', fontSize: 10, display: 'block' }}>{label}</Typography>
                      <Typography variant="body1" fontWeight={700}
                        sx={{ fontFamily: typeof value === 'string' ? 'monospace' : 'inherit', mt: 0.25 }}>
                        {value}
                      </Typography>
                      <Typography variant="caption" color="text.disabled" sx={{ fontSize: 10 }}>{sub}</Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>

              {/* ── Baseline vs Latest comparison ───────────────────────── */}
              {paired.length > 0 && (
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
                    Baseline vs Latest Comparison
                    <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                      {paired.length} MSME{paired.length !== 1 ? 's' : ''} with both baseline &amp; update
                    </Typography>
                  </Typography>
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                        <TableRow>
                          <TableCell>MSME</TableCell>
                          <TableCell>Baseline</TableCell>
                          <TableCell>Latest</TableCell>
                          <TableCell>Annual Turnover</TableCell>
                          <TableCell>Last Month Revenue</TableCell>
                          <TableCell>Employees</TableCell>
                          <TableCell>Compliance Change</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paired.map(s => {
                          const f = s._first;
                          const revB = Number(f.annual_turnover) || 0;
                          const revA = Number(s.annual_turnover) || 0;
                          const revDelta = revB > 0 && revA > 0
                            ? ((revA - revB) / revB * 100).toFixed(0) : null;
                          const moRevB = Number(f.last_month_revenue) || 0;
                          const moRevA = Number(s.last_month_revenue) || 0;
                          const moRevDelta = moRevB > 0 && moRevA > 0
                            ? ((moRevA - moRevB) / moRevB * 100).toFixed(0) : null;
                          const empB = (f.employees_ft_male||0)+(f.employees_ft_female||0)+(f.employees_pt_male||0)+(f.employees_pt_female||0);
                          const empA = (s.employees_ft_male||0)+(s.employees_ft_female||0)+(s.employees_pt_male||0)+(s.employees_pt_female||0);
                          const empDelta = empA - empB;
                          const gained = COMP_KEYS.filter(k => !f[k] && s[k]);
                          const lost   = COMP_KEYS.filter(k =>  f[k] && !s[k]);
                          return (
                            <TableRow key={s.id} hover>
                              <TableCell>
                                <Typography variant="body2" fontWeight={500}>{s.msme_name}</Typography>
                                <Typography variant="caption" color="text.secondary">{s.collected_by_name || ''}</Typography>
                              </TableCell>
                              <TableCell sx={{ color: 'text.secondary', fontSize: 12 }}>
                                {f.snapshot_date}<br/>
                                <Typography variant="caption" color="text.disabled">{SOURCE_LABELS[f.source] || f.source}</Typography>
                              </TableCell>
                              <TableCell sx={{ color: 'text.secondary', fontSize: 12 }}>
                                {s.snapshot_date}<br/>
                                <Typography variant="caption" color="text.disabled">{SOURCE_LABELS[s.source] || s.source}</Typography>
                              </TableCell>
                              <TableCell>
                                {(revB > 0 || revA > 0) ? (
                                  <Box>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace', display: 'block' }}>
                                      {fmtUGX(revB)}
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontFamily: 'monospace', display: 'block' }}>
                                      {fmtUGX(revA)}
                                    </Typography>
                                    {revDelta && (
                                      <Chip label={`${revDelta > 0 ? '+' : ''}${revDelta}%`} size="small"
                                        color={Number(revDelta) > 0 ? 'success' : 'error'}
                                        sx={{ height: 18, fontSize: 10, mt: 0.5 }} />
                                    )}
                                  </Box>
                                ) : '—'}
                              </TableCell>
                              <TableCell>
                                {(moRevB > 0 || moRevA > 0) ? (
                                  <Box>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace', display: 'block' }}>
                                      {fmtUGX(moRevB)}
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontFamily: 'monospace', display: 'block' }}>
                                      {fmtUGX(moRevA)}
                                    </Typography>
                                    {moRevDelta && (
                                      <Chip label={`${moRevDelta > 0 ? '+' : ''}${moRevDelta}%`} size="small"
                                        color={Number(moRevDelta) > 0 ? 'success' : 'error'}
                                        sx={{ height: 18, fontSize: 10, mt: 0.5 }} />
                                    )}
                                  </Box>
                                ) : '—'}
                              </TableCell>
                              <TableCell>
                                <Typography variant="caption" color="text.secondary" display="block">{empB} → {empA}</Typography>
                                {empDelta !== 0 && (
                                  <Chip label={`${empDelta > 0 ? '+' : ''}${empDelta}`} size="small"
                                    color={empDelta > 0 ? 'success' : 'error'} sx={{ height: 18, fontSize: 10 }} />
                                )}
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                  {gained.map(k => (
                                    <Chip key={k} label={`+${COMP_LABELS[k]}`} size="small" color="success"
                                      sx={{ height: 18, fontSize: 10 }} />
                                  ))}
                                  {lost.map(k => (
                                    <Chip key={k} label={`−${COMP_LABELS[k]}`} size="small" color="error"
                                      sx={{ height: 18, fontSize: 10 }} />
                                  ))}
                                  {gained.length === 0 && lost.length === 0 && (
                                    <Typography variant="caption" color="text.disabled">No change</Typography>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}

              {/* ── All submissions table ───────────────────────────────── */}
              <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
                All Submissions
                {(snapshotFilterBge || snapshotFilterSource) && (
                  <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (filtered · {filtered.length} result{filtered.length !== 1 ? 's' : ''})
                  </Typography>
                )}
              </Typography>
              {filtered.length === 0 ? (
                <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                  No submissions match the current filters.
                </Paper>
              ) : (
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                      <TableRow>
                        <TableCell>MSME</TableCell>
                        <TableCell>BGE</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Source</TableCell>
                        <TableCell>Annual Turnover</TableCell>
                        <TableCell>Last Mo. Revenue</TableCell>
                        <TableCell>Employees</TableCell>
                        <TableCell>Compliance</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pageSlice.map(s => {
                        const totalEmp = (s.employees_ft_male||0)+(s.employees_ft_female||0)
                          +(s.employees_pt_male||0)+(s.employees_pt_female||0);
                        return (
                          <TableRow key={s.id} hover>
                            <TableCell>
                              <Typography variant="body2" fontWeight={500}>{s.msme_name}</Typography>
                            </TableCell>
                            <TableCell>{s.collected_by_name || '—'}</TableCell>
                            <TableCell>{s.snapshot_date}</TableCell>
                            <TableCell>
                              <Chip label={SOURCE_LABELS[s.source] || s.source} size="small" variant="outlined" />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>
                              {fmtUGX(s.annual_turnover)}
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>
                              {fmtUGX(s.last_month_revenue)}
                            </TableCell>
                            <TableCell>{totalEmp > 0 ? totalEmp : '—'}</TableCell>
                            <TableCell>
                              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                {s.has_tin           && <Chip label="TIN"  size="small" color="success" variant="outlined" sx={{ fontSize: 10, height: 20 }} />}
                                {s.has_ursb          && <Chip label="URSB" size="small" color="success" variant="outlined" sx={{ fontSize: 10, height: 20 }} />}
                                {s.has_business_bank && <Chip label="Bank" size="small" color="success" variant="outlined" sx={{ fontSize: 10, height: 20 }} />}
                                {s.has_sacco         && <Chip label="SACCO" size="small" color="success" variant="outlined" sx={{ fontSize: 10, height: 20 }} />}
                                {s.has_mobile_money  && <Chip label="MoMo" size="small" color="info"    variant="outlined" sx={{ fontSize: 10, height: 20 }} />}
                                {s.has_momo_pay      && <Chip label="MoMo Pay" size="small" color="info" variant="outlined" sx={{ fontSize: 10, height: 20 }} />}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Tooltip title="View full update">
                                <IconButton size="small" color="primary" onClick={() => setViewSnapshot(s)}>
                                  <Visibility fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div" count={filtered.length} page={snapshotPage}
                    rowsPerPage={ROWS_PER_PAGE} rowsPerPageOptions={[ROWS_PER_PAGE]}
                    onPageChange={(_, p) => setSnapshotPage(p)}
                  />
                </TableContainer>
              )}
            </>
          );
        })()}
      </Box>
    </Box>
  );

  const openAddMsme = (bge) => {
    setAssignTarget(null);
    setAddMsmeDialog(bge);
    setAddMsmePick('');
    setAddMsmeSearch('');
  };

  const renderAssignments = () => {
    const msmePool = allMsmes.length > 0 ? allMsmes : msmes;
    const unassigned = msmePool.filter(m => !m.assigned_bge);

    // Sort BGEs: those with assignments first (desc by count), then without.
    // Use assigned_msme_count from the serializer — it includes direct, co-assigned
    // and group-assigned MSMEs, giving the accurate total per BGE.
    const sortedExperts = [...experts].sort((a, b) =>
      (b.assigned_msme_count || 0) - (a.assigned_msme_count || 0)
    );

    return (
      <Box>
        <SectionHeader
          title="BGE Assignments"
          subtitle={`${msmePool.filter(m => m.assigned_bge).length} assigned · ${unassigned.length} unassigned`}
        />

        {/* Unassigned MSMEs summary */}
        {unassigned.length > 0 && (
          <Accordion variant="outlined" sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Chip label={`${unassigned.length} unassigned`} color="warning" size="small" />
                <Typography variant="body2" fontWeight={600}>Unassigned MSMEs</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <Table size="small">
                <TableBody>
                  {unassigned.map(m => (
                    <TableRow key={m.id} hover>
                      <TableCell>
                        <Typography variant="body2" fontWeight={600}>{m.business_name}</Typography>
                        <Typography variant="caption" color="text.secondary">{m.sector}</Typography>
                      </TableCell>
                      <TableCell>
                        <Chip label={m.msme_code} size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: 11 }} />
                      </TableCell>
                      <TableCell align="right">
                        <Button size="small" variant="outlined" onClick={() => openAssignDialog(m)} sx={{ fontSize: 11 }}>
                          Assign
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        )}

        {/* BGE cards */}
        {experts.length === 0 ? (
          <Paper variant="outlined" sx={{ py: 6, textAlign: 'center', color: 'text.secondary' }}>
            No BGE experts yet. Import experts first.
          </Paper>
        ) : (
          <Grid container spacing={2}>
            {sortedExperts.map(e => {
              // Use assigned_msmes_list from the serializer so direct, co-assigned,
              // and group-assigned MSMEs are all counted. Enrich with full MSME data
              // where available (for the assign dialog), falling back to the list row.
              const bgeMsmes = e.assigned_msmes_list?.length
                ? e.assigned_msmes_list.map(am => msmePool.find(m => m.id === am.id) || am)
                : msmePool.filter(m => m.assigned_bge === e.id);
              // Initialize bgeObjectives from expert data if not already in state
              const objValue = e.id in bgeObjectives ? bgeObjectives[e.id] : (e.deployment_objectives || '');

              return (
                <Grid item xs={12} md={6} key={e.id}>
                  <Card variant="outlined">
                    <CardContent>
                      {/* Header row */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                        <Avatar sx={{ width: 36, height: 36, fontSize: 14, bgcolor: BRAND.primaryMain }}>
                          {(e.name || '?')[0]}
                        </Avatar>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography variant="subtitle2" fontWeight={700} noWrap>
                            {e.name}
                            {e.bge_code && (
                              <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                · {e.bge_code}
                              </Typography>
                            )}
                          </Typography>
                          {e.email && (
                            <Typography variant="caption" color="text.secondary" noWrap display="block">{e.email}</Typography>
                          )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
                          <Tooltip title={(!e.email || bgeMsmes.length === 0) ? 'Need email and assigned MSMEs to send' : `Preview & send email to ${e.email}`}>
                            <span>
                              <IconButton
                                size="small"
                                disabled={!e.email || bgeMsmes.length === 0 || emailingBgeId === e.id}
                                onClick={() => previewBgeEmail(e)}
                                color="primary"
                              >
                                {emailingBgeId === e.id ? <CircularProgress size={16} /> : <Email fontSize="small" />}
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Add MSME to this BGE">
                            <IconButton size="small" color="success" onClick={() => openAddMsme(e)}>
                              <Add fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      {/* Assigned MSMEs list */}
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.5 }}>
                        Assigned MSMEs ({bgeMsmes.length}):
                      </Typography>
                      {bgeMsmes.length === 0 ? (
                        <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                          No MSMEs assigned yet
                        </Typography>
                      ) : (
                        <Box sx={{ mb: 1 }}>
                          {bgeMsmes.map((m, idx) => (
                            <Box key={m.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                              <Typography variant="caption" color="text.disabled" sx={{ minWidth: 18, fontSize: 11 }}>
                                {idx + 1}.
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ flex: 1, cursor: 'pointer', '&:hover': { color: 'primary.main' } }}
                                onClick={() => openAssignDialog(m)}
                              >
                                {m.business_name}
                                <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
                                  ({m.msme_code}) — {m.sector}
                                </Typography>
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}

                      <Divider sx={{ my: 1 }} />

                      {/* Deployment Objectives */}
                      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.5 }}>
                        Deployment Objectives:
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                        <TextField
                          fullWidth
                          size="small"
                          multiline
                          rows={2}
                          placeholder="Shared objectives for this BGE's deployment…"
                          value={objValue}
                          onChange={ev => !isProgrammeManager && setBgeObjectives(prev => ({ ...prev, [e.id]: ev.target.value }))}
                          onFocus={() => {
                            if (!(e.id in bgeObjectives)) {
                              setBgeObjectives(prev => ({ ...prev, [e.id]: e.deployment_objectives || '' }));
                            }
                          }}
                          InputProps={{ readOnly: isProgrammeManager }}
                          InputLabelProps={{ shrink: true }}
                        />
                        {isStaff && (
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={!!savingObjectives[e.id]}
                            sx={{ flexShrink: 0, mt: 0.5 }}
                            onClick={async () => {
                              setSavingObjectives(prev => ({ ...prev, [e.id]: true }));
                              try {
                                await axios.patch(
                                  `${API_ENDPOINTS.EXPERTS}${e.id}/set-objectives/`,
                                  { deployment_objectives: objValue },
                                  { headers }
                                );
                                notify('Objectives saved');
                                fetchAll();
                              } catch {
                                notify('Failed to save objectives', 'error');
                              } finally {
                                setSavingObjectives(prev => ({ ...prev, [e.id]: false }));
                              }
                            }}
                          >
                            {savingObjectives[e.id] ? <CircularProgress size={14} /> : 'Save'}
                          </Button>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}

        {/* Add MSME to BGE dialog */}
        <Dialog open={!!addMsmeDialog} onClose={() => setAddMsmeDialog(null)} maxWidth="sm" fullWidth>
          <DialogTitle>Add MSME to {addMsmeDialog?.name}</DialogTitle>
          <DialogContent>
            {(() => {
              const msmePool = allMsmes.length > 0 ? allMsmes : msmes;
              const sortedMsmes = [...msmePool].sort((a, b) => {
                const aOwn = a.assigned_bge === addMsmeDialog?.id;
                const bOwn = b.assigned_bge === addMsmeDialog?.id;
                if (aOwn !== bOwn) return aOwn ? -1 : 1;
                const aFree = !a.assigned_bge, bFree = !b.assigned_bge;
                if (aFree !== bFree) return aFree ? -1 : 1;
                return (a.business_name || '').localeCompare(b.business_name || '');
              });
              const filtered = sortedMsmes.filter(m =>
                !addMsmeSearch || (m.business_name || '').toLowerCase().includes(addMsmeSearch.toLowerCase())
              );
              const alreadyElsewhere = addMsmePick
                ? msmePool.find(m => m.id === addMsmePick && m.assigned_bge && m.assigned_bge !== addMsmeDialog?.id)
                : null;
              return (
                <>
                  <Alert severity="info" sx={{ mb: 2, mt: 1 }} icon={false}>
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                      Deploying multiple BGEs to the same MSMEs?
                    </Typography>
                    <Typography variant="body2">
                      All MSMEs are shown — including those assigned to other BGEs.
                      MSMEs tagged <strong style={{color:'#E65100'}}>→ [BGE Name]</strong> are already assigned.
                      Selecting one will move the primary assignment to <strong>{addMsmeDialog?.name}</strong>.
                    </Typography>
                  </Alert>
                  <TextField
                    size="small" fullWidth placeholder="Search MSMEs…"
                    value={addMsmeSearch} onChange={e => startTransition(() => setAddMsmeSearch(e.target.value))}
                    sx={{ mb: 1.5 }}
                    InputProps={{ startAdornment: <Search sx={{ mr: 0.5, color: 'text.secondary', fontSize: 18 }} /> }}
                  />
                  <FormControl fullWidth size="small">
                    <InputLabel>Select MSME</InputLabel>
                    <Select value={addMsmePick} label="Select MSME" onChange={ev => setAddMsmePick(ev.target.value)}>
                      <MenuItem value=""><em>Choose…</em></MenuItem>
                      {filtered.map(m => {
                        const isOwn    = m.assigned_bge === addMsmeDialog?.id;
                        const isFree   = !m.assigned_bge;
                        const primary  = !isFree && !isOwn ? m.assigned_bge_name : null;
                        const coNames  = (m.co_assigned_bge_names || []).map(b => b.name);
                        const isCoHere = (m.co_assigned_bge_names || []).some(b => b.id === addMsmeDialog?.id);
                        return (
                          <MenuItem key={m.id} value={m.id}
                            sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
                            <span>{m.business_name}</span>
                            <Box sx={{ display:'flex', gap:0.5, flexWrap:'wrap' }}>
                              {isOwn    && <Chip label="Primary here" size="small" sx={{ fontSize:10, height:18, bgcolor:'#E8F5E9', color:'#2E7D32' }}/>}
                              {isCoHere && <Chip label="Co-assigned here" size="small" sx={{ fontSize:10, height:18, bgcolor:'#FEF3C7', color:'#92400E' }}/>}
                              {isFree   && <Chip label="Unassigned" size="small" sx={{ fontSize:10, height:18, bgcolor:'#F5F5F4', color:'#57534E' }}/>}
                              {primary  && <Chip label={`Primary: ${primary}`} size="small" sx={{ fontSize:10, height:18, bgcolor:'#FFF3E0', color:'#E65100' }}/>}
                              {coNames.length > 0 && !isCoHere && <Chip label={`Co: ${coNames.join(', ')}`} size="small" sx={{ fontSize:10, height:18, bgcolor:'#F3E5F5', color:'#6A1B9A' }}/>}
                            </Box>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {alreadyElsewhere && (
                    <Alert severity="warning" sx={{ mt: 1.5 }} icon={false}>
                      <Typography variant="body2">
                        <strong>{alreadyElsewhere.business_name}</strong> is currently assigned to{' '}
                        <strong>{alreadyElsewhere.assigned_bge_name}</strong>.
                        Proceeding moves the primary assignment to <strong>{addMsmeDialog?.name}</strong>.
                        Both BGEs retain access for reporting.
                      </Typography>
                    </Alert>
                  )}
                </>
              );
            })()}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAddMsmeDialog(null)}>Cancel</Button>
            <Button
              variant="contained"
              disabled={!addMsmePick}
              onClick={() => {
                const msmePool = allMsmes.length > 0 ? allMsmes : msmes;
                const msme = msmePool.find(m => m.id === addMsmePick);
                if (msme) {
                  setAddMsmeDialog(null);
                  setAssignTarget(msme);
                  setAssignForm({
                    bge_id: addMsmeDialog.id,
                    objectives: msme.assignment_objectives || '',
                    assignment_date: msme.assignment_date || new Date().toISOString().slice(0, 10),
                  });
                  setAssignDialog(true);
                }
              }}
            >
              Next: Set Objectives
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };

  const openWoCreate = () => startTransition(() => { setWoEditing(null); setWoDialog(true); });
  const openWoEdit = (wo) => startTransition(() => { setWoEditing(wo); setWoDialog(true); });

  // ── Data-update distributor ───────────────────────────────────────────────
  const openDuDialog = async () => {
    setDuDialog(true);
    setDuPreview(null);
    setDuResult(null);
    setDuLoading(true);
    try {
      const res = await axios.get(`${API_ENDPOINTS.WORK_ORDERS}auto-create-data-updates/`, { headers });
      setDuPreview(res.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Could not load preview.');
    } finally {
      setDuLoading(false);
    }
  };
  const createDuWorkOrders = async () => {
    setDuCreating(true);
    try {
      const res = await axios.post(`${API_ENDPOINTS.WORK_ORDERS}auto-create-data-updates/`, {
        start_date: duStartDate,
        end_date: duEndDate,
        max_days: duMaxDays,
        rate_per_day: duRatePerDay,
        update_assignments: duUpdateAssign,
      }, { headers });
      setDuResult(res.data);
      setSuccess(`Created ${res.data.created} data-update work orders.`);
      // Refresh work orders list
      const wo = await axios.get(API_ENDPOINTS.WORK_ORDERS, { headers });
      setWorkOrders(wo.data.results || wo.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to create work orders.');
    } finally {
      setDuCreating(false);
    }
  };

  // ── Permanent-assignee distributor handlers (3x/month) ─────────────────────
  const openPaDialog = async () => {
    setPaDialog(true);
    setPaPreview(null);
    setPaResult(null);
    setPaLoading(true);
    try {
      const res = await axios.get(`${API_ENDPOINTS.WORK_ORDERS}auto-create-permanent-assignee-wos/`, { headers });
      setPaPreview(res.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Could not load preview.');
    } finally {
      setPaLoading(false);
    }
  };
  const createPaWorkOrders = async () => {
    setPaCreating(true);
    try {
      const res = await axios.post(`${API_ENDPOINTS.WORK_ORDERS}auto-create-permanent-assignee-wos/`, {
        start_date: paStartDate,
        end_date: paEndDate,
        max_days: paMaxDays,
        rate_per_day: paRatePerDay,
        allow_empty: paAllowEmpty,
      }, { headers });
      setPaResult(res.data);
      setSuccess(`Created ${res.data.created} permanent assignee support work orders.`);
      const wo = await axios.get(API_ENDPOINTS.WORK_ORDERS, { headers });
      setWorkOrders(wo.data.results || wo.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to create work orders.');
    } finally {
      setPaCreating(false);
    }
  };

  // ── Smart assignment handlers ─────────────────────────────────────────────
  const loadSmartAssign = async (applyTo = saApplyTo, excludeList = saExclude) => {
    setSaLoading(true);
    setSaData(null);
    const excludeParam = excludeList.map(b => b.id).join(',');
    try {
      const res = await axios.get(
        `${SMART_ASSIGN_URL}?apply_to=${applyTo}${excludeParam ? `&exclude=${excludeParam}` : ''}`,
        { headers }
      );
      setSaData(res.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Could not load assignment preview.');
    } finally {
      setSaLoading(false);
    }
  };
  const applySmartAssign = async (clearFirst = false) => {
    setSaApplying(true);
    try {
      const res = await axios.post(SMART_ASSIGN_URL, {
        apply_to: saApplyTo,
        exclude_bge_ids: saExclude.map(b => b.id),
        clear_first: clearFirst,
      }, { headers });
      const msg = clearFirst
        ? `Reset & reassigned: ${res.data.applied} MSMEs assigned fresh.`
        : `Applied: ${res.data.applied} updated, ${res.data.unchanged} unchanged.`;
      setSuccess(msg);
      setSaData(prev => prev ? { ...prev, _applied: true, ...res.data } : prev);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to apply assignments.');
    } finally {
      setSaApplying(false);
    }
  };
  const [saResetConfirm, setSaResetConfirm] = useState(false);
  const downloadSmartAssignExcel = async () => {
    try {
      const excludeParam = saExclude.map(b => b.id).join(',');
      const res = await axios.get(
        `${SMART_ASSIGN_EXPORT_URL}?apply_to=${saApplyTo}${excludeParam ? `&exclude=${excludeParam}` : ''}`,
        { headers, responseType: 'blob' }
      );
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      a.download = `BGE_Assignment_${date}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      setError('Failed to download Excel export.');
    }
  };

  const issueWo = async (wo) => {
    setWoIssuing(wo.id);
    try {
      await axios.post(WORK_ORDER_ISSUE_URL(wo.id), {}, { headers });
      setSuccess(`Work order ${wo.work_order_number} issued and emailed to ${wo.bge_name}.`);
      fetchWorkOrders();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to issue work order.');
    } finally {
      setWoIssuing(null);
    }
  };

  const deleteWo = async (wo) => {
    if (!window.confirm(`Delete work order ${wo.work_order_number}?`)) return;
    try {
      await axios.delete(`${API_ENDPOINTS.WORK_ORDERS}${wo.id}/`, { headers });
      setSuccess('Work order deleted.');
      fetchWorkOrders();
    } catch {
      setError('Failed to delete work order.');
    }
  };

  const deleteWoAttachment = async (att) => {
    if (!window.confirm(`Delete "${att.caption || att.filename}"? This cannot be undone.`)) return;
    try {
      await axios.delete(`${API_ENDPOINTS.WORK_ORDER_ATTACHMENTS}${att.id}/`, { headers });
      notify('Attachment deleted');
      fetchWoAttachments();
    } catch (e) {
      notify(e.response?.data?.error || 'Failed to delete attachment', 'error');
    }
  };

  const withdrawWo = async () => {
    if (!woWithdrawTarget) return;
    setWoWithdrawing(woWithdrawTarget.id);
    try {
      await axios.post(WORK_ORDER_WITHDRAW_URL(woWithdrawTarget.id), { reason: woWithdrawReason }, { headers });
      setSuccess(`Work order ${woWithdrawTarget.work_order_number} withdrawn. BGE has been notified by email.`);
      setWoWithdrawDialog(false);
      setWoWithdrawTarget(null);
      setWoWithdrawReason('');
      fetchWorkOrders();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to withdraw work order.');
    } finally {
      setWoWithdrawing(null);
    }
  };

  const downloadWoPdf = async (wo) => {
    try {
      const res = await axios.get(WORK_ORDER_PDF_URL(wo.id), {
        headers, responseType: 'blob',
      });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `WorkOrder_${(wo.work_order_number || wo.id).replace(/\s/g, '_')}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch { notify('Failed to download PDF', 'error'); }
  };

  const openWoPaymentSubmit = (wo) => {
    setWoPaymentSubmitTarget(wo);
    setWoPaymentSubmitForm({
      payment_reference: wo.payment_reference || '',
      payment_status: wo.payment_status === 'payment_confirmed' ? 'payment_confirmed' : (wo.payment_status || 'submitted_for_payment'),
      payment_notes: '',
    });
    setWoPaymentSubmitDialog(true);
  };

  const handleWoPaymentSubmit = async () => {
    if (!woPaymentSubmitTarget) return;
    setWoPaymentSubmitting(true);
    try {
      await axios.post(WORK_ORDER_SUBMIT_PAYMENT_URL(woPaymentSubmitTarget.id), woPaymentSubmitForm, { headers });
      notify(`Work Order ${woPaymentSubmitTarget.work_order_number} payment status updated ✓`, 'success');
      setWoPaymentSubmitDialog(false);
      setWoPaymentSubmitTarget(null);
      fetchWorkOrders();
      fetchConfirmedPayments();
    } catch (err) {
      notify(err.response?.data?.error || err.response?.data?.detail || 'Failed to update payment status', 'error');
    } finally {
      setWoPaymentSubmitting(false);
    }
  };

  const openReportPaymentSubmit = (report, type = 'msme') => {
    setReportPaymentSubmitTarget(report);
    setReportPaymentSubmitType(type);
    setReportPaymentSubmitForm({
      payment_reference: report.payment_reference || '',
      payment_status: report.payment_status || 'submitted',
      payment_notes: '',
    });
    setReportPaymentSubmitDialog(true);
  };

  const handleReportPaymentSubmit = async () => {
    if (!reportPaymentSubmitTarget) return;
    setReportPaymentSubmitting(true);
    try {
      const url = reportPaymentSubmitType === 'group' ? GROUP_REPORTS_SUBMIT_PAYMENT_URL : REPORTS_SUBMIT_PAYMENT_URL;
      await axios.post(url, {
        report_id: reportPaymentSubmitTarget.id,
        ...reportPaymentSubmitForm,
      }, { headers });
      notify(`Report submitted for payment [Ref: ${reportPaymentSubmitForm.payment_reference || 'N/A'}] ✓`, 'success');
      setReportPaymentSubmitDialog(false);
      setReportPaymentSubmitTarget(null);
      fetchAll();
      fetchConfirmedPayments();
    } catch (err) {
      notify(err.response?.data?.error || err.response?.data?.detail || 'Failed to submit report for payment', 'error');
    } finally {
      setReportPaymentSubmitting(false);
    }
  };

  const downloadSubmissionFile = async (sub, kind) => {
    const url = kind === 'timesheet' ? WORK_ORDER_SUBMISSION_TIMESHEET_URL(sub.id) : WORK_ORDER_SUBMISSION_INVOICE_URL(sub.id);
    const filename = kind === 'timesheet' ? sub.timesheet_filename : sub.invoice_filename;
    try {
      const res = await axios.get(url, { headers, responseType: 'blob' });
      const blobUrl = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename || `${kind}.xlsx`;
      a.click();
      URL.revokeObjectURL(blobUrl);
    } catch {
      notify(`Failed to download ${kind}`, 'error');
    }
  };

  const downloadAttachment = async (att) => {
    try {
      const res = await axios.get(WORK_ORDER_ATTACHMENT_DOWNLOAD_URL(att.id), { headers, responseType: 'blob' });
      const blobUrl = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = att.filename || 'attachment';
      a.click();
      URL.revokeObjectURL(blobUrl);
    } catch {
      notify('Failed to download attachment', 'error');
    }
  };

  const setWoPaymentField = (woId, field, value) => {
    setWoPaymentForms(prev => ({ ...prev, [woId]: { ...prev[woId], [field]: value } }));
  };

  const addWoPayment = async (wo) => {
    const form = woPaymentForms[wo.id] || {};
    if (!form.amount || !form.payment_date) {
      notify('Enter an amount and payment date', 'error');
      return;
    }
    setWoPaymentSaving(wo.id);
    try {
      await axios.post(API_ENDPOINTS.WORK_ORDER_PAYMENTS, {
        work_order: wo.id,
        amount: form.amount,
        payment_date: form.payment_date,
        balance: form.balance || null,
        reference: form.reference || '',
        notes: form.notes || '',
      }, { headers });
      notify('Payment recorded');
      setWoPaymentForms(prev => ({ ...prev, [wo.id]: { amount: '', payment_date: '', balance: '', reference: '', notes: '' } }));
      fetchWoPayments();
    } catch (err) {
      const errData = err.response?.data;
      const msg = errData?.error || errData?.detail ||
        (typeof errData === 'object' ? Object.values(errData).flat()[0] : null) ||
        'Failed to record payment';
      notify(String(msg), 'error');
    } finally {
      setWoPaymentSaving(null);
    }
  };

  const deleteWoPayment = async (payment) => {
    if (!window.confirm('Delete this payment record?')) return;
    try {
      await axios.delete(`${API_ENDPOINTS.WORK_ORDER_PAYMENTS}${payment.id}/`, { headers });
      setWoPayments(prev => prev.filter(p => p.id !== payment.id));
      notify('Payment deleted');
    } catch {
      notify('Failed to delete payment', 'error');
    }
  };

  const [woPaymentNotifying, setWoPaymentNotifying] = useState(null);

  const notifyBgePayment = async (payment) => {
    setWoPaymentNotifying(payment.id);
    try {
      const res = await axios.post(WORK_ORDER_PAYMENT_NOTIFY_URL(payment.id), {}, { headers });
      setWoPayments(prev => prev.map(p => p.id === payment.id ? res.data : p));
      notify('BGE notified by email');
    } catch {
      notify('Failed to notify BGE', 'error');
    } finally {
      setWoPaymentNotifying(null);
    }
  };

  // ── BGE Assignment section ────────────────────────────────────────────────
  const renderBgeAssignment = () => {
    const STATUS_COLOR = { unchanged: 'success', new: 'default', reassigned: 'warning' };
    const STATUS_LABEL = { unchanged: 'Unchanged', new: 'New', reassigned: 'Changed' };
    const filteredRows = (saData?.assignments || []).filter(a => {
      const q = saSearch.toLowerCase();
      return !q || a.msme_name.toLowerCase().includes(q)
        || a.msme_city?.toLowerCase().includes(q)
        || a.proposed_bge_name?.toLowerCase().includes(q);
    });

    return (
      <Box>
        <SectionHeader title="BGE Assignment" subtitle="Smart focal-person assignment by proximity & engagement">
          <Button variant="outlined" size="small" startIcon={<Download />} onClick={downloadSmartAssignExcel} disabled={!saData} sx={{ mr: 1 }}>
            Export Excel
          </Button>
          <Button variant="contained" size="small" onClick={() => loadSmartAssign(saApplyTo)} disabled={saLoading}>
            {saLoading ? 'Loading…' : saData ? 'Refresh Preview' : 'Load Preview'}
          </Button>
        </SectionHeader>

        {/* Controls */}
        <Paper variant="outlined" sx={{ p: 2, mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Scope</InputLabel>
            <Select value={saApplyTo} label="Scope" onChange={e => { setSaApplyTo(e.target.value); setSaData(null); }}>
              <MenuItem value="all">All active MSMEs</MenuItem>
              <MenuItem value="unassigned">Unassigned MSMEs only</MenuItem>
            </Select>
          </FormControl>
          {saData && (
            <TextField size="small" placeholder="Search MSME / BGE / district…" value={saSearch}
              onChange={e => setSaSearch(e.target.value)} sx={{ flex: '1 1 220px' }} />
          )}
          {saData && !saData._applied && (
            <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
              <Button variant="outlined" color="error" size="small"
                onClick={() => setSaResetConfirm(true)} disabled={saApplying}>
                Reset &amp; Reassign All
              </Button>
              <Button variant="contained" color="warning" size="small"
                onClick={() => applySmartAssign(false)} disabled={saApplying}>
                {saApplying ? 'Applying…' : `Apply ${saData.stats?.total || ''} Assignments`}
              </Button>
            </Box>
          )}
          {saData?._applied && (
            <Chip label={`✅ Applied — ${saData.applied} updated`} color="success" sx={{ ml: 'auto' }} />
          )}
        </Paper>

        {/* Exclude BGEs panel — shown once we have a BGE list from the preview */}
        {saData?.bge_summary?.length > 0 && (
          <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
            <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
              Exclude BGEs from pool
              {saExclude.length > 0 && (
                <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                  ({saExclude.length} excluded — click Refresh Preview to recompute)
                </Typography>
              )}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {/* Chips for all BGEs in the current summary */}
              {(saData.bge_summary || []).map(b => {
                const isExcluded = saExclude.some(e => e.id === b.bge_id);
                return (
                  <Chip
                    key={b.bge_id}
                    label={b.bge_name}
                    size="small"
                    color={isExcluded ? 'error' : 'default'}
                    variant={isExcluded ? 'filled' : 'outlined'}
                    onClick={() => {
                      setSaExclude(prev =>
                        isExcluded
                          ? prev.filter(e => e.id !== b.bge_id)
                          : [...prev, { id: b.bge_id, name: b.bge_name }]
                      );
                      setSaData(null); // clear stale preview so user knows to reload
                    }}
                    sx={{ cursor: 'pointer' }}
                  />
                );
              })}
              {/* Also show any excluded BGEs that are no longer in summary */}
              {saExclude.filter(e => !(saData?.bge_summary || []).some(b => b.bge_id === e.id)).map(e => (
                <Chip
                  key={e.id}
                  label={e.name}
                  size="small"
                  color="error"
                  variant="filled"
                  onDelete={() => setSaExclude(prev => prev.filter(x => x.id !== e.id))}
                />
              ))}
            </Box>
          </Paper>
        )}

        {saLoading && <Box sx={{ textAlign: 'center', py: 6 }}><CircularProgress /></Box>}

        {saData && (
          <>
            {/* Summary chips */}
            <Box sx={{ display: 'flex', gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
              <Chip label={`${saData.stats?.total} MSMEs`} color="primary" />
              <Chip label={`${saData.stats?.unchanged} unchanged`} color="success" variant="outlined" />
              <Chip label={`${saData.stats?.new} new assignments`} color="default" variant="outlined" />
              <Chip label={`${saData.stats?.reassigned} to be changed`} color="warning" variant="outlined" />
            </Box>

            <Tabs value={saTab} onChange={(_, v) => setSaTab(v)} sx={{ mb: 2 }}>
              <Tab label={`By BGE (${saData.bge_summary?.length || 0})`} />
              <Tab label={`All MSMEs (${filteredRows.length})`} />
            </Tabs>

            {/* Tab 0: BGE summary cards */}
            {saTab === 0 && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                {(saData.bge_summary || []).map(b => (
                  <Paper key={b.bge_id} variant="outlined" sx={{ p: 2, flex: '1 1 260px', maxWidth: 340 }}>
                    <Typography fontWeight={700} fontSize={14}>{b.bge_name}</Typography>
                    <Typography variant="caption" color="text.secondary">{b.bge_code} · {b.location || 'No location'}</Typography>
                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip label={`${b.count} MSMEs`} size="small" color="primary" />
                    </Box>
                    <Box sx={{ mt: 1 }}>
                      {(saData.assignments || [])
                        .filter(a => a.proposed_bge_id === b.bge_id)
                        .slice(0, 6)
                        .map(a => (
                          <Typography key={a.msme_id} variant="caption" display="block" noWrap color="text.secondary">
                            {a.msme_name} <span style={{ color: '#999' }}>· {a.msme_city}</span>
                          </Typography>
                        ))}
                      {b.count > 6 && (
                        <Typography variant="caption" color="primary">+{b.count - 6} more</Typography>
                      )}
                    </Box>
                  </Paper>
                ))}
              </Box>
            )}

            {/* Tab 1: Full MSME table */}
            {saTab === 1 && (
              <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 520, overflow: 'auto' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>MSME</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>City</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Focal BGE</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Previous BGE</TableCell>
                      <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>Eng.</TableCell>
                      <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>Loc.</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Reason</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredRows.map(a => (
                      <TableRow key={a.msme_id} hover>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600} noWrap>{a.msme_name}</Typography>
                          {a.msme_code && <Typography variant="caption" color="text.secondary">{a.msme_code}</Typography>}
                        </TableCell>
                        <TableCell><Typography variant="body2">{a.msme_city}</Typography></TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600}>{a.proposed_bge_name}</Typography>
                          <Typography variant="caption" color="text.secondary">{a.proposed_bge_loc}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color={a.current_bge_name ? 'text.primary' : 'text.disabled'}>
                            {a.current_bge_name || '—'}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip label={STATUS_LABEL[a.status]} color={STATUS_COLOR[a.status]} size="small" />
                        </TableCell>
                        <TableCell align="center">
                          <Chip label={a.engagement_score} size="small" color={a.engagement_score > 0 ? 'success' : 'default'} variant="outlined" />
                        </TableCell>
                        <TableCell align="center">
                          <Chip label={a.location_score} size="small" color={a.location_score > 0 ? 'info' : 'default'} variant="outlined" />
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption" color="text.secondary">{a.engagement_reason}</Typography>
                          {a.location_score > 0 && (
                            <Typography variant="caption" display="block" color="info.main">{a.location_reason}</Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}

        {!saData && !saLoading && (
          <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary' }}>
            <LocationOn sx={{ fontSize: 48, mb: 1, opacity: 0.3 }} />
            <Typography>Click "Load Preview" to compute the smart assignment.</Typography>
            <Typography variant="caption">Factors: previous engagement + location proximity + load balancing</Typography>
          </Box>
        )}

        {/* ── Reset & Reassign confirmation dialog ── */}
        <Dialog open={saResetConfirm} onClose={() => setSaResetConfirm(false)} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ color: 'error.main', fontWeight: 700 }}>
            ⚠️ Reset All Assignments?
          </DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              This will <strong>clear every existing MSME assignment</strong> and replace them with
              the proposed distribution shown in the preview.
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              • All <strong>{saData?.stats?.total || 0} active MSMEs</strong> will be reassigned
            </Typography>
            {saExclude.length > 0 && (
              <Typography variant="body2" color="text.secondary" gutterBottom>
                • <strong>{saExclude.map(e => e.name).join(', ')}</strong> are excluded from the pool
              </Typography>
            )}
            <Typography variant="body2" color="text.secondary">
              • This action cannot be undone automatically — export the Excel first if you need a record of the previous state.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSaResetConfirm(false)}>Cancel</Button>
            <Button
              variant="contained" color="error"
              disabled={saApplying}
              onClick={() => { setSaResetConfirm(false); applySmartAssign(true); }}
            >
              {saApplying ? 'Resetting…' : 'Yes, Reset & Reassign'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };

  const renderWorkOrders = () => {
    const filteredWorkOrders = deferredWorkOrders.filter(wo => {
      if (!woFilterPaymentStatus) return true;
      if (woFilterPaymentStatus === 'payment_confirmed') return wo.payment_status === 'payment_confirmed' || wo.payment_confirmed_by_bge;
      if (woFilterPaymentStatus === 'submitted_for_payment') return wo.payment_status === 'submitted_for_payment';
      if (woFilterPaymentStatus === 'paid') return wo.payment_status === 'paid';
      if (woFilterPaymentStatus === 'pending_submission') return !wo.payment_status || wo.payment_status === 'pending_submission';
      return true;
    });

    return (
    <Box>
      <SectionHeader title="Work Orders" subtitle={`${workOrders.length} work orders`}>
        <Button variant="outlined" color="primary" size="small" onClick={openPaDialog} sx={{ mr: 1 }}>🤝 Bulk Issue Permanent Assignee WOs (3x/Mo)</Button>
        <Button variant="outlined" size="small" onClick={openDuDialog} sx={{ mr: 1 }}>📊 Distribute Data Updates</Button>
        <Button variant="contained" startIcon={<Add />} size="small" onClick={openWoCreate}>New Work Order</Button>
      </SectionHeader>

      {/* Confirmed Payments Live Feed Banner */}
      {confirmedPaymentsFeed && confirmedPaymentsFeed.length > 0 && (
        <Paper variant="outlined" sx={{ p: 2, mb: 2.5, bgcolor: '#F1F8E9', borderColor: '#C8E6C9', borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CheckCircle sx={{ color: '#2E7D32', fontSize: 20 }} />
              <Typography variant="subtitle2" fontWeight={700} color="#2E7D32">
                Recent BGE Payment Confirmations ({confirmedPaymentsFeed.length})
              </Typography>
            </Box>
            <Chip label="BGE Confirmed" size="small" color="success" sx={{ height: 20, fontSize: 10, fontWeight: 700 }} />
          </Box>
          <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', pb: 0.5 }}>
            {confirmedPaymentsFeed.slice(0, 6).map((item, idx) => (
              <Paper key={idx} variant="outlined" sx={{ p: 1.2, minWidth: 220, bgcolor: '#fff', borderColor: '#E0E0E0', flexShrink: 0 }}>
                <Typography variant="caption" fontWeight={700} display="block" color="#1b5e20">
                  {item.bge_name} {item.bge_code ? `(${item.bge_code})` : ''}
                </Typography>
                <Typography variant="caption" color="text.primary" display="block">
                  {item.title}
                </Typography>
                {item.amount && (
                  <Typography variant="caption" fontWeight={700} color="primary.main" display="block">
                    UGX {Number(item.amount).toLocaleString()}
                  </Typography>
                )}
                <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: 10 }}>
                  Confirmed: {item.confirmed_at ? item.confirmed_at.slice(0, 10) : 'Recently'} {item.reference ? `· ${item.reference}` : ''}
                </Typography>
              </Paper>
            ))}
          </Box>
        </Paper>
      )}

      {/* Filters */}
      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, mb: 2, display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
        <FormControl size="small" sx={{ flex: '1 1 160px', minWidth: 0 }}>
          <InputLabel>Filter by BGE</InputLabel>
          <Select value={woFilterBge} label="Filter by BGE" onChange={e => { const v = e.target.value; startTransition(() => setWoFilterBge(v)); }}>
            <MenuItem value="">All BGEs</MenuItem>
            {experts.map(e => <MenuItem key={e.id} value={e.id}>{e.name} ({e.bge_code})</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ flex: '1 1 110px', minWidth: 0 }}>
          <InputLabel>Status</InputLabel>
          <Select value={woFilterStatus} label="Status" onChange={e => { const v = e.target.value; startTransition(() => setWoFilterStatus(v)); }}>
            <MenuItem value="">All</MenuItem>
            <MenuItem value="draft">Draft</MenuItem>
            <MenuItem value="issued">Issued</MenuItem>
            <MenuItem value="signed">Signed</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ flex: '1 1 150px', minWidth: 0 }}>
          <InputLabel>Payment Status</InputLabel>
          <Select value={woFilterPaymentStatus} label="Payment Status" onChange={e => { const v = e.target.value; startTransition(() => setWoFilterPaymentStatus(v)); }}>
            <MenuItem value="">All Payment Statuses</MenuItem>
            <MenuItem value="pending_submission">Pending Submission</MenuItem>
            <MenuItem value="submitted_for_payment">Submitted for Payment</MenuItem>
            <MenuItem value="paid">Paid</MenuItem>
            <MenuItem value="payment_confirmed">Confirmed by BGE ✓</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ flex: '1 1 160px', minWidth: 0 }}>
          <InputLabel>Type</InputLabel>
          <Select value={woFilterType || ''} label="Type" onChange={e => { const v = e.target.value; startTransition(() => setWoFilterType(v)); }}>
            <MenuItem value="">All Types</MenuItem>
            <MenuItem value="permanent_assignee_support">Permanent Assignee Support (3x/Mo)</MenuItem>
            <MenuItem value="msme_support">MSME CRM &amp; Business Support</MenuItem>
            <MenuItem value="msme_data_update">MSME Data Update &amp; Verification</MenuItem>
            <MenuItem value="msme_finance_survey">MSME Finance Survey (Google Forms)</MenuItem>
            <MenuItem value="msme_access_finance">Access to Finance &amp; Digital Onboarding</MenuItem>
            <MenuItem value="access_to_finance_bge">Access to Finance — BGE Template</MenuItem>
            <MenuItem value="biz_continuity">Business Continuity &amp; Operational Planning</MenuItem>
            <MenuItem value="biz_continuity_workshop">Business Continuity — Workshop Design &amp; Facilitation</MenuItem>
            <MenuItem value="mobilisation">Mobilisation / Outreach</MenuItem>
            <MenuItem value="group_session">Peer-to-Peer Group Session</MenuItem>
            <MenuItem value="training_facilitation">Training Facilitation — Senior BGE</MenuItem>
            <MenuItem value="bge_technical_co_assignment">BGE Technical Co-Assignment Support</MenuItem>
            <MenuItem value="bds_manual_module">BDS Manual — Additional Module</MenuItem>
            <MenuItem value="fi_mobilisation_bcp">BCP Tool - Field Implementation</MenuItem>
            <MenuItem value="carbon_emissions_training">Carbon Emissions Measurement Framework</MenuItem>
            <MenuItem value="csa_rapid_assessment">CSA Rapid Assessment — Resilience Activity</MenuItem>
            <MenuItem value="csa_eoi_data_entry">CSA Demonstration Sites — EOI Data Entry</MenuItem>
            <MenuItem value="market_activation_mobilisation">Market Activation Event — MSME Mobilisation</MenuItem>
            <MenuItem value="bge_bankable_docs_training">Bankable Documents Workshop — Co-Facilitator</MenuItem>
            <MenuItem value="bge_bankable_docs_participant">Bankable Documents Workshop — BGE Participant</MenuItem>
            <MenuItem value="bge_business_diagnostics">Business Diagnostics Assignment</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </Select>
        </FormControl>
      </Paper>

      {woLoading ? (
        <Paper sx={{ p: 6, textAlign: 'center' }}>
          <CircularProgress size={32} sx={{ mb: 1.5 }} />
          <Typography color="text.secondary">
            {woError && woError.includes('waking up') ? woError : 'Loading work orders…'}
          </Typography>
        </Paper>
      ) : woError && filteredWorkOrders.length === 0 ? (
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', bgcolor: '#FFF5F5', borderColor: '#FFCDD2' }}>
          <Typography color="error.main" fontWeight={600} sx={{ mb: 1.5 }}>
            {woError}
          </Typography>
          <Button variant="outlined" color="primary" size="small" onClick={fetchWorkOrders}>
            Retry Loading Work Orders
          </Button>
        </Paper>
      ) : filteredWorkOrders.length === 0 ? (
        <Paper sx={{ p: 6, textAlign: 'center' }}>
          <Assignment sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
          <Typography color="text.secondary">No work orders match the selected filters.</Typography>
        </Paper>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {filteredWorkOrders.map(wo => (
            <Card variant="outlined" key={wo.id}
              sx={
                wo.work_order_type === 'training_facilitation'
                  ? { borderLeft: '4px solid #7B1FA2' }
                  : wo.work_order_type === 'bge_technical_co_assignment'
                  ? { borderLeft: `4px solid ${BRAND.gopaGoldDark}` }
                  : wo.work_order_type === 'bds_manual_module'
                  ? { borderLeft: '4px solid #E65100' }
                  : wo.work_order_type === 'market_activation_mobilisation'
                  ? { borderLeft: '4px solid #0284C7' }
                  : wo.work_order_type === 'bge_bankable_docs_training'
                  ? { borderLeft: '4px solid #4A148C' }
                  : wo.work_order_type === 'bge_bankable_docs_participant'
                  ? { borderLeft: '4px solid #0D9488' }
                  : wo.work_order_type === 'bge_business_diagnostics'
                  ? { borderLeft: '4px solid #1E3A8A' }
                  : {}
              }>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3, flexWrap: 'wrap' }}>
                      <Typography fontWeight={700}>{wo.work_order_number}</Typography>
                      {wo.work_order_type === 'training_facilitation' && (
                        <Chip label="Senior BGE" size="small"
                          sx={{ bgcolor: '#7B1FA2', color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                      {wo.work_order_type === 'bge_technical_co_assignment' && (
                        <Chip label="Specialist Co-Assignment" size="small"
                          sx={{ bgcolor: BRAND.gopaGoldDark, color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                      {wo.work_order_type === 'bds_manual_module' && (
                        <Chip label="BDS Manual Module" size="small"
                          sx={{ bgcolor: '#E65100', color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                      {wo.work_order_type === 'market_activation_mobilisation' && (
                        <Chip label="Market Activation" size="small"
                          sx={{ bgcolor: '#0284C7', color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                      {wo.work_order_type === 'bge_bankable_docs_training' && (
                        <Chip label="Bankable Docs Co-Facilitator" size="small"
                          sx={{ bgcolor: '#4A148C', color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                      {wo.work_order_type === 'bge_bankable_docs_participant' && (
                        <Chip label="Bankable Docs Participant" size="small"
                          sx={{ bgcolor: '#0D9488', color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                      {wo.work_order_type === 'bge_business_diagnostics' && (
                        <Chip label="Business Diagnostics" size="small"
                          sx={{ bgcolor: '#1E3A8A', color: '#fff', fontSize: 10, fontWeight: 700 }} />
                      )}
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      {wo.work_order_type_display} · {wo.bge_name} ({wo.bge_code_display})
                    </Typography>
                    {wo.work_order_type === 'bge_technical_co_assignment' && (
                      <Box sx={{ mt: 0.5, mb: 0.5, p: 0.8, bgcolor: 'action.hover', borderRadius: 1 }}>
                        {wo.supported_bge_name && (
                          <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, color: 'info.main' }}>
                            Supporting Primary BGE: {wo.supported_bge_name} {wo.supported_bge_code ? `(${wo.supported_bge_code})` : ''}
                          </Typography>
                        )}
                        {(wo.technical_area || wo.bge_top_skills) && (
                          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                            Technical Specialty: {wo.technical_area || wo.bge_top_skills}
                          </Typography>
                        )}
                        {wo.target_msmes_detail && wo.target_msmes_detail.length > 0 && (
                          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                            Target MSMEs ({wo.target_msmes_detail.length}): {wo.target_msmes_detail.map(m => m.name).slice(0, 3).join(', ')}{wo.target_msmes_detail.length > 3 ? ` +${wo.target_msmes_detail.length - 3} more` : ''}
                          </Typography>
                        )}
                      </Box>
                    )}
                    <Typography variant="caption" color="text.secondary" display="block">
                      Issued: {wo.issue_date}{wo.start_date ? ` · Start: ${wo.start_date}` : ''}{wo.end_date ? ` – ${wo.end_date}` : ''}
                    </Typography>
                    {wo.status === 'signed' && wo.bge_signed_date && (
                      <Typography variant="caption" color="success.main" display="block" fontWeight={600}>
                        Signed by BGE: {wo.bge_signed_date}
                      </Typography>
                    )}
                    <Typography variant="caption" color="text.secondary" display="block">{wo.location}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Chip
                      label={wo.status_display || wo.status}
                      size="small"
                      color={wo.status === 'signed' ? 'success' : wo.status === 'issued' ? 'primary' : 'default'}
                    />

                    {/* Payment Status Badges */}
                    {wo.payment_status === 'submitted_for_payment' && (
                      <Tooltip title={`Submitted for payment on ${wo.payment_submitted_at ? wo.payment_submitted_at.slice(0,10) : ''} · Ref: ${wo.payment_reference || 'N/A'}`}>
                        <Chip
                          label={wo.payment_reference ? `Submitted: ${wo.payment_reference}` : 'Submitted for Payment'}
                          size="small"
                          sx={{ bgcolor: '#FFF3E0', color: '#E65100', fontWeight: 600, border: '1px solid #FFE082' }}
                        />
                      </Tooltip>
                    )}
                    {(wo.payment_status === 'payment_confirmed' || wo.payment_confirmed_by_bge) && (
                      <Tooltip title={`Payment confirmed by BGE on ${wo.payment_confirmed_at ? wo.payment_confirmed_at.slice(0, 16).replace('T', ' ') : ''}`}>
                        <Chip
                          label="✓ Confirmed by BGE"
                          size="small"
                          sx={{ bgcolor: '#E8F5E9', color: '#2E7D32', fontWeight: 600, border: '1px solid #A5D6A7' }}
                        />
                      </Tooltip>
                    )}
                    {wo.payment_status === 'paid' && !wo.payment_confirmed_by_bge && (
                      <Chip label="Paid" size="small" color="info" />
                    )}

                    {/* Submit for Payment Action */}
                    {isStaff && (
                      <Tooltip title="Submit for payment / update payment batch reference">
                        <Button
                          variant="outlined" size="small"
                          color={wo.payment_confirmed_by_bge ? 'success' : wo.payment_status === 'submitted_for_payment' ? 'warning' : 'primary'}
                          startIcon={<Payments fontSize="small" />}
                          onClick={() => openWoPaymentSubmit(wo)}
                          sx={{ fontSize: 11, py: 0.25, height: 28 }}
                        >
                          {wo.payment_confirmed_by_bge ? 'Payment Confirmed' : wo.payment_status === 'submitted_for_payment' ? 'Payment Submitted' : 'Submit for Payment'}
                        </Button>
                      </Tooltip>
                    )}

                    {isStaff && wo.status === 'draft' && (
                      <Tooltip title="Issue & email PDF to BGE">
                        <span>
                          <Button
                            variant="contained" size="small" color="success"
                            startIcon={woIssuing === wo.id ? <CircularProgress size={14} color="inherit" /> : <Email />}
                            disabled={woIssuing === wo.id}
                            onClick={() => issueWo(wo)}
                          >
                            Issue
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    {isStaff && (wo.status === 'issued' || wo.status === 'signed') && (
                      <Tooltip title="Withdraw work order back to draft">
                        <Button
                          variant="outlined" size="small" color="warning"
                          startIcon={woWithdrawing === wo.id ? <CircularProgress size={14} color="inherit" /> : <Undo />}
                          disabled={woWithdrawing === wo.id}
                          onClick={() => { setWoWithdrawTarget(wo); setWoWithdrawReason(''); setWoWithdrawDialog(true); }}
                        >
                          Withdraw
                        </Button>
                      </Tooltip>
                    )}
                    {wo.status !== 'draft' && (
                      <Tooltip title={wo.status === 'signed' ? 'Download signed work order PDF' : 'Download work order PDF'}>
                        <IconButton
                          size="small"
                          color={wo.status === 'signed' ? 'success' : 'primary'}
                          onClick={() => downloadWoPdf(wo)}
                        >
                          <Download fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Edit work order">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => openWoEdit(wo)}
                          disabled={!isStaff && wo.status !== 'draft'}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <span>
                        <IconButton size="small" color="error" onClick={() => deleteWo(wo)} disabled={wo.status !== 'draft'}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                </Box>
                {wo.objective && (
                  <Alert severity="info" sx={{ mt: 1.5, py: 0.5 }} icon={false}>
                    <Typography variant="caption" fontWeight={600}>Objective</Typography>
                    <Typography variant="caption" display="block">
                      {wo.objective.length > 200 ? wo.objective.slice(0, 200) + '…' : wo.objective}
                    </Typography>
                  </Alert>
                )}
                <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap' }}>
                  <Typography variant="caption" color="text.secondary">
                    Rate: <strong>UGX {Number(wo.rate_per_day).toLocaleString()}/day</strong>
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Max: <strong>{wo.max_days} days</strong>
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Net: <strong>UGX {(wo.rate_per_day * wo.max_days * 0.94).toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong>
                  </Typography>
                </Box>

                {(() => {
                  const subs = woSubmissions.filter(s => s.work_order === wo.id);
                  const payments = woPayments.filter(p => p.work_order === wo.id);
                  const atts = woAttachments.filter(a => {
                    const aWoId = typeof a.work_order === 'object' ? a.work_order?.id : a.work_order;
                    return String(aWoId) === String(wo.id);
                  });
                  const amountDue = Number(wo.amount_due || 0);
                  const totalPaid = Number(wo.total_paid || 0);
                  const outstanding = Number(wo.outstanding ?? (amountDue - totalPaid));
                  const pf = woPaymentForms[wo.id] || {};
                  return (
                    <Accordion variant="outlined" sx={{ mt: 1.5 }} disableGutters TransitionProps={{ unmountOnExit: true }}>
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
                          <Typography variant="caption" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Description fontSize="inherit" /> {subs.length} submission{subs.length !== 1 ? 's' : ''}
                          </Typography>
                          <Typography variant="caption" fontWeight={700} color={outstanding > 0 ? 'warning.main' : 'success.main'}
                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Payments fontSize="inherit" />
                            Paid UGX {totalPaid.toLocaleString()} of {amountDue.toLocaleString()}
                            {outstanding > 0 ? ` · UGX ${outstanding.toLocaleString()} outstanding` : ' · fully paid'}
                          </Typography>
                          {atts.length > 0 && (
                            <Typography variant="caption" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <AttachFile fontSize="inherit" /> {atts.length} doc{atts.length !== 1 ? 's' : ''}
                            </Typography>
                          )}
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails>
                        {/* Supporting documents uploaded by BGE */}
                        {atts.length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" fontWeight={700} gutterBottom>Supporting Documents</Typography>
                            <TableContainer>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Title / Caption</TableCell>
                                    <TableCell>File</TableCell>
                                    <TableCell>Uploaded by</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell align="right">Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {atts.map(att => (
                                    <TableRow key={att.id}>
                                      <TableCell>{att.caption || <em style={{ color: '#999' }}>No title</em>}</TableCell>
                                      <TableCell>
                                        <Tooltip title={att.filename}>
                                          <IconButton size="small" color="primary"
                                            onClick={() => downloadAttachment(att)}>
                                            <Download fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                        <Typography variant="caption" color="text.secondary">{att.filename}</Typography>
                                      </TableCell>
                                      <TableCell>{att.uploaded_by_name || '—'}</TableCell>
                                      <TableCell>{att.created_at ? new Date(att.created_at).toLocaleDateString() : '—'}</TableCell>
                                      <TableCell align="right">
                                        <Tooltip title="Delete attachment">
                                          <IconButton size="small" color="error" onClick={() => deleteWoAttachment(att)}>
                                            <DeleteForever fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        )}

                        {/* Timesheet & invoice submissions */}
                        <Typography variant="subtitle2" fontWeight={700} gutterBottom>Timesheets & Invoices</Typography>
                        {subs.length === 0 ? (
                          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                            No submissions from {wo.bge_name} yet.
                          </Typography>
                        ) : (
                          <TableContainer sx={{ mb: 2 }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Submitted</TableCell>
                                  <TableCell>Timesheet</TableCell>
                                  <TableCell>Invoice</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {subs.map(sub => (
                                  <TableRow key={sub.id}>
                                    <TableCell>{new Date(sub.created_at).toLocaleDateString()}</TableCell>
                                    <TableCell>
                                      {sub.has_timesheet ? (
                                        <Tooltip title={sub.timesheet_filename}>
                                          <IconButton size="small" color="primary" onClick={() => downloadSubmissionFile(sub, 'timesheet')}>
                                            <Download fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      ) : <Typography variant="caption" color="text.disabled">—</Typography>}
                                    </TableCell>
                                    <TableCell>
                                      {sub.has_invoice ? (
                                        <Tooltip title={sub.invoice_filename}>
                                          <IconButton size="small" color="primary" onClick={() => downloadSubmissionFile(sub, 'invoice')}>
                                            <Download fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      ) : <Typography variant="caption" color="text.disabled">—</Typography>}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}

                        {/* Payment log */}
                        <Typography variant="subtitle2" fontWeight={700} gutterBottom>Payment Log</Typography>
                        {payments.length > 0 && (
                          <TableContainer sx={{ mb: 1.5 }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  <TableCell align="right">Amount (UGX)</TableCell>
                                  <TableCell align="right">Balance (UGX)</TableCell>
                                  <TableCell>Reference</TableCell>
                                  <TableCell>Notes</TableCell>
                                  <TableCell>Recorded by</TableCell>
                                  <TableCell>Status</TableCell>
                                  <TableCell align="right">Actions</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {payments.map(p => (
                                  <TableRow key={p.id}>
                                    <TableCell>{p.payment_date}</TableCell>
                                    <TableCell align="right">{Number(p.amount).toLocaleString()}</TableCell>
                                    <TableCell align="right">
                                      {p.balance != null
                                        ? <strong style={{ color: Number(p.balance) > 0 ? '#d32f2f' : 'inherit' }}>{Number(p.balance).toLocaleString()}</strong>
                                        : '—'}
                                    </TableCell>
                                    <TableCell>{p.reference || '—'}</TableCell>
                                    <TableCell>{p.notes || '—'}</TableCell>
                                    <TableCell>{p.recorded_by_name || '—'}</TableCell>
                                    <TableCell>
                                      {p.confirmed_by_bge ? (
                                        <Chip
                                          size="small" color="success" icon={<CheckCircle />}
                                          label={`Confirmed ${new Date(p.confirmed_at).toLocaleDateString()}`}
                                        />
                                      ) : p.notified_at ? (
                                        <Chip
                                          size="small" variant="outlined"
                                          label={`Notified ${new Date(p.notified_at).toLocaleDateString()}`}
                                        />
                                      ) : (
                                        <Typography variant="caption" color="text.disabled">Not notified</Typography>
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {!p.confirmed_by_bge && (
                                        <Tooltip title="Email BGE about this payment">
                                          <span>
                                            <IconButton
                                              size="small" color="primary"
                                              disabled={woPaymentNotifying === p.id}
                                              onClick={() => notifyBgePayment(p)}
                                            >
                                              {woPaymentNotifying === p.id ? <CircularProgress size={16} /> : <SendIcon fontSize="small" />}
                                            </IconButton>
                                          </span>
                                        </Tooltip>
                                      )}
                                      <Tooltip title="Delete payment">
                                        <IconButton size="small" color="error" onClick={() => deleteWoPayment(p)}>
                                          <Delete fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}

                        {/* Add payment */}
                        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
                          <TextField
                            size="small" type="date" label="Date" InputLabelProps={{ shrink: true }}
                            value={pf.payment_date || ''}
                            onChange={e => setWoPaymentField(wo.id, 'payment_date', e.target.value)}
                            sx={{ width: 160 }}
                          />
                          <TextField
                            size="small" type="number" label="Amount (UGX)"
                            value={pf.amount || ''}
                            onChange={e => setWoPaymentField(wo.id, 'amount', e.target.value)}
                            sx={{ width: 150 }}
                          />
                          <TextField
                            size="small" type="number" label="Balance (UGX)"
                            value={pf.balance || ''}
                            onChange={e => setWoPaymentField(wo.id, 'balance', e.target.value)}
                            sx={{ width: 150 }}
                          />
                          <TextField
                            size="small" label="Reference"
                            value={pf.reference || ''}
                            onChange={e => setWoPaymentField(wo.id, 'reference', e.target.value)}
                            sx={{ width: 180 }}
                          />
                          <TextField
                            size="small" label="Notes"
                            value={pf.notes || ''}
                            onChange={e => setWoPaymentField(wo.id, 'notes', e.target.value)}
                            sx={{ flex: '1 1 200px' }}
                          />
                          <Button
                            variant="contained" size="small"
                            startIcon={woPaymentSaving === wo.id ? <CircularProgress size={14} color="inherit" /> : <Add />}
                            disabled={woPaymentSaving === wo.id}
                            onClick={() => addWoPayment(wo)}
                          >
                            Add Payment
                          </Button>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  );
                })()}
              </CardContent>
            </Card>
          ))}
        </Box>
      )}

      {/* ── Data-Update Distribution Dialog ─────────────────────────────── */}
      <Dialog open={duDialog} onClose={() => { setDuDialog(false); setDuResult(null); }} maxWidth="md" fullWidth>
        <DialogTitle>📊 Distribute Data-Update Work Orders</DialogTitle>
        <DialogContent dividers>
          {duLoading && <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress /></Box>}

          {!duLoading && duPreview && !duResult && (
            <>
              {/* Summary chips */}
              <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <Chip label={`${duPreview.total_qualifying_msmes} qualifying MSMEs`} color="primary" />
                <Chip label={`${duPreview.total_bges} active BGEs`} color="secondary" />
                <Chip label={`~${duPreview.per_bge_target} per BGE`} color="success" />
              </Box>

              {/* Config fields */}
              <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <TextField label="Start Date" type="date" size="small" value={duStartDate}
                  onChange={e => setDuStartDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ flex: '1 1 140px' }} />
                <TextField label="End Date" type="date" size="small" value={duEndDate}
                  onChange={e => setDuEndDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ flex: '1 1 140px' }} />
                <TextField label="Max Days" type="number" size="small" value={duMaxDays}
                  onChange={e => setDuMaxDays(Number(e.target.value))} sx={{ flex: '1 1 100px' }} />
                <TextField label="Rate/Day (UGX)" type="number" size="small" value={duRatePerDay}
                  onChange={e => setDuRatePerDay(Number(e.target.value))} sx={{ flex: '1 1 140px' }} />
              </Box>
              <FormControlLabel
                control={<Checkbox checked={duUpdateAssign} onChange={e => setDuUpdateAssign(e.target.checked)} size="small" />}
                label="Also update assigned_bge on each MSME"
                sx={{ mb: 2 }}
              />

              {/* Distribution preview table */}
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>Proposed Distribution</Typography>
              <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 340, overflow: 'auto' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>BGE</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">MSMEs</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>MSME Names</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {duPreview.distribution.map(row => (
                      <TableRow key={row.bge_id} hover>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600}>{row.bge_name}</Typography>
                          {row.bge_code && <Typography variant="caption" color="text.secondary">{row.bge_code}</Typography>}
                        </TableCell>
                        <TableCell align="center">
                          <Chip label={row.count} size="small" color={row.count > 0 ? 'primary' : 'default'} />
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption" color="text.secondary">
                            {row.msmes.slice(0, 5).map(m => m.name).join(', ')}
                            {row.msmes.length > 5 && ` +${row.msmes.length - 5} more`}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {/* Result after creation */}
          {duResult && (
            <Box>
              <Typography variant="h6" color="success.main" sx={{ mb: 1 }}>
                ✅ {duResult.created} work orders created
              </Typography>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>Work Order #</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>BGE</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">MSMEs</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(duResult.work_orders || []).map(w => (
                      <TableRow key={w.work_order_id}>
                        <TableCell><Typography variant="body2" fontWeight={600}>{w.work_order_number}</Typography></TableCell>
                        <TableCell>{w.bge_name}</TableCell>
                        <TableCell align="center"><Chip label={w.msme_count} size="small" color="primary" /></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {duResult.errors?.length > 0 && (
                <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                  {duResult.errors.map(e => `${e.bge}: ${e.error}`).join('; ')}
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setDuDialog(false); setDuResult(null); }}>Close</Button>
          {!duResult && duPreview && (
            <Button variant="contained" onClick={createDuWorkOrders} disabled={duCreating}>
              {duCreating ? 'Creating…' : `Create ${duPreview.total_bges} Work Orders`}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* ── Permanent Assignee (3x/Mo) Bulk Work Order Distribution Dialog ── */}
      <Dialog open={paDialog} onClose={() => { setPaDialog(false); setPaResult(null); }} maxWidth="md" fullWidth>
        <DialogTitle>🤝 Bulk Issue Permanent Assignee Work Orders (3x/Month)</DialogTitle>
        <DialogContent dividers>
          {paLoading && <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress /></Box>}

          {!paLoading && paPreview && !paResult && (
            <>
              {/* Summary chips */}
              <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <Chip label={`${paPreview.total_assigned_msmes} assigned MSMEs`} color="primary" />
                <Chip label={`${paPreview.total_bges} active/approved BGEs`} color="secondary" />
                <Chip label={`${paPreview.bges_with_assignees} BGEs with assignees`} color="success" />
              </Box>

              {/* Alert explaining the thematic requirements */}
              <Alert severity="info" sx={{ mb: 2 }}>
                <strong>Thematic Enterprise Coaching Framework:</strong> Mandates minimum 3 on-site coaching visits/month per MSME, applies the 4 Reflection Standards (opening stated purpose, diagnose &amp; advise, Acid Test 1 concrete change, visible closing with SMS Action Handout), strictly bans meeting off-premise in town solely for signatures, and drives core enterprise growth themes (formalization via URSB &amp; TIN, digital bookkeeping via ISM / One Tap POS, and operational revenue coaching).
              </Alert>

              {/* Config fields */}
              <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <TextField label="Start Date" type="date" size="small" value={paStartDate}
                  onChange={e => setPaStartDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ flex: '1 1 140px' }} />
                <TextField label="End Date" type="date" size="small" value={paEndDate}
                  onChange={e => setPaEndDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ flex: '1 1 140px' }} />
                <TextField label="Max Days" type="number" size="small" value={paMaxDays}
                  onChange={e => setPaMaxDays(Number(e.target.value))} sx={{ flex: '1 1 100px' }} />
                <TextField label="Rate/Day (UGX)" type="number" size="small" value={paRatePerDay}
                  onChange={e => setPaRatePerDay(Number(e.target.value))} sx={{ flex: '1 1 140px' }} />
              </Box>
              <FormControlLabel
                control={<Checkbox checked={paAllowEmpty} onChange={e => setPaAllowEmpty(e.target.checked)} size="small" />}
                label="Also create work orders for BGEs with 0 assigned MSMEs"
                sx={{ mb: 2 }}
              />

              {/* Distribution preview table */}
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>Permanent Assignees per BGE</Typography>
              <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 340, overflow: 'auto' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>BGE</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">Assigned MSMEs</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>MSME Names &amp; Districts</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paPreview.distribution.map(row => (
                      <TableRow key={row.bge_id} hover>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600}>{row.bge_name}</Typography>
                          {row.bge_code && <Typography variant="caption" color="text.secondary">{row.bge_code}</Typography>}
                        </TableCell>
                        <TableCell align="center">
                          <Chip label={row.count} size="small" color={row.count > 0 ? 'primary' : 'default'} />
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption" color="text.secondary">
                            {row.msmes.length === 0
                              ? <em>No assigned MSMEs</em>
                              : row.msmes.slice(0, 6).map(m => `${m.business_name} (${m.district})`).join(', ')}
                            {row.msmes.length > 6 && ` +${row.msmes.length - 6} more`}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {/* Result after creation */}
          {paResult && (
            <Box>
              <Typography variant="h6" color="success.main" sx={{ mb: 1 }}>
                ✅ {paResult.created} work orders created
              </Typography>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>Work Order #</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>BGE</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">Assigned MSMEs</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(paResult.work_orders || []).map(w => (
                      <TableRow key={w.work_order_id}>
                        <TableCell><Typography variant="body2" fontWeight={600}>{w.work_order_number}</Typography></TableCell>
                        <TableCell>{w.bge_name} {w.bge_code ? `(${w.bge_code})` : ''}</TableCell>
                        <TableCell align="center"><Chip label={w.msme_count} size="small" color="primary" /></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {paResult.errors?.length > 0 && (
                <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                  {paResult.errors.map(e => `${e.bge}: ${e.error}`).join('; ')}
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setPaDialog(false); setPaResult(null); }}>Close</Button>
          {!paResult && paPreview && (
            <Button variant="contained" onClick={createPaWorkOrders} disabled={paCreating}>
              {paCreating ? 'Creating…' : `Create Work Orders (${paAllowEmpty ? paPreview.total_bges : paPreview.bges_with_assignees} BGEs)`}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Create / Edit Dialog — extracted to WorkOrderDialog to prevent full-Dashboard re-renders on keystrokes */}
      <WorkOrderDialog
        open={woDialog}
        onClose={() => setWoDialog(false)}
        woEditing={woEditing}
        experts={experts}
        headers={headers}
        fetchWorkOrders={fetchWorkOrders}
        onSaved={(msg) => { setSuccess(msg); setWoDialog(false); }}
      />

      {/* Withdraw confirmation dialog */}
      <Dialog open={woWithdrawDialog} onClose={() => setWoWithdrawDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Withdraw Work Order</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Withdrawing <strong>{woWithdrawTarget?.work_order_number}</strong> will reset it to draft status
            and notify <strong>{woWithdrawTarget?.bge_name}</strong> by email. You can then edit and re-issue it.
          </Typography>
          <TextField
            fullWidth
            size="small"
            label="Reason for withdrawal (optional)"
            multiline
            rows={3}
            value={woWithdrawReason}
            onChange={e => setWoWithdrawReason(e.target.value)}
            placeholder="e.g. Budget revision required, dates need updating..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWoWithdrawDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="warning"
            onClick={withdrawWo}
            disabled={woWithdrawing === woWithdrawTarget?.id}
            startIcon={woWithdrawing === woWithdrawTarget?.id ? <CircularProgress size={14} color="inherit" /> : null}
          >
            Withdraw & Notify BGE
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    );
  };

  const renderParticipation = () => {
    const s = participationSummary;

    const statBox = (label, value, color = BRAND.primaryMain) => (
      <Grid item xs={6} sm={4} md={3} lg={2} key={label}>
        <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="h4" fontWeight={700} sx={{ color }}>{value ?? '—'}</Typography>
          <Typography variant="caption" color="text.secondary">{label}</Typography>
        </Paper>
      </Grid>
    );

    const demCells = (row) => (
      <>
        <TableCell align="center">
          <Chip label={row.total} size="small"
            color={row.total > 0 ? 'primary' : 'default'} />
        </TableCell>
        <TableCell align="center">{row.female || 0}</TableCell>
        <TableCell align="center">{row.male || 0}</TableCell>
        <TableCell align="center" sx={{ color: '#E65100' }}>
          {(row.female_youth || 0) + (row.male_youth || 0) || 0}
        </TableCell>
        <TableCell align="center">
          {row.refugees_total > 0
            ? <Chip label={row.refugees_total} size="small" color="warning" />
            : 0}
        </TableCell>
        <TableCell align="center">{row.host_community || 0}</TableCell>
      </>
    );

    const demHeader = (
      <>
        <TableCell align="center">Present</TableCell>
        <TableCell align="center">F</TableCell>
        <TableCell align="center">M</TableCell>
        <TableCell align="center">Youth</TableCell>
        <TableCell align="center">Refugees</TableCell>
        <TableCell align="center">Host Comm.</TableCell>
      </>
    );

    return (
      <Box sx={{ p: 3 }}>
        {/* Header row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexWrap: 'wrap', gap: 1 }}>
          <Box>
            <Typography variant="h5" fontWeight={700}>Participation</Typography>
            <Typography variant="body2" color="text.secondary">
              Live attendance tracking across all training sessions
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Filter by Cohort</InputLabel>
              <Select value={participationCohort} label="Filter by Cohort"
                onChange={e => { setParticipationCohort(e.target.value); fetchParticipationSummary(e.target.value); }}>
                <MenuItem value="">All Cohorts</MenuItem>
                {cohorts.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
              </Select>
            </FormControl>
            <Button variant="outlined" size="small" startIcon={participationLoading ? <CircularProgress size={14} /> : null}
              onClick={() => fetchParticipationSummary(participationCohort)} disabled={participationLoading}>
              Refresh
            </Button>
          </Box>
        </Box>

        {participationLoading && !s ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>
        ) : !s ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography color="text.secondary" gutterBottom>No participation data yet.</Typography>
            <Button variant="contained" onClick={() => fetchParticipationSummary('')}>Load Summary</Button>
          </Box>
        ) : (
          <>
            {/* ── 1. Per-Session table ───────────────────────────────────────── */}
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Training Sessions ({(s.by_session || []).length})
            </Typography>
            {(s.by_session || []).length === 0 ? (
              <Typography color="text.secondary" sx={{ mb: 3 }}>No training sessions recorded yet.</Typography>
            ) : (
              <TableContainer component={Paper} variant="outlined" sx={{ mb: 4 }}>
                <Table size="small">
                  <TableHead sx={{ bgcolor: '#FAF9F6' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Session / Topic</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Lead BGE</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700 }}>Reg.</TableCell>
                      {demHeader}
                      <TableCell align="center" sx={{ fontWeight: 700 }}>Lead Report</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700 }}>Mentor Reports</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(s.by_session || []).map(sess => {
                      const noAtt = sess.total === 0;
                      const bgColor = noAtt ? '#FFFDE7' : 'inherit';
                      return (
                        <TableRow key={sess.session_id} hover sx={{ bgcolor: bgColor }}>
                          <TableCell sx={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                            {sess.session_date}
                          </TableCell>
                          <TableCell sx={{ maxWidth: 220 }}>
                            <Typography variant="body2" fontWeight={600} noWrap>
                              {sess.session_title}
                            </Typography>
                            {sess.topic_name && (
                              <Typography variant="caption" color="text.secondary" display="block" noWrap>
                                {sess.topic_number ? `§${sess.topic_number} · ` : ''}{sess.topic_name}
                              </Typography>
                            )}
                            {sess.session_location && (
                              <Typography variant="caption" color="text.secondary" display="block" noWrap>
                                📍 {sess.session_location}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ fontSize: 12 }}>
                            {sess.lead_bge_name || <Typography variant="caption" color="text.secondary">—</Typography>}
                            {(sess.mentor_names || []).length > 0 && (
                              <Typography variant="caption" display="block" color="text.secondary" noWrap>
                                +{sess.mentor_names.length} mentor{sess.mentor_names.length > 1 ? 's' : ''}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="caption" color="text.secondary">{sess.registered_count}</Typography>
                          </TableCell>
                          {demCells(sess)}
                          <TableCell align="center">
                            {sess.has_training_report
                              ? <Chip label="Filed" size="small" color="success" />
                              : <Chip label="Pending" size="small" color="default" />}
                          </TableCell>
                          <TableCell align="center">
                            {sess.mentor_report_count > 0
                              ? <Chip label={sess.mentor_report_count} size="small" color="info" />
                              : <Typography variant="caption" color="text.secondary">—</Typography>}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {/* ── 2. Overall totals ─────────────────────────────────────────── */}
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>Overall Attendance Totals</Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              {statBox('Total Present', s.total, BRAND.primaryMain)}
              {statBox('Female', s.female, '#AD1457')}
              {statBox('Male', s.male, BRAND.primaryMain)}
              {statBox('Female Youth (18–34)', s.female_youth, '#AD1457')}
              {statBox('Male Youth (18–34)', s.male_youth, BRAND.primaryMain)}
              {statBox('Adult Female', s.female_adult, '#AD1457')}
              {statBox('Adult Male', s.male_adult, BRAND.primaryMain)}
              {statBox('Refugees', s.refugees_total, '#E65100')}
              {statBox('Female Refugees', s.refugee_female, '#E65100')}
              {statBox('Male Refugees', s.refugee_male, '#E65100')}
              {statBox('Host Community', s.host_community, '#2E7D32')}
            </Grid>

            {/* ── 3. BGE report totals ──────────────────────────────────────── */}
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>BGE Field Reports</Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              {statBox('MSME Visit Reports', s.msme_reports, '#5C6BC0')}
              {statBox('Unique MSMEs Visited', s.unique_msmes_visited, '#5C6BC0')}
              {statBox('Group Sessions Filed', s.group_sessions, '#00695C')}
            </Grid>

            {/* ── 4. Per-cohort breakdown ───────────────────────────────────── */}
            {(s.by_cohort || []).length > 0 && (
              <>
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>Attendance by Cohort</Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ mb: 4 }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>Cohort</TableCell>
                        {demHeader}
                        <TableCell align="center" sx={{ fontWeight: 700 }}>Youth Total</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 700 }}>Adults</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 700 }}>MSME Reports</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 700 }}>Unique MSMEs</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {s.by_cohort.map(c => (
                        <TableRow key={c.cohort_id} hover>
                          <TableCell sx={{ fontWeight: 500 }}>{c.cohort_name}</TableCell>
                          {demCells(c)}
                          <TableCell align="center">{(c.male_youth || 0) + (c.female_youth || 0)}</TableCell>
                          <TableCell align="center">{(c.male_adult || 0) + (c.female_adult || 0)}</TableCell>
                          <TableCell align="center">{c.msme_reports}</TableCell>
                          <TableCell align="center">{c.unique_msmes}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}

            {/* ── 5. Per-work-order (BGE deployment) breakdown ─────────────── */}
            {(s.by_work_order || []).length > 0 && (
              <>
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>By BGE Deployment / Work Order</Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ mb: 2 }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>Work Order</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>BGE</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                        {demHeader}
                        <TableCell align="center" sx={{ fontWeight: 700 }}>Reports</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 700 }}>Unique MSMEs</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {s.by_work_order.map(w => (
                        <TableRow key={w.work_order_id} hover>
                          <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>{w.work_order_number}</TableCell>
                          <TableCell sx={{ fontSize: 12 }}>{w.bge_name}</TableCell>
                          <TableCell sx={{ fontSize: 12 }}>{w.work_order_type}</TableCell>
                          <TableCell>
                            <Chip label={w.status} size="small"
                              color={w.status === 'signed' ? 'success' : w.status === 'issued' ? 'primary' : 'default'} />
                          </TableCell>
                          {demCells(w)}
                          <TableCell align="center">{w.msme_reports}</TableCell>
                          <TableCell align="center">{w.unique_msmes}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </>
        )}
      </Box>
    );
  };

  // ── Communications ────────────────────────────────────────────────────────
  const COMM_TEMPLATES = [
    {
      key: 'bge_portal_login_resolution',
      label: 'BGE & Reviewers — Portal Login & Access Resolution',
      subject: 'Important Update: Resolution of Portal Login & Password Reset Issues — PRUDEV II Portfolio System',
      body: `Dear {{name}},

I hope this email finds you well.

We would like to address the recent difficulties several of you experienced when trying to log into the PRUDEV II Portfolio Management Portal (https://bds.glowi.africa) or when attempting to reset your passwords.

We sincerely apologize for any inconvenience this caused in submitting your visit reports and accessing programme materials.

---

1. WHAT WAS CAUSING THE ISSUE?

Our technical team investigated and resolved the following factors:

• Strict Username & Case-Sensitivity: Previously, the portal required an exact username match. Entering your email address, BGE code, or mobile auto-capitalization (e.g. John.doe instead of john.doe) resulted in an "Invalid username or password" error.
• Trailing Whitespace: Copy-pasting credentials on mobile devices sometimes added trailing spaces that caused logins to fail.
• Network & DNS Connectivity: Some local networks and mobile routers failed to resolve the backend API, triggering "Something went wrong. Please try again." during password resets.

---

2. WHAT HAS BEEN FIXED?

• Flexible Sign-In: You can now sign in using any of the following:
  - Your registered Email address
  - Your Portal Username
  - Your BGE Code (e.g. PRUDEV II-BGE-010T-01 or BGE-010T-01)
• Case-Insensitive & Whitespace Forgiving: The system now automatically trims extra spaces and handles uppercase/lowercase variations.
• Streamlined Password Reset: Password reset links have been updated to open reliably across all mobile and desktop browsers.

---

3. HOW TO ACCESS YOUR ACCOUNT NOW

1. Visit the Portal: Open https://bds.glowi.africa (please refresh your browser if already open).
2. Sign In:
   - Identifier: Enter your Email address, Username, or BGE Code.
   - Password: Enter your existing password. If your account was newly provisioned and you haven't set a personal password yet, use the default temporary password: bds123 (you will be prompted to change it upon login).
3. Need to Reset Your Password?
   - Click "Forgot password?" on the login screen.
   - Enter your registered email address and click "Send Reset Link".
   - Open the link received in your inbox to create your new password.

If you encounter any difficulty logging in or accessing your assigned work orders and visit planner, please reply directly to this email or reach out to our BDS support team so we can assist you immediately.

Thank you for your dedication to supporting MSMEs under the PRUDEV II Programme.

Best regards,
PRUDEV II BDS Team
GOPA Pro · GIZ Uganda`,
    },
    {
      key: 'bge_tbip_rollout',
      label: 'BGE — Enterprise Improvement Plan (TBIP) Rollout & Coaching Roadmap',
      subject: 'Action Required: Enterprise Improvement Plan (TBIP) Rollout & Monthly Coaching Roadmap',
      body: `Dear {{name}},

I hope this email finds you well and progressing smoothly with your field engagements.

As part of strengthening our Business Development Services (BDS) under PRUDEV II, we have launched a new tool on the BGE Portal: the Enterprise Improvement Plan (MSME Business Assessment & Technical Business Improvement Plan - TBIP).

---

1. PURPOSE & STRATEGIC IMPORTANCE
Conducting this diagnostic assessment and formulating the TBIP is now mandatory for each of your assigned MSMEs.

The TBIP serves as the strategic foundation and operational roadmap guiding your 3 monthly coaching visits per MSME. Every visit and intervention you carry out should directly track and address the priority gaps identified in this plan.

---

2. KEY STEPS IN THE ASSESSMENT PROCESS
When conducting the assessment with your MSMEs, please complete the following steps directly in the portal:

1. 7-Dimension Diagnostic Assessment: Complete the guided questionnaire covering Governance & Strategy, Financial Management, HR & Decent Work, Market & Customers, Digital & Technology, Environmental Sustainability, and Regulatory Compliance.
2. Gap Analysis & Observations: Review the auto-computed health status and record concise notes on the critical challenges identified.
3. Priority Action Roadmap (3–5 Actions): Agree on 3 to 5 high-impact, measurable actions with the MSME owner, specifying the responsible lead, expected timeline, and target outcomes.
4. BGE Sign-Off & Submission: Complete your BGE sign-off and submit the assessment through the portal.

---

3. REVIEW & APPROVAL MEETINGS
Once you submit the Enterprise Improvement Plans for your assigned portfolio:
- We will schedule an individual review meeting with you to walk through the identified diagnostic gaps, evaluate the proposed action plans, and grant final approval.
- You can also export and print the official branded PDF report or Excel workbook directly from the portal for your reference and to share with the enterprise owner.

---

4. NEXT STEPS & TIMELINES
Please log into the BGE Portal, navigate to the "Improvement Plans (TBIP)" tab (or launch directly from your MSME card), and begin conducting the assessments during your upcoming field visits.

Should you have any questions or require guidance on navigating the tool, please reach out directly.

Thank you for your continued dedication to supporting our MSMEs.

Best regards,
PRUDEV II BDS Team
GOPA Pro / GIZ`,
    },
    {
      key: 'bge_guidance',
      label: 'BGE — Data Update & Annual Review Guide',
      subject: 'How to Use the Data Update Tool and Annual Review Template',
      body: `Dear {{name}},

We hope this message finds you well. This email provides a quick guide on two key tools you will use during your support visits.

---

DATA COLLECTION VISIT — Data Update Tool

The Data Update Tool helps you capture the latest business metrics for each MSME you support. Please follow these steps:

1. Log in to the portal and navigate to "My MSMEs".
2. Select the MSME you just visited.
3. Click "Record Growth Snapshot" and fill in the current figures (revenue, employees, etc.).
4. Submit the form. The data is saved immediately.

Tips:
- Record figures as reported by the business owner. Do not estimate.
- If the owner is unsure of a number, note this in the "Remarks" field.
- Always confirm the reporting period with the owner before submitting.

---

ANNUAL REVIEW TEMPLATE

After completing a Data Update visit, you should also file an Annual Review Report. This report captures qualitative observations that the numbers alone cannot show.

1. Go to "My Reports" and click "New Report".
2. Select "Annual Review" as the report type and choose the MSME.
3. Complete all sections, paying special attention to:
   - Data Confidence Level — Was the business owner confident or guessing?
   - Records Sighted — Did you see physical or digital records to verify the figures?
   - Owner Certainty Observation — Note any hesitations or inconsistencies.
   - Data Collection Challenges — Record any difficulties encountered.
4. Submit the report. It will be reviewed and signed off by the programme team.

If you have any questions, please reply to this email.

Best regards,
PRUDEV II BDS Team`,
    },
    {
      key: 'bge_timesheet_payment_update',
      label: 'BGE — Timesheet, Invoice & Payment Tracking Update',
      subject: 'Important Update: New Timesheet, Invoice & Payment Tracking on the Portfolio System',
      body: `Dear {{name}},

We've added new features to the portfolio system to make submitting your timesheets and invoices, and tracking payments, faster and more reliable.

1. Upload Timesheets & Invoices Directly on the System
Go to your Dashboard → Work Orders. There you'll find a "Submit Timesheet & Invoice" section where you can:
- Select the relevant Work Order
- Upload your timesheet and/or invoice (Excel format)

This replaces sending these documents by email. We're making this change because emails often get mixed up, lost, or sent to the wrong inbox — uploading directly to the system ensures your documents are linked to the correct work order and are always accessible to the admin team.

Important: When preparing your invoice, please make sure to use your exact BGE number/code (as shown on your work order) so payments can be matched and processed correctly.

2. Payment Notifications & Confirmation
When a payment is recorded against your work order, you may receive an email notification with the payment details. Please log in to your Dashboard → Work Orders → Payments section and click "Confirm Received" once you have received the payment. This helps us keep accurate records and resolve any payment queries quickly.

If you have any questions about these changes, please don't hesitate to reach out.

Thank you for your continued cooperation.

Regards,
PRUDEV II BDS Team
GOPA Pro / GIZ`,
    },
    {
      key: 'msme_data_visit',
      label: 'MSME — Upcoming Data Visit Notification',
      subject: 'A Quick Check-In From the PRUDEV II Team',
      body: `Dear {{name}},

We hope you and your business are doing well.

As you may recall, we recently held a training session on business compliance and governance — and we are truly grateful for your participation and continued engagement with the PRUDEV II programme.

As part of our ongoing commitment to supporting your growth, we are now reaching out to check on how things are progressing. We want to understand the real impact our training and support have been making, and to hear directly from you about what is working and what more we can do.

To that end, we are sending one of our Business Growth Experts (BGEs) to visit you at your business. They will be in touch with you shortly to arrange a convenient time to come by. The visit will be brief and informal — they simply want to sit with you, listen, and document how your business is doing at this stage.

We kindly ask that you make yourself available this week or next week to receive them. Your honest feedback means a great deal to us and will directly shape how we support you going forward.

Thank you for being such a valued part of the PRUDEV II community. We look forward to seeing you soon.

Warm regards,
PRUDEV II BDS Team`,
    },
    {
      key: 'msme_upcoming_visit',
      label: 'MSME — Upcoming visit from our Business Growth Experts',
      subject: 'PRUDEV II: Upcoming visit from our Business Growth Experts to support your enterprise',
      body: `Dear {{name}},

We hope you and your business are doing well.

As you may recall, we recently provided technical training and mentorship/coaching support focused on improving your agro-processing operations, energy efficiency, and quality certifications. You have been working closely on this with Gloria, our Agroprocessing Expert, in conjunction with UNBS and our energy audit teams. We are truly grateful for your continued partnership and active engagement with the PRUDEV II programme.

At this stage, we want to learn and improve how we support you. To do that, we want to understand the real impact our combined technical support, audits, and mentorship have made on your daily operations, and to hear directly from you about what is working well and what we can do better going forward.

To that end, we are sending one of our Business Growth Experts (BGEs) to visit you at your enterprise. They will be administering our Outcome Assessment Tool to document your progress, system adoptions, and milestone achievements—such as changes in energy costs, employment, or certification tracks.

Our BGE will be in touch with you shortly to arrange a convenient time to come by. The visit will be practical and straightforward—they simply want to sit with you, listen to your experiences, and learn how we can continue to strengthen your business.

We kindly ask that you make yourself available this week or next week to receive them. Your honest insights mean a great deal to us and will directly shape the future of our support for you and other agro-processors.

Thank you for being such a valued part of the PRUDEV II community. We look forward to celebrating your business's growth and learning how to serve you even better.

Warm regards,

PRUDEV II BDS Team`,
    },
  ];

  const [commChannel, setCommChannel] = React.useState('email'); // 'email' | 'sms'
  const [commTab, setCommTab] = React.useState(0); // 0=BGEs 1=MSMEs
  const [commSearch, setCommSearch] = React.useState('');
  const [commSelected, setCommSelected] = React.useState(new Set());
  const [commSubject, setCommSubject] = React.useState('');
  const [commBody, setCommBody] = React.useState('');
  const [commTemplate, setCommTemplate] = React.useState('');
  const [commSending, setCommSending] = React.useState(false);
  const [commConfirm, setCommConfirm] = React.useState(false);
  const [commSkipSent, setCommSkipSent] = React.useState(false);
  const [commAlreadySent, setCommAlreadySent] = React.useState([]);  // ids already sent this subject
  const commBodyRef = useRef(null);
  const [datePickerAnchor, setDatePickerAnchor] = React.useState(null);
  const [datePickerValue, setDatePickerValue] = React.useState('');

  const _insertIntoBody = (before, after = '') => {
    const el = commBodyRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const end   = el.selectionEnd;
    const sel   = commBody.substring(start, end);
    const next  = commBody.substring(0, start) + before + sel + after + commBody.substring(end);
    setCommBody(next);
    setTimeout(() => { el.focus(); el.setSelectionRange(start + before.length, start + before.length + sel.length); }, 0);
  };

  const applyEmailBold = () => _insertIntoBody('<b>', '</b>');

  const applyEmailBullets = () => {
    const el = commBodyRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const end   = el.selectionEnd;
    const sel   = commBody.substring(start, end) || '';
    const lines = sel ? sel.split('\n') : [''];
    const toggled = lines.map(l => l.startsWith('• ') ? l.slice(2) : '• ' + l).join('\n');
    const next = commBody.substring(0, start) + toggled + commBody.substring(end);
    setCommBody(next);
    setTimeout(() => { el.focus(); el.setSelectionRange(start, start + toggled.length); }, 0);
  };

  const bodyToHtml = (text) => {
    const blocks = text.split(/\n\n+/);
    const htmlBlocks = blocks.map(block => {
      const lines = block.split('\n').filter(l => l.trim() !== '');
      if (!lines.length) return '';
      const allBullets = lines.every(l => l.trimStart().startsWith('• '));
      if (allBullets) {
        const items = lines.map(l => `<li>${l.replace(/^•\s*/, '').trim()}</li>`).join('');
        return `<ul style="margin:8px 0;padding-left:20px;">${items}</ul>`;
      }
      return `<p style="margin:0 0 12px 0;">${lines.join('<br />')}</p>`;
    });
    return `<!DOCTYPE html><html><body style="font-family:Arial,sans-serif;font-size:14px;line-height:1.6;color:#333;max-width:600px;margin:0 auto;padding:20px;">${htmlBlocks.filter(Boolean).join('')}</body></html>`;
  };

  const insertEmailDate = (dateStr) => {
    const el = commBodyRef.current;
    if (!el) return;
    const pos  = el.selectionStart;
    const next = commBody.substring(0, pos) + dateStr + commBody.substring(pos);
    setCommBody(next);
    setTimeout(() => { el.focus(); el.setSelectionRange(pos + dateStr.length, pos + dateStr.length); }, 0);
  };
  // ── SMS state ──────────────────────────────────────────────────────────────
  const [smsTab, setSmsTab] = React.useState(0); // 0=BGEs 1=MSMEs
  const [smsSearch, setSmsSearch] = React.useState('');
  const [smsSelected, setSmsSelected] = React.useState(new Set());
  const [smsBody, setSmsBody] = React.useState('');
  const [smsSending, setSmsSending] = React.useState(false);
  const [smsConfirm, setSmsConfirm] = React.useState(false);
  const [smsBalance, setSmsBalance] = React.useState(null);      // credits balance
  const [smsBalanceLoading, setSmsBalanceLoading] = React.useState(false);
  const [smsBalanceError, setSmsBalanceError] = React.useState(null);
  const [smsBalanceBefore, setSmsBalanceBefore] = React.useState(null); // snapshot before send

  // ── Schedule Send state ──────────────────────────────────────────────────
  const [scheduleDialogOpen, setScheduleDialogOpen] = React.useState(false);
  const [scheduleDateTime, setScheduleDateTime] = React.useState('');
  const [scheduleFor, setScheduleFor] = React.useState(null); // { channel, recipients, subject, body, recipientType, skipSent }
  const [scheduledMessages, setScheduledMessages] = React.useState([]);
  const [scheduledLoading, setScheduledLoading] = React.useState(false);

  // ── Session MSME notification dialog ────────────────────────────────────
  const [sessionNotifyDialog, setSessionNotifyDialog] = React.useState(false);
  const [sessionNotifySession, setSessionNotifySession] = React.useState(null);
  const [sessionNotifySubject, setSessionNotifySubject] = React.useState('');
  const [sessionNotifyBody, setSessionNotifyBody] = React.useState('');
  const [sessionNotifySending, setSessionNotifySending] = React.useState(false);
  const [sessionNotifySkip, setSessionNotifySkip] = React.useState(false);
  const [sessionNotifyAlreadySent, setSessionNotifyAlreadySent] = React.useState([]);

  const openSessionNotify = async (s) => {
    setSessionNotifySession(s);
    setSessionNotifySkip(false);
    setSessionNotifyAlreadySent([]);
    const msmeNames = (s.businesses_detail || []).map(m => `- ${m.business_name}${m.owner_name ? ` (${m.owner_name})` : ''}`).join('\n');
    setSessionNotifySubject(`Training Session: ${s.title}`);
    setSessionNotifyBody(
`Dear {{name}},

We are pleased to inform you that your business has been registered to participate in an upcoming training session under the PRUDEV II programme.

Training Details:
- Title: ${s.title}
- Date: ${s.date}${s.location ? `\n- Location: ${s.location}` : ''}${(s.team||[]).find(m=>m.role==='lead')?.bge_name ? `\n- Lead Facilitator: ${(s.team||[]).find(m=>m.role==='lead').bge_name}` : ''}

${(s.businesses_detail || []).length > 1 ? `Participating MSMEs:\n${msmeNames}\n\n` : ''}Please make sure you are available on the day of the training. Your participation is very important for your business growth and for the success of the programme.

If you have any questions or need to make alternative arrangements, please get in touch with us as soon as possible.

We look forward to seeing you there.

Warm regards,
PRUDEV II BDS Team`
    );
    setSessionNotifyDialog(true);
    // check who was already sent this subject
    const ids = (s.businesses_detail || []).map(m => m.id);
    if (ids.length) {
      const subject = `Training Session: ${s.title}`;
      const params = new URLSearchParams({ subject, recipient_type: 'msme' });
      ids.forEach(id => params.append('ids', id));
      try {
        const r = await axios.get(`${BULK_EMAIL_LOG}?${params}`, { headers });
        setSessionNotifyAlreadySent(r.data.already_sent || []);
      } catch { /* silent */ }
    }
  };

  const sendSessionNotify = async () => {
    setSessionNotifySending(true);
    try {
      const ids = (sessionNotifySession.businesses_detail || []).map(m => m.id);
      const res = await axios.post(BULK_EMAIL, {
        recipient_type: 'msme',
        recipient_ids: ids,
        subject: sessionNotifySubject,
        body: sessionNotifyBody,
        skip_already_sent: sessionNotifySkip,
      }, { headers });
      const d = res.data;
      const parts = [`Queued: ${d.queued ?? d.sent ?? 0}`];
      if (d.skipped > 0) parts.push(`Skipped: ${d.skipped}`);
      if (d.duplicates_removed > 0) parts.push(`Duplicates removed: ${d.duplicates_removed}`);
      notify(parts.join(' · '), 'success');
      setSessionNotifyDialog(false);
    } catch (err) {
      const d = err.response?.data;
      notify(d?.detail || d?.error || 'Failed to send notifications', 'error');
    } finally {
      setSessionNotifySending(false);
    }
  };

  const commRecipients = commTab === 0
    ? experts.filter(e => e.email)
    : (allMsmes.length > 0 ? allMsmes : msmes).filter(m => m.email);

  const commFiltered = commRecipients.filter(r => {
    const name = commTab === 0
      ? (r.name || r.full_name || r.expert_name || '')
      : (r.business_name || r.owner_name || '');
    return name.toLowerCase().includes(commSearch.toLowerCase()) ||
      (r.email || '').toLowerCase().includes(commSearch.toLowerCase());
  });

  const commAllSelected = commFiltered.length > 0 && commFiltered.every(r => commSelected.has(r.id));

  const toggleCommAll = () => {
    if (commAllSelected) {
      setCommSelected(prev => {
        const next = new Set(prev);
        commFiltered.forEach(r => next.delete(r.id));
        return next;
      });
    } else {
      setCommSelected(prev => {
        const next = new Set(prev);
        commFiltered.forEach(r => next.add(r.id));
        return next;
      });
    }
  };

  const handleCommTemplate = (key) => {
    setCommTemplate(key);
    const tmpl = COMM_TEMPLATES.find(t => t.key === key);
    if (tmpl) {
      setCommSubject(tmpl.subject);
      setCommBody(tmpl.body);
    }
  };

  // Check send log whenever subject or recipient list changes
  React.useEffect(() => {
    if (!commSubject.trim() || commFiltered.length === 0) { setCommAlreadySent([]); return; }
    const ids = commFiltered.map(r => r.id);
    const rtype = commTab === 0 ? 'bge' : 'msme';
    const params = new URLSearchParams({ subject: commSubject, recipient_type: rtype });
    ids.forEach(id => params.append('ids', id));
    axios.get(`${BULK_EMAIL_LOG}?${params}`, { headers })
      .then(r => setCommAlreadySent(r.data.already_sent || []))
      .catch(() => setCommAlreadySent([]));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commSubject, commTab, commFiltered.length]);

  const handleCommSend = async () => {
    setCommConfirm(false);
    setCommSending(true);
    try {
      const selectedList = commFiltered.filter(r => commSelected.has(r.id));
      const payload = {
        recipient_type: commTab === 0 ? 'bge' : 'msme',
        recipient_ids: selectedList.map(r => r.id),
        subject: commSubject,
        body: commBody.replace(/<\/?b>/gi, ''),
        body_html: bodyToHtml(commBody),
        skip_already_sent: commSkipSent,
      };
      const res = await axios.post(BULK_EMAIL, payload, { headers });
      const d = res.data;
      const parts = [`Queued: ${d.queued ?? d.sent ?? 0}`];
      if (d.skipped > 0) parts.push(`Skipped (already sent): ${d.skipped}`);
      if (d.duplicates_removed > 0) parts.push(`Duplicates removed: ${d.duplicates_removed}`);
      if (d.failed > 0) parts.push(`Failed: ${d.failed}`);
      notify(parts.join(' · '), 'success');
      setCommSelected(new Set());
      setCommAlreadySent([]);
    } catch (err) {
      const d = err.response?.data;
      notify(d?.detail || d?.error || d?.body?.[0] || 'Failed to send emails', 'error');
    } finally {
      setCommSending(false);
    }
  };

  // ── SMS helpers ────────────────────────────────────────────────────────────
  const fetchSmsBalance = React.useCallback(async () => {
    setSmsBalanceLoading(true);
    setSmsBalanceError(null);
    try {
      const res = await axios.get(BULK_SMS_BALANCE, { headers });
      const bal = res.data.balance;
      if (bal != null) {
        setSmsBalance(bal);
      } else {
        setSmsBalance(null);
        setSmsBalanceError(res.data.message || 'Could not read balance');
      }
    } catch (err) {
      setSmsBalance(null);
      setSmsBalanceError(err.response?.data?.detail || 'Failed to connect to SMS provider');
    } finally {
      setSmsBalanceLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // Auto-fetch balance when switching to SMS channel
  React.useEffect(() => {
    if (commChannel === 'sms') fetchSmsBalance();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commChannel]);

  const SMS_TEMPLATES = [
    {
      key: 'bge_portal_login_resolution',
      label: 'BGE — Portal Login & Access Resolution',
      body: 'Dear {{name}}, portal login issues have been resolved. You can now log in at https://bds.glowi.africa using your Email, Username, or BGE Code. If you forgot your password, use the "Forgot password?" link on the login page. Default temp password for new accounts is bds123. — PRUDEV II BDS Team',
    },
    {
      key: 'bge_tbip_reminder',
      label: 'BGE — Enterprise Improvement Plan (TBIP) Rollout',
      body: 'Dear {{name}}, please log in to the PRUDEV II portal to complete the new Enterprise Improvement Plan (TBIP) for your assigned MSMEs. This forms the basis of your 3 monthly visits. We will schedule a meeting to review and approve your submissions. — PRUDEV II BDS Team',
    },
    {
      key: 'data_reminder',
      label: 'BGE — Data update reminder',
      body: 'Dear {{name}}, please log in to the PRUDEV II portal and submit data updates for your MSMEs. Thank you. — PRUDEV II BDS Team',
    },
    {
      key: 'visit_notify',
      label: 'MSME — BGE visit notification',
      body: 'Dear {{name}}, a PRUDEV II Business Growth Expert will visit your business this week to check on your progress. Kindly be available. — PRUDEV II BDS Team',
    },
    {
      key: 'msme_upcoming_visit',
      label: 'MSME — Upcoming BGE visit',
      body: "Dear {{name}}, to help us learn & improve how we support you, a PRUDEV II Business Growth Expert will visit your enterprise this or next week. They will briefly review your progress following the agro-processing and UNBS work you've been doing with Gloria. They will call you shortly to schedule a convenient time. We appreciate your continued partnership! — PRUDEV II BDS Team",
    },
    {
      key: 'training_reminder',
      label: 'MSME — Training session reminder',
      body: 'Dear {{name}}, you are invited to a PRUDEV II training session. Please contact your BGE for the date and venue. — PRUDEV II BDS Team',
    },
  ];

  const smsRecipients = smsTab === 0
    ? experts.filter(e => e.phone)
    : (allMsmes.length > 0 ? allMsmes : msmes).filter(m => m.phone);

  const smsFiltered = smsRecipients.filter(r => {
    const name = smsTab === 0 ? (r.name || '') : (r.business_name || r.owner_name || '');
    return name.toLowerCase().includes(smsSearch.toLowerCase()) ||
      (r.phone || '').includes(smsSearch);
  });

  const smsAllSelected = smsFiltered.length > 0 && smsFiltered.every(r => smsSelected.has(r.id));
  const toggleSmsAll = () => {
    if (smsAllSelected) {
      setSmsSelected(prev => { const n = new Set(prev); smsFiltered.forEach(r => n.delete(r.id)); return n; });
    } else {
      setSmsSelected(prev => { const n = new Set(prev); smsFiltered.forEach(r => n.add(r.id)); return n; });
    }
  };

  const handleSmsSend = async () => {
    setSmsConfirm(false);
    setSmsSending(true);
    setSmsBalanceBefore(smsBalance); // snapshot balance before send
    try {
      const selectedList = smsFiltered.filter(r => smsSelected.has(r.id));
      const res = await axios.post(BULK_SMS, {
        recipient_type: smsTab === 0 ? 'bge' : 'msme',
        recipient_ids: selectedList.map(r => r.id),
        message: smsBody,
      }, { headers });
      const d = res.data;
      notify(`Queued: ${d.queued} SMS message${d.queued !== 1 ? 's' : ''}${d.duplicates_removed > 0 ? ` · Duplicates removed: ${d.duplicates_removed}` : ''}`, 'success');
      setSmsSelected(new Set());
      // Refresh balance after a short delay to let the provider update
      setTimeout(() => fetchSmsBalance(), 3000);
    } catch (err) {
      const d = err.response?.data;
      notify(d?.detail || d?.error || 'Failed to send SMS', 'error');
    } finally {
      setSmsSending(false);
    }
  };

  // ── Scheduled messages helpers ─────────────────────────────────────────────
  const loadScheduledMessages = React.useCallback(async () => {
    setScheduledLoading(true);
    try {
      const res = await axios.get(SCHEDULED_MESSAGES, { headers });
      setScheduledMessages(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {
      // silent — non-critical
    } finally {
      setScheduledLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  React.useEffect(() => {
    if (section !== 'communications') return;
    loadScheduledMessages();
    const id = setInterval(async () => {
      try { await axios.post(SCHEDULED_MESSAGES_PROCESS, {}, { headers }); } catch {}
      loadScheduledMessages();
    }, 60000);
    return () => clearInterval(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section, token]);

  const handleScheduleSubmit = async () => {
    if (!scheduleFor || !scheduleDateTime) return;
    try {
      await axios.post(SCHEDULED_MESSAGES, {
        channel: scheduleFor.channel,
        recipient_type: scheduleFor.recipientType,
        recipient_ids: scheduleFor.recipients,
        subject: scheduleFor.subject,
        body: scheduleFor.body,
        body_html: scheduleFor.body_html || '',
        skip_already_sent: scheduleFor.skipSent,
        scheduled_at: scheduleDateTime,
      }, { headers });
      notify(`${scheduleFor.channel === 'email' ? 'Email' : 'SMS'} scheduled for ${new Date(scheduleDateTime).toLocaleString()}`, 'success');
      setScheduleDialogOpen(false);
      setScheduleDateTime('');
      setScheduleFor(null);
      loadScheduledMessages();
    } catch (err) {
      const d = err.response?.data;
      notify(d?.detail || d?.error || 'Failed to schedule message', 'error');
    }
  };

  const handleScheduleCancel = async (id) => {
    try {
      await axios.delete(SCHEDULED_MESSAGE_CANCEL(id), { headers });
      notify('Scheduled message cancelled', 'info');
      loadScheduledMessages();
    } catch {
      notify('Failed to cancel scheduled message', 'error');
    }
  };

  const renderCommunications = () => (
    <Box>
      <SectionHeader title="Communications" subtitle="Send bulk emails or SMS to BGEs or MSMEs" />

      {/* Channel toggle */}
      <Paper variant="outlined" sx={{ p: 1.5, mb: 2, display: 'flex', gap: 1 }}>
        <Button
          variant={commChannel === 'email' ? 'contained' : 'outlined'}
          size="small"
          startIcon={<span>✉️</span>}
          onClick={() => setCommChannel('email')}
        >Email</Button>
        <Button
          variant={commChannel === 'sms' ? 'contained' : 'outlined'}
          size="small"
          color={commChannel === 'sms' ? 'success' : 'primary'}
          startIcon={<span>💬</span>}
          onClick={() => { setCommChannel('sms'); fetchSmsBalance(); }}
        >SMS</Button>
      </Paper>

      {commChannel === 'sms' ? (
        /* ── SMS panel ──────────────────────────────────────────────── */
        <Box>
          {/* Wallet / balance card */}
          <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, bgcolor: 'success.50', borderColor: 'success.200' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ fontSize: 28 }}>💳</Box>
              <Box>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>SMS Credits</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2, color: smsBalanceLoading ? 'text.disabled' : smsBalance != null ? 'success.dark' : 'error.main' }}>
                  {smsBalanceLoading ? '…' : smsBalance != null ? `UGX ${smsBalance}` : '—'}
                </Typography>
                {smsBalanceError && !smsBalanceLoading && (
                  <Typography variant="caption" color="error.main" sx={{ display: 'block' }}>
                    {smsBalanceError}
                  </Typography>
                )}
                {smsBalanceBefore != null && smsBalance != null && smsBalanceBefore !== smsBalance && (
                  <Typography variant="caption" color="text.secondary">
                    Was UGX {smsBalanceBefore} → now UGX {smsBalance}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button size="small" variant="outlined" color="success" onClick={fetchSmsBalance} disabled={smsBalanceLoading}>
                {smsBalanceLoading ? <CircularProgress size={14} /> : '↻ Refresh'}
              </Button>
              <Button size="small" variant="contained" color="success"
                href="https://www.messagecarrier.africa/app/wallet" target="_blank" rel="noopener">
                + Top Up
              </Button>
            </Box>
          </Paper>

          <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>SMS Template</Typography>
            <FormControl size="small" fullWidth sx={{ mb: 2 }}>
              <InputLabel>Load a template (optional)</InputLabel>
              <Select
                value={''}
                label="Load a template (optional)"
                onChange={e => { const t = SMS_TEMPLATES.find(x => x.key === e.target.value); if (t) setSmsBody(t.body); }}
              >
                <MenuItem value=""><em>— none —</em></MenuItem>
                {SMS_TEMPLATES.map(t => <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField
              label="Message"
              value={smsBody}
              onChange={e => setSmsBody(e.target.value)}
              fullWidth multiline minRows={4}
              inputProps={{ maxLength: 480 }}
              helperText={`${smsBody.length} characters · ${Math.ceil(smsBody.length / 160) || 1} SMS part(s). Use {{name}} to personalise.`}
            />
          </Paper>

          <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
              <Tabs value={smsTab} onChange={(_, v) => { setSmsTab(v); setSmsSelected(new Set()); setSmsSearch(''); }}>
                <Tab label={`BGE Experts (${experts.filter(e => e.phone).length})`} />
                <Tab label={`MSMEs (${(allMsmes.length > 0 ? allMsmes : msmes).filter(m => m.phone).length})`} />
              </Tabs>
              {smsSelected.size > 0 && (
                <Chip label={`${smsSelected.size} selected`} color="success" size="small" onDelete={() => setSmsSelected(new Set())} />
              )}
            </Box>

            <TextField
              size="small" placeholder="Search by name or phone…"
              value={smsSearch} onChange={e => setSmsSearch(e.target.value)}
              InputProps={{ startAdornment: <Search sx={{ mr: 0.5, color: 'text.secondary', fontSize: 18 }} /> }}
              sx={{ mb: 1, width: { xs: '100%', sm: 280 } }}
            />

            <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, maxHeight: 320, overflowY: 'auto' }}>
              <ListItemButton onClick={toggleSmsAll} dense sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50' }}>
                <ListItemIcon><Checkbox checked={smsAllSelected} indeterminate={smsSelected.size > 0 && !smsAllSelected} size="small" disableRipple tabIndex={-1} /></ListItemIcon>
                <ListItemText primary={<Typography variant="body2" fontWeight={600}>{smsAllSelected ? 'Deselect all' : `Select all (${smsFiltered.length})`}</Typography>} />
              </ListItemButton>
              {smsFiltered.length === 0 && (
                <Box sx={{ p: 2, textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary">No recipients with phone numbers found.</Typography>
                </Box>
              )}
              {smsFiltered.map(r => {
                const name = smsTab === 0 ? (r.name || '—') : (r.business_name || '—');
                const sub  = smsTab === 0 ? (r.location || r.bge_code || '') : (r.owner_name || '');
                return (
                  <ListItemButton key={r.id} onClick={() => setSmsSelected(prev => {
                    const n = new Set(prev); n.has(r.id) ? n.delete(r.id) : n.add(r.id); return n;
                  })} dense>
                    <ListItemIcon><Checkbox checked={smsSelected.has(r.id)} size="small" disableRipple tabIndex={-1} /></ListItemIcon>
                    <ListItemText
                      primary={name}
                      secondary={`📱 ${r.phone}${sub ? ' · ' + sub : ''}`}
                    />
                  </ListItemButton>
                );
              })}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
              <Button
                variant="outlined"
                color="success"
                startIcon={<ScheduleIcon />}
                disabled={smsSelected.size === 0 || !smsBody.trim() || smsSending}
                onClick={() => {
                  setScheduleFor({
                    channel: 'sms',
                    recipients: Array.from(smsSelected),
                    subject: '',
                    body: smsBody,
                    recipientType: smsTab === 0 ? 'bge' : 'msme',
                    skipSent: false,
                  });
                  setScheduleDialogOpen(true);
                }}
              >
                Schedule
              </Button>
              <Button
                variant="contained"
                color="success"
                startIcon={smsSending ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
                disabled={smsSelected.size === 0 || !smsBody.trim() || smsSending}
                onClick={() => setSmsConfirm(true)}
              >
                Send SMS to {smsSelected.size} recipient{smsSelected.size !== 1 ? 's' : ''}
              </Button>
            </Box>
          </Paper>

          {/* SMS Confirm dialog */}
          <Dialog open={smsConfirm} onClose={() => setSmsConfirm(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Confirm Bulk SMS</DialogTitle>
            <DialogContent>
              <Typography variant="body2" sx={{ mb: 1 }}>
                You are about to send an SMS to <strong>{smsSelected.size} recipient{smsSelected.size !== 1 ? 's' : ''}</strong>.
              </Typography>
              <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'grey.50' }}>
                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12 }}>
                  {smsBody.substring(0, 200)}{smsBody.length > 200 ? '…' : ''}
                </Typography>
              </Paper>
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                {Math.ceil(smsBody.length / 160)} SMS part(s) per recipient · via Message Carrier
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSmsConfirm(false)}>Cancel</Button>
              <Button variant="contained" color="success" startIcon={<SendIcon />} onClick={handleSmsSend}>Send</Button>
            </DialogActions>
          </Dialog>
        </Box>
      ) : (
        /* ── Email panel (existing) ──────────────────────────────────── */
        <Box>

      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>Email Template</Typography>
        <FormControl size="small" fullWidth>
          <InputLabel>Load a template (optional)</InputLabel>
          <Select
            value={commTemplate}
            label="Load a template (optional)"
            onChange={e => handleCommTemplate(e.target.value)}
          >
            <MenuItem value=""><em>— none —</em></MenuItem>
            {COMM_TEMPLATES.map(t => (
              <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>

      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>Message</Typography>
        <TextField
          label="Subject"
          value={commSubject}
          onChange={e => setCommSubject(e.target.value)}
          fullWidth size="small" sx={{ mb: 1.5 }}
        />

        {/* Formatting toolbar */}
        <Box sx={{ display: 'flex', gap: 0.5, mb: 0.5, p: 0.5, border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'grey.50' }}>
          <Tooltip title="Bold selected text">
            <IconButton size="small" onClick={applyEmailBold}><FormatBold fontSize="small" /></IconButton>
          </Tooltip>
          <Tooltip title="Toggle bullets on selected lines">
            <IconButton size="small" onClick={applyEmailBullets}><FormatListBulleted fontSize="small" /></IconButton>
          </Tooltip>
          <Tooltip title="Insert date">
            <IconButton size="small" onClick={e => { setDatePickerValue(''); setDatePickerAnchor(e.currentTarget); }}>
              <CalendarToday fontSize="small" />
            </IconButton>
          </Tooltip>
          <Box sx={{ ml: 'auto' }}>
            <Button
              size="small"
              variant="outlined"
              sx={{ fontSize: '0.72rem', py: 0.2, px: 1 }}
              onClick={() => {
                setCommSubject('Invitation: Market Activation Event — PRUDEV II');
                setCommBody(`Dear {{name}},\n\nThe PRUDEV II consortium including GOPA, Friends Consult and Farm Africa invites you to a Market Activation Event bringing together MSMEs, cooperative leaders and Business Development Service Providers.\n\nCome and explore opportunities to:\n• Connect with potential suppliers and customers.\n• Find reliable sources of raw materials and negotiate business deals.\n• Discover practical business solutions to improve your performance, including digital marketing, online presence, accounting systems, financial management and more.\n• Interact directly with Business Growth Experts and see live demonstrations of tools you can use in your business.\n\nCome ready to learn, connect, and do business.\n\nSchedule of Events — all sessions run from 9:00 AM – 4:00 PM:\n\n<b>Date</b>\t     <b>Location</b>\t     <b>Venue</b>\n21-09-26\t     Agago (Patongo)\t       Top View Hotel/White House\n23-09-26\t     Dokolo\t                        Exodus Inn\n24-09-26\t     Lira City\t                        Graceville Hotel\n25-09-26\t     Kole\t                                District Hall\n28-09-26\t     Nwoya (Koch Goma)\t        Vilanova Business Park, SMC Limited\n29-09-26\t     Gulu City\t                        Lamaco White House Hotel\n02-10-26\t     Kitgum Municipality\t        Kitgum Royal Hotel\n\nPlease attend only the event closest to you. <b>Note</b>: transport refunds will <b>NOT</b> be provided, but meals will be covered on the day.\n\nWe look forward to having you with us.\n\nBest regards,\n\nRichard Obuku\nBDS Expert / BDS Component Coordinator, WP2, PRUDEV II / GOPA AFC\n+256774963756 | richard.obuku@gopa.eu`);
              }}
            >
              Insert Market Activation Invite
            </Button>
          </Box>
        </Box>

        <TextField
          label="Body"
          value={commBody}
          onChange={e => setCommBody(e.target.value)}
          fullWidth multiline minRows={8}
          inputRef={commBodyRef}
          helperText="Use {{name}} to personalise. Select text then click B to bold, or • to add bullets."
        />

        {/* Date picker popover */}
        <Popover
          open={Boolean(datePickerAnchor)}
          anchorEl={datePickerAnchor}
          onClose={() => setDatePickerAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5, minWidth: 220 }}>
            <Typography variant="caption" fontWeight={700}>Insert date</Typography>
            <TextField
              type="date"
              size="small"
              value={datePickerValue}
              onChange={e => setDatePickerValue(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <Button
              size="small" variant="contained"
              disabled={!datePickerValue}
              onClick={() => {
                const [y, m, d] = datePickerValue.split('-');
                const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
                insertEmailDate(`${d} ${months[parseInt(m,10)-1]} ${y}`);
                setDatePickerAnchor(null);
              }}
            >Insert</Button>
          </Box>
        </Popover>
      </Paper>

      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
          <Tabs value={commTab} onChange={(_, v) => { setCommTab(v); setCommSelected(new Set()); setCommSearch(''); }}>
            <Tab label={`BGE Experts (${experts.filter(e => e.email).length})`} />
            <Tab label={`MSMEs (${(allMsmes.length > 0 ? allMsmes : msmes).filter(m => m.email).length})`} />
          </Tabs>
          {commSelected.size > 0 && (
            <Chip
              label={`${commSelected.size} selected`}
              color="primary" size="small"
              onDelete={() => setCommSelected(new Set())}
            />
          )}
        </Box>

        <TextField
          size="small" placeholder="Search by name or email…"
          value={commSearch} onChange={e => setCommSearch(e.target.value)}
          InputProps={{ startAdornment: <Search sx={{ mr: 0.5, color: 'text.secondary', fontSize: 18 }} /> }}
          sx={{ mb: 1, width: { xs: '100%', sm: 280 } }}
        />

        <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, maxHeight: 320, overflowY: 'auto' }}>
          <ListItemButton onClick={toggleCommAll} dense sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50' }}>
            <ListItemIcon><Checkbox checked={commAllSelected} indeterminate={commSelected.size > 0 && !commAllSelected} size="small" disableRipple tabIndex={-1} /></ListItemIcon>
            <ListItemText primary={<Typography variant="body2" fontWeight={600}>{commAllSelected ? 'Deselect all' : `Select all (${commFiltered.length})`}</Typography>} />
          </ListItemButton>
          {commFiltered.length === 0 && (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">No recipients found.</Typography>
            </Box>
          )}
          {commFiltered.map(r => {
            const name = commTab === 0
              ? (r.name || r.full_name || r.expert_name || '—')
              : (r.business_name || '—');
            const email = r.email;
            const sub = commTab === 0 ? (r.location || r.bge_code || '') : (r.owner_name || '');
            return (
              <ListItemButton key={r.id} onClick={() => setCommSelected(prev => {
                const next = new Set(prev);
                next.has(r.id) ? next.delete(r.id) : next.add(r.id);
                return next;
              })} dense>
                <ListItemIcon><Checkbox checked={commSelected.has(r.id)} size="small" disableRipple tabIndex={-1} /></ListItemIcon>
                <ListItemText
                  primary={name}
                  secondary={`${email}${sub ? ' · ' + sub : ''}`}
                />
              </ListItemButton>
            );
          })}
        </Box>

        {commAlreadySent.length > 0 && (
          <Alert severity="warning" sx={{ mt: 1.5 }}
            action={
              <Button size="small" color="inherit" onClick={() => setCommSkipSent(s => !s)}>
                {commSkipSent ? 'Include all' : 'Skip already sent'}
              </Button>
            }>
            {commAlreadySent.length} of your selected recipients already received this subject.
            {commSkipSent && ` They will be skipped.`}
          </Alert>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<ScheduleIcon />}
            disabled={commSelected.size === 0 || !commSubject.trim() || !commBody.trim() || commSending}
            onClick={() => {
              setScheduleFor({
                channel: 'email',
                recipients: Array.from(commSelected),
                subject: commSubject,
                body: commBody.replace(/<\/?b>/gi, ''),
                body_html: bodyToHtml(commBody),
                recipientType: commTab === 0 ? 'bge' : 'msme',
                skipSent: commSkipSent,
              });
              setScheduleDialogOpen(true);
            }}
          >
            Schedule
          </Button>
          <Button
            variant="contained"
            startIcon={commSending ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
            disabled={commSelected.size === 0 || !commSubject.trim() || !commBody.trim() || commSending}
            onClick={() => setCommConfirm(true)}
          >
            Send to {commSelected.size} recipient{commSelected.size !== 1 ? 's' : ''}
          </Button>
        </Box>
      </Paper>

      {/* Confirmation dialog */}
      <Dialog open={commConfirm} onClose={() => setCommConfirm(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Bulk Email</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            You are about to send <strong>"{commSubject}"</strong> to{' '}
            <strong>{commSelected.size} recipient{commSelected.size !== 1 ? 's' : ''}</strong>.
            This cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCommConfirm(false)}>Cancel</Button>
          <Button variant="contained" startIcon={<SendIcon />} onClick={handleCommSend}>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
      )} {/* end email/sms ternary */}

      {/* ── Scheduled Messages Queue ──────────────────────────────────────── */}
      {scheduledMessages.length > 0 && (
        <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
          <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <ScheduleIcon fontSize="small" /> Scheduled Messages{scheduledLoading && <CircularProgress size={14} sx={{ ml: 1 }} />}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {scheduledMessages.map(msg => (
              <Box key={msg.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, borderRadius: 1, bgcolor: 'grey.50', border: '1px solid', borderColor: msg.status === 'pending' ? 'warning.200' : msg.status === 'sent' ? 'success.200' : 'error.200' }}>
                <Chip
                  label={msg.channel.toUpperCase()}
                  size="small"
                  color={msg.channel === 'email' ? 'primary' : 'success'}
                  variant="outlined"
                />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {msg.subject && <Typography variant="body2" noWrap fontWeight={500}>{msg.subject}</Typography>}
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {msg.body.substring(0, 80)}{msg.body.length > 80 ? '…' : ''}
                  </Typography>
                  <Typography variant="caption" display="block" color="text.secondary">
                    {new Date(msg.scheduled_at).toLocaleString()} · {msg.recipient_count} recipient{msg.recipient_count !== 1 ? 's' : ''} · <strong>{msg.status}</strong>
                    {msg.error && <span style={{ color: 'red' }}> · {msg.error}</span>}
                  </Typography>
                </Box>
                {msg.status === 'pending' && (
                  <Button size="small" color="error" onClick={() => handleScheduleCancel(msg.id)}>Cancel</Button>
                )}
              </Box>
            ))}
          </Box>
        </Paper>
      )}

      {/* ── Schedule Send Dialog ──────────────────────────────────────────── */}
      <Dialog open={scheduleDialogOpen} onClose={() => { setScheduleDialogOpen(false); setScheduleDateTime(''); }} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ScheduleIcon fontSize="small" /> Schedule Send
        </DialogTitle>
        <DialogContent>
          {scheduleFor && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>{scheduleFor.channel === 'email' ? 'Email' : 'SMS'}</strong> to{' '}
                <strong>{scheduleFor.recipients.length} recipient{scheduleFor.recipients.length !== 1 ? 's' : ''}</strong>
                {scheduleFor.subject && <> · <em>{scheduleFor.subject}</em></>}
              </Typography>
              <Paper variant="outlined" sx={{ p: 1, bgcolor: 'grey.50', mb: 2 }}>
                <Typography variant="caption" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
                  {scheduleFor.body.substring(0, 120)}{scheduleFor.body.length > 120 ? '…' : ''}
                </Typography>
              </Paper>
            </Box>
          )}
          <TextField
            label="Send at"
            type="datetime-local"
            fullWidth
            size="small"
            value={scheduleDateTime}
            onChange={e => setScheduleDateTime(e.target.value)}
            inputProps={{ min: new Date(Date.now() + 60000).toISOString().slice(0, 16) }}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setScheduleDialogOpen(false); setScheduleDateTime(''); }}>Cancel</Button>
          <Button
            variant="contained"
            startIcon={<ScheduleIcon />}
            disabled={!scheduleDateTime}
            onClick={handleScheduleSubmit}
          >
            Schedule
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );

  // ── T-Shirt Receipts helpers ───────────────────────────────────────────────
  const tshirtDetail = tshirtDetailId ? tshirtReceipts.find(r => r.id === tshirtDetailId) : null;

  const openCreateTshirt = async () => {
    setTshirtForm({ title: 'PRUDEV II T-Shirt Collection', event: '', colour: 'Blue', notes: '' });
    setTshirtFormEntries([]);
    setTshirtBgeSearch('');
    setTshirtDialog(true);

    // Fetch experts fresh every time the dialog opens so the list is always current
    const h = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(API_ENDPOINTS.EXPERTS, { headers: h });
      const bgeList = Array.isArray(res.data) ? res.data : res.data.results || [];
      setExperts(bgeList);
      const sorted = [...bgeList].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      setTshirtFormEntries(sorted.map((e, idx) => ({ bge_id: e.id, name: e.name, size: 'L', quantity: 1, order: idx })));
    } catch {
      // fall back to whatever is already in state
      const sorted = [...experts].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      setTshirtFormEntries(sorted.map((e, idx) => ({ bge_id: e.id, name: e.name, size: 'L', quantity: 1, order: idx })));
    }
  };

  const handleCreateTshirt = async () => {
    const h = { Authorization: `Bearer ${token}` };
    setTshirtSaving(true);
    try {
      const rRes = await axios.post(API_ENDPOINTS.TSHIRT_RECEIPTS, {
        title: tshirtForm.title,
        event: tshirtForm.event,
        colour: tshirtForm.colour,
        notes: tshirtForm.notes,
      }, { headers: h });
      const receiptId = rRes.data.id;
      const selected = tshirtFormEntries.filter(e => e._selected !== false);
      await Promise.all(selected.map((e, idx) =>
        axios.post(API_ENDPOINTS.TSHIRT_ENTRIES, {
          receipt: receiptId,
          bge: e.bge_id,
          size: e.size,
          quantity: e.quantity,
          order: e.order ?? idx,
        }, { headers: h })
      ));
      setTshirtDialog(false);
      await fetchTshirtReceipts();
      setSuccess('T-shirt receipt created successfully.');
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data?.non_field_errors?.[0] || 'Failed to create receipt.');
    } finally {
      setTshirtSaving(false);
    }
  };

  const handleTshirtBulkSign = async (receiptId) => {
    const h = { Authorization: `Bearer ${token}` };
    setTshirtBulkSigning(true);
    try {
      const res = await axios.post(TSHIRT_RECEIPT_BULK_SIGN(receiptId), {}, { headers: h });
      await fetchTshirtReceipts();
      setSuccess(`Bulk sign complete — ${res.data.signed} BGE(s) signed.`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Bulk sign failed.');
    } finally {
      setTshirtBulkSigning(false);
    }
  };

  const handleDownloadTshirtPdf = async (receiptId) => {
    const h = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(TSHIRT_RECEIPT_PDF_URL(receiptId), { headers: h, responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      const receipt = tshirtReceipts.find(r => r.id === receiptId);
      a.download = `tshirt-receipt-${receipt?.title?.replace(/\s+/g, '-') || receiptId}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setError('Failed to download PDF.');
    }
  };

  // ── renderTshirtReceipts ───────────────────────────────────────────────────
  const renderTshirtReceipts = () => {
    const filteredFormEntries = tshirtFormEntries.filter(e =>
      !tshirtBgeSearch || (e.name || '').toLowerCase().includes(tshirtBgeSearch.toLowerCase())
    );
    const selectedCount = tshirtFormEntries.filter(e => e._selected !== false).length;

    return (
      <Box>
        <SectionHeader
          title="T-Shirt Receipts"
          subtitle="Create digital sign-off receipts for BGE t-shirt distribution"
        >
          <Button variant="contained" startIcon={<Add />} onClick={openCreateTshirt}>
            Create Receipt
          </Button>
        </SectionHeader>

        {tshirtLoading && <LinearProgress sx={{ mb: 2 }} />}

        {tshirtReceipts.length === 0 && !tshirtLoading && (
          <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
            <Checkroom sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
            <Typography variant="body1" color="text.secondary">No receipts yet.</Typography>
            <Typography variant="body2" color="text.secondary">Create a receipt to track t-shirt distribution.</Typography>
          </Paper>
        )}

        {tshirtReceipts.length > 0 && (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: '#F8FAFC' }}>
                  <TableCell sx={{ fontWeight: 700 }}>Title</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Event</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Colour</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Progress</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Created</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {tshirtReceipts.slice(tshirtPage * ROWS_PER_PAGE, (tshirtPage + 1) * ROWS_PER_PAGE).map(r => (
                  <TableRow key={r.id} hover>
                    <TableCell>
                      <Typography variant="body2" fontWeight={600}>{r.title}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">{r.event || '—'}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">{r.colour}</Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip
                          size="small"
                          label={`${r.signed_count}/${r.total_entries} signed`}
                          color={r.fully_signed ? 'success' : r.signed_count > 0 ? 'warning' : 'default'}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {r.created_at ? new Date(r.created_at).toLocaleDateString() : '—'}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                        <Tooltip title="View details">
                          <IconButton size="small" onClick={() => setTshirtDetailId(r.id)}>
                            <Visibility fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download PDF">
                          <IconButton size="small" onClick={() => handleDownloadTshirtPdf(r.id)}>
                            <Download fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {tshirtReceipts.length > ROWS_PER_PAGE && (
              <TablePagination
                component="div"
                count={tshirtReceipts.length}
                rowsPerPage={ROWS_PER_PAGE}
                page={tshirtPage}
                onPageChange={(_, p) => setTshirtPage(p)}
                rowsPerPageOptions={[ROWS_PER_PAGE]}
              />
            )}
          </TableContainer>
        )}

        {/* ── Create Receipt dialog ────────────────────────────────────────── */}
        <Dialog open={tshirtDialog} onClose={() => setTshirtDialog(false)} maxWidth="md" fullWidth
          PaperProps={{ sx: { maxHeight: '90vh' } }}>
          <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Checkroom sx={{ color: BRAND.sidebarBg }} />
              <Typography variant="h6" fontWeight={700}>Create T-Shirt Receipt</Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Receipt Title" fullWidth size="small"
                  value={tshirtForm.title}
                  onChange={e => setTshirtForm(f => ({ ...f, title: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Event / Programme" fullWidth size="small"
                  value={tshirtForm.event}
                  onChange={e => setTshirtForm(f => ({ ...f, event: e.target.value }))}
                  placeholder="e.g. BGE TOT 2026, Adjumani"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl size="small" fullWidth>
                  <InputLabel>T-Shirt Colour</InputLabel>
                  <Select
                    label="T-Shirt Colour"
                    value={tshirtForm.colour}
                    onChange={e => setTshirtForm(f => ({ ...f, colour: e.target.value }))}
                  >
                    {['Blue', 'White', 'Navy', 'Black', 'Grey', 'Green', 'Red'].map(c => (
                      <MenuItem key={c} value={c}>{c}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  label="Notes (optional)" fullWidth size="small"
                  value={tshirtForm.notes}
                  onChange={e => setTshirtForm(f => ({ ...f, notes: e.target.value }))}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="subtitle2" fontWeight={700}>
                BGE Recipients ({selectedCount} selected)
              </Typography>
              <TextField
                size="small" placeholder="Search BGEs…"
                value={tshirtBgeSearch}
                onChange={e => setTshirtBgeSearch(e.target.value)}
                InputProps={{ startAdornment: <Search sx={{ mr: 0.5, color: 'text.secondary', fontSize: 18 }} /> }}
                sx={{ width: 220 }}
              />
            </Box>

            <Paper variant="outlined" sx={{ maxHeight: 360, overflowY: 'auto' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#F8FAFC' }}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        size="small"
                        checked={tshirtFormEntries.length > 0 && tshirtFormEntries.every(e => e._selected !== false)}
                        indeterminate={tshirtFormEntries.some(e => e._selected !== false) && !tshirtFormEntries.every(e => e._selected !== false)}
                        onChange={e => setTshirtFormEntries(prev => prev.map(x => ({ ...x, _selected: e.target.checked })))}
                      />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>BGE Name</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Code</TableCell>
                    <TableCell sx={{ fontWeight: 700, width: 110 }}>Size</TableCell>
                    <TableCell sx={{ fontWeight: 700, width: 80 }}>Qty</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredFormEntries.map(entry => (
                    <TableRow key={entry.bge_id} hover>
                      <TableCell padding="checkbox">
                        <Checkbox
                          size="small"
                          checked={entry._selected !== false}
                          onChange={ev => setTshirtFormEntries(prev =>
                            prev.map(x => x.bge_id === entry.bge_id ? { ...x, _selected: ev.target.checked } : x)
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{entry.name}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {experts.find(e => e.id === entry.bge_id)?.bge_code || '—'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Select
                          size="small" value={entry.size}
                          onChange={ev => setTshirtFormEntries(prev =>
                            prev.map(x => x.bge_id === entry.bge_id ? { ...x, size: ev.target.value } : x)
                          )}
                          sx={{ fontSize: 13, minWidth: 80 }}
                        >
                          {['L', 'XL', '2XL'].map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                        </Select>
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number" size="small" value={entry.quantity}
                          inputProps={{ min: 1, max: 5, style: { width: 44, textAlign: 'center' } }}
                          onChange={ev => setTshirtFormEntries(prev =>
                            prev.map(x => x.bge_id === entry.bge_id ? { ...x, quantity: Math.max(1, parseInt(ev.target.value) || 1) } : x)
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  {filteredFormEntries.length === 0 && tshirtFormEntries.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        <Box sx={{ py: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                          <CircularProgress size={16} />
                          <Typography variant="body2" color="text.secondary">Loading BGE list…</Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                  {filteredFormEntries.length === 0 && tshirtFormEntries.length > 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>No BGEs match your search.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </DialogContent>
          <DialogActions sx={{ borderTop: 1, borderColor: 'divider', gap: 1 }}>
            <Typography variant="caption" color="text.secondary" sx={{ flex: 1, ml: 1 }}>
              {selectedCount} BGE(s) will be added to this receipt.
            </Typography>
            <Button onClick={() => setTshirtDialog(false)}>Cancel</Button>
            <Button
              variant="contained"
              disabled={tshirtSaving || !tshirtForm.title.trim() || selectedCount === 0}
              startIcon={tshirtSaving ? <CircularProgress size={16} color="inherit" /> : <Add />}
              onClick={handleCreateTshirt}
            >
              Create Receipt
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Detail / Signing dialog ──────────────────────────────────────── */}
        <Dialog open={!!tshirtDetailId} onClose={() => setTshirtDetailId(null)} maxWidth="md" fullWidth
          PaperProps={{ sx: { maxHeight: '90vh' } }}>
          {tshirtDetail && (() => {
            const r = tshirtDetail;
            return (
              <>
                <Box sx={{ bgcolor: BRAND.sidebarBg, px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 1.2 }}>
                      T-Shirt Receipt
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700 }}>{r.title}</Typography>
                    {r.event && <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>{r.event}</Typography>}
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Chip
                      label={`${r.signed_count}/${r.total_entries} signed`}
                      color={r.fully_signed ? 'success' : r.signed_count > 0 ? 'warning' : 'default'}
                      sx={{ fontWeight: 700 }}
                    />
                    {r.created_by_name && (
                      <Typography variant="caption" sx={{ display: 'block', color: 'rgba(255,255,255,0.6)', mt: 0.5 }}>
                        Created by {r.created_by_name}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <DialogContent sx={{ p: 0 }}>
                  <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, bgcolor: '#F8FAFC', borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
                    {[
                      ['Colour', r.colour],
                      ['Total BGEs', r.total_entries],
                      ['Signed', r.signed_count],
                      ['Pending', r.total_entries - r.signed_count],
                      ['Created', r.created_at ? new Date(r.created_at).toLocaleDateString() : '—'],
                    ].map(([label, val]) => (
                      <Box key={label}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.6 }}>{label}</Typography>
                        <Typography variant="body2" fontWeight={600}>{val}</Typography>
                      </Box>
                    ))}
                  </Box>

                  <TableContainer sx={{ maxHeight: 420 }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow sx={{ bgcolor: '#F8FAFC' }}>
                          <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>BGE Name</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Code</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Location</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Size</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Qty</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Signature</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(r.entries || []).map((entry, idx) => (
                          <TableRow key={entry.id} hover sx={{ bgcolor: entry.signed ? 'rgba(0,155,98,0.04)' : 'inherit' }}>
                            <TableCell>
                              <Typography variant="body2" color="text.secondary">{idx + 1}</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" fontWeight={600}>{entry.bge_name}</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="text.secondary">{entry.bge_code || '—'}</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="text.secondary">{entry.bge_location || '—'}</Typography>
                            </TableCell>
                            <TableCell>
                              <Chip label={entry.size} size="small" variant="outlined" />
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">{entry.quantity}</Typography>
                            </TableCell>
                            <TableCell>
                              {entry.has_signature
                                ? <Chip label="On file" size="small" color="success" variant="outlined" />
                                : <Chip label="Missing" size="small" color="default" variant="outlined" />
                              }
                            </TableCell>
                            <TableCell>
                              {entry.signed ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  <CheckCircle sx={{ fontSize: 16, color: '#009B62' }} />
                                  <Typography variant="body2" color="success.main" fontWeight={600}>
                                    Signed {entry.signed_at ? new Date(entry.signed_at).toLocaleDateString() : ''}
                                  </Typography>
                                </Box>
                              ) : (
                                <Chip label="Pending" size="small" color="default" />
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </DialogContent>

                <DialogActions sx={{ borderTop: '1px solid #E5E7EB', gap: 1, flexWrap: 'wrap' }}>
                  <Button
                    variant="outlined"
                    startIcon={tshirtBulkSigning ? <CircularProgress size={16} /> : <DrawOutlined />}
                    disabled={tshirtBulkSigning}
                    onClick={() => handleTshirtBulkSign(r.id)}
                  >
                    Bulk Sign (Admin)
                  </Button>
                  <Box sx={{ flex: 1 }} />
                  <Button
                    startIcon={<Download />}
                    onClick={() => handleDownloadTshirtPdf(r.id)}
                  >
                    Download PDF
                  </Button>
                  <Button onClick={() => setTshirtDetailId(null)}>Close</Button>
                </DialogActions>
              </>
            );
          })()}
        </Dialog>
      </Box>
    );
  };

  const handleDownloadTbipPdf = async (planObj) => {
    try {
      const res = await axios.get(TBIP_PDF_URL(planObj.id), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `TBIP_${planObj.msme_name || 'MSME'}_${planObj.assessment_date}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      setError('Failed to download PDF');
    }
  };

  const handleDownloadTbipExcel = async (planObj) => {
    try {
      const res = await axios.get(TBIP_EXCEL_URL(planObj.id), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `TBIP_${planObj.msme_name || 'MSME'}_${planObj.assessment_date}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      setError('Failed to download Excel workbook');
    }
  };

  const renderTbip = () => {
    const filtered = tbipPlans.filter(p => {
      if (tbipFilterStatus !== 'all' && p.status !== tbipFilterStatus) return false;
      if (tbipFilterPriority !== 'all' && p.overall_priority !== tbipFilterPriority) return false;
      if (tbipFilterBge !== 'all' && String(p.bge) !== String(tbipFilterBge)) return false;
      if (tbipSearch.trim()) {
        const q = tbipSearch.toLowerCase();
        const mName = (p.msme_name || '').toLowerCase();
        const mCode = (p.msme_code || '').toLowerCase();
        const bName = (p.bge_name || '').toLowerCase();
        if (!mName.includes(q) && !mCode.includes(q) && !bName.includes(q)) return false;
      }
      return true;
    });

    const totalPlans = tbipPlans.length;
    const submittedCount = tbipPlans.filter(p => p.status === 'submitted').length;
    const approvedCount = tbipPlans.filter(p => p.status === 'approved').length;
    const highPriorityCount = tbipPlans.filter(p => p.overall_priority === 'High').length;

    return (
      <Box>
        <SectionHeader
          title="Enterprise Improvement Plans (TBIP)"
          count={totalPlans}
          subtitle="MSME Business Diagnostic Assessments & Technical Improvement Roadmap"
          action={
            !isViewer ? (
              <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                <Button
                  variant="outlined"
                  startIcon={<CalendarMonth />}
                  onClick={() => {
                    setTbipBookMeetingMsme(null);
                    setTbipBookMeetingPlan(null);
                    setTbipBookMeetingOpen(true);
                  }}
                  sx={{
                    borderColor: BRAND.primaryMain,
                    color: BRAND.primaryMain,
                    bgcolor: '#FFFFFF',
                    '&:hover': { bgcolor: '#F1F5F9' },
                    fontWeight: 700,
                    borderRadius: 2,
                  }}
                >
                  Book Meeting with Richard & Stephen
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => {
                    setSelectedTbip(null);
                    setSelectedTbipMsme(null);
                    setTbipDialog(true);
                  }}
                  sx={{ bgcolor: BRAND.gizRed, '&:hover': { bgcolor: BRAND.gizDarkRed }, fontWeight: 700, borderRadius: 2 }}
                >
                  New Assessment / Plan
                </Button>
              </Box>
            ) : null
          }
        />


        {/* KPI Cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6} sm={3}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #E2E8F0', bgcolor: '#FFFFFF' }}>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>Total Assessments</Typography>
              <Typography variant="h5" fontWeight={800} color={BRAND.primaryMain}>{totalPlans}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #FCA5A5', bgcolor: '#FEF2F2' }}>
              <Typography variant="caption" color="error.main" fontWeight={700}>High Priority</Typography>
              <Typography variant="h5" fontWeight={800} color="#991B1B">{highPriorityCount}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #93C5FD', bgcolor: '#EFF6FF' }}>
              <Typography variant="caption" color="primary.main" fontWeight={700}>Pending HOA Review</Typography>
              <Typography variant="h5" fontWeight={800} color="#1E40AF">{submittedCount}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #A7F3D0', bgcolor: '#ECFDF5' }}>
              <Typography variant="caption" color="success.main" fontWeight={700}>HOA Approved</Typography>
              <Typography variant="h5" fontWeight={800} color="#065F46">{approvedCount}</Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Filters */}
        <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #CBD5E1', bgcolor: '#FFFFFF', mb: 2.5 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={4}>
              <TextField
                size="small"
                placeholder="Search MSME name, code, or BGE..."
                value={tbipSearch}
                onChange={(e) => setTbipSearch(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControl size="small" fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={tbipFilterStatus}
                  onChange={(e) => setTbipFilterStatus(e.target.value)}
                >
                  <MenuItem value="all">All Statuses</MenuItem>
                  <MenuItem value="draft">Draft</MenuItem>
                  <MenuItem value="submitted">Submitted (Pending Review)</MenuItem>
                  <MenuItem value="approved">Approved</MenuItem>
                  <MenuItem value="rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2.5}>
              <FormControl size="small" fullWidth>
                <InputLabel>Priority</InputLabel>
                <Select
                  label="Priority"
                  value={tbipFilterPriority}
                  onChange={(e) => setTbipFilterPriority(e.target.value)}
                >
                  <MenuItem value="all">All Priorities</MenuItem>
                  <MenuItem value="High">High Priority</MenuItem>
                  <MenuItem value="Medium">Medium Priority</MenuItem>
                  <MenuItem value="Low">Low Priority</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={2.5}>
              <FormControl size="small" fullWidth>
                <InputLabel>Lead BGE</InputLabel>
                <Select
                  label="Lead BGE"
                  value={tbipFilterBge}
                  onChange={(e) => setTbipFilterBge(e.target.value)}
                >
                  <MenuItem value="all">All BGEs</MenuItem>
                  {experts.map(b => (
                    <MenuItem key={b.id} value={String(b.id)}>{b.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        {/* Table */}
        {filtered.length === 0 ? (
          <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 2, border: '1px solid #E2E8F0' }}>
            <TrendingUp sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
            <Typography fontWeight={600} color="text.secondary">No Enterprise Improvement Plans found.</Typography>
          </Paper>
        ) : (
          <TableContainer component={Paper} elevation={0} sx={{ overflowX: 'auto', border: '1px solid #CBD5E1', borderRadius: 2 }}>
            <Table size="small" sx={{ minWidth: 760 }}>
              <TableHead sx={{ bgcolor: '#1A365D' }}>
                <TableRow>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }}>MSME</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Lead BGE</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Assessment Date</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }} align="center">Diagnostic Snapshot</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }} align="center">Priority</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }} align="center">Status</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700 }} align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filtered.slice(tbipPage * ROWS_PER_PAGE, (tbipPage + 1) * ROWS_PER_PAGE).map((p) => {
                  const diag = p.diagnostic_snapshot || {};
                  const totalGaps = diag.total_gaps != null ? diag.total_gaps : (diag.totalGaps || 0);
                  const totalApp = diag.total_applicable != null ? diag.total_applicable : (diag.totalApplicable || 0);
                  const isHigh = p.overall_priority === 'High';
                  const isMed = p.overall_priority === 'Medium';

                  return (
                    <TableRow key={p.id} hover>
                      <TableCell>
                        <Typography fontSize={13.5} fontWeight={700} color={BRAND.primaryMain}>
                          {p.msme_name || `MSME #${p.msme}`}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary">
                          {p.msme_code || '—'}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ fontSize: 13, fontWeight: 600 }}>
                        {p.bge_name || '—'}
                      </TableCell>
                      <TableCell sx={{ fontSize: 13, fontWeight: 600 }}>
                        {p.assessment_date}
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                          <Typography fontSize={12} fontWeight={800} color={totalGaps > 0 ? '#C8102E' : '#009B62'}>
                            {totalGaps} / {totalApp} gaps
                          </Typography>
                          <LinearProgress
                            variant="determinate"
                            value={totalApp > 0 ? (totalGaps / totalApp) * 100 : 0}
                            sx={{
                              width: 70,
                              height: 4,
                              borderRadius: 2,
                              mt: 0.5,
                              bgcolor: '#E2E8F0',
                              '& .MuiLinearProgress-bar': {
                                bgcolor: totalGaps > 6 ? '#C8102E' : totalGaps > 3 ? '#F59E0B' : '#009B62',
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={p.overall_priority || 'Low'}
                          size="small"
                          sx={{
                            fontWeight: 800,
                            fontSize: 11,
                            bgcolor: isHigh ? '#FEE2E2' : isMed ? '#FEF3C7' : '#ECFDF5',
                            color: isHigh ? '#991B1B' : isMed ? '#92400E' : '#065F46',
                            border: '1px solid',
                            borderColor: isHigh ? '#F87171' : isMed ? '#FBBF24' : '#A7F3D0',
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={(p.status || 'draft').toUpperCase()}
                          size="small"
                          color={p.status === 'approved' ? 'success' : p.status === 'submitted' ? 'primary' : p.status === 'rejected' ? 'error' : 'default'}
                          sx={{ fontWeight: 700, fontSize: 10.5 }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end', alignItems: 'center' }}>
                          <Tooltip title="Book Meeting with Richard & Stephen">
                            <IconButton
                              size="small"
                              sx={{ color: '#0F172A' }}
                              onClick={() => {
                                const mTarget = msmes.find(m => m.id === p.msme) || allMsmes.find(m => m.id === p.msme);
                                setTbipBookMeetingMsme(mTarget || null);
                                setTbipBookMeetingPlan(p);
                                setTbipBookMeetingOpen(true);
                              }}
                            >
                              <CalendarMonth fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={isViewer ? "View Assessment" : "Review / Approve / Edit Assessment"}>
                            <IconButton
                              size="small"
                              color="primary"

                              onClick={() => {
                                const mTarget = msmes.find(m => m.id === p.msme) || allMsmes.find(m => m.id === p.msme);
                                setSelectedTbipMsme(mTarget || null);
                                setSelectedTbip(p);
                                setTbipDialog(true);
                              }}
                            >
                              {isViewer ? <Visibility fontSize="small" /> : <Edit fontSize="small" />}
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download Official PDF">
                            <IconButton size="small" color="error" onClick={() => handleDownloadTbipPdf(p)}>
                              <PictureAsPdf fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download Excel Workbook">
                            <IconButton size="small" color="success" onClick={() => handleDownloadTbipExcel(p)}>
                              <Download fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={filtered.length}
              page={tbipPage}
              rowsPerPage={ROWS_PER_PAGE}
              rowsPerPageOptions={[ROWS_PER_PAGE]}
              onPageChange={(_, p) => setTbipPage(p)}
            />
          </TableContainer>
        )}
      </Box>
    );
  };

  const handleDownloadFiapPdf = async (planObj) => {
    try {
      const res = await axios.get(FIAP_PDF_URL(planObj.id), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `FIAP_${(planObj.msme_name || 'MSME').replace(/\s+/g, '_')}_${planObj.assessment_date || 'action_plan'}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setError('Failed to download Financial Action Plan PDF.');
    }
  };

  const renderFiap = () => {
    const filtered = fiapPlans.filter(p => {
      if (fiapFilterCategory !== 'all' && String(p.category) !== String(fiapFilterCategory)) return false;
      if (fiapFilterPriority !== 'all' && p.support_priority !== fiapFilterPriority) return false;
      if (fiapFilterStatus !== 'all' && p.status !== fiapFilterStatus) return false;
      if (fiapSearch.trim()) {
        const q = fiapSearch.toLowerCase();
        const mName = (p.msme_name || '').toLowerCase();
        const mCode = (p.msme_code || '').toLowerCase();
        const cName = (p.category_name || '').toLowerCase();
        const sector = (p.msme_sector || '').toLowerCase();
        const dist = (p.msme_district || '').toLowerCase();
        if (!mName.includes(q) && !mCode.includes(q) && !cName.includes(q) && !sector.includes(q) && !dist.includes(q)) return false;
      }
      return true;
    });

    const totalPlans = fiapPlans.length;
    const highPriorityCount = fiapPlans.filter(p => p.support_priority === 'High').length;
    const mediumPriorityCount = fiapPlans.filter(p => p.support_priority === 'Medium').length;
    const lowPriorityCount = fiapPlans.filter(p => p.support_priority === 'Low').length;
    const approvedCount = fiapPlans.filter(p => p.status === 'approved').length;
    const submittedCount = fiapPlans.filter(p => p.status === 'submitted').length;

    const summaryMatrix = (FIAP_CATEGORIES || []).map(cat => {
      const inCat = fiapPlans.filter(p => p.category === cat.id || String(p.category) === String(cat.number) || (p.category_name && p.category_name.toLowerCase().includes(cat.name.toLowerCase().slice(0, 15))));
      const count = inCat.length;
      const pct = totalPlans > 0 ? ((count / totalPlans) * 100).toFixed(1) : '0.0';
      const high = inCat.filter(p => p.support_priority === 'High').length;
      const med = inCat.filter(p => p.support_priority === 'Medium').length;
      const low = inCat.filter(p => p.support_priority === 'Low').length;
      return {
        ...cat,
        count,
        pct,
        high,
        med,
        low,
      };
    });

    return (
      <Box>
        {/* Header */}
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', sm: 'center' },
          gap: 2,
          mb: 3,
        }}>
          <Box>
            <Typography variant="h5" fontWeight={800} color="#1E3A8A">
              Financial Improvement Action Plans (FIAP)
            </Typography>
            <Typography variant="body2" color="text.secondary">
              PRUDEV II / GOPA Pro MSME Diagnostic & Credit Readiness Roadmap (Access to Finance)
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              startIcon={<EventAvailable />}
              onClick={() => {
                setSelectedFiap(null);
                setSelectedFiapMsme(null);
                setFiapBookMeetingOpen(true);
              }}
              sx={{
                borderColor: '#1E3A8A',
                color: '#1E3A8A',
                bgcolor: '#FFFFFF',
                '&:hover': { bgcolor: '#EFF6FF' },
                fontWeight: 700,
              }}
            >
              Request Approval Meeting
            </Button>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => {
                setSelectedFiap(null);
                setSelectedFiapMsme(null);
                setFiapDialog(true);
              }}
              sx={{ bgcolor: '#1E3A8A', '&:hover': { bgcolor: '#172554' }, fontWeight: 700 }}
            >
              New Action Plan
            </Button>
          </Box>
        </Box>

        {/* KPI Summary Cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6} sm={2.4}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #E2E8F0', bgcolor: '#FFFFFF' }}>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>Total Action Plans</Typography>
              <Typography variant="h5" fontWeight={800} color="#1E3A8A">{totalPlans}</Typography>
              <Typography variant="caption" color="text.secondary">{submittedCount} submitted</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #FCA5A5', bgcolor: '#FEF2F2' }}>
              <Typography variant="caption" color="error.main" fontWeight={700}>High Priority (Severe Gaps)</Typography>
              <Typography variant="h5" fontWeight={800} color="#991B1B">{highPriorityCount}</Typography>
              <Typography variant="caption" color="error.main">Needs intensive coaching</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #FCD34D', bgcolor: '#FFFBEB' }}>
              <Typography variant="caption" sx={{ color: '#B45309', fontWeight: 700 }}>Medium Priority</Typography>
              <Typography variant="h5" fontWeight={800} sx={{ color: '#B45309' }}>{mediumPriorityCount}</Typography>
              <Typography variant="caption" sx={{ color: '#B45309' }}>Standard roadmap</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #A7F3D0', bgcolor: '#F0FDF4' }}>
              <Typography variant="caption" sx={{ color: '#047857', fontWeight: 700 }}>Low Priority (Finance Ready)</Typography>
              <Typography variant="h5" fontWeight={800} sx={{ color: '#047857' }}>{lowPriorityCount}</Typography>
              <Typography variant="caption" sx={{ color: '#047857' }}>FSP application ready</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #BFDBFE', bgcolor: '#EFF6FF' }}>
              <Typography variant="caption" sx={{ color: '#1E3A8A', fontWeight: 700 }}>Officially Approved</Typography>
              <Typography variant="h5" fontWeight={800} color="#1E3A8A">{approvedCount}</Typography>
              <Typography variant="caption" sx={{ color: '#1E3A8A' }}>Rosemary / Harriet endorsed</Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* ── Section 7: Portfolio Summary Reporting Matrix (Template Section 7) ── */}
        <Paper elevation={0} sx={{ p: 2.5, mb: 3, borderRadius: 2, border: '1px solid #E2E8F0', bgcolor: '#FFFFFF' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
            <Box>
              <Typography variant="subtitle2" fontWeight={800} color="#1E3A8A" sx={{ letterSpacing: 0.3 }}>
                SECTION 7: PORTFOLIO SUMMARY REPORTING MATRIX
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Project-Level Aggregation & Partner FSP Reporting Across Northern Uganda
              </Typography>
            </Box>
            {fiapFilterCategory !== 'all' && (
              <Button size="small" variant="text" onClick={() => { setFiapFilterCategory('all'); setFiapPage(0); }}>
                Clear Category Filter ({fiapFilterCategory})
              </Button>
            )}
          </Box>
          <TableContainer sx={{ border: '1px solid #E2E8F0', borderRadius: 1.5 }}>
            <Table size="small">
              <TableHead sx={{ bgcolor: '#F1F5F9' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 800, fontSize: 12, width: 40 }}>#</TableCell>
                  <TableCell sx={{ fontWeight: 800, fontSize: 12 }}>Primary Action Plan Category</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 800, fontSize: 12, width: 110 }}>Total MSMEs</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 800, fontSize: 12, width: 100 }}>% of Total</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 800, fontSize: 12, width: 110, color: '#991B1B' }}>High Priority</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 800, fontSize: 12, width: 120, color: '#B45309' }}>Medium Priority</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 800, fontSize: 12, width: 110, color: '#047857' }}>Low Priority</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryMatrix.map((catRow) => {
                  const isSelected = String(fiapFilterCategory) === String(catRow.id);
                  return (
                    <TableRow
                      key={catRow.id}
                      hover
                      onClick={() => {
                        setFiapFilterCategory(isSelected ? 'all' : catRow.id);
                        setFiapPage(0);
                      }}
                      sx={{
                        cursor: 'pointer',
                        bgcolor: isSelected ? '#EFF6FF' : 'inherit',
                        '&:hover': { bgcolor: isSelected ? '#DBEAFE' : '#F8FAFC' },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 800, color: '#1E3A8A' }}>{catRow.number}</TableCell>
                      <TableCell>
                        <Typography fontSize={13} fontWeight={700} color="#0F172A">
                          {catRow.name}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary">
                          {catRow.what_it_addresses}
                        </Typography>
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 800, color: '#1E3A8A' }}>
                        {catRow.count}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 600 }}>
                        {catRow.pct}%
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700, color: '#991B1B' }}>
                        {catRow.high}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700, color: '#B45309' }}>
                        {catRow.med}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700, color: '#047857' }}>
                        {catRow.low}
                      </TableCell>
                    </TableRow>
                  );
                })}
                <TableRow sx={{ bgcolor: '#F8FAFC', borderTop: '2px solid #CBD5E1' }}>
                  <TableCell sx={{ fontWeight: 900 }}>TOTAL</TableCell>
                  <TableCell sx={{ fontWeight: 900 }}>Full Portfolio Aggregation</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900, color: '#1E3A8A' }}>{totalPlans}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900 }}>100%</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900, color: '#991B1B' }}>{highPriorityCount}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900, color: '#B45309' }}>{mediumPriorityCount}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900, color: '#047857' }}>{lowPriorityCount}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Filter Bar */}
        <Paper elevation={0} sx={{ p: 2, mb: 2.5, borderRadius: 2, border: '1px solid #E2E8F0', bgcolor: '#FFFFFF' }}>
          <Grid container spacing={1.5} alignItems="center">
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search MSME, code, sector, district..."
                value={fiapSearch}
                onChange={(e) => { setFiapSearch(e.target.value); setFiapPage(0); }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search fontSize="small" sx={{ color: '#94A3B8' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Category</InputLabel>
                <Select
                  value={fiapFilterCategory}
                  label="Category"
                  onChange={(e) => { setFiapFilterCategory(e.target.value); setFiapPage(0); }}
                >
                  <MenuItem value="all">All 9 Categories</MenuItem>
                  {FIAP_CATEGORIES.map(c => (
                    <MenuItem key={c.id} value={c.id}>{c.number}. {c.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={2.5}>
              <FormControl fullWidth size="small">
                <InputLabel>Priority</InputLabel>
                <Select
                  value={fiapFilterPriority}
                  label="Priority"
                  onChange={(e) => { setFiapFilterPriority(e.target.value); setFiapPage(0); }}
                >
                  <MenuItem value="all">All Priorities</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={2.5}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={fiapFilterStatus}
                  label="Status"
                  onChange={(e) => { setFiapFilterStatus(e.target.value); setFiapPage(0); }}
                >
                  <MenuItem value="all">All Statuses</MenuItem>
                  <MenuItem value="draft">Draft</MenuItem>
                  <MenuItem value="submitted">Submitted</MenuItem>
                  <MenuItem value="approved">Approved</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        {/* Table of Plans */}
        {filtered.length === 0 ? (
          <Paper elevation={0} sx={{ p: 4, textAlign: 'center', borderRadius: 2, border: '1px dashed #CBD5E1', bgcolor: '#F8FAFC' }}>
            <AccountBalance sx={{ fontSize: 48, color: '#94A3B8', mb: 1.5 }} />
            <Typography variant="subtitle1" fontWeight={700} color="text.secondary">
              No Financial Improvement Action Plans Found
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Formulate a credit readiness diagnostic and tailored roadmap for assigned MSMEs.
            </Typography>
          </Paper>
        ) : (
          <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 2, border: '1px solid #E2E8F0' }}>
            <Table size="small">
              <TableHead sx={{ bgcolor: '#1E3A8A' }}>
                <TableRow>
                  <TableCell sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: 12 }}>MSME & Details</TableCell>
                  <TableCell sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: 12 }}>Action Plan Category</TableCell>
                  <TableCell sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: 12 }}>Gaps & Target Facility</TableCell>
                  <TableCell align="center" sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: 12 }}>Priority</TableCell>
                  <TableCell align="center" sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: 12 }}>Status</TableCell>
                  <TableCell align="right" sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: 12 }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filtered.slice(fiapPage * ROWS_PER_PAGE, fiapPage * ROWS_PER_PAGE + ROWS_PER_PAGE).map((p) => {
                  const isHigh = p.support_priority === 'High';
                  const isMed = p.support_priority === 'Medium';
                  const gapsCount = (p.identified_gaps || p.gaps_identified || []).length;
                  const stepsCount = (p.action_plan_steps || []).length;

                  return (
                    <TableRow key={p.id} hover sx={{ '&:hover': { bgcolor: '#F8FAFC' } }}>
                      <TableCell sx={{ py: 1.5 }}>
                        <Typography fontWeight={700} fontSize={13.5} color="#1E3A8A">
                          {p.msme_name || `MSME #${p.msme}`}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary">
                          {p.msme_code ? `${p.msme_code} · ` : ''}{p.msme_sector || 'General'}
                          {p.msme_district ? ` · ${p.msme_district}` : ''}
                        </Typography>
                        {p.bge_name && (
                          <Typography fontSize={10.5} color="text.secondary">
                            Coach: {p.bge_name}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 280 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Chip
                            label={`#${p.category || '—'}`}
                            size="small"
                            sx={{
                              bgcolor: '#EFF6FF',
                              color: '#1E3A8A',
                              fontWeight: 800,
                              fontSize: 11,
                              border: '1px solid #BFDBFE',
                              minWidth: 32,
                            }}
                          />
                          <Box>
                            <Typography fontSize={12.5} fontWeight={700} color="#1E293B">
                              {p.category_name || `Category ${p.category}`}
                            </Typography>
                            <Typography fontSize={11} color="text.secondary" sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                            }}>
                              {p.category_addresses}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ maxWidth: 240 }}>
                        <Typography fontSize={12} fontWeight={600} color="#334155">
                          {gapsCount} gap{gapsCount === 1 ? '' : 's'} identified · {stepsCount} step{stepsCount === 1 ? '' : 's'}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary" sx={{
                          display: '-webkit-box',
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}>
                          {p.financing_target || 'Target financing not specified'}
                          {p.estimated_amount ? ` (UGX ${p.estimated_amount})` : ''}
                          {p.preferred_fsp ? ` · ${p.preferred_fsp}` : ''}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={p.support_priority || 'Low'}
                          size="small"
                          sx={{
                            fontWeight: 800,
                            fontSize: 11,
                            bgcolor: isHigh ? '#FEE2E2' : isMed ? '#FEF3C7' : '#ECFDF5',
                            color: isHigh ? '#991B1B' : isMed ? '#92400E' : '#065F46',
                            border: '1px solid',
                            borderColor: isHigh ? '#F87171' : isMed ? '#FBBF24' : '#A7F3D0',
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={p.status === 'approved' ? `Approved${p.approved_by_name ? ` by ${p.approved_by_name.split(' ')[0]}` : ''}` : (p.status || 'draft')}
                          size="small"
                          color={p.status === 'approved' ? 'success' : p.status === 'submitted' ? 'primary' : 'default'}
                          sx={{ fontWeight: 700, fontSize: 10.5 }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end', alignItems: 'center' }}>
                          <Tooltip title="View / Review / Edit Action Plan">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => {
                                const mTarget = msmes.find(m => m.id === p.msme) || allMsmes.find(m => m.id === p.msme);
                                setSelectedFiapMsme(mTarget || null);
                                setSelectedFiap(p);
                                setFiapDialog(true);
                              }}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Request Approval Meeting with Rosemary or Harriet">
                            <IconButton
                              size="small"
                              sx={{ color: '#1E3A8A' }}
                              onClick={() => {
                                const mTarget = msmes.find(m => m.id === p.msme) || allMsmes.find(m => m.id === p.msme);
                                setFiapBookMeetingPlan(p);
                                setFiapBookMeetingMsme(mTarget || null);
                                setFiapBookMeetingOpen(true);
                              }}
                            >
                              <EventAvailable fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download Official PRUDEV II PDF">
                            <IconButton size="small" color="error" onClick={() => handleDownloadFiapPdf(p)}>
                              <PictureAsPdf fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={filtered.length}
              page={fiapPage}
              rowsPerPage={ROWS_PER_PAGE}
              rowsPerPageOptions={[ROWS_PER_PAGE]}
              onPageChange={(_, page) => setFiapPage(page)}
            />
          </TableContainer>
        )}
      </Box>
    );
  };

  const sectionMap = {
    overview: renderOverview,
    calendar: () => (
      <CalendarPlanner
        token={token}
        currentUser={currentUser}
        msmes={allMsmes.length > 0 ? allMsmes : msmes}
        experts={experts}
        onViewMsme={(m) => { setViewItem(m); setViewType('msme'); }}
      />
    ),
    msmes: renderMSMEs,
    maps: renderMaps,
    experts: renderExperts,
    assignments: renderAssignments,
    users: renderUsers,
    bgegroups: renderBGEGroups,
    cohorts: renderCohorts,
    training: renderTraining,
    participation: renderParticipation,
    reports: renderReports,
    tbip: renderTbip,
    fiap: renderFiap,
    workorders: renderWorkOrders,
    bgeassignment: renderBgeAssignment,
    analytics: renderAnalytics,
    communications: renderCommunications,
    tshirts: renderTshirtReceipts,
  };


  // ── main render ────────────────────────────────────────────────────────────
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* mobile top bar */}
      <AppBar position="fixed" sx={{
        display: { md: 'none' }, bgcolor: BRAND.sidebarBg,
        zIndex: (t) => t.zIndex.drawer + 1,
        borderBottom: `2px solid ${BRAND.gopaGold}`,
      }}>
        <Toolbar variant="dense">
          <IconButton
            color="inherit" edge="start"
            onClick={() => setMobileOpen(true)}
            sx={{ mr: 1, p: 1.25, touchAction: 'manipulation' }}
            aria-label="Open navigation menu">
            <MenuIcon />
          </IconButton>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} noWrap>PRUDEV II</Typography>
            <Typography variant="caption" sx={{ display: 'block', color: 'rgba(255,255,255,0.7)', lineHeight: 1 }} noWrap>
              {orderedNav.find(item => item.key === section)?.label || 'Dashboard'}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      {/* sidebar — permanent on desktop, drawer on mobile */}
      <Box component="nav" sx={{ width: { md: DRAWER_WIDTH }, flexShrink: { md: 0 } }}>
        <Drawer variant="temporary" open={mobileOpen} onClose={() => setMobileOpen(false)}
          keepMounted disableScrollLock
          sx={{ display: { xs: 'block', md: 'none' }, '& .MuiDrawer-paper': { width: DRAWER_WIDTH, maxWidth: '86vw', height: '100dvh', boxSizing: 'border-box', border: 'none' } }}>
          {drawerContent}
        </Drawer>
        <Drawer variant="permanent"
          sx={{ display: { xs: 'none', md: 'block' }, '& .MuiDrawer-paper': { width: DRAWER_WIDTH, height: '100dvh', boxSizing: 'border-box', border: 'none' } }}>
          {drawerContent}
        </Drawer>
      </Box>

      {/* main content */}
      <Box component="main" sx={{
        flex: 1,
        width: { xs: '100%', md: `calc(100% - ${DRAWER_WIDTH}px)` },
        p: { xs: 1.5, sm: 2, md: 3 },
        mt: { xs: 7, md: 0 },
        overflow: 'auto',
        minWidth: 0,
        overflowX: 'hidden',
      }}>
        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 1 }} />}
        {sectionMap[section]?.()}
      </Box>

      {/* ── View dialog ──────────────────────────────────────────────────── */}
      <Dialog open={!!viewItem} onClose={() => { setViewItem(null); setMsmeDetailTab(0); setBgeTrReports([]); setBgeMrReports([]); }} maxWidth={viewItem && viewType === 'msme' && msmeDetailTab === 2 ? "md" : "sm"} fullWidth>
        <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider', pb: 0 }}>
          <Typography variant="subtitle1" fontWeight={700}>{viewItem?.business_name || viewItem?.name} — Details</Typography>
          {viewItem && viewType === 'msme' && (
            <Tabs value={msmeDetailTab} onChange={(_, v) => setMsmeDetailTab(v)}
              textColor="primary" indicatorColor="primary" sx={{ mt: 0.5 }}>
              <Tab label="Profile" sx={{ fontSize: 12 }} />
              <Tab label={`Growth History (${adminSnapshots.filter(s => s.msme === viewItem.id).length})`} sx={{ fontSize: 12 }} />
              <Tab label="Visit Schedule" sx={{ fontSize: 12 }} />
            </Tabs>
          )}
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {viewItem && viewType === 'expert' ? (
            /* ── BGE Expert view: show profile + assigned MSMEs ── */
            <Box>
              <Grid container spacing={1.5} sx={{ mb: 2 }}>
                {[
                  ['BGE Code', viewItem.bge_code],
                  ['Phone', viewItem.phone],
                  ['Email', viewItem.email],
                  ['Location', viewItem.location],
                  ['Status', viewItem.status],
                  ['Groups', (viewItem.group_names || []).join(', ') || '—'],
                ].map(([label, val]) => (
                  <Grid item xs={6} key={label}>
                    <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
                    <Typography variant="body2">{val || '—'}</Typography>
                  </Grid>
                ))}
              </Grid>

              <Divider sx={{ mb: 2 }} />

              {/* Signature preview + admin rotation controls */}
              {viewItem.signature_url && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Signature</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Box sx={{
                      border: '1px solid #e0e0e0', borderRadius: 1, p: 1,
                      // checkered pattern so transparency is visible
                      backgroundImage: 'linear-gradient(45deg,#ccc 25%,transparent 25%),linear-gradient(-45deg,#ccc 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#ccc 75%),linear-gradient(-45deg,transparent 75%,#ccc 75%)',
                      backgroundSize: '10px 10px',
                      backgroundPosition: '0 0,0 5px,5px -5px,-5px 0',
                      display: 'inline-flex',
                    }}>
                      <img
                        src={viewItem.signature_url}
                        alt="BGE signature"
                        style={{ maxHeight: 64, maxWidth: 200, objectFit: 'contain' }}
                      />
                    </Box>
                    {isStaff && (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Rotate 90° counter-clockwise (left)">
                          <span>
                            <Button
                              size="small" variant="outlined" disabled={rotatingSig}
                              startIcon={rotatingSig ? <CircularProgress size={14}/> : <RotateLeft fontSize="small"/>}
                              onClick={() => rotateBgeSignature(viewItem.id, 'ccw')}
                            >CCW</Button>
                          </span>
                        </Tooltip>
                        <Tooltip title="Rotate 90° clockwise (right)">
                          <span>
                            <Button
                              size="small" variant="outlined" disabled={rotatingSig}
                              startIcon={rotatingSig ? <CircularProgress size={14}/> : <RotateRight fontSize="small"/>}
                              onClick={() => rotateBgeSignature(viewItem.id, 'cw')}
                            >CW</Button>
                          </span>
                        </Tooltip>
                        <Tooltip title="Remove background — flood-fills from corners to erase white, grey or coloured backgrounds">
                          <span>
                            <Button
                              size="small" variant="outlined" color="secondary" disabled={cleaningSig}
                              startIcon={cleaningSig ? <CircularProgress size={14}/> : <DrawOutlined fontSize="small"/>}
                              onClick={() => cleanBgeSignature(viewItem.id)}
                            >Clean BG</Button>
                          </span>
                        </Tooltip>
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
              {isStaff && !viewItem.signature_url && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="caption" color="text.disabled">No signature uploaded yet.</Typography>
                </Box>
              )}

              <Divider sx={{ mb: 2 }} />

              {(() => {
                const allMsmes = viewItem.assigned_msmes_list || [];
                const primary = allMsmes.filter(m => !m.is_co_assigned);
                const coAssigned = allMsmes.filter(m => m.is_co_assigned);
                return (
                  <>
                    <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb: 1.5 }}>
                      <Typography variant="subtitle2" fontWeight={700}>
                        Assigned MSMEs ({allMsmes.length})
                      </Typography>
                      {coAssigned.length > 0 && (
                        <Chip size="small" label={`${primary.length} primary · ${coAssigned.length} joint`}
                          sx={{ fontSize:11, height:20, bgcolor:'#EDE7F6', color:'#4527A0' }} />
                      )}
                    </Box>
                    {allMsmes.length === 0 ? (
                      <Typography variant="body2" color="text.secondary">No MSMEs assigned yet.</Typography>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {allMsmes.map((m, idx) => (
                          <Box key={m.id} sx={{
                            display: 'flex', alignItems: 'center', gap: 1.5,
                            p: 1.2, borderRadius: 1.5,
                            bgcolor: m.is_co_assigned ? '#F3E5F5' : (idx % 2 === 0 ? '#F8FAFC' : '#fff'),
                            border: `1px solid ${m.is_co_assigned ? '#CE93D8' : '#E8EDF2'}`,
                          }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 24, color: 'text.disabled', fontSize: 11 }}>
                              {idx + 1}.
                            </Typography>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Box sx={{ display:'flex', alignItems:'center', gap: 0.75 }}>
                                <Typography variant="body2" fontWeight={600} noWrap>{m.business_name}</Typography>
                                {m.is_co_assigned && (
                                  <Chip label="Joint" size="small"
                                    sx={{ fontSize:9, height:16, bgcolor:'#7B1FA2', color:'#fff' }} />
                                )}
                              </Box>
                              <Typography variant="caption" color="text.secondary">
                                {[m.msme_code, m.business_type, m.sector, m.city].filter(Boolean).join(' · ')}
                              </Typography>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </>
                );
              })()}

              {/* ── Training & Mentor Reports for this BGE ── */}
              {(bgeTrReports.length > 0 || bgeMrReports.length > 0) && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
                    Reports ({bgeTrReports.length} lead · {bgeMrReports.length} mentor)
                  </Typography>

                  {bgeTrReports.length > 0 && (
                    <Box sx={{ mb: bgeMrReports.length > 0 ? 2 : 0 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600}
                        sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 0.75 }}>
                        Lead Reports
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                        {bgeTrReports.map(r => (
                          <Box key={r.id} sx={{
                            display: 'flex', alignItems: 'center', gap: 1,
                            p: 1, borderRadius: 1, border: '1px solid #E8EDF2', bgcolor: '#F8FAFC',
                          }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography variant="body2" fontWeight={500} noWrap>{r.session_title}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {[r.session_date, r.session_location].filter(Boolean).join(' · ')}
                              </Typography>
                            </Box>
                            <Chip label={r.status} size="small"
                              color={r.status === 'submitted' ? 'primary' : 'default'}
                              sx={{ fontSize: 10, height: 18 }} />
                            <Tooltip title="Open PDF">
                              <IconButton size="small" onClick={() => openTrainingReportPdf('lead', r.id, 'view')}>
                                <PictureAsPdf fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Download PDF">
                              <IconButton size="small" onClick={() => openTrainingReportPdf('lead', r.id, 'download')}>
                                <Download fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}

                  {bgeMrReports.length > 0 && (
                    <Box>
                      <Typography variant="caption" color="text.secondary" fontWeight={600}
                        sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 0.75 }}>
                        Mentor Reports
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                        {bgeMrReports.map(r => (
                          <Box key={r.id} sx={{
                            display: 'flex', alignItems: 'center', gap: 1,
                            p: 1, borderRadius: 1, border: '1px solid #E8EDF2', bgcolor: '#F8FAFC',
                          }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography variant="body2" fontWeight={500} noWrap>{r.session_title}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {[r.session_date, r.session_location].filter(Boolean).join(' · ')}
                              </Typography>
                            </Box>
                            <Chip label={r.status} size="small"
                              color={r.status === 'submitted' ? 'primary' : 'default'}
                              sx={{ fontSize: 10, height: 18 }} />
                            <Tooltip title="Open PDF">
                              <IconButton size="small" onClick={() => openTrainingReportPdf('mentor', r.id, 'view')}>
                                <PictureAsPdf fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Download PDF">
                              <IconButton size="small" onClick={() => openTrainingReportPdf('mentor', r.id, 'download')}>
                                <Download fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </>
              )}
            </Box>
          ) : viewItem && viewType === 'msme' && msmeDetailTab === 0 ? (
            /* ── MSME Profile tab ── */
            <Grid container spacing={1.5}>
              {Object.entries(viewItem)
                .filter(([k]) => !['id','is_active','source_file','created_at','updated_at','latitude','longitude','assigned_msmes_list','group_names','programme_groups_detail','programme_groups'].includes(k))
                .map(([k, v]) => (
                  <Grid item xs={6} key={k}>
                    <Typography variant="caption" color="text.secondary" display="block">
                      {k.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                    </Typography>
                    <Typography variant="body2">{v !== null && v !== '' && v !== undefined ? String(v) : '—'}</Typography>
                  </Grid>
                ))}
            </Grid>
          ) : viewItem && viewType === 'msme' && msmeDetailTab === 1 ? (
            /* ── MSME Growth History tab ── */
            (() => {
              const snaps = adminSnapshots
                .filter(s => s.msme === viewItem.id)
                .sort((a, b) => new Date(b.snapshot_date) - new Date(a.snapshot_date));
              if (!snaps.length) return (
                <Box sx={{ py: 4, textAlign: 'center' }}>
                  <TrendingUp sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
                  <Typography color="text.secondary">No growth updates recorded yet.</Typography>
                </Box>
              );
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {snaps.map((s, idx) => (
                    <Card key={s.id} variant="outlined" sx={{ borderLeft: `3px solid ${idx === 0 ? '#2E7D32' : '#90A4AE'}` }}>
                      <CardContent sx={{ pb: '12px !important', pt: '12px !important' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="subtitle2" fontWeight={700}>{s.snapshot_date}</Typography>
                          {idx === 0 && <Chip label="Latest" size="small" color="success" />}
                        </Box>
                        <Grid container spacing={1}>
                          {[
                            ['FT Employees', s.employees_ft_male != null ? `${(s.employees_ft_male||0)+(s.employees_ft_female||0)} (M:${s.employees_ft_male||0}/F:${s.employees_ft_female||0})` : '—'],
                            ['PT Employees', s.employees_pt_male != null ? `${(s.employees_pt_male||0)+(s.employees_pt_female||0)} (M:${s.employees_pt_male||0}/F:${s.employees_pt_female||0})` : '—'],
                            ['Annual Turnover', s.annual_turnover ? `UGX ${Number(s.annual_turnover).toLocaleString()}` : '—'],
                            ['Last Month Revenue', s.last_month_revenue ? `UGX ${Number(s.last_month_revenue).toLocaleString()}` : '—'],
                            ['Has URSB', s.has_ursb ? `Yes${s.ursb_reg_number ? ` (${s.ursb_reg_number})` : ''}` : 'No'],
                            ['Has TIN', s.has_tin ? `Yes${s.tin_number ? ` (${s.tin_number})` : ''}` : 'No'],
                            ['Business Bank', s.has_business_bank ? `Yes${s.bank_name ? ` — ${s.bank_name}` : ''}` : 'No'],
                            ['Mobile Money', s.has_mobile_money ? 'Yes' : 'No'],
                            ['MOMO Pay', s.has_momo_pay ? `Yes${s.momo_pay_code ? ` (${s.momo_pay_code})` : ''}` : 'No'],
                            ['SACCO', s.has_sacco ? 'Yes' : 'No'],
                            ['Collected By', s.collected_by_name || '—'],
                          ].map(([label, val]) => (
                            <Grid item xs={6} key={label}>
                              <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
                              <Typography variant="body2">{val}</Typography>
                            </Grid>
                          ))}
                        </Grid>
                        {s.notes && (
                          <Box sx={{ mt: 1, p: 1, bgcolor: '#F8FAFC', borderRadius: 1 }}>
                            <Typography variant="caption" color="text.secondary">Notes</Typography>
                            <Typography variant="body2" sx={{ fontSize: 12 }}>{s.notes}</Typography>
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  ))}
                </Box>
              );
            })()
          ) : viewItem && viewType === 'msme' && msmeDetailTab === 2 ? (
            /* ── MSME Visit Schedule tab ── */
            <Box sx={{ p: 2 }}>
              <MSMEVisitSchedule
                token={token}
                msme={viewItem}
                currentUser={currentUser}
              />
            </Box>
          ) : null}
        </DialogContent>
        <DialogActions><Button onClick={() => { setViewItem(null); setMsmeDetailTab(0); }}>Close</Button></DialogActions>
      </Dialog>

      {/* ── Edit dialog ──────────────────────────────────────────────────── */}
      <Dialog open={!!editItem} onClose={closeEdit} maxWidth="sm" fullWidth>
        <DialogTitle>Edit {editType === 'msme' ? 'MSME' : 'Expert'}</DialogTitle>
        <DialogContent dividers>
          {editType === 'msme' && (
            <Grid container spacing={2}>
              {[['business_name','Business Name'],['owner_name','Owner Name'],['email','Email'],['phone','Phone'],['district','District'],['city','City / Town'],['address','Address / Location']].map(([f,l]) => (
                <Grid item xs={12} sm={f === 'address' ? 12 : 6} key={f}>
                  <TextField fullWidth size="small" label={l} value={editForm[f] || ''} onChange={e => setEditForm({...editForm, [f]: e.target.value})} />
                </Grid>
              ))}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small"><InputLabel>Type</InputLabel>
                  <Select value={editForm.business_type || ''} onChange={e => setEditForm({...editForm, business_type: e.target.value})} label="Type">
                    {['MICRO','SMALL','MEDIUM'].map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small"><InputLabel>Sector</InputLabel>
                  <Select value={editForm.sector || ''} onChange={e => setEditForm({...editForm, sector: e.target.value})} label="Sector">
                    {['MANUFACTURING','SERVICES','TRADE','AGRICULTURE','TECHNOLOGY','CONSTRUCTION','HEALTHCARE','EDUCATION','OTHER'].map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small"><InputLabel>Status</InputLabel>
                  <Select value={editForm.status || 'active'} onChange={e => setEditForm({...editForm, status: e.target.value})} label="Status">
                    {STATUS_OPTIONS.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.icon} {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {[['annual_revenue','Annual Revenue'],['investment_needed','Investment Needed'],['employee_count','Employees']].map(([f,l]) => (
                <Grid item xs={12} sm={4} key={f}>
                  <TextField fullWidth size="small" label={l} type="number" value={editForm[f] || ''} onChange={e => setEditForm({...editForm, [f]: e.target.value})} />
                </Grid>
              ))}

              {/* ── Alternative Contact ── */}
              <Grid item xs={12}>
                <Divider sx={{ my: 0.5 }} />
                <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                  Alternative / Secondary Contact
                </Typography>
              </Grid>
              {[['alt_contact_name','Alt Contact Name'],['alt_phone','Alt Phone'],['alt_contact_role','Alt Role (Manager, Spouse, etc.)'],['alt_email','Alt Email']].map(([f,l]) => (
                <Grid item xs={12} sm={6} key={f}>
                  <TextField fullWidth size="small" label={l} value={editForm[f] || ''} onChange={e => setEditForm({...editForm, [f]: e.target.value})} />
                </Grid>
              ))}

              <Grid item xs={12}>
                <TextField fullWidth size="small" multiline rows={2} label="Description" value={editForm.business_description || ''} onChange={e => setEditForm({...editForm, business_description: e.target.value})} />
              </Grid>

              {/* ── GPS Location ── */}
              <Grid item xs={12}>
                <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <MyLocation sx={{ fontSize: 14 }} /> GPS Business Location
                    </Typography>
                    <Button
                      size="small" variant="outlined" color="success"
                      startIcon={editForm._gpsLoading ? <CircularProgress size={12} /> : (editForm.latitude ? <GpsFixed sx={{ fontSize: 14 }} /> : <GpsNotFixed sx={{ fontSize: 14 }} />)}
                      disabled={!!editForm._gpsLoading}
                      onClick={() => {
                        if (!navigator.geolocation) {
                          notify('Geolocation is not supported by your browser', 'error');
                          return;
                        }
                        setEditForm(f => ({ ...f, _gpsLoading: true }));
                        navigator.geolocation.getCurrentPosition(
                          (pos) => setEditForm(f => ({
                            ...f,
                            latitude:  pos.coords.latitude.toFixed(6),
                            longitude: pos.coords.longitude.toFixed(6),
                            _gpsLoading: false,
                          })),
                          () => {
                            notify('Unable to retrieve device GPS location. Please ensure location permissions are granted.', 'error');
                            setEditForm(f => ({ ...f, _gpsLoading: false }));
                          },
                          { enableHighAccuracy: true, timeout: 15000 },
                        );
                      }}
                      sx={{ fontSize: 11, py: 0.25, textTransform: 'none', fontWeight: 600 }}
                    >
                      {editForm._gpsLoading ? 'Capturing GPS…' : editForm.latitude ? 'Recapture Live Location' : 'Capture Live Location'}
                    </Button>
                  </Box>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField fullWidth size="small" label="Latitude" type="number"
                        inputProps={{ step: 'any' }}
                        value={editForm.latitude || ''}
                        onChange={e => setEditForm(f => ({ ...f, latitude: e.target.value }))}
                        placeholder="e.g. 2.774950"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField fullWidth size="small" label="Longitude" type="number"
                        inputProps={{ step: 'any' }}
                        value={editForm.longitude || ''}
                        onChange={e => setEditForm(f => ({ ...f, longitude: e.target.value }))}
                        placeholder="e.g. 32.299110"
                      />
                    </Grid>
                  </Grid>
                  {editForm.latitude && editForm.longitude && (
                    <Typography variant="caption" color="success.main" sx={{ mt: 0.75, display: 'block' }}>
                      📍 {Number(editForm.latitude).toFixed(6)}, {Number(editForm.longitude).toFixed(6)}
                      {' · '}
                      <a href={`https://maps.google.com/?q=${editForm.latitude},${editForm.longitude}`}
                        target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                        View on map ↗
                      </a>
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
          {editType === 'expert' && (
            <Grid container spacing={2}>
              {[['name','Name'],['email','Email'],['phone','Phone'],['location','Base District / Location']].map(([f,l]) => (
                <Grid item xs={12} sm={6} key={f}>
                  <TextField fullWidth size="small" label={l} value={editForm[f] || ''} onChange={e => setEditForm({...editForm, [f]: e.target.value})} />
                </Grid>
              ))}
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" label="Years of Experience" type="number" value={editForm.years_of_experience || ''} onChange={e => setEditForm({...editForm, years_of_experience: e.target.value})} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small"><InputLabel>Status</InputLabel>
                  <Select value={editForm.status || 'active'} onChange={e => setEditForm({...editForm, status: e.target.value})} label="Status">
                    {STATUS_OPTIONS.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.icon} {opt.label}
                      </MenuItem>
                    ))}
                    <MenuItem value="approved">🟢 Approved (Legacy)</MenuItem>
                    <MenuItem value="pending">🟡 Pending (Legacy)</MenuItem>
                    <MenuItem value="rejected">🔴 Rejected (Legacy)</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {[['top_skills','Top Skills'],['second_area','Second Area'],['third_area','Third Area']].map(([f,l]) => (
                <Grid item xs={12} sm={4} key={f}>
                  <TextField fullWidth size="small" label={l} value={editForm[f] || ''} onChange={e => setEditForm({...editForm, [f]: e.target.value})} />
                </Grid>
              ))}

              {/* ── BGE GPS Location ── */}
              <Grid item xs={12}>
                <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <MyLocation sx={{ fontSize: 14 }} /> BGE Base GPS Location
                    </Typography>
                    <Button
                      size="small" variant="outlined" color="primary"
                      startIcon={editForm._gpsLoading ? <CircularProgress size={12} /> : (editForm.latitude ? <GpsFixed sx={{ fontSize: 14 }} /> : <GpsNotFixed sx={{ fontSize: 14 }} />)}
                      disabled={!!editForm._gpsLoading}
                      onClick={() => {
                        if (!navigator.geolocation) {
                          notify('Geolocation is not supported by your browser', 'error');
                          return;
                        }
                        setEditForm(f => ({ ...f, _gpsLoading: true }));
                        navigator.geolocation.getCurrentPosition(
                          (pos) => setEditForm(f => ({
                            ...f,
                            latitude:  pos.coords.latitude.toFixed(6),
                            longitude: pos.coords.longitude.toFixed(6),
                            _gpsLoading: false,
                          })),
                          () => {
                            notify('Unable to retrieve device GPS location. Please ensure location permissions are granted.', 'error');
                            setEditForm(f => ({ ...f, _gpsLoading: false }));
                          },
                          { enableHighAccuracy: true, timeout: 15000 },
                        );
                      }}
                      sx={{ fontSize: 11, py: 0.25, textTransform: 'none', fontWeight: 600 }}
                    >
                      {editForm._gpsLoading ? 'Capturing GPS…' : editForm.latitude ? 'Recapture BGE Location' : 'Capture BGE Location'}
                    </Button>
                  </Box>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField fullWidth size="small" label="Latitude" type="number"
                        inputProps={{ step: 'any' }}
                        value={editForm.latitude || ''}
                        onChange={e => setEditForm(f => ({ ...f, latitude: e.target.value }))}
                        placeholder="e.g. 2.774950"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField fullWidth size="small" label="Longitude" type="number"
                        inputProps={{ step: 'any' }}
                        value={editForm.longitude || ''}
                        onChange={e => setEditForm(f => ({ ...f, longitude: e.target.value }))}
                        placeholder="e.g. 32.299110"
                      />
                    </Grid>
                  </Grid>
                  {editForm.latitude && editForm.longitude && (
                    <Typography variant="caption" color="primary.main" sx={{ mt: 0.75, display: 'block' }}>
                      📍 {Number(editForm.latitude).toFixed(6)}, {Number(editForm.longitude).toFixed(6)}
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEdit}>Cancel</Button>
          <Button variant="contained" onClick={saveEdit} disabled={editLoading}>
            {editLoading ? <CircularProgress size={18} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete confirm ────────────────────────────────────────────────── */}
      <Dialog open={!!deleteItem} onClose={() => setDeleteItem(null)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Delete <strong>{deleteItem?.business_name || deleteItem?.name}</strong>? This cannot be undone.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteItem(null)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={confirmDelete} disabled={deleteLoading}>
            {deleteLoading ? <CircularProgress size={18} /> : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Import MSME List ─────────────────────────────────────────────── */}
      {/* ── Inactive MSMEs dialog ── */}
      <Dialog open={inactiveMsmes !== null} onClose={() => setInactiveMsmes(null)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Inactive MSMEs
          <Typography variant="caption" display="block" color="text.secondary">
            {inactiveMsmes?.length
              ? `${inactiveMsmes.length} MSME(s) currently marked inactive (hidden from all views)`
              : 'No inactive MSMEs found — all records are active.'}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          {inactiveMsmes?.length > 0 ? (
            <Box sx={{ maxHeight: 360, overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F3F6FA' }}>
                    {['#', 'Business Name', 'MSME Code', 'Owner', 'City'].map(h => (
                      <th key={h} style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, borderBottom: '1px solid #DDE4EE' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {inactiveMsmes.map((m, i) => (
                    <tr key={m.id} style={{ borderBottom: '1px solid #EEF1F5' }}>
                      <td style={{ padding: '5px 8px', color: '#888' }}>{i + 1}</td>
                      <td style={{ padding: '5px 8px', fontWeight: 500 }}>{m.business_name}</td>
                      <td style={{ padding: '5px 8px', fontFamily: 'monospace' }}>{m.msme_code || '—'}</td>
                      <td style={{ padding: '5px 8px' }}>{m.owner_name || '—'}</td>
                      <td style={{ padding: '5px 8px' }}>{m.city || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">Nothing to do.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInactiveMsmes(null)}>Close</Button>
          {inactiveMsmes?.length > 0 && (
            <Button variant="contained" color="success" disabled={reactivating}
              onClick={reactivateAll}>
              {reactivating ? 'Reactivating…' : `Reactivate All (${inactiveMsmes.length})`}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog open={msmeUploadDialog} onClose={() => setMsmeUploadDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Import MSME List
          <Typography variant="caption" display="block" color="text.secondary">
            Use the unified template — works for any cohort.
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Alert
            severity="info"
            sx={{ mb: 2 }}
            action={
              <Button size="small" variant="outlined" onClick={downloadMsmeTemplate}>
                Download template
              </Button>
            }
          >
            Required columns: <strong>Business Name, Owner Name, Sex, Phone, Email, District, Town</strong>.
            Optional: Business Email, Business Type, Physical Location, Role, Cohort.
            Legacy Cohort 1 / Cohort 2 files still upload — format is auto-detected.
          </Alert>

          {/* File picker */}
          <Box
            onClick={() => msmeFileRef.current?.click()}
            sx={{
              border: '2px dashed', borderColor: msmeUploadFile ? 'success.main' : 'divider',
              borderRadius: 2, p: 3, mb: 2, textAlign: 'center', cursor: 'pointer',
              bgcolor: msmeUploadFile ? 'success.50' : 'background.default',
              '&:hover': { borderColor: 'primary.main' },
            }}
          >
            <Upload sx={{ fontSize: 36, color: msmeUploadFile ? 'success.main' : 'text.secondary', mb: 1 }} />
            <Typography variant="body2" color={msmeUploadFile ? 'success.dark' : 'text.secondary'}>
              {msmeUploadFile ? `✓ ${msmeUploadFile.name}` : 'Click to select a CSV or Excel file'}
            </Typography>
            <input
              ref={msmeFileRef}
              type="file"
              accept=".csv,.xlsx,.xls"
              hidden
              onChange={e => setMsmeUploadFile(e.target.files[0] || null)}
            />
          </Box>

          {/* Cohort assignment */}
          <FormControl fullWidth size="small" sx={{ mb: msmeUploadCohort === '__new__' ? 1.5 : 0 }}>
            <InputLabel>Assign to Cohort (optional)</InputLabel>
            <Select
              value={msmeUploadCohort}
              label="Assign to Cohort (optional)"
              onChange={e => setMsmeUploadCohort(e.target.value)}
            >
              <MenuItem value=""><em>No cohort</em></MenuItem>
              {cohorts.map(c => (
                <MenuItem key={c.id} value={c.name}>{c.name}</MenuItem>
              ))}
              <MenuItem value="__new__">+ Create new cohort…</MenuItem>
            </Select>
          </FormControl>
          {msmeUploadCohort === '__new__' && (
            <TextField
              fullWidth size="small"
              label="New cohort name (e.g. Cohort 3)"
              value={msmeUploadNewCohort}
              onChange={e => setMsmeUploadNewCohort(e.target.value)}
              sx={{ mb: 2 }}
            />
          )}

          {/* Duplicate handling */}
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <Checkbox
              size="small"
              checked={msmeUploadSkipDups}
              onChange={e => setMsmeUploadSkipDups(e.target.checked)}
            />
            <Typography variant="body2" color="text.secondary">
              Skip duplicates (leave existing records unchanged)
            </Typography>
          </Box>

          {/* Result panel */}
          {msmeUploadResult && (
            <Alert severity={msmeUploadResult.skipped ? 'warning' : 'success'} sx={{ mt: 2 }}>
              <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                {msmeUploadResult.message}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
                <Chip size="small" color="success" label={`${msmeUploadResult.created || 0} created`} />
                <Chip size="small" color="info"    label={`${msmeUploadResult.updated || 0} updated`} />
                {msmeUploadResult.skipped > 0 && (
                  <Chip size="small" color="warning" label={`${msmeUploadResult.skipped} skipped`} />
                )}
                {msmeUploadResult.blank_rows > 0 && (
                  <Chip size="small" variant="outlined" label={`${msmeUploadResult.blank_rows} blank`} />
                )}
                <Chip size="small" variant="outlined" label={`${msmeUploadResult.total_rows || 0} total`} />
              </Box>
              {msmeUploadResult.errors?.length > 0 && (
                <Box sx={{ mt: 1.5, maxHeight: 160, overflow: 'auto', bgcolor: 'background.paper', p: 1, borderRadius: 1 }}>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                    Skipped rows:
                  </Typography>
                  {msmeUploadResult.errors.slice(0, 20).map((e, i) => (
                    <Typography key={i} variant="caption" display="block" sx={{ fontFamily: 'monospace' }}>
                      Row {e.row}: {e.error}
                    </Typography>
                  ))}
                  {msmeUploadResult.errors.length > 20 && (
                    <Typography variant="caption" color="text.secondary">
                      …and {msmeUploadResult.errors.length - 20} more
                    </Typography>
                  )}
                </Box>
              )}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMsmeUploadDialog(false)}>
            {msmeUploadResult ? 'Close' : 'Cancel'}
          </Button>
          {msmeUploadResult && (
            <Button onClick={() => { setMsmeUploadResult(null); setMsmeUploadFile(null); }}>
              Upload another
            </Button>
          )}
          <Button
            variant="contained"
            onClick={doMsmeUpload}
            disabled={msmeUploading || !msmeUploadFile || !!msmeUploadResult || (msmeUploadCohort === '__new__' && !msmeUploadNewCohort.trim())}
            startIcon={msmeUploading ? <CircularProgress size={16} /> : <Upload />}
          >
            {msmeUploading ? 'Uploading…' : 'Upload'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── BGE Upload ────────────────────────────────────────────────────── */}
      <Dialog open={bgeUploadDialog} onClose={() => setBgeUploadDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Import BGE Experts</DialogTitle>
        <DialogContent dividers>
          <Alert severity="info" sx={{ mb: 2 }} icon={false}>
            Required columns: <code>Full name</code>, <code>Phone number</code>, <code>Email address</code>, <code>Location</code>, <code>BGE code</code>.
          </Alert>

          <Box
            onClick={() => bgeFileRef.current?.click()}
            sx={{
              border: '2px dashed', borderColor: bgeUploadFile ? 'success.main' : 'divider',
              borderRadius: 2, p: 3, mb: 2, textAlign: 'center', cursor: 'pointer',
              bgcolor: bgeUploadFile ? 'success.50' : 'background.default',
              '&:hover': { borderColor: 'primary.main' },
            }}
          >
            <Upload sx={{ fontSize: 36, color: bgeUploadFile ? 'success.main' : 'text.secondary', mb: 1 }} />
            <Typography variant="body2" color={bgeUploadFile ? 'success.dark' : 'text.secondary'}>
              {bgeUploadFile ? `✓ ${bgeUploadFile.name}` : 'Click to select an Excel file (.xlsx or .xls)'}
            </Typography>
            <input
              ref={bgeFileRef}
              type="file"
              accept=".xlsx,.xls"
              hidden
              onChange={e => setBgeUploadFile(e.target.files[0] || null)}
            />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              size="small"
              checked={bgeUploadSkipDups}
              onChange={e => setBgeUploadSkipDups(e.target.checked)}
            />
            <Typography variant="body2" color="text.secondary">
              Skip duplicates (leave existing BGE records unchanged)
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBgeUploadDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={doBgeUpload}
            disabled={bgeUploading || !bgeUploadFile}
            startIcon={bgeUploading ? <CircularProgress size={16} /> : <Upload />}
          >
            {bgeUploading ? 'Uploading…' : 'Upload'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={bgeDialog} onClose={() => setBgeDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add BGE Expert</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Create a single BGE expert profile for the programme.
          </Typography>
          <TextField
            fullWidth size="small" label="Full name"
            value={bgeForm.name}
            onChange={e => setBgeForm(f => ({ ...f, name: e.target.value }))}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth size="small" label="Email address"
            value={bgeForm.email}
            onChange={e => setBgeForm(f => ({ ...f, email: e.target.value }))}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth size="small" label="Phone number"
            value={bgeForm.phone}
            onChange={e => setBgeForm(f => ({ ...f, phone: e.target.value }))}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth size="small" label="Location"
            value={bgeForm.location}
            onChange={e => setBgeForm(f => ({ ...f, location: e.target.value }))}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth size="small" label="BGE code"
            value={bgeForm.bge_code}
            onChange={e => setBgeForm(f => ({ ...f, bge_code: e.target.value }))}
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth size="small" sx={{ mb: 1 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={bgeForm.status}
              label="Status"
              onChange={e => setBgeForm(f => ({ ...f, status: e.target.value }))}
            >
              {STATUS_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.icon} {opt.label}
                </MenuItem>
              ))}
              <MenuItem value="approved">🟢 Approved (Legacy)</MenuItem>
              <MenuItem value="pending">🟡 Pending (Legacy)</MenuItem>
              <MenuItem value="rejected">🔴 Rejected (Legacy)</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBgeDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={createBge}
            disabled={bgeSaving}
            startIcon={bgeSaving ? <CircularProgress size={16} /> : <Add />}
          >
            {bgeSaving ? 'Saving…' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Create Cohort ─────────────────────────────────────────────────── */}
      <Dialog open={cohortDialog} onClose={() => setCohortDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>New Cohort</DialogTitle>
        <DialogContent dividers>
          <TextField fullWidth size="small" label="Name (e.g. Cohort 4)" sx={{ mb: 2 }} value={cohortForm.name} onChange={e => setCohortForm({...cohortForm, name: e.target.value})} />
          <TextField fullWidth size="small" multiline rows={2} label="Description" value={cohortForm.description} onChange={e => setCohortForm({...cohortForm, description: e.target.value})} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCohortDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={createCohort} disabled={cohortLoading || !cohortForm.name}>
            {cohortLoading ? <CircularProgress size={18} /> : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Create BGE Group ──────────────────────────────────────────────── */}
      <Dialog open={groupDialog} onClose={() => setGroupDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          New BGE Group
          <Typography variant="caption" display="block" color="text.secondary">
            Objectives flow into every MSME assigned to this group and appear in the BGE's report context.
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <TextField fullWidth size="small" label="Group Name" sx={{ mb: 2 }} value={groupForm.name} onChange={e => setGroupForm({...groupForm, name: e.target.value})} />
          <TextField fullWidth size="small" multiline rows={2} label="Description" sx={{ mb: 2 }} value={groupForm.description} onChange={e => setGroupForm({...groupForm, description: e.target.value})} />
          <TextField fullWidth size="small" multiline rows={4} label="Objectives" placeholder="What is this team's mission? e.g. Drive financial-literacy uptake among Lira & Gulu Cohort 1 MSMEs through 2 BGE-led sessions per quarter…"
            value={groupForm.objectives} onChange={e => setGroupForm({...groupForm, objectives: e.target.value})}
            helperText="Shown to the BGE inside their report context for each assigned MSME."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setGroupDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={createGroup} disabled={groupLoading || !groupForm.name}>
            {groupLoading ? <CircularProgress size={18} /> : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Manage group members ──────────────────────────────────────────── */}
      <AssignMsmesDialog
        assignMsmeGroup={assignMsmeGroup}
        setAssignMsmeGroup={setAssignMsmeGroup}
        msmes={allMsmes.length > 0 ? allMsmes : msmes}
        headers={headers}
        notify={notify}
        fetchAll={fetchAll}
      />

      <Dialog open={!!manageGroupItem} onClose={() => setManageGroupItem(null)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Manage Members — {manageGroupItem?.name}
          <Typography variant="caption" display="block" color="text.secondary">
            Tick a row to add/remove the BGE; click the star to designate them as team lead.
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <List dense>
            {experts.map(e => {
              const isMember = manageGroupItem?.members_detail?.some(m => m.id === e.id);
              const isLead = manageGroupItem?.team_lead === e.id;
              return (
                <ListItemButton key={e.id} onClick={() => toggleGroupMember(manageGroupItem.id, e.id, isMember)}>
                  <ListItemIcon>
                    <Checkbox checked={!!isMember} size="small" disableRipple />
                  </ListItemIcon>
                  <ListItemText
                    primary={e.name}
                    secondary={`${e.location || '—'} · ${e.top_skills || '—'}${isLead ? ' · Team Lead' : ''}`}
                  />
                  <Tooltip title={isLead ? 'Remove team-lead' : (isMember ? 'Make team lead' : 'Add as member first')}>
                    <span>
                      <IconButton
                        size="small"
                        disabled={!isMember}
                        onClick={(ev) => {
                          ev.stopPropagation();
                          setGroupTeamLead(manageGroupItem.id, isLead ? null : e.id);
                        }}
                        sx={{ mr: 1, color: isLead ? '#FFB300' : 'text.disabled' }}
                      >
                        {isLead ? <Star fontSize="small" /> : <StarBorder fontSize="small" />}
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Chip label={e.status} color={statusColor(e.status)} size="small" />
                </ListItemButton>
              );
            })}
            {experts.length === 0 && <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>No experts to add</Box>}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setManageGroupItem(null); fetchAll(); }}>Done</Button>
        </DialogActions>
      </Dialog>

      {/* ── Create Training Session ───────────────────────────────────────── */}
      {/* ── Session MSME notification dialog ─────────────────────────────── */}
      <Dialog open={sessionNotifyDialog} onClose={() => setSessionNotifyDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Notify MSMEs — {sessionNotifySession?.title}
          <Typography variant="caption" display="block" color="text.secondary">
            {(sessionNotifySession?.businesses_detail || []).length} recipient{(sessionNotifySession?.businesses_detail || []).length !== 1 ? 's' : ''}
            {' · '}{sessionNotifySession?.date}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>Sending to:</Typography>
            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
              {(sessionNotifySession?.businesses_detail || []).map(m => (
                <Chip key={m.id} label={m.business_name} size="small" color="info" variant="outlined" />
              ))}
            </Box>
          </Box>
          {sessionNotifyAlreadySent.length > 0 && (
            <Alert severity="warning" sx={{ mb: 1.5 }}
              action={
                <Button size="small" color="inherit" onClick={() => setSessionNotifySkip(s => !s)}>
                  {sessionNotifySkip ? 'Include all' : 'Skip already sent'}
                </Button>
              }>
              {sessionNotifyAlreadySent.length} MSME{sessionNotifyAlreadySent.length !== 1 ? 's' : ''} already received this notification.
              {sessionNotifySkip && ' They will be skipped.'}
            </Alert>
          )}
          <TextField label="Subject" value={sessionNotifySubject}
            onChange={e => setSessionNotifySubject(e.target.value)}
            fullWidth size="small" sx={{ mb: 1.5 }} />
          <TextField label="Message" value={sessionNotifyBody}
            onChange={e => setSessionNotifyBody(e.target.value)}
            fullWidth multiline minRows={10}
            helperText="{{name}} is replaced with the business owner's first name." />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSessionNotifyDialog(false)}>Cancel</Button>
          <Button variant="contained" startIcon={sessionNotifySending ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
            onClick={sendSessionNotify}
            disabled={sessionNotifySending || !sessionNotifySubject.trim() || !sessionNotifyBody.trim()}>
            Send to {(sessionNotifySession?.businesses_detail || []).length} MSME{(sessionNotifySession?.businesses_detail || []).length !== 1 ? 's' : ''}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={sessionDialog} onClose={() => { setSessionDialog(false); setSessionEditing(null); }} maxWidth="sm" fullWidth>
        <DialogTitle>{sessionEditing ? 'Edit Training Session' : 'New Training Session'}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField fullWidth size="small" required label="Title" value={sessionForm.title} onChange={e => setSessionForm({...sessionForm, title: e.target.value})} /></Grid>
            <Grid item xs={4}><TextField fullWidth size="small" required label="Start Date" type="date" InputLabelProps={{shrink:true}} value={sessionForm.date} onChange={e => setSessionForm({...sessionForm, date: e.target.value})} /></Grid>
            <Grid item xs={4}><TextField fullWidth size="small" label="End Date" type="date" InputLabelProps={{shrink:true}} helperText="Leave blank for single-day" value={sessionForm.end_date} onChange={e => setSessionForm({...sessionForm, end_date: e.target.value})} /></Grid>
            <Grid item xs={4}><TextField fullWidth size="small" label="Location" value={sessionForm.location} onChange={e => setSessionForm({...sessionForm, location: e.target.value})} /></Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="small"><InputLabel>Topic</InputLabel>
                <Select value={sessionForm.topic} onChange={e => setSessionForm({...sessionForm, topic: e.target.value})} label="Topic">
                  <MenuItem value="">None</MenuItem>
                  {(() => {
                    const grouped = trainingTopics.reduce((acc, t) => {
                      const key = t.module_number || 0;
                      if (!acc[key]) acc[key] = { label: t.module_name || 'Other', items: [] };
                      acc[key].items.push(t);
                      return acc;
                    }, {});
                    return Object.entries(grouped).map(([modNum, { label, items }]) => [
                      <ListSubheader key={`mod-${modNum}`} sx={{ fontWeight: 700, lineHeight: '2em', bgcolor: 'grey.100' }}>
                        {modNum > 0 ? `Module ${modNum}: ${label}` : label}
                      </ListSubheader>,
                      ...items.map(t => (
                        <MenuItem key={t.id} value={t.id} sx={{ pl: 3 }}>
                          {t.section_number ? `${t.section_number} – ` : ''}{t.name}
                        </MenuItem>
                      )),
                    ]);
                  })()}
                </Select>
              </FormControl>
            </Grid>
            {/* ── Team (facilitation assignments) ── */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2" fontWeight={600} color="text.secondary">Facilitation Team</Typography>
                <Box>
                  <Button size="small" startIcon={<Add />}
                    onClick={() => setSessionForm(f => ({ ...f, team: [...f.team, { _key: Math.random(), role: 'lead', bge_id: '', work_order_id: '' }] }))}>
                    Add Lead
                  </Button>
                  <Button size="small" startIcon={<Add />} color="secondary"
                    onClick={() => setSessionForm(f => ({ ...f, team: [...f.team, { _key: Math.random(), role: 'mentor', bge_id: '', work_order_id: '' }] }))}>
                    Add Mentor
                  </Button>
                </Box>
              </Box>
              {sessionForm.team.length === 0 && (
                <Typography variant="caption" color="text.disabled">No team members added yet.</Typography>
              )}
              {sessionForm.team.map((member, idx) => (
                <Box key={member._key} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}>
                  <Chip
                    label={member.role === 'lead' ? 'Lead' : 'Mentor'}
                    size="small"
                    color={member.role === 'lead' ? 'primary' : 'secondary'}
                    sx={{ minWidth: 62, flexShrink: 0 }}
                  />
                  <FormControl size="small" sx={{ flex: 2 }}>
                    <InputLabel>BGE</InputLabel>
                    <Select value={member.bge_id} label="BGE"
                      onChange={e => setSessionForm(f => ({ ...f, team: f.team.map((m, i) => i === idx ? { ...m, bge_id: e.target.value } : m) }))}>
                      <MenuItem value="">— Select —</MenuItem>
                      {experts.map(ex => <MenuItem key={ex.id} value={ex.id}>{ex.name}{ex.bge_code ? ` (${ex.bge_code})` : ''}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <FormControl size="small" sx={{ flex: 2 }}>
                    <InputLabel>Work Order</InputLabel>
                    <Select value={member.work_order_id} label="Work Order"
                      onChange={e => setSessionForm(f => ({ ...f, team: f.team.map((m, i) => i === idx ? { ...m, work_order_id: e.target.value } : m) }))}>
                      <MenuItem value="">— None —</MenuItem>
                      {workOrders.map(wo => <MenuItem key={wo.id} value={wo.id}>{wo.work_order_number} · {wo.bge_name}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <IconButton size="small" color="error"
                    onClick={() => setSessionForm(f => ({ ...f, team: f.team.filter((_, i) => i !== idx) }))}>
                    <Delete fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.75 }}>
                <Typography variant="body2" fontWeight={600} color="text.secondary">
                  Attendee MSMEs ({sessionForm.businesses.length} selected)
                </Typography>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<ViewList />}
                  onClick={() => setSessionMsmeListOpen(true)}
                  sx={{ textTransform: 'none', py: 0.25, fontSize: 12, fontWeight: 600 }}
                >
                  + Select from List / Groups
                </Button>
              </Box>
              <Autocomplete
                multiple
                size="small"
                options={allMsmes.length > 0 ? allMsmes : msmes}
                getOptionLabel={(m) => `${m.business_name || ''} ${m.owner_name ? `· ${m.owner_name}` : ''} ${m.msme_code ? `(${m.msme_code})` : ''}`}
                value={(allMsmes.length > 0 ? allMsmes : msmes).filter(m => sessionForm.businesses.includes(m.id))}
                onChange={(_, selectedOptions) => {
                  setSessionForm(f => ({ ...f, businesses: selectedOptions.map(m => m.id) }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options, state) => {
                  const q = state.inputValue.toLowerCase().trim();
                  if (!q) return options.slice(0, 50);
                  return options.filter(m =>
                    (m.business_name || '').toLowerCase().includes(q) ||
                    (m.owner_name || '').toLowerCase().includes(q) ||
                    (m.msme_code || '').toLowerCase().includes(q) ||
                    (m.district || m.city || '').toLowerCase().includes(q) ||
                    (m.sector || '').toLowerCase().includes(q)
                  ).slice(0, 50);
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={option.business_name}
                      size="small"
                      {...getTagProps({ index })}
                      sx={{ mr: 0.5, mb: 0.5, fontSize: 11 }}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={sessionForm.businesses.length === 0 ? "Search or select MSMEs…" : "Add more MSMEs…"}
                    label="Attendee MSMEs"
                    helperText={sessionForm.businesses.length > 0 ? `${sessionForm.businesses.length} MSME${sessionForm.businesses.length !== 1 ? 's' : ''} selected` : 'Search by name, owner, code, or click "+ Select from List / Groups"'}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.75 }}>
                <Typography variant="body2" fontWeight={600} color="text.secondary">
                  BGE Participants ({sessionForm.bge_participants.length} selected)
                </Typography>
              </Box>
              <Autocomplete
                multiple
                size="small"
                options={experts}
                getOptionLabel={(ex) => `${ex.name || ''}${ex.bge_code ? ` (${ex.bge_code})` : ''}`}
                value={experts.filter(ex => sessionForm.bge_participants.includes(ex.id))}
                onChange={(_, selectedOptions) => {
                  setSessionForm(f => ({ ...f, bge_participants: selectedOptions.map(ex => ex.id) }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options, state) => {
                  const q = state.inputValue.toLowerCase().trim();
                  if (!q) return options;
                  return options.filter(ex =>
                    (ex.name || '').toLowerCase().includes(q) ||
                    (ex.bge_code || '').toLowerCase().includes(q) ||
                    (ex.email || '').toLowerCase().includes(q) ||
                    (ex.district || '').toLowerCase().includes(q)
                  );
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={`${option.name}${option.bge_code ? ` (${option.bge_code})` : ''}`}
                      size="small"
                      {...getTagProps({ index })}
                      sx={{ mr: 0.5, mb: 0.5, fontSize: 11 }}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={sessionForm.bge_participants.length === 0 ? "Search or select BGE participants…" : "Add more BGEs…"}
                    label="BGE Participants"
                    helperText={sessionForm.bge_participants.length > 0 ? `${sessionForm.bge_participants.length} BGE${sessionForm.bge_participants.length !== 1 ? 's' : ''} selected` : 'Select BGE experts attending as participants'}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}><TextField fullWidth size="small" multiline rows={2} label="Description" value={sessionForm.description} onChange={e => setSessionForm({...sessionForm, description: e.target.value})} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setSessionDialog(false); setSessionEditing(null); }}>Cancel</Button>
          <Button variant="contained" onClick={createSession} disabled={sessionLoading || !sessionForm.title || !sessionForm.date}>
            {sessionLoading ? <CircularProgress size={18} /> : sessionEditing ? 'Save Changes' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Select MSMEs from List Dialog ─────────────────────────────────── */}
      <SelectSessionMsmesDialog
        open={sessionMsmeListOpen}
        onClose={() => setSessionMsmeListOpen(false)}
        selectedMsmeIds={sessionForm.businesses}
        onApply={(newIds) => setSessionForm(f => ({ ...f, businesses: newIds }))}
        msmes={allMsmes.length > 0 ? allMsmes : msmes}
        cohorts={cohorts}
        bgeGroups={bgeGroups}
        programmeGroups={programmeGroups}
      />

      {/* ── Attendance (per-person demographic sheet) ─────────────────────── */}
      <Dialog open={attendanceDialog} onClose={() => setAttendanceDialog(false)} maxWidth="xl" fullWidth>
        <DialogTitle sx={{ pb: 1 }}>
          Attendance Sheet — {selectedSession?.title}
          <Typography variant="caption" display="block" color="text.secondary">
            {selectedSession?.date}{selectedSession?.end_date && selectedSession.end_date !== selectedSession.date ? ` – ${selectedSession.end_date}` : ''} · {selectedSession?.location}
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          {attendanceLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>
          ) : (
            <Box>
              {/* Day tabs for multi-day sessions */}
              {activeDays.length > 1 && (
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, pt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {activeDays.map((day, i) => (
                    <Box
                      key={day}
                      onClick={() => setAttendanceDay(day)}
                      sx={{
                        px: 2, py: 0.75, borderRadius: '4px 4px 0 0', cursor: 'pointer', fontSize: 13, fontWeight: 600,
                        borderBottom: attendanceDay === day ? `3px solid ${BRAND.primaryMain}` : '3px solid transparent',
                        color: attendanceDay === day ? BRAND.primaryMain : 'text.secondary',
                        bgcolor: attendanceDay === day ? '#F5F5F4' : 'transparent',
                        '&:hover': { bgcolor: '#F5F5F4' },
                      }}
                    >
                      Day {i + 1} — {new Date(day + 'T00:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })}
                      <Typography component="span" variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                        ({sessionAttendees.filter(a => a.attendance_date === day).length})
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
              {/* Per-person rows */}
              <Table size="small" stickyHeader>
                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell sx={{ minWidth: 30 }}>#</TableCell>
                    <TableCell sx={{ minWidth: 160 }}>Name</TableCell>
                    <TableCell sx={{ minWidth: 120 }}>Phone</TableCell>
                    <TableCell sx={{ minWidth: 180 }}>MSME / Business</TableCell>
                    <TableCell sx={{ minWidth: 60 }}>Sex</TableCell>
                    <TableCell sx={{ minWidth: 90 }}>Age Group</TableCell>
                    <TableCell sx={{ minWidth: 90 }}>Status</TableCell>
                    <TableCell sx={{ minWidth: 80 }} align="center">Consent</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dayAttendees.map((att, idx) => (
                    <AttendeeRow key={att._key} att={att} idx={idx} msmes={allMsmes.length > 0 ? allMsmes : msmes}
                      bgeParticipants={experts}
                      updateAttendee={updateAttendee} removeAttendeeRow={removeAttendeeRow} />
                  ))}
                </TableBody>
              </Table>

              {/* Summary table — mirrors the PRUDEV II attendance sheet footer */}
              {dayAttendees.length > 0 && (() => {
                const present = dayAttendees;
                const male   = present.filter(a => a.gender === 'M');
                const female = present.filter(a => a.gender === 'F');
                const youth  = present.filter(a => a.age_group === '18-34');
                const adult  = present.filter(a => ['35-45','46-55','56+'].includes(a.age_group));
                const ref    = present.filter(a => a.refugee_status === 'R');
                const host   = present.filter(a => a.refugee_status === 'H');
                return (
                  <Box sx={{ m: 2, p: 2, bgcolor: '#FAF9F6', border: '1px solid #E7E5E4', borderRadius: 1 }}>
                    <Typography variant="subtitle2" fontWeight={700} gutterBottom>Summary</Typography>
                    <Grid container spacing={1}>
                      {[
                        { label: 'Total', value: present.length, color: BRAND.primaryMain },
                        { label: 'Female', value: female.length, color: '#AD1457' },
                        { label: 'Male', value: male.length, color: BRAND.primaryMain },
                        { label: 'Female Youth', value: youth.filter(a => a.gender === 'F').length, color: '#AD1457' },
                        { label: 'Male Youth', value: youth.filter(a => a.gender === 'M').length, color: BRAND.primaryMain },
                        { label: 'Adult Female', value: adult.filter(a => a.gender === 'F').length, color: '#AD1457' },
                        { label: 'Adult Male', value: adult.filter(a => a.gender === 'M').length, color: BRAND.primaryMain },
                        { label: 'Refugees', value: ref.length, color: '#E65100' },
                        { label: 'Female Refugee', value: ref.filter(a => a.gender === 'F').length, color: '#E65100' },
                        { label: 'Male Refugee', value: ref.filter(a => a.gender === 'M').length, color: '#E65100' },
                        { label: 'Host Community', value: host.length, color: '#2E7D32' },
                      ].map(({ label, value, color }) => (
                        <Grid item xs={6} sm={4} md={3} lg={2} key={label}>
                          <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#fff', borderRadius: 1, border: `1px solid ${color}20` }}>
                            <Typography variant="h6" fontWeight={700} sx={{ color }}>{value}</Typography>
                            <Typography variant="caption" color="text.secondary">{label}</Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                );
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button size="small" startIcon={<Add />} onClick={addAttendeeRow} sx={{ mr: 'auto' }}>
            Add row
          </Button>
          <Button onClick={() => setAttendanceDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveAttendance} disabled={attendanceLoading}>
            {attendanceLoading ? <CircularProgress size={18} /> : 'Save Attendance'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Create User Account ───────────────────────────────────────────── */}
      <Dialog open={userDialog} onClose={() => setUserDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Create Login Account</DialogTitle>
        <DialogContent dividers>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Account Type</InputLabel>
            <Select value={userForm.role} label="Account Type"
              onChange={e => setUserForm(f => ({ ...f, role: e.target.value, bge_id: '', group_ids: [] }))}>
              <MenuItem value="bge">BGE Expert — sees only their assigned MSMEs</MenuItem>
              <MenuItem value="cohort_admin">Programme Manager — manages specific groups</MenuItem>
              <MenuItem value="viewer">Viewer — read-only access to all data</MenuItem>
            </Select>
          </FormControl>

          {userForm.role === 'bge' && (
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel>Link to BGE Expert Profile</InputLabel>
              <Select value={userForm.bge_id} label="Link to BGE Expert Profile"
                onChange={e => handleUserBgeSelect(e.target.value)}>
                <MenuItem value="">— Not linked yet —</MenuItem>
                {experts.filter(e => !bgeUsers.some(u => u.bge_profile?.id === e.id)).map(e => (
                  <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {userForm.role === 'cohort_admin' && (
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel>Managed Programme Groups</InputLabel>
              <Select multiple value={userForm.group_ids} label="Managed Programme Groups"
                onChange={e => setUserForm(f => ({ ...f, group_ids: e.target.value }))}>
                {programmeGroups.map(g => (
                  <MenuItem key={g.id} value={g.id}>{g.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <TextField fullWidth size="small" label="Username" sx={{ mb: 2 }}
            value={userForm.username} onChange={e => setUserForm(f => ({ ...f, username: e.target.value }))} />
          <TextField fullWidth size="small" label="Password" type="password" sx={{ mb: 2 }}
            value={userForm.password} onChange={e => setUserForm(f => ({ ...f, password: e.target.value }))} />
          <TextField fullWidth size="small" label="Email (optional)"
            value={userForm.email} onChange={e => setUserForm(f => ({ ...f, email: e.target.value }))} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUserDialog(false)}>Cancel</Button>
          <Button variant="contained" startIcon={<PersonAdd />} onClick={createBGEUser}
            disabled={userLoading || !userForm.username || !userForm.password ||
              (userForm.role === 'cohort_admin' && userForm.group_ids.length === 0)}>
            {userLoading ? <CircularProgress size={18} /> : 'Create Account'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Reset Password ─────────────────────────────────────────────────── */}
      <Dialog open={pwdDialog} onClose={() => { setPwdDialog(false); setNewPwd(''); }} maxWidth="xs" fullWidth>
        <DialogTitle>Reset Password — {pwdUser?.username}</DialogTitle>
        <DialogContent dividers>
          <TextField fullWidth size="small" label="New Password" type="password"
            value={newPwd} onChange={e => setNewPwd(e.target.value)}
            helperText="Minimum 6 characters" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setPwdDialog(false); setNewPwd(''); }}>Cancel</Button>
          <Button variant="contained" startIcon={<LockReset />}
            onClick={resetPassword}
            disabled={pwdLoading || newPwd.length < 6}>
            {pwdLoading ? <CircularProgress size={18} /> : 'Reset Password'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Bulk Reset All BGE Passwords ───────────────────────────────────── */}
      <Dialog open={bulkPwdDialog} onClose={() => setBulkPwdDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Reset All BGE Passwords</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            This will set the password for all Business Growth Experts (BGEs) to the temporary password below, clearing any forced-change locks.
          </Typography>
          <TextField
            fullWidth size="small" label="New Password (min 8 chars)"
            value={bulkPwdValue} onChange={e => setBulkPwdValue(e.target.value)}
            sx={{ mb: 2 }}
          />
          <FormControlLabel
            control={<Checkbox checked={bulkPwdSendEmail} onChange={e => setBulkPwdSendEmail(e.target.checked)} size="small" />}
            label={<Typography variant="body2">Send email notification with login credentials</Typography>}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkPwdDialog(false)}>Cancel</Button>
          <Button variant="contained" color="warning" onClick={handleBulkResetPasswords} disabled={bulkPwdLoading}>
            {bulkPwdLoading ? <CircularProgress size={18} /> : 'Reset All Passwords'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Set Role ──────────────────────────────────────────────────────── */}
      <Dialog open={roleDialog} onClose={() => setRoleDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          Change Role
          <Typography variant="caption" display="block" color="text.secondary">{roleUser?.username}</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Role</InputLabel>
            <Select value={roleForm.role} label="Role"
              onChange={e => setRoleForm(f => ({ ...f, role: e.target.value, group_ids: [] }))}>
              <MenuItem value="bge">BGE Expert — sees only their assigned MSMEs</MenuItem>
              <MenuItem value="cohort_admin">Programme Manager — sees all MSMEs in assigned groups</MenuItem>
              <MenuItem value="viewer">Viewer — read-only access to all data</MenuItem>
            </Select>
          </FormControl>

          {roleForm.role === 'bge' && (
            <FormControl fullWidth size="small" sx={{ mb: 1 }}>
              <InputLabel>Link to BGE Expert Profile</InputLabel>
              <Select value={roleForm.bge_id || ''} label="Link to BGE Expert Profile"
                onChange={e => setRoleForm(f => ({ ...f, bge_id: e.target.value }))}>
                <MenuItem value="">— Not linked —</MenuItem>
                {experts
                  .filter(e => !bgeUsers.some(u => u.bge_profile?.id === e.id && u.id !== roleUser?.id))
                  .map(e => <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>)}
              </Select>
            </FormControl>
          )}

          {roleForm.role === 'cohort_admin' && (
            <FormControl fullWidth size="small">
              <InputLabel>Programme Groups</InputLabel>
              <Select multiple value={roleForm.group_ids} label="Programme Groups"
                onChange={e => setRoleForm(f => ({ ...f, group_ids: e.target.value }))}>
                {programmeGroups.map(g => (
                  <MenuItem key={g.id} value={g.id}>{g.name}</MenuItem>
                ))}
              </Select>
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                Select all groups this person should see MSMEs from.
              </Typography>
            </FormControl>
          )}

          {roleForm.role === 'viewer' && (
            <Typography variant="body2" color="text.secondary">
              Viewers can see all MSMEs, reports and analytics but cannot create or edit anything.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRoleDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveRole} disabled={userLoading ||
            (roleForm.role === 'cohort_admin' && roleForm.group_ids.length === 0)}>
            {userLoading ? <CircularProgress size={18} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Email Preview (editable) ──────────────────────────────────────── */}
      <Dialog open={!!emailPreview} onClose={() => setEmailPreview(null)} maxWidth="md" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider', pb: 1 }}>
          <Typography variant="h6" fontWeight={700}>Email Preview — {emailPreview?.bge?.name}</Typography>
          <Typography variant="caption" color="text.secondary">
            Edit the subject or body before sending. Changes only affect this send.
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>TO</Typography>
            <Typography variant="body2" fontWeight={600}>{emailPreview?.to}</Typography>
          </Box>
          <TextField
            label="Subject"
            size="small"
            fullWidth
            value={emailEditSubject}
            onChange={e => setEmailEditSubject(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Message Body"
            multiline
            minRows={12}
            fullWidth
            value={emailEditBody}
            onChange={e => setEmailEditBody(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ style: { fontFamily: 'monospace', fontSize: 13, lineHeight: 1.7 } }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setEmailPreview(null)}>Cancel</Button>
          <Button
            variant="contained"
            startIcon={emailSending ? <CircularProgress size={16} color="inherit" /> : <Email />}
            disabled={emailSending || !emailEditSubject || !emailEditBody}
            onClick={confirmSendEmail}
          >
            {emailSending ? 'Sending…' : 'Send Email'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Assign BGE + Objectives ────────────────────────────────────────── */}
      <Dialog open={assignDialog} onClose={() => setAssignDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {assignForm.bge_id ? 'Edit Assignment' : 'Assign BGE Expert'}
        </DialogTitle>
        <DialogContent dividers>
          {assignTarget && (
            <Alert severity="info" icon={false} sx={{ mb: 2 }}>
              <strong>{assignTarget.business_name}</strong>{' '}
              <Typography component="span" variant="caption" color="text.secondary">({assignTarget.msme_code})</Typography>
            </Alert>
          )}
          {assignTarget && assignTarget.status && assignTarget.status !== 'active' && (
            <Alert severity="warning" icon={<Warning fontSize="small" />} sx={{ mb: 2 }}>
              <Typography variant="caption" fontWeight={700} display="block">
                ⚠️ Inactive MSME Warning ({getStatusInfo(assignTarget.status).label})
              </Typography>
              <Typography variant="caption">
                This business is currently marked as <strong>{getStatusInfo(assignTarget.status).label}</strong>. Deploying a BGE to a closed or unavailable MSME will require explicit confirmation.
              </Typography>
            </Alert>
          )}
          {assignTarget && (
            <Accordion defaultExpanded={false} variant="outlined" sx={{ mb: 2 }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="body2" fontWeight={600}>MSME Background &amp; Challenges</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 1 }}>
                {!assignTarget.business_description && !assignTarget.challenges && !assignTarget.opportunities ? (
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    No diagnostic data recorded for this MSME yet.
                  </Typography>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    {assignTarget.business_description && (
                      <Box>
                        <Typography variant="caption" color="text.secondary" display="block">Business Description</Typography>
                        <Typography variant="body2">{assignTarget.business_description}</Typography>
                      </Box>
                    )}
                    {assignTarget.challenges && (
                      <Box>
                        <Typography variant="caption" color="text.secondary" display="block">Key Challenges</Typography>
                        <Typography variant="body2">{assignTarget.challenges}</Typography>
                      </Box>
                    )}
                    {assignTarget.opportunities && (
                      <Box>
                        <Typography variant="caption" color="text.secondary" display="block">Opportunities</Typography>
                        <Typography variant="body2">{assignTarget.opportunities}</Typography>
                      </Box>
                    )}
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                      {assignTarget.sector && <Chip label={assignTarget.sector} size="small" variant="outlined" />}
                      {assignTarget.business_type && <Chip label={assignTarget.business_type} size="small" variant="outlined" color="primary" />}
                      {assignTarget.city && <Chip label={assignTarget.city} size="small" variant="outlined" icon={<LocationOn sx={{ fontSize: 14 }} />} />}
                    </Box>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          )}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Primary BGE Expert (Persistent)</InputLabel>
            <Select
              value={assignForm.bge_id}
              label="Primary BGE Expert (Persistent)"
              onChange={e => setAssignForm({ ...assignForm, bge_id: e.target.value })}
            >
              <MenuItem value=""><em>None (unassigned)</em></MenuItem>
              {experts.map(e => {
                const eStatus = getStatusInfo(e.status);
                const isInactiveBge = e.status && e.status !== 'active' && e.status !== 'approved';
                return (
                  <MenuItem key={e.id} value={e.id}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1 }}>
                      <span>{e.name}{e.bge_code ? ` · ${e.bge_code}` : ''}</span>
                      {isInactiveBge && (
                        <Chip
                          label={eStatus.label}
                          size="small"
                          sx={{ height: 18, fontSize: 9, bgcolor: eStatus.bgcolor, color: eStatus.textColor, border: `1px solid ${eStatus.border}` }}
                        />
                      )}
                    </Box>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          {/* Co-assigned BGEs — shown once a primary is assigned */}
          {assignTarget?.assigned_bge && (
            <Box sx={{ mb: 2, p: 1.5, border: '1px solid', borderColor: '#CE93D8', bgcolor: '#FDFBFE', borderRadius: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="caption" sx={{ color: '#7B1FA2', fontWeight: 700, letterSpacing: 0.5 }}>
                  CO-ASSIGNED BGEs (JOINT DEPLOYMENT)
                </Typography>
                <Chip label="Primary BGE Protected" size="small" color="success" variant="outlined" sx={{ height: 18, fontSize: 9 }} />
              </Box>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5, fontSize: 11 }}>
                Joint deployment team supporting this MSME. Adding or removing co-assigned BGEs will never modify or remove the Primary BGE.
              </Typography>

              {(assignTarget.co_assigned_bge_names || []).length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', fontSize: 12, mb: 1.5, p: 1, bgcolor: '#fff', borderRadius: 1, border: '1px dashed #E0E0E0' }}>
                  No co-assigned BGEs yet — select a BGE below to jointly assign them
                </Typography>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1.5 }}>
                  {(assignTarget.co_assigned_bge_names || []).map(b => (
                    <Box key={b.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#fff', border: '1px solid #E1BEE7', borderRadius: 1, p: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ width: 24, height: 24, bgcolor: '#7B1FA2', fontSize: 11, fontWeight: 700 }}>
                          {b.name ? b.name[0] : 'B'}
                        </Avatar>
                        <Box>
                          <Typography variant="body2" fontWeight={600} sx={{ color: '#4A148C', lineHeight: 1.2 }}>
                            {b.name}
                          </Typography>
                          {b.bge_code && (
                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                              {b.bge_code}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Button
                        size="small"
                        color="error"
                        variant="outlined"
                        disabled={removingCoId === b.id}
                        onClick={() => removeCoAssignee(b.id)}
                        startIcon={removingCoId === b.id ? <CircularProgress size={12} color="inherit" /> : null}
                        sx={{ minWidth: 0, px: 1.2, py: 0.2, fontSize: 11, textTransform: 'none' }}
                      >
                        {removingCoId === b.id ? 'Removing…' : 'Remove Co-Assignee'}
                      </Button>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Add co-assignee row */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Add co-assignee</InputLabel>
                  <Select
                    value={coAssignAdd}
                    label="Add co-assignee"
                    onChange={e => setCoAssignAdd(e.target.value)}
                  >
                    <MenuItem value=""><em>Select BGE to co-assign...</em></MenuItem>
                    {experts
                      .filter(e =>
                        e.id !== parseInt(assignForm.bge_id) &&
                        e.id !== assignTarget.assigned_bge &&
                        !(assignTarget.co_assigned_bge_names || []).some(b => b.id === e.id)
                      )
                      .map(e => (
                        <MenuItem key={e.id} value={e.id}>{e.name}{e.bge_code ? ` · ${e.bge_code}` : ''}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  disabled={!coAssignAdd || coAssignSaving}
                  onClick={() => addCoAssignee(coAssignAdd)}
                  startIcon={coAssignSaving ? <CircularProgress size={14} color="inherit" /> : null}
                  sx={{ alignSelf: 'flex-end', textTransform: 'none', bgcolor: '#7B1FA2', '&:hover': { bgcolor: '#6A1B9A' } }}
                >
                  {coAssignSaving ? 'Adding…' : '+ Add Co-Assignee'}
                </Button>
              </Box>
            </Box>
          )}

          <TextField
            fullWidth size="small" label="Assignment Date" type="date"
            value={assignForm.assignment_date}
            onChange={e => setAssignForm({ ...assignForm, assignment_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth size="small" multiline rows={4}
            label="Deployment Objectives"
            placeholder="Describe the objectives and scope of this BGE's deployment for this MSME — e.g. areas of business development support, expected outcomes, milestones…"
            value={assignForm.objectives}
            onChange={e => setAssignForm({ ...assignForm, objectives: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          {assignForm.bge_id && (
            <Button color="error" sx={{ mr: 'auto' }} onClick={async () => {
              await axios.patch(`${API_ENDPOINTS.MSMES}${assignTarget.id}/assign_bge/`, { bge_id: null }, { headers });
              notify('All BGE assignments removed'); setAssignDialog(false); fetchAll();
            }}>
              Remove All
            </Button>
          )}
          <Button onClick={() => setAssignDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={assignSaving}
            startIcon={assignSaving ? <CircularProgress size={16} color="inherit" /> : null}
            onClick={() => saveAssignment(false)}
          >
            {assignSaving ? 'Saving…' : 'Save Assignment'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Inactive MSME Assignment Confirmation Dialog ── */}
      <Dialog
        open={inactiveConfirmDialog}
        onClose={() => setInactiveConfirmDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'warning.dark' }}>
          <Warning color="warning" /> Inactive MSME Assignment Warning
        </DialogTitle>
        <DialogContent dividers>
          {inactiveConfirmData && (
            <Box>
              <Alert severity="warning" sx={{ mb: 2 }}>
                <Typography variant="subtitle2" fontWeight={700}>
                  {inactiveConfirmData.msme?.business_name} is currently {getStatusInfo(inactiveConfirmData.msme?.status).label}.
                </Typography>
              </Alert>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                Assigning a Business Growth Expert to a closed or unavailable MSME may lead to unfulfilled visits and inaccurate workload metrics.
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                Are you sure you want to proceed with this assignment?
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInactiveConfirmDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="warning"
            disabled={assignSaving || coAssignSaving}
            onClick={() => {
              if (inactiveConfirmData?.actionType === 'co_assign') {
                addCoAssignee(inactiveConfirmData.bgeId, true);
              } else {
                saveAssignment(true);
              }
            }}
          >
            Assign Inactive MSME Anyway
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Status Change Menu Popover ── */}
      <Menu
        anchorEl={statusMenuAnchor}
        open={Boolean(statusMenuAnchor)}
        onClose={closeStatusMenu}
        PaperProps={{
          elevation: 4,
          sx: { minWidth: 220, borderRadius: 2, p: 0.5 }
        }}
      >
        <Box sx={{ px: 1.5, py: 1, borderBottom: '1px solid', borderColor: 'divider', mb: 0.5 }}>
          <Typography variant="caption" fontWeight={700} color="text.secondary" textTransform="uppercase">
            Set {statusMenuTarget?.type === 'expert' ? 'BGE Expert' : 'MSME'} Status
          </Typography>
          <Typography variant="body2" fontWeight={600} noWrap>
            {statusMenuTarget?.item?.business_name || statusMenuTarget?.item?.name}
          </Typography>
        </Box>
        {STATUS_OPTIONS.map((opt) => {
          const currentStatus = (statusMenuTarget?.item?.status || 'active').toLowerCase();
          const isSelected = currentStatus === opt.value || (currentStatus === 'approved' && opt.value === 'active');
          return (
            <MenuItem
              key={opt.value}
              onClick={() => updateItemStatus(opt.value)}
              disabled={statusUpdating}
              selected={isSelected}
              sx={{
                py: 0.8,
                px: 1.5,
                borderRadius: 1,
                my: 0.2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                '&.Mui-selected': { bgcolor: opt.bgcolor, color: opt.textColor, fontWeight: 700 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>{opt.icon}</span>
                <Typography variant="body2" fontWeight={isSelected ? 700 : 500}>
                  {opt.label}
                </Typography>
              </Box>
              {isSelected && <Check fontSize="small" sx={{ color: opt.textColor }} />}
            </MenuItem>
          );
        })}
      </Menu>

      {/* ── Link BGE Profile ──────────────────────────────────────────────── */}
      <Dialog open={!!linkBgeUser} onClose={() => setLinkBgeUser(null)} maxWidth="xs" fullWidth>
        <DialogTitle>Link BGE Profile</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Select the BGE Expert profile to link to <strong>{linkBgeUser?.username}</strong> ({linkBgeUser?.email || 'no email'}).
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel>BGE Expert</InputLabel>
            <Select
              value={linkBgeId}
              label="BGE Expert"
              onChange={e => setLinkBgeId(e.target.value)}
            >
              <MenuItem value=""><em>Select a BGE Expert…</em></MenuItem>
              {experts
                .filter(e => !bgeUsers.some(u => u.bge_profile?.id === e.id))
                .map(e => (
                  <MenuItem key={e.id} value={e.id}>{e.name}{e.email ? ` (${e.email})` : ''}</MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLinkBgeUser(null)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!linkBgeId}
            onClick={() => linkBGE(linkBgeUser.id, linkBgeId)}
          >
            Link Profile
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── In-App Report Viewer ──────────────────────────────────────────── */}
      {/* ── Growth Snapshot detail dialog ────────────────────────────────── */}
      <Dialog open={!!viewSnapshot} onClose={() => setViewSnapshot(null)} maxWidth="sm" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        {viewSnapshot && (() => {
          const s = viewSnapshot;
          const fmtUGX = v => v == null || v === '' ? '—' : `UGX ${Number(v).toLocaleString()}`;
          const SOURCE_LABELS = {
            diagnostic: 'Baseline Diagnostic', bge_visit: 'BGE Visit',
            quarterly: 'Quarterly Review', annual: 'Data Update', other: 'Other',
          };
          const ftTotal = (s.employees_ft_male||0)+(s.employees_ft_female||0);
          const ptTotal = (s.employees_pt_male||0)+(s.employees_pt_female||0);
          return <>
            <Box sx={{ bgcolor: BRAND.primaryMain, px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 1.2 }}>
                  Growth Update
                </Typography>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.3 }}>
                  {s.msme_name}
                </Typography>
              </Box>
              <Chip label={SOURCE_LABELS[s.source] || s.source} size="small"
                sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: '#fff' }} />
            </Box>
            <DialogContent sx={{ p: 0 }}>
              <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, bgcolor: '#F8FAFC',
                borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
                {[
                  ['BGE', s.collected_by_name],
                  ['Date', s.snapshot_date],
                ].filter(([, v]) => v).map(([label, val]) => (
                  <Box key={label}>
                    <Typography variant="caption" color="text.secondary" display="block"
                      sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.6 }}>{label}</Typography>
                    <Typography variant="body2" fontWeight={600}>{val}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ px: 3, py: 2 }}>
                {/* Financials */}
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Financials</Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
                  {[
                    { label: 'Annual Turnover', value: fmtUGX(s.annual_turnover) },
                    { label: 'Last Month Revenue', value: fmtUGX(s.last_month_revenue) },
                    { label: 'Total Assets', value: fmtUGX(s.total_assets) },
                  ].map(({ label, value }) => (
                    <Box key={label} sx={{ bgcolor: '#F4F6F9', borderRadius: 1.5, px: 2, py: 1, flex: '1 1 140px' }}>
                      <Typography variant="caption" color="text.secondary" display="block"
                        sx={{ fontSize: 10, textTransform: 'uppercase' }}>{label}</Typography>
                      <Typography variant="body2" fontWeight={600} sx={{ fontFamily: 'monospace' }}>{value}</Typography>
                    </Box>
                  ))}
                </Box>
                {/* Workforce */}
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Workforce</Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
                  {[
                    { label: 'FT Male', value: s.employees_ft_male ?? '—' },
                    { label: 'FT Female', value: s.employees_ft_female ?? '—' },
                    { label: 'PT Male', value: s.employees_pt_male ?? '—' },
                    { label: 'PT Female', value: s.employees_pt_female ?? '—' },
                    { label: 'FT Total', value: ftTotal },
                    { label: 'PT Total', value: ptTotal },
                    { label: 'FT Refugee', value: s.employees_ft_refugee ?? '—' },
                    { label: 'PT Refugee', value: s.employees_pt_refugee ?? '—' },
                  ].map(({ label, value }) => (
                    <Box key={label} sx={{ textAlign: 'center', bgcolor: '#F4F6F9',
                      borderRadius: 1.5, px: 1.5, py: 1, minWidth: 68 }}>
                      <Typography variant="h6" fontWeight={700}>{value}</Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>{label}</Typography>
                    </Box>
                  ))}
                </Box>
                {/* Compliance */}
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Compliance & Access</Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                  {[
                    { key: 'has_tin', label: 'TIN', detail: s.tin_number },
                    { key: 'has_ursb', label: 'URSB', detail: s.ursb_reg_number },
                    { key: 'has_business_bank', label: 'Business Bank', detail: s.bank_name },
                    { key: 'has_sacco', label: 'SACCO' },
                    { key: 'has_mobile_money', label: 'Mobile Money' },
                    { key: 'has_momo_pay', label: 'MOMO Pay', detail: s.momo_pay_code },
                  ].map(({ key, label, detail }) => (
                    <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.5,
                      bgcolor: s[key] ? '#E8F5E9' : '#FAFAFA', borderRadius: 1, px: 1.5, py: 0.5,
                      border: `1px solid ${s[key] ? '#A5D6A7' : '#E0E0E0'}` }}>
                      <CheckCircle sx={{ fontSize: 14, color: s[key] ? '#2E7D32' : '#BDBDBD' }} />
                      <Typography variant="caption" fontWeight={500}>{label}</Typography>
                      {detail && <Typography variant="caption" color="text.secondary">({detail})</Typography>}
                    </Box>
                  ))}
                </Box>
                {/* Digital tools */}
                {s.digital_tools && s.digital_tools.length > 0 && (
                  <>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Digital Tools Adopted</Typography>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 2 }}>
                      {s.digital_tools.map(t => (
                        <Chip key={t} label={t} size="small" variant="outlined" />
                      ))}
                      {s.digital_tools_other && <Chip label={s.digital_tools_other} size="small" variant="outlined" />}
                    </Box>
                  </>
                )}
                {/* Training impact */}
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Training Impact</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1,
                  bgcolor: s.training_made_changes ? '#E8F5E9' : '#FFF3E0', borderRadius: 1,
                  border: `1px solid ${s.training_made_changes ? '#A5D6A7' : '#FFE0B2'}` }}>
                  <CheckCircle sx={{ fontSize: 16, color: s.training_made_changes ? '#2E7D32' : '#BDBDBD' }} />
                  <Typography variant="body2">
                    {s.training_made_changes === true
                      ? 'Training delivered by the programme has made changes to this business'
                      : s.training_made_changes === false
                        ? 'Training has not yet made changes to this business'
                        : 'Training impact not recorded'}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #E5E7EB' }}>
              <Button onClick={() => setViewSnapshot(null)}>Close</Button>
            </DialogActions>
          </>;
        })()}
      </Dialog>

      {/* ── Training Report detail dialog ────────────────────────────────── */}
      <Dialog open={!!viewTrReport} onClose={() => setViewTrReport(null)} maxWidth="md" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        {viewTrReport && (() => {
          const tr = viewTrReport;
          const total = (tr.participants_male_youth || 0) + (tr.participants_female_youth || 0)
            + (tr.participants_adult_male || 0) + (tr.participants_adult_female || 0);
          const SECTIONS = [
            { key: 'training_purpose',    label: 'Background & Purpose' },
            { key: 'session_objectives',  label: 'Session Objectives' },
            { key: 'activities_delivered', label: 'Activities Delivered' },
            { key: 'key_lessons',         label: 'Key Lessons Learnt' },
            { key: 'growth_support_areas', label: 'Growth Support Areas' },
            { key: 'key_findings',        label: 'Key Findings & Critical Issues' },
            { key: 'bge_contributions',   label: 'BGE Contributions & Development Needs' },
            { key: 'bds_actions',         label: 'Proposed BDS Actions (Next 3 Months)' },
            { key: 'recommendations',     label: 'Recommendations' },
            { key: 'next_steps',          label: 'Next Steps' },
            { key: 'conclusion',          label: 'Conclusion' },
          ];
          return <>
            <Box sx={{ bgcolor: BRAND.sidebarBg, px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 1.2 }}>
                  Lead Training Report
                </Typography>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.3 }}>
                  {tr.session_title}
                </Typography>
              </Box>
              <Chip label={tr.status} size="small" color={tr.status === 'submitted' ? 'primary' : 'default'} />
            </Box>
            <DialogContent sx={{ p: 0 }}>
              <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, bgcolor: '#F8FAFC', borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
                {[
                  ['Lead BGE', tr.bge_name],
                  ['Session Date', tr.session_date],
                  ['Location', tr.session_location],
                  ['Training Dates', tr.training_dates],
                  ['Venue', tr.venue],
                  ['District', tr.district],
                  ['Time Allocation', tr.time_allocation],
                ].filter(([, v]) => v).map(([label, val]) => (
                  <Box key={label}>
                    <Typography variant="caption" color="text.secondary" display="block"
                      sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.6 }}>{label}</Typography>
                    <Typography variant="body2" fontWeight={600}>{val}</Typography>
                  </Box>
                ))}
              </Box>
              {/* Demographics */}
              <Box sx={{ px: 3, pt: 2, pb: 1 }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Participant Demographics</Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                  {[
                    { label: 'Male Youth', value: tr.participants_male_youth || 0 },
                    { label: 'Female Youth', value: tr.participants_female_youth || 0 },
                    { label: 'Adult Male', value: tr.participants_adult_male || 0 },
                    { label: 'Adult Female', value: tr.participants_adult_female || 0 },
                    { label: 'Total', value: total },
                  ].map(({ label, value }) => (
                    <Box key={label} sx={{ textAlign: 'center', minWidth: 72,
                      bgcolor: '#F4F6F9', borderRadius: 1.5, px: 1.5, py: 1 }}>
                      <Typography variant="h6" fontWeight={700}>{value}</Typography>
                      <Typography variant="caption" color="text.secondary">{label}</Typography>
                    </Box>
                  ))}
                </Box>
                {tr.facilitation_team && (
                  <Box sx={{ mt: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontSize: 10 }}>
                      Facilitation Team
                    </Typography>
                    <Typography variant="body2">{tr.facilitation_team}</Typography>
                  </Box>
                )}
              </Box>
              <Divider />
              <Box sx={{ px: 3, py: 2 }}>
                {SECTIONS.map(({ key, label }, idx) => (
                  <Box key={key} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <Box sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: BRAND.sidebarBg,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Typography sx={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>{idx + 1}</Typography>
                      </Box>
                      <Typography variant="subtitle2" fontWeight={700} color="primary">{label}</Typography>
                    </Box>
                    <Box sx={{ bgcolor: '#F4F6F9', borderRadius: 1.5, px: 2, py: 1.5,
                      borderLeft: `3px solid ${tr[key] ? '#009B62' : '#E5E7EB'}` }}>
                      {tr[key] ? (
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>{tr[key]}</Typography>
                      ) : (
                        <Typography variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>No information recorded.</Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>

              {/* Attendance sheet */}
              {(tr.attendance_list || []).length > 0 && (() => {
                const attList = tr.attendance_list;
                const days = [...new Set(attList.map(a => a.attendance_date).filter(Boolean))].sort();
                const isMultiday = days.length > 1 || (days.length === 1 && days[0]);
                const groups = isMultiday
                  ? days.map(d => ({ day: d, rows: attList.filter(a => a.attendance_date === d) }))
                  : [{ day: null, rows: attList }];
                return (
                  <>
                    <Divider />
                    <Box sx={{ px: 3, py: 2 }}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>Attendance Sheet</Typography>
                      {groups.map(({ day, rows }) => (
                        <Box key={day || 'all'} sx={{ mb: 2 }}>
                          {day && (
                            <Typography variant="caption" fontWeight={600} color="text.secondary"
                              sx={{ display: 'block', mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.6 }}>
                              {new Date(day + 'T00:00:00').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                            </Typography>
                          )}
                          <Table size="small">
                            <TableHead>
                              <TableRow sx={{ bgcolor: '#f0f4f8' }}>
                                <TableCell sx={{ fontSize: 11, fontWeight: 700, py: 0.5 }}>#</TableCell>
                                <TableCell sx={{ fontSize: 11, fontWeight: 700, py: 0.5 }}>Name</TableCell>
                                <TableCell sx={{ fontSize: 11, fontWeight: 700, py: 0.5 }}>MSME / Business</TableCell>
                                <TableCell sx={{ fontSize: 11, fontWeight: 700, py: 0.5 }}>Sex</TableCell>
                                <TableCell sx={{ fontSize: 11, fontWeight: 700, py: 0.5 }}>Age Group</TableCell>
                                <TableCell sx={{ fontSize: 11, fontWeight: 700, py: 0.5 }}>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((a, i) => (
                                <TableRow key={a.id} hover>
                                  <TableCell sx={{ fontSize: 11, color: 'text.secondary' }}>{i + 1}</TableCell>
                                  <TableCell sx={{ fontSize: 11 }}>{a.attendee_name || '—'}</TableCell>
                                  <TableCell sx={{ fontSize: 11, color: 'text.secondary' }}>{a.msme_name || '—'}</TableCell>
                                  <TableCell sx={{ fontSize: 11 }}>{a.gender || '—'}</TableCell>
                                  <TableCell sx={{ fontSize: 11 }}>{a.age_group || '—'}</TableCell>
                                  <TableCell sx={{ fontSize: 11 }}>{a.refugee_status === 'R' ? 'Refugee' : a.refugee_status === 'H' ? 'Host' : '—'}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      ))}
                    </Box>
                  </>
                );
              })()}
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #E5E7EB', gap: 1 }}>
              <Button onClick={() => openTrainingReportPdf('lead', tr.id, 'view')} startIcon={<PictureAsPdf />}>
                Open PDF
              </Button>
              <Button onClick={() => openTrainingReportPdf('lead', tr.id, 'download')} startIcon={<Download />}>
                Download
              </Button>
              <Button onClick={() => setViewTrReport(null)}>Close</Button>
            </DialogActions>
          </>;
        })()}
      </Dialog>

      {/* ── Mentor Training Report detail dialog ─────────────────────────── */}
      <Dialog open={!!viewMrReport} onClose={() => setViewMrReport(null)} maxWidth="md" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        {viewMrReport && (() => {
          const mr = viewMrReport;
          const SECTIONS = [
            { key: 'mentoring_activities', label: 'Mentoring Activities' },
            { key: 'msmes_mentored',       label: 'MSMEs Specifically Supported' },
            { key: 'key_observations',     label: 'Key Observations' },
            { key: 'challenges',           label: 'Challenges Encountered' },
            { key: 'recommendations',      label: 'Recommendations' },
            { key: 'next_steps',           label: 'Next Steps' },
          ];
          return <>
            <Box sx={{ bgcolor: '#6a1b9a', px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 1.2 }}>
                  Mentor Training Report
                </Typography>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.3 }}>
                  {mr.session_title}
                </Typography>
              </Box>
              <Chip label={mr.status} size="small" color={mr.status === 'submitted' ? 'primary' : 'default'} />
            </Box>
            <DialogContent sx={{ p: 0 }}>
              <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, bgcolor: '#F8FAFC', borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
                {[
                  ['Mentor BGE', mr.bge_name],
                  ['Lead BGE', mr.lead_bge_name],
                  ['Session Date', mr.session_date],
                  ['Location', mr.session_location],
                  ['Training Dates', mr.training_dates],
                  ['Venue', mr.venue],
                ].filter(([, v]) => v).map(([label, val]) => (
                  <Box key={label}>
                    <Typography variant="caption" color="text.secondary" display="block"
                      sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.6 }}>{label}</Typography>
                    <Typography variant="body2" fontWeight={600}>{val}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ px: 3, py: 2 }}>
                {SECTIONS.map(({ key, label }, idx) => (
                  <Box key={key} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <Box sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: '#6a1b9a',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Typography sx={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>{idx + 1}</Typography>
                      </Box>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#6a1b9a' }}>{label}</Typography>
                    </Box>
                    <Box sx={{ bgcolor: '#F4F6F9', borderRadius: 1.5, px: 2, py: 1.5,
                      borderLeft: `3px solid ${mr[key] ? '#6a1b9a' : '#E5E7EB'}` }}>
                      {mr[key] ? (
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>{mr[key]}</Typography>
                      ) : (
                        <Typography variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>No information recorded.</Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #E5E7EB', gap: 1 }}>
              <Button onClick={() => openTrainingReportPdf('mentor', mr.id, 'view')} startIcon={<PictureAsPdf />}>
                Open PDF
              </Button>
              <Button onClick={() => openTrainingReportPdf('mentor', mr.id, 'download')} startIcon={<Download />}>
                Download
              </Button>
              <Button onClick={() => setViewMrReport(null)}>Close</Button>
            </DialogActions>
          </>;
        })()}
      </Dialog>

      {/* ── View Participant Training Report ───────────────────────────── */}
      <Dialog open={!!viewPtReport} onClose={() => setViewPtReport(null)} maxWidth="md" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        {viewPtReport && (() => {
          const pt = viewPtReport;
          const SECTIONS = [
            { key: 'topics_covered',         label: 'Topics / Modules Covered' },
            { key: 'key_learnings',          label: 'Key Learnings & Insights' },
            { key: 'practical_application',  label: 'Practical Application with MSMEs' },
            { key: 'msmes_as_test_subjects', label: 'MSMEs Used as Practice Subjects' },
            { key: 'challenges',             label: 'Challenges Encountered' },
            { key: 'action_plan',            label: 'Action Plan & Next Steps' },
          ];
          return <>
            <Box sx={{ bgcolor: BRAND.primaryMain, px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 1.2 }}>
                  BGE Participant Training Report
                </Typography>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.3 }}>
                  {pt.training_title || 'Training Report'}
                </Typography>
              </Box>
              <Chip label={pt.status} size="small" color={pt.status === 'submitted' ? 'primary' : 'default'} />
            </Box>
            <DialogContent sx={{ p: 0 }}>
              <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, bgcolor: '#FAF9F6', borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
                {[
                  ['BGE', pt.bge_name],
                  ['Training Dates', pt.training_dates],
                  ['Venue', pt.venue],
                  ['District', pt.district],
                  ['Facilitator', pt.facilitator_name],
                ].filter(([, v]) => v).map(([label, val]) => (
                  <Box key={label}>
                    <Typography variant="caption" color="text.secondary" display="block"
                      sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.6 }}>{label}</Typography>
                    <Typography variant="body2" fontWeight={600}>{val}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ px: 3, py: 2 }}>
                {SECTIONS.map(({ key, label }, idx) => (
                  <Box key={key} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <Box sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: BRAND.primaryMain,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Typography sx={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>{idx + 1}</Typography>
                      </Box>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: BRAND.primaryMain }}>{label}</Typography>
                    </Box>
                    <Box sx={{ bgcolor: '#F5F5F4', borderRadius: 1.5, px: 2, py: 1.5,
                      borderLeft: `3px solid ${pt[key] ? BRAND.primaryMain : '#E5E7EB'}` }}>
                      {pt[key] ? (
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>{pt[key]}</Typography>
                      ) : (
                        <Typography variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>No information recorded.</Typography>
                      )}
                    </Box>
                  </Box>
                ))}
                {(pt.attendees || []).length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ color: BRAND.primaryMain, mb: 1 }}>
                      Attendance Register ({pt.attendees.length} participants)
                    </Typography>
                    <TableContainer component={Paper} variant="outlined">
                      <Table size="small">
                        <TableHead sx={{ bgcolor: BRAND.primaryMain }}>
                          <TableRow>
                            {['#', 'Name', 'BGE Code', 'Phone', 'Gender', 'Organisation'].map(h => (
                              <TableCell key={h} sx={{ color: '#fff', fontSize: 11 }}>{h}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pt.attendees.map((a, i) => (
                            <TableRow key={i} sx={{ bgcolor: i % 2 === 0 ? '#F8FAFC' : '#fff' }}>
                              <TableCell>{i + 1}</TableCell>
                              <TableCell>{a.name || '—'}</TableCell>
                              <TableCell>{a.bge_code || '—'}</TableCell>
                              <TableCell>{a.phone || '—'}</TableCell>
                              <TableCell>{a.gender || '—'}</TableCell>
                              <TableCell>{a.organisation || '—'}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
              </Box>
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #E5E7EB', gap: 1 }}>
              <Button onClick={() => openTrainingReportPdf('participant', pt.id, 'view')} startIcon={<PictureAsPdf />}>
                Open PDF
              </Button>
              <Button onClick={() => openTrainingReportPdf('participant', pt.id, 'download')} startIcon={<Download />}>
                Download
              </Button>
              <Button onClick={() => setViewPtReport(null)}>Close</Button>
            </DialogActions>
          </>;
        })()}
      </Dialog>

      <Dialog open={!!viewReport} onClose={() => setViewReport(null)} maxWidth="md" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        {viewReport && (() => {
          const vr = viewReport;
          const visitLabels = { initial: 'Initial Assessment', followup: 'Follow-up Visit', final: 'Final Assessment', training: 'Training Support', mentoring: 'Mentoring Session' };
          const statusColors = { draft: 'default', submitted: 'primary', reviewed: 'success' };
          const SECTIONS = [
            { key: 'business_overview',     label: 'Business Overview' },
            { key: 'challenges_identified', label: 'Challenges Identified' },
            { key: 'support_provided',      label: 'Support Provided' },
            { key: 'recommendations',       label: 'Recommendations' },
            { key: 'action_plan',           label: 'Action Plan' },
            { key: 'next_steps',            label: 'Next Steps' },
            { key: 'additional_notes',      label: 'Additional Notes' },
          ];
          return <>
            {/* Branded letterhead — hidden on screen, shown on print only. */}
            <div className="print-letterhead">
              <img className="gopa" src="/gopa-logo.png" alt="GOPA Pro" />
              <div className="wordmark">
                <div className="title">PRUDEV II</div>
                <div className="subtitle">MSME Portfolio Management</div>
              </div>
              <img className="giz" src="/giz-logo.png" alt="German Cooperation · Implemented by GIZ" />
            </div>
            {/* Header bar */}
            <Box sx={{ bgcolor: BRAND.sidebarBg, px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 1.2 }}>
                  Visit Report
                </Typography>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.3 }}>
                  {visitLabels[vr.visit_type] || vr.visit_type}
                </Typography>
              </Box>
              <Chip label={vr.status} size="small" color={statusColors[vr.status] || 'default'} />
            </Box>

            <DialogContent sx={{ p: 0 }}>
              {/* Meta strip */}
              <Box sx={{ display: 'flex', gap: 3, px: 3, py: 1.5, bgcolor: '#F8FAFC', borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
                {[
                  ['Business', vr._msme?.business_name || vr.msme_name],
                  ['MSME Code', vr._msme?.msme_code || vr.msme_code],
                  ['Sector', vr._msme?.sector],
                  ['Location', vr._msme?.city || vr._msme?.location],
                  ['BGE Expert', vr._bgeName],
                  ['Visit Date', vr.visit_date],
                ].filter(([, v]) => v).map(([label, val]) => (
                  <Box key={label}>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.6 }}>{label}</Typography>
                    <Typography variant="body2" fontWeight={600}>{val}</Typography>
                  </Box>
                ))}
              </Box>

              {/* Report sections */}
              <Box sx={{ px: 3, py: 2 }}>
                {SECTIONS.map(({ key, label }, idx) => (
                  <Box key={key} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <Box sx={{
                        width: 22, height: 22, borderRadius: '50%', bgcolor: BRAND.sidebarBg,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}>
                        <Typography sx={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>{idx + 1}</Typography>
                      </Box>
                      <Typography variant="subtitle2" fontWeight={700} color="primary">{label}</Typography>
                    </Box>
                    <Box sx={{
                      bgcolor: '#F4F6F9', borderRadius: 1.5, px: 2, py: 1.5,
                      borderLeft: `3px solid ${vr[key] ? '#009B62' : '#E5E7EB'}`,
                    }}>
                      {vr[key] ? (
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
                          {vr[key]}
                        </Typography>
                      ) : (
                        <Typography variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                          No information recorded.
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #E5E7EB', gap: 1 }}>
              <Button onClick={() => setViewReport(null)}>Close</Button>
            </DialogActions>
          </>;
        })()}
      </Dialog>

      {/* ── Submit Work Order for Payment Dialog ─────────────────────────── */}
      <Dialog open={woPaymentSubmitDialog} onClose={() => setWoPaymentSubmitDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Payments color="primary" /> Submit Work Order for Payment
        </DialogTitle>
        <DialogContent dividers>
          {woPaymentSubmitTarget && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Alert severity="info" icon={false}>
                <Typography variant="subtitle2" fontWeight={700}>
                  Work Order: {woPaymentSubmitTarget.work_order_number}
                </Typography>
                <Typography variant="body2">
                  BGE Expert: <strong>{woPaymentSubmitTarget.bge_name}</strong> ({woPaymentSubmitTarget.bge_code_display || 'BGE'})
                </Typography>
                <Typography variant="body2">
                  Net Amount: <strong>UGX {(woPaymentSubmitTarget.rate_per_day * woPaymentSubmitTarget.max_days * 0.94).toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong>
                </Typography>
              </Alert>

              <TextField
                label="Payment / Batch Reference #"
                placeholder="e.g. PRUDEV2-BATCH-AUG-001 or REQ-2026-08"
                value={woPaymentSubmitForm.payment_reference}
                onChange={e => setWoPaymentSubmitForm({ ...woPaymentSubmitForm, payment_reference: e.target.value })}
                size="small"
                fullWidth
                helperText="Enter the finance requisition voucher or payment batch identifier"
              />

              <FormControl fullWidth size="small">
                <InputLabel>Payment Status</InputLabel>
                <Select
                  value={woPaymentSubmitForm.payment_status}
                  label="Payment Status"
                  onChange={e => setWoPaymentSubmitForm({ ...woPaymentSubmitForm, payment_status: e.target.value })}
                >
                  <MenuItem value="submitted_for_payment">🟡 Submitted for Payment (Pending BGE Receipt)</MenuItem>
                  <MenuItem value="paid">🔵 Paid by Finance</MenuItem>
                  <MenuItem value="payment_confirmed">🟢 Payment Confirmed by BGE ✓</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Finance / Administrative Notes"
                placeholder="Optional notes regarding submission date, account details, or instructions..."
                value={woPaymentSubmitForm.payment_notes}
                onChange={e => setWoPaymentSubmitForm({ ...woPaymentSubmitForm, payment_notes: e.target.value })}
                multiline
                rows={3}
                size="small"
                fullWidth
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWoPaymentSubmitDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={woPaymentSubmitting}
            onClick={handleWoPaymentSubmit}
            startIcon={woPaymentSubmitting ? <CircularProgress size={16} color="inherit" /> : <Payments />}
          >
            {woPaymentSubmitting ? 'Saving…' : 'Save Payment Submission'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Submit Visit / Group Report for Payment Dialog ────────────────── */}
      <Dialog open={reportPaymentSubmitDialog} onClose={() => setReportPaymentSubmitDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Payments color="primary" /> Submit Report for Payment
        </DialogTitle>
        <DialogContent dividers>
          {reportPaymentSubmitTarget && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Alert severity="info" icon={false}>
                <Typography variant="subtitle2" fontWeight={700}>
                  {reportPaymentSubmitType === 'group'
                    ? `Group Report: ${reportPaymentSubmitTarget.group_name}`
                    : `Visit Report: ${reportPaymentSubmitTarget.msme_name || reportPaymentSubmitTarget.msme?.business_name || 'MSME Visit'}`}
                </Typography>
                <Typography variant="body2">
                  BGE: <strong>{reportPaymentSubmitTarget.bge_name || reportPaymentSubmitTarget.team_lead_name || 'BGE Expert'}</strong>
                </Typography>
                <Typography variant="body2">
                  Visit Date: <strong>{reportPaymentSubmitTarget.visit_date}</strong>
                </Typography>
              </Alert>

              <TextField
                label="Payment / Batch Reference #"
                placeholder="e.g. BATCH-REPORTS-2026-08 or REQ-089"
                value={reportPaymentSubmitForm.payment_reference}
                onChange={e => setReportPaymentSubmitForm({ ...reportPaymentSubmitForm, payment_reference: e.target.value })}
                size="small"
                fullWidth
                helperText="Enter the finance requisition voucher or payment batch identifier"
              />

              <FormControl fullWidth size="small">
                <InputLabel>Payment Status</InputLabel>
                <Select
                  value={reportPaymentSubmitForm.payment_status}
                  label="Payment Status"
                  onChange={e => setReportPaymentSubmitForm({ ...reportPaymentSubmitForm, payment_status: e.target.value })}
                >
                  <MenuItem value="submitted">🟡 Submitted for Payment</MenuItem>
                  <MenuItem value="paid">🔵 Paid by Finance</MenuItem>
                  <MenuItem value="confirmed">🟢 Payment Confirmed by BGE ✓</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Notes"
                placeholder="Optional notes or batch details..."
                value={reportPaymentSubmitForm.payment_notes}
                onChange={e => setReportPaymentSubmitForm({ ...reportPaymentSubmitForm, payment_notes: e.target.value })}
                multiline
                rows={3}
                size="small"
                fullWidth
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReportPaymentSubmitDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={reportPaymentSubmitting}
            onClick={handleReportPaymentSubmit}
            startIcon={reportPaymentSubmitting ? <CircularProgress size={16} color="inherit" /> : <Payments />}
          >
            {reportPaymentSubmitting ? 'Saving…' : 'Save Payment Submission'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Enterprise Improvement Plan (TBIP) Dialog (Admin / HOA view) ── */}
      <EnterpriseImprovementPlanDialog
        open={tbipDialog}
        onClose={() => setTbipDialog(false)}
        plan={selectedTbip}
        msme={selectedTbipMsme || (selectedTbip ? msmes.find(m => m.id === selectedTbip.msme) || allMsmes.find(m => m.id === selectedTbip.msme) : null)}
        bge={selectedTbip?.bge ? experts.find(e => e.id === selectedTbip.bge) : null}
        currentUser={currentUser}
        token={token}
        onSaved={(updated) => {
          fetchTbipPlans();
          setSelectedTbip(updated);
          setSuccess('Enterprise Improvement Plan updated.');
        }}
        notify={(msg, type) => {
          if (type === 'error') setError(msg);
          else setSuccess(msg);
        }}
      />

      {/* ── Book Meeting with Richard & Stephen Dialog ── */}
      <BookTBIPMeetingDialog
        open={tbipBookMeetingOpen}
        onClose={() => setTbipBookMeetingOpen(false)}
        plan={tbipBookMeetingPlan}
        msme={tbipBookMeetingMsme}
        msmes={msmes.length > 0 ? msmes : allMsmes}
        currentUser={currentUser}
        token={token}
        notify={(msg, type) => {
          if (type === 'error') setError(msg);
          else setSuccess(msg);
        }}
      />

      {/* ── Financial Improvement Plan (FIAP) Dialog ── */}
      <FinancialImprovementPlanDialog
        open={fiapDialog}
        onClose={() => setFiapDialog(false)}
        plan={selectedFiap}
        msme={selectedFiapMsme || (selectedFiap ? msmes.find(m => m.id === selectedFiap.msme) || allMsmes.find(m => m.id === selectedFiap.msme) : null)}
        allMsmes={allMsmes.length > 0 ? allMsmes : msmes}
        bge={selectedFiap?.bge ? experts.find(e => e.id === selectedFiap.bge) : null}
        currentUser={currentUser}
        token={token}
        onSaved={(updated) => {
          fetchFiapPlans();
          setSelectedFiap(updated);
          setSuccess('Financial Improvement Plan updated.');
        }}
        notify={(msg, type) => {
          if (type === 'error') setError(msg);
          else setSuccess(msg);
        }}
      />

      {/* ── Book FIAP Approval Meeting Dialog (Rosemary / Harriet) ── */}
      <BookFIAPMeetingDialog
        open={fiapBookMeetingOpen}
        onClose={() => setFiapBookMeetingOpen(false)}
        plan={fiapBookMeetingPlan}
        msme={fiapBookMeetingMsme}
        msmes={msmes.length > 0 ? msmes : allMsmes}
        currentUser={currentUser}
        token={token}
        onBooked={(resData) => {
          fetchFiapPlans();
          setSuccess('Approval meeting request and calendar invite sent.');
        }}
        notify={(msg, type) => {
          if (type === 'error') setError(msg);
          else setSuccess(msg);
        }}
      />




      {/* ── Notifications ─────────────────────────────────────────────────── */}
      <Snackbar open={!!error} autoHideDuration={5000} onClose={() => setError('')} anchorOrigin={{vertical:'bottom',horizontal:'center'}}>
        <Alert severity="error" onClose={() => setError('')} sx={{ width: '100%' }}>{error}</Alert>
      </Snackbar>
      <Snackbar open={!!success} autoHideDuration={3000} onClose={() => setSuccess('')} anchorOrigin={{vertical:'bottom',horizontal:'center'}}>
        <Alert severity="success" onClose={() => setSuccess('')} sx={{ width: '100%' }}>{success}</Alert>
      </Snackbar>
    </Box>
  );
}
